// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"7Uw6j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "configureMonkeyFetch", ()=>configureMonkeyFetch);
var _monkeyFetch = require("@timwheeler/monkey-fetch");
var _getMsalObj = require("./getMsalObj");
var _msalBrowser = require("@azure/msal-browser");
const ONEWAY_STATEMENTS_URL_PROD_PREFIX = "/oneway-internals/restriction-statements-from-csv-";
const ONEWAY_STATEMENTS_URL_DEV_PREFIX = "/oneway-internals/restriction-statements-from-csv-dev-";
const HDLANERESTRICTION_STATEMENTS_URL_PROD_PREFIX = "/laneres-internals/hdlaneres-statements-from-csv-";
const SDLANERESTRICTION_STATEMENTS_URL_PROD_PREFIX = "/sdlaneres-internals/sdlaneres-statements-from-csv-";
const GENESIS_CURVATURES_URL = "/genesis-curvatures/genesis-curvatures-from-csv.fgb";
const GENESIS_GRADIENT_URL = "/genesis-gradient/genesis-gradient-from-csv.fgb";
const ONEWAY_MODERATIONS_URL = "/oneway-internals/moderations.fgb";
const LANERES_MODERATIONS_URL = "/laneres-internals/moderations.fgb";
const DEM_GRADIENT_URL = "/dem-internals/dem-gradient-from-csv.fgb";
const SDLANERES_MODERATIONS_URL = "/sdlaneres-internals/moderations.fgb";
const BINDING_REPORTS_URL = "/binding-reports";
const MOMA_TRACES_URL = "/moma-traces";
function configureMonkeyFetch() {
    const monkeyFetch = new (0, _monkeyFetch.MonkeyFetch)();
    monkeyFetch.configure({
        request: (resource, options)=>{
            if (!resource.startsWith(ONEWAY_STATEMENTS_URL_PROD_PREFIX) && !resource.startsWith(ONEWAY_STATEMENTS_URL_DEV_PREFIX) && !resource.startsWith(HDLANERESTRICTION_STATEMENTS_URL_PROD_PREFIX) && !resource.startsWith(SDLANERESTRICTION_STATEMENTS_URL_PROD_PREFIX) && !resource.startsWith(GENESIS_CURVATURES_URL) && !resource.startsWith(GENESIS_GRADIENT_URL) && !resource.startsWith(ONEWAY_MODERATIONS_URL) && !resource.startsWith(LANERES_MODERATIONS_URL) && !resource.startsWith(SDLANERES_MODERATIONS_URL) && !resource.startsWith(DEM_GRADIENT_URL) && !resource.startsWith(BINDING_REPORTS_URL) && !(MOMA_TRACES_URL && resource.startsWith(MOMA_TRACES_URL)) && !resource.includes(".blob.core.windows.net")) return Promise.resolve([
                resource,
                options
            ]);
            const newOptions = {
                ...options
            };
            return (0, _getMsalObj.getMsalObjPromise)().then((msalObj)=>{
                const account = msalObj.getAllAccounts()[0];
                const request = {
                    account: account,
                    scopes: [
                        "https://storage.azure.com/user_impersonation"
                    ]
                };
                return msalObj.acquireTokenSilent(request).then(function(tokenResponse) {
                    if (resource.includes(".blob.core.windows.net")) newOptions.headers = {
                        ...newOptions.headers,
                        Authorization: `Bearer ${tokenResponse.accessToken}`,
                        "x-ms-version": "2020-04-08"
                    };
                    else newOptions.headers = {
                        ...newOptions.headers,
                        Authorization: `Bearer ${tokenResponse.idToken}`
                    };
                    return Promise.resolve([
                        resource,
                        newOptions
                    ]);
                }).catch(function(error) {
                    if (error instanceof (0, _msalBrowser.InteractionRequiredAuthError) || error instanceof (0, _msalBrowser.BrowserAuthError)) return msalObj.acquireTokenRedirect(request);
                    return Promise.reject();
                });
            });
        },
        requestError: (error)=>{
            return Promise.reject(error);
        },
        response: (response)=>{
            // check if response is a 401, if so
            // reject and invoke response error handler
            if (response.status === 401) return Promise.reject(response);
            return Promise.resolve(response);
        },
        responseError: async (response)=>{
            // add custom response error handling
            return Promise.reject(response);
        }
    });
}

},{"@timwheeler/monkey-fetch":"7qfuo","./getMsalObj":"hTW2R","@azure/msal-browser":[["BrowserAuthError","k9YIy"],["InteractionRequiredAuthError","jiVlC"]],"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7qfuo":[function(require,module,exports,__globalThis) {
"use strict";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MonkeyFetch = void 0;
class MonkeyFetch {
    constructor(){
        this.debug = false;
        this.interceptors = {
            request: (resource, options)=>Promise.resolve([
                    resource,
                    options
                ]),
            requestError: (error)=>Promise.reject(error),
            response: (response)=>Promise.resolve(response),
            responseError: (response)=>Promise.reject(response)
        };
        this.getCurrentRuntimeContext();
    }
    /**
     * @description Determine the current JS runtime context, either Browser or Node.js
     */ getCurrentRuntimeContext() {
        const isBrowserExecutionContext = typeof window !== 'undefined';
        this.debugLog(isBrowserExecutionContext ? 'Browser runtime' : 'Node Runtime');
        if (isBrowserExecutionContext) require("f9da432c79853978");
        else require("23a7685465292f26");
    }
    /**
     * @description Applies the default or user-supplied `request` and/or the `requestError` interceptors
     * @param {[(RequestInfo | URL), RequestInit]} args - the request arguments used to create the monkey-patched request
     * @returns {Promise<IMonkeyFetchResponse>} - the Promise containing the request arguments after interceptors have been applied
     */ applyRequestInterceptors(args) {
        return __awaiter(this, void 0, void 0, function*() {
            this.debugLog('Initial Request Args:', args);
            const { request, requestError } = this.interceptors;
            try {
                return request(...args);
            } catch (err) {
                return requestError(err);
            }
        });
    }
    /**
     * @description Returns the monkey-patched promise that was either resolved or rejected
     * @param {Function} fetch - the Fetch API for the current JavaScript runtime context
     * @param {[(RequestInfo | URL), RequestInit]} args - the request arguments used to create the monkey-patched request
     * @returns {Promise<IMonkeyFetchResponse>} - the Promise containing the response with interceptors applied
     */ sendInterceptedRequest(fetch, args) {
        return __awaiter(this, void 0, void 0, function*() {
            const interceptedRequest = new Request(...args);
            try {
                const resolvedResponse = yield fetch(interceptedRequest);
                resolvedResponse.request = interceptedRequest;
                this.debugLog('Intercepted Request:', interceptedRequest);
                this.debugLog('Resolved Response:', resolvedResponse);
                return resolvedResponse;
            } catch (error) {
                error.request = interceptedRequest;
                return error;
            }
        });
    }
    /**
     * @description Applies the default or user-supplied `response` and `responseError` interceptors
     * @param {IMonkeyFetchResponse} initialResponse - the initial, unaltered response before interceptors are applied
     * @returns {Promise<IMonkeyFetchResponse>} - the response with interceptors applied
     */ applyResponseInterceptors(initialResponse) {
        return __awaiter(this, void 0, void 0, function*() {
            const { response, responseError } = this.interceptors;
            try {
                const interceptedResponse = response(initialResponse);
                this.debugLog('Intercepted Response:', interceptedResponse);
                return yield interceptedResponse;
            } catch (err) {
                return yield responseError(err);
            }
        });
    }
    /**
     * @description Applies all interceptors to the request and response objects
     * @param {Function} fetch - the Fetch API for the current JavaScript runtime context
     * @param {[(RequestInfo | URL), RequestInit]} args - the request arguments used to create the monkey-patched request
     * @returns {Promise<IMonkeyFetchResponse>} - the response with all interceptors applied
     */ applyInterceptors(fetch, ...args) {
        return __awaiter(this, void 0, void 0, function*() {
            const monkeyFetchRequestOptions = yield this.applyRequestInterceptors(args);
            const responseWithoutInterceptors = yield this.sendInterceptedRequest(fetch, monkeyFetchRequestOptions);
            return yield this.applyResponseInterceptors(responseWithoutInterceptors);
        });
    }
    /**
     * Debugging tool for internal logging
     * @param {any} args - Arbitrary arguments to be emitted via logger
     * @returns {void}
     */ debugLog(...args) {
        if (this.debug) console.warn(`[DEBUG] @timwheeler/monkey-fetch | `, ...args);
    }
    /**
     * @description Custom, user-supplied configuration that is applied to `MonkeyFetch`
     * @param {IMonkeyFetchConfiguration} configuration - Custom configuration applied to all requests and responses
     * @returns {void}
     */ configure(configuration) {
        for(let configurationKey in configuration)if (configurationKey in this.interceptors) this.interceptors[configurationKey] = configuration[configurationKey];
        else this[configurationKey] = configuration[configurationKey];
        globalThis.fetch = ((fetch)=>(...args)=>this.applyInterceptors(fetch, ...args))(globalThis.fetch);
    }
}
exports.MonkeyFetch = MonkeyFetch;

},{"f9da432c79853978":"jR8EP","23a7685465292f26":"hCuoO"}],"jR8EP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Headers", ()=>Headers);
parcelHelpers.export(exports, "Request", ()=>Request);
parcelHelpers.export(exports, "Response", ()=>Response);
parcelHelpers.export(exports, "DOMException", ()=>DOMException);
parcelHelpers.export(exports, "fetch", ()=>fetch);
var global = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || typeof global !== 'undefined' && global;
var support = {
    searchParams: 'URLSearchParams' in global,
    iterable: 'Symbol' in global && 'iterator' in Symbol,
    blob: 'FileReader' in global && 'Blob' in global && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in global,
    arrayBuffer: 'ArrayBuffer' in global
};
function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if (support.arrayBuffer) {
    var viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
    ];
    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function normalizeName(name) {
    if (typeof name !== 'string') name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function normalizeValue(value) {
    if (typeof value !== 'string') value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if (support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function Headers(headers) {
    this.map = {};
    if (headers instanceof Headers) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
};
Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name));
};
Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
};
Headers.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return iteratorFor(items);
};
Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return iteratorFor(items);
};
Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return iteratorFor(items);
};
if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
function consumed(body) {
    if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
    body.bodyUsed = true;
}
function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise;
}
function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join('');
}
function bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) this._bodyText = '';
        else if (typeof body === 'string') this._bodyText = body;
        else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if (support.arrayBuffer && support.blob && isDataView(body)) {
            this._bodyArrayBuffer = bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
            else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
    };
    if (support.blob) {
        this.blob = function() {
            var rejected = consumed(this);
            if (rejected) return rejected;
            if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
            else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                this._bodyArrayBuffer
            ]));
            else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
            else return Promise.resolve(new Blob([
                this._bodyText
            ]));
        };
        this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
                var isConsumed = consumed(this);
                if (isConsumed) return isConsumed;
                if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                else return Promise.resolve(this._bodyArrayBuffer);
            } else return this.blob().then(readBlobAsArrayBuffer);
        };
    }
    this.text = function() {
        var rejected = consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error('could not read FormData body as text');
        else return Promise.resolve(this._bodyText);
    };
    if (support.formData) this.formData = function() {
        return this.text().then(decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var methods = [
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'POST',
    'PUT'
];
function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method;
}
function Request(input, options) {
    if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof Request) {
        if (input.bodyUsed) throw new TypeError('Already read');
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new Headers(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) this.headers = new Headers(options.headers);
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;
    if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
    this._initBody(body);
    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}
Request.prototype.clone = function() {
    return new Request(this, {
        body: this._bodyInit
    });
};
function decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            headers.append(key, value);
        }
    });
    return headers;
}
Body.call(Request.prototype);
function Response(bodyInit, options) {
    if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}
Body.call(Response.prototype);
Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new Headers(this.headers),
        url: this.url
    });
};
Response.error = function() {
    var response = new Response(null, {
        status: 0,
        statusText: ''
    });
    response.type = 'error';
    return response;
};
var redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
    return new Response(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var DOMException = global.DOMException;
try {
    new DOMException();
} catch (err) {
    DOMException = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    DOMException.prototype = Object.create(Error.prototype);
    DOMException.prototype.constructor = DOMException;
}
function fetch(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new Request(input, init);
        if (request.signal && request.signal.aborted) return reject(new DOMException('Aborted', 'AbortError'));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                status: xhr.status,
                statusText: xhr.statusText,
                headers: parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new Response(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new DOMException('Aborted', 'AbortError'));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === '' && global.location.href ? global.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === 'include') xhr.withCredentials = true;
        else if (request.credentials === 'omit') xhr.withCredentials = false;
        if ('responseType' in xhr) {
            if (support.blob) xhr.responseType = 'blob';
            else if (support.arrayBuffer && request.headers.get('Content-Type') && request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1) xhr.responseType = 'arraybuffer';
        }
        if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) Object.getOwnPropertyNames(init.headers).forEach(function(name) {
            xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
        });
        else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}
fetch.polyfill = true;
if (!global.fetch) {
    global.fetch = fetch;
    global.Headers = Headers;
    global.Request = Request;
    global.Response = Response;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hCuoO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const node_fetch_1 = require("aef4bcdf1e1aacd3");
globalThis.fetch = node_fetch_1.default;
globalThis.Headers = node_fetch_1.Headers;
globalThis.Request = node_fetch_1.Request;
globalThis.Response = node_fetch_1.Response;
globalThis.Blob = node_fetch_1.Blob;
globalThis.blobFrom = node_fetch_1.blobFrom;
globalThis.blobFromSync = node_fetch_1.blobFromSync;
globalThis.File = node_fetch_1.File;
globalThis.fileFrom = node_fetch_1.fileFrom;
globalThis.fileFromSync = node_fetch_1.fileFromSync;
globalThis.FormData = node_fetch_1.FormData;

},{"aef4bcdf1e1aacd3":"bRc2L"}],"bRc2L":[function(require,module,exports,__globalThis) {
"use strict";
// ref: https://github.com/tc39/proposal-global
var getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof global !== 'undefined') return global;
    throw new Error('unable to locate global object');
};
var global = getGlobal();
module.exports = exports = global.fetch;
// Needed for TypeScript and Webpack.
if (global.fetch) exports.default = global.fetch.bind(global);
exports.Headers = global.Headers;
exports.Request = global.Request;
exports.Response = global.Response;

},{}],"gl3dx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addSDOLayersAndControls", ()=>addSDOLayersAndControls);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _sdocontrol = require("../controls/SDOControl");
var _sdolayer = require("../layers/SDOLayer");
function addSDOLayersAndControls(map, azureLoginControl, dateInputControl, target) {
    // Initialization of the SDO checkbox control.
    const sdoControl = new (0, _sdocontrol.SDOControl)({
        target: target
    });
    // Initialization of the OpenLayers layer that will be added to the Map.
    // This layer contains all the traffic signs (SDOs).
    const sdoLayer = (0, _sdolayer.getSDOLayer)(dateInputControl, sdoControl, azureLoginControl);
    map.addLayer(sdoLayer);
    map.addControl(sdoControl);
    // These are some forced updates that trigger certain onpropertychange events in getSDOLayer and SDOControl.
    // Default behaviour: SDO is turned on and should therefore be set immediately when the page is loaded.
    // The bbox is set before the sdoToggle because otherwise the propertychange listener in getSDOLayer would have
    // an undefined bbox.
    sdoControl.set("bbox", map.getView().calculateExtent(map.getSize()));
    sdoControl.set("sdoToggle", false);
    // The on moveend event listener fires when the mouse is released or the scroll wheel is used to zoom in/out.
    // We only want this on moveend and not on every change, because then the API would get flooded with useless
    // and aborted calls.
    map.on("moveend", function(event) {
        // Because the map has changed after a moveevent, the bounding box of the map is set as a property of sdoControl
        // which can then be used in the API call.
        sdoControl.set("bbox", event.target.getView().calculateExtent(event.target.getSize()));
    });
    // The SDO layer is also add statically to every TrafficSign instance, to be able
    // to force the layer to rerender when the scale of an object has changed.
    (0, _sdolayer.TrafficSign).sdoLayer = sdoLayer;
    // This Select Interaction is used to check for hover updates of the SDO objects.
    let hoverSelect = new (0, _selectDefault.default)({
        condition: (0, _condition.pointerMove)
    });
    // This line is used to be able to get the styles of the features that were selected and deselected by the mouse pointer.
    // ! Weird: see https://github.com/openlayers/openlayers/issues/10131.
    hoverSelect.style_ = null;
    hoverSelect.on("select", (0, _sdolayer.TrafficSign).hoverSelectHandler);
    map.addInteraction(hoverSelect);
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../controls/SDOControl":"1rKl0","../layers/SDOLayer":"hgUxd","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1uL1O":[function(require,module,exports,__globalThis) {
/**
 * @module ol/interaction/Select
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A function that takes a {@link module:ol/Feature~Feature} and returns `true` if the feature may be
 * selected or `false` otherwise.
 * @typedef {function(import("../Feature.js").default, import("../layer/Layer.js").default<import("../source/Source.js").default> | undefined):boolean} FilterFunction
 */ /**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [addCondition] A function
 * that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * By default, this is {@link module:ol/events/condition.never}. Use this if you
 * want to use different events for add and remove instead of `toggle`.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. This is the event
 * for the selected features as a whole. By default, this is
 * {@link module:ol/events/condition.singleClick}. Clicking on a feature selects that
 * feature and removes any that were in the selection. Clicking outside any
 * feature removes all from the selection.
 * See `toggle`, `add`, `remove` options for adding/removing extra features to/
 * from the selection.
 * @property {Array<import("../layer/Layer.js").default>|function(import("../layer/Layer.js").default<import("../source/Source.js").default>): boolean} [layers]
 * A list of layers from which features should be selected. Alternatively, a
 * filter function can be provided. The function will be called for each layer
 * in the map and should return `true` for layers that you want to be
 * selectable. If the option is absent, all visible layers will be considered
 * selectable.
 * @property {import("../style/Style.js").StyleLike|null} [style]
 * Style for the selected features. By default the default edit style is used
 * (see {@link module:ol/style/Style~Style}). Set to `null` if this interaction should not apply
 * any style changes for selected features.
 * If set to a falsey value, the selected feature's style will not change.
 * @property {import("../events/condition.js").Condition} [removeCondition] A function
 * that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * By default, this is {@link module:ol/events/condition.never}. Use this if you
 * want to use different events for add and remove instead of `toggle`.
 * @property {import("../events/condition.js").Condition} [toggleCondition] A function
 * that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. This is in addition
 * to the `condition` event. By default,
 * {@link module:ol/events/condition.shiftKeyOnly}, i.e. pressing `shift` as
 * well as the `condition` event, adds that feature to the current selection if
 * it is not currently selected, and removes it if it is. See `add` and `remove`
 * if you want to use different events instead of a toggle.
 * @property {boolean} [multi=false] A boolean that determines if the default
 * behaviour should select only single features or all (overlapping) features at
 * the clicked map position. The default of `false` means single select.
 * @property {Collection<Feature>} [features]
 * Collection where the interaction will place selected features. Optional. If
 * not set the interaction will create a collection. In any case the collection
 * used by the interaction is returned by
 * {@link module:ol/interaction/Select~Select#getFeatures}.
 * @property {FilterFunction} [filter] A function
 * that takes a {@link module:ol/Feature~Feature} and a
 * {@link module:ol/layer/Layer~Layer} and returns `true` if the feature may be
 * selected or `false` otherwise.
 * @property {number} [hitTolerance=0] Hit-detection tolerance. Pixels inside
 * the radius around the given position will be checked for features.
 */ /**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/Select~Select} instances are instances of
 * this type.
 */ parcelHelpers.export(exports, "SelectEvent", ()=>SelectEvent);
var _collectionJs = require("../Collection.js");
var _collectionJsDefault = parcelHelpers.interopDefault(_collectionJs);
var _collectionEventTypeJs = require("../CollectionEventType.js");
var _collectionEventTypeJsDefault = parcelHelpers.interopDefault(_collectionEventTypeJs);
var _featureJs = require("../Feature.js");
var _featureJsDefault = parcelHelpers.interopDefault(_featureJs);
var _arrayJs = require("../array.js");
var _eventJs = require("../events/Event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _conditionJs = require("../events/condition.js");
var _functionsJs = require("../functions.js");
var _vectorJs = require("../layer/Vector.js");
var _vectorJsDefault = parcelHelpers.interopDefault(_vectorJs);
var _styleJs = require("../style/Style.js");
var _utilJs = require("../util.js");
var _interactionJs = require("./Interaction.js");
var _interactionJsDefault = parcelHelpers.interopDefault(_interactionJs);
/**
 * @enum {string}
 */ const SelectEventType = {
    /**
   * Triggered when feature(s) has been (de)selected.
   * @event SelectEvent#select
   * @api
   */ SELECT: 'select'
};
class SelectEvent extends (0, _eventJsDefault.default) {
    /**
   * @param {SelectEventType} type The event type.
   * @param {Array<import("../Feature.js").default>} selected Selected features.
   * @param {Array<import("../Feature.js").default>} deselected Deselected features.
   * @param {import("../MapBrowserEvent.js").default|undefined} mapBrowserEvent Associated
   *     {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   */ constructor(type, selected, deselected, mapBrowserEvent){
        super(type);
        /**
     * Selected features array.
     * @type {Array<import("../Feature.js").default>}
     * @api
     */ this.selected = selected;
        /**
     * Deselected features array.
     * @type {Array<import("../Feature.js").default>}
     * @api
     */ this.deselected = deselected;
        /**
     * Associated {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
     * @type {import("../MapBrowserEvent.js").default|undefined}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/**
 * Original feature styles to reset to when features are no longer selected.
 * @type {Object<string, import("../style/Style.js").default|Array<import("../style/Style.js").default>|import("../style/Style.js").StyleFunction|null|undefined>}
 */ const originalFeatureStyles = {};
/***
 * @template Return
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<import("../ObjectEventType.js").Types|
 *     'change:active', import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").OnSignature<'select', SelectEvent, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|import("../ObjectEventType.js").Types|
 *     'change:active'|'select', Return>} SelectOnSignature
 */ /**
 * @classdesc
 * Interaction for selecting vector features. By default, selected features are
 * styled differently, so this interaction can be used for visual highlighting,
 * as well as selecting features for other actions, such as modification or
 * output. There are three ways of controlling which features are selected:
 * using the browser event as defined by the `condition` and optionally the
 * `toggle`, `add`/`remove`, and `multi` options; a `layers` filter; and a
 * further feature filter using the `filter` option.
 *
 * @fires SelectEvent
 * @api
 */ class Select extends (0, _interactionJsDefault.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {SelectOnSignature<import("../events.js").EventsKey>}
     */ this.on;
        /***
     * @type {SelectOnSignature<import("../events.js").EventsKey>}
     */ this.once;
        /***
     * @type {SelectOnSignature<void>}
     */ this.un;
        options = options ? options : {};
        /**
     * @private
     */ this.boundAddFeature_ = this.addFeature_.bind(this);
        /**
     * @private
     */ this.boundRemoveFeature_ = this.removeFeature_.bind(this);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, _conditionJs.singleClick);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.addCondition_ = options.addCondition ? options.addCondition : (0, _conditionJs.never);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.removeCondition_ = options.removeCondition ? options.removeCondition : (0, _conditionJs.never);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.toggleCondition_ = options.toggleCondition ? options.toggleCondition : (0, _conditionJs.shiftKeyOnly);
        /**
     * @private
     * @type {boolean}
     */ this.multi_ = options.multi ? options.multi : false;
        /**
     * @private
     * @type {FilterFunction}
     */ this.filter_ = options.filter ? options.filter : (0, _functionsJs.TRUE);
        /**
     * @private
     * @type {number}
     */ this.hitTolerance_ = options.hitTolerance ? options.hitTolerance : 0;
        /**
     * @private
     * @type {import("../style/Style.js").default|Array<import("../style/Style.js").default>|import("../style/Style.js").StyleFunction|null}
     */ this.style_ = options.style !== undefined ? options.style : getDefaultStyleFunction();
        /**
     * @private
     * @type {Collection<Feature>}
     */ this.features_ = options.features || new (0, _collectionJsDefault.default)();
        /** @type {function(import("../layer/Layer.js").default<import("../source/Source.js").default>): boolean} */ let layerFilter;
        if (options.layers) {
            if (typeof options.layers === 'function') layerFilter = options.layers;
            else {
                const layers = options.layers;
                layerFilter = function(layer) {
                    return layers.includes(layer);
                };
            }
        } else layerFilter = (0, _functionsJs.TRUE);
        /**
     * @private
     * @type {function(import("../layer/Layer.js").default<import("../source/Source.js").default>): boolean}
     */ this.layerFilter_ = layerFilter;
        /**
     * An association between selected feature (key)
     * and layer (value)
     * @private
     * @type {Object<string, import("../layer/Layer.js").default>}
     */ this.featureLayerAssociation_ = {};
    }
    /**
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("../layer/Layer.js").default} layer Layer.
   * @private
   */ addFeatureLayerAssociation_(feature, layer) {
        this.featureLayerAssociation_[(0, _utilJs.getUid)(feature)] = layer;
    }
    /**
   * Get the selected features.
   * @return {Collection<Feature>} Features collection.
   * @api
   */ getFeatures() {
        return this.features_;
    }
    /**
   * Returns the Hit-detection tolerance.
   * @return {number} Hit tolerance in pixels.
   * @api
   */ getHitTolerance() {
        return this.hitTolerance_;
    }
    /**
   * Returns the associated {@link module:ol/layer/Vector~VectorLayer vector layer} of
   * a selected feature.
   * @param {import("../Feature.js").default} feature Feature
   * @return {import('../layer/Vector.js').default} Layer.
   * @api
   */ getLayer(feature) {
        return /** @type {import('../layer/Vector.js').default} */ this.featureLayerAssociation_[(0, _utilJs.getUid)(feature)];
    }
    /**
   * Hit-detection tolerance. Pixels inside the radius around the given position
   * will be checked for features.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @api
   */ setHitTolerance(hitTolerance) {
        this.hitTolerance_ = hitTolerance;
    }
    /**
   * Remove the interaction from its current map, if any,  and attach it to a new
   * map, if any. Pass `null` to just remove the interaction from the current map.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   * @override
   */ setMap(map) {
        const currentMap = this.getMap();
        if (currentMap && this.style_) this.features_.forEach(this.restorePreviousStyle_.bind(this));
        super.setMap(map);
        if (map) {
            this.features_.addEventListener((0, _collectionEventTypeJsDefault.default).ADD, /** @type {import("../events.js").Listener} */ this.boundAddFeature_);
            this.features_.addEventListener((0, _collectionEventTypeJsDefault.default).REMOVE, /** @type {import("../events.js").Listener} */ this.boundRemoveFeature_);
            if (this.style_) this.features_.forEach(this.applySelectedStyle_.bind(this));
        } else {
            this.features_.removeEventListener((0, _collectionEventTypeJsDefault.default).ADD, /** @type {import("../events.js").Listener} */ this.boundAddFeature_);
            this.features_.removeEventListener((0, _collectionEventTypeJsDefault.default).REMOVE, /** @type {import("../events.js").Listener} */ this.boundRemoveFeature_);
        }
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<Feature>} evt Event.
   * @private
   */ addFeature_(evt) {
        const feature = evt.element;
        if (this.style_) this.applySelectedStyle_(feature);
        if (!this.getLayer(feature)) {
            const layer = this.findLayerOfFeature_(feature);
            if (layer) this.addFeatureLayerAssociation_(feature, layer);
        }
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<Feature>} evt Event.
   * @private
   */ removeFeature_(evt) {
        if (this.style_) this.restorePreviousStyle_(evt.element);
        this.removeFeatureLayerAssociation_(evt.element);
    }
    /**
   * @param {Feature} feature Feature of which to get the layer
   * @return {VectorLayer|undefined} layer, if one was found.
   * @private
   */ findLayerOfFeature_(feature) {
        const map = this.getMap();
        if (!map) return undefined;
        const layer = /** @type {VectorLayer|undefined} */ map.getAllLayers().find(function(layer) {
            if (layer instanceof (0, _vectorJsDefault.default) && layer.getSource() && layer.getSource().hasFeature(feature)) return layer;
        });
        return layer;
    }
    /**
   * @return {import("../style/Style.js").StyleLike|null} Select style.
   */ getStyle() {
        return this.style_;
    }
    /**
   * @param {Feature} feature Feature
   * @private
   */ applySelectedStyle_(feature) {
        const key = (0, _utilJs.getUid)(feature);
        if (!(key in originalFeatureStyles)) originalFeatureStyles[key] = feature.getStyle();
        feature.setStyle(this.style_);
    }
    /**
   * @param {Feature} feature Feature
   * @private
   */ restorePreviousStyle_(feature) {
        const map = this.getMap();
        if (!map) return;
        const interactions = map.getInteractions().getArray();
        for(let i = interactions.length - 1; i >= 0; --i){
            const interaction = interactions[i];
            if (interaction !== this && interaction instanceof Select && interaction.getStyle() && interaction.getFeatures().getArray().lastIndexOf(feature) !== -1) {
                feature.setStyle(interaction.getStyle());
                return;
            }
        }
        const key = (0, _utilJs.getUid)(feature);
        feature.setStyle(originalFeatureStyles[key]);
        delete originalFeatureStyles[key];
    }
    /**
   * @param {Feature} feature Feature.
   * @private
   */ removeFeatureLayerAssociation_(feature) {
        delete this.featureLayerAssociation_[(0, _utilJs.getUid)(feature)];
    }
    /**
   * Try to select a feature as if it was clicked and `addCondition` evaluated to True.
   * Unlike modifying `select.getFeatures()` directly, this respects the `filter` and `layers` options (except `multi`, which is ignored).
   * The {@link module:ol/interaction/Select~SelectEvent} fired by this won't have a mapBrowserEvent property
   * @param {Feature} feature The feature to select
   * @return {boolean} True if the feature was selected
   * @api
   */ selectFeature(feature) {
        const layer = this.findLayerOfFeature_(feature);
        if (!layer || !this.layerFilter_(layer) || !this.filter_(feature, layer)) return false;
        const features = this.getFeatures();
        if (features.getArray().includes(feature)) return false;
        this.addFeatureLayerAssociation_(feature, layer);
        features.push(feature);
        this.dispatchEvent(new SelectEvent(SelectEventType.SELECT, [
            feature
        ], [], undefined));
        return true;
    }
    /**
   * Try to deselect a feature as if it was clicked.
   * Compared to `select.getFeatures().remove(feature)` this causes a SelectEvent.
   * The {@link module:ol/interaction/Select~SelectEvent} fired by this won't have a mapBrowserEvent property
   * @param {Feature} feature The feature to deselect
   * @return {boolean} True if the feature was deselected
   * @api
   */ deselectFeature(feature) {
        const features = this.getFeatures();
        const index = features.getArray().indexOf(feature);
        if (index === -1) return false;
        features.removeAt(index);
        this.dispatchEvent(new SelectEvent(SelectEventType.SELECT, [], [
            feature
        ], undefined));
        return true;
    }
    /**
   * Try to toggle a feature as if it was clicked and `toggleCondition` was True.
   * Unlike modifying `select.getFeatures()` directly, this respects the `filter` and `layers` options (except `multi`, which is ignored).
   * The {@link module:ol/interaction/Select~SelectEvent} fired by this won't have a mapBrowserEvent property
   * @param {Feature} feature The feature to deselect
   * @api
   */ toggleFeature(feature) {
        if (!this.deselectFeature(feature)) this.selectFeature(feature);
    }
    /**
   * Deselect all features as if a user deselected them.
   * Compared to `select.getFeatures().clear()` this causes a SelectEvent.
   * The {@link module:ol/interaction/Select~SelectEvent} fired by this won't have a mapBrowserEvent property
   * @api
   */ clearSelection() {
        const features = this.getFeatures();
        if (features.getLength() !== 0) {
            const deselected = features.getArray().slice(); // shallow copy
            features.clear();
            this.dispatchEvent(new SelectEvent(SelectEventType.SELECT, [], deselected, undefined));
        }
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may change the
   * selected state of features.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!this.condition_(mapBrowserEvent)) return true;
        const add = this.addCondition_(mapBrowserEvent);
        const remove = this.removeCondition_(mapBrowserEvent);
        const toggle = this.toggleCondition_(mapBrowserEvent);
        const set = !add && !remove && !toggle;
        const map = mapBrowserEvent.map;
        const features = this.getFeatures();
        /**
     * @type {Array<Feature>}
     */ const deselected = [];
        /**
     * @type {Array<Feature>}
     */ const selected = [];
        if (set) {
            // Replace the currently selected feature(s) with the feature(s) at the
            // pixel, or clear the selected feature(s) if there is no feature at
            // the pixel.
            map.forEachFeatureAtPixel(mapBrowserEvent.pixel, (feature, layer)=>{
                if (!(feature instanceof (0, _featureJsDefault.default)) || !this.filter_(feature, layer)) return;
                this.addFeatureLayerAssociation_(feature, layer);
                selected.push(feature);
                return !this.multi_;
            }, {
                layerFilter: this.layerFilter_,
                hitTolerance: this.hitTolerance_
            });
            for(let i = features.getLength() - 1; i >= 0; --i){
                const feature = features.item(i);
                const index = selected.indexOf(feature);
                if (index === -1) {
                    features.removeAt(i);
                    deselected.push(feature);
                } else // feature is already selected
                selected.splice(index, 1);
            }
            if (selected.length !== 0) features.extend(selected);
        } else {
            // Modify the currently selected feature(s).
            map.forEachFeatureAtPixel(mapBrowserEvent.pixel, (feature, layer)=>{
                if (!(feature instanceof (0, _featureJsDefault.default)) || !this.filter_(feature, layer)) return;
                const hasFeature = features.getArray().includes(feature);
                if (hasFeature && (remove || toggle)) deselected.push(feature);
                else if (!hasFeature && (add || toggle)) {
                    this.addFeatureLayerAssociation_(feature, layer);
                    selected.push(feature);
                }
                return !this.multi_; // stop if not multi
            }, {
                layerFilter: this.layerFilter_,
                hitTolerance: this.hitTolerance_
            });
            for(let j = deselected.length - 1; j >= 0; --j)features.remove(deselected[j]);
            features.extend(selected);
        }
        if (selected.length > 0 || deselected.length > 0) this.dispatchEvent(new SelectEvent(SelectEventType.SELECT, selected, deselected, mapBrowserEvent));
        return true;
    }
}
/**
 * @return {import("../style/Style.js").StyleFunction} Styles.
 */ function getDefaultStyleFunction() {
    const styles = (0, _styleJs.createEditingStyle)();
    (0, _arrayJs.extend)(styles['Polygon'], styles['LineString']);
    (0, _arrayJs.extend)(styles['GeometryCollection'], styles['LineString']);
    return function(feature) {
        const geometry = feature.getGeometry();
        if (!geometry) return null;
        return styles[geometry.getType()];
    };
}
exports.default = Select;

},{"../Collection.js":"8dtMA","../CollectionEventType.js":"jVYia","../Feature.js":"iVSSP","../array.js":"2IuG2","../events/Event.js":"5kI1G","../events/condition.js":"2tMOf","../functions.js":"5nAKV","../layer/Vector.js":"7ga2c","../style/Style.js":"gqpPW","../util.js":"9Y20j","./Interaction.js":"1QCYK","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1rKl0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SDOControl", ()=>SDOControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
var _sdotrafficSigns = require("../SDOTrafficSigns");
class SDOControl extends (0, _controlDefault.default) {
    constructor(opt_options){
        const options = opt_options || {};
        const div = document.createElement("div");
        super({
            element: div,
            target: options.target
        });
        const this_ = this;
        div.className = "sdo-input";
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.className = "sdo-checkbox";
        checkbox.id = "sdo-input";
        checkbox.checked = false;
        checkbox.addEventListener("change", function() {
            this_.set("sdoToggle", checkbox.checked);
        });
        const label = document.createElement("label");
        label.htmlFor = "sdo-input";
        label.className = "sdo-text";
        label.innerText = "SDO";
        const area = document.createElement("p");
        area.className = "sdo-area";
        area.innerText = "Area too large";
        const signSearch = document.createElement("div");
        signSearch.className = "sdo-sign-search";
        const dataList = document.createElement("datalist");
        dataList.id = "sign-selection";
        const dataListInput = document.createElement("input");
        dataListInput.className = "sdo-datalist";
        dataListInput.autocomplete = "on";
        dataListInput.placeholder = "Select a sign type";
        dataListInput.setAttribute("list", "sign-selection");
        dataListInput.addEventListener("change", function(e) {
            if ((0, _sdotrafficSigns.UNUSED_SIGN_TYPES).includes(e.target.value)) {
                (0, _sdotrafficSigns.UNUSED_SIGN_TYPES).splice((0, _sdotrafficSigns.UNUSED_SIGN_TYPES).indexOf(e.target.value), 1);
                (0, _sdotrafficSigns.USED_SIGN_TYPES).push(e.target.value);
                this_.set("add_sign", e.target.value + String(Math.random()));
                renderSignTypes();
            }
            dataListInput.value = "";
            dataListInput.blur();
        });
        const dataListDiv = document.createElement("div");
        dataListDiv.appendChild(dataList);
        dataListDiv.appendChild(dataListInput);
        div.appendChild(checkbox);
        div.appendChild(label);
        div.appendChild(area);
        div.appendChild(dataListDiv);
        div.appendChild(signSearch);
        this.on("propertychange", function(e) {
            switch(e.key){
                case "tooLarge":
                    if (this_.get("tooLarge") === true) area.innerText = "Area too large!";
                    else area.innerText = "";
                    break;
                case "loading":
                    if (this_.get("loading") === true) area.innerText = "Fetching data...";
                    else area.innerText = "";
                    break;
                case "idTokenSet":
                    if (this_.get("idTokenSet") === false) area.innerText = "Not yet logged in.";
            }
        });
        (0, _sdotrafficSigns.USED_SIGN_TYPES).map(function(value) {
            if ((0, _sdotrafficSigns.UNUSED_SIGN_TYPES).includes(value)) (0, _sdotrafficSigns.UNUSED_SIGN_TYPES).splice((0, _sdotrafficSigns.UNUSED_SIGN_TYPES).indexOf(value), 1);
        });
        renderSignTypes();
        function renderSignTypes() {
            dataList.innerHTML = "";
            (0, _sdotrafficSigns.UNUSED_SIGN_TYPES).sort();
            (0, _sdotrafficSigns.UNUSED_SIGN_TYPES).map(function(value) {
                const option = document.createElement("option");
                option.value = value;
                option.innerHTML = value;
                dataList.appendChild(option);
            });
            signSearch.innerHTML = "";
            (0, _sdotrafficSigns.USED_SIGN_TYPES).sort();
            (0, _sdotrafficSigns.USED_SIGN_TYPES).map(function(value) {
                const removeButton = document.createElement("a");
                removeButton.className = "sdo-sign-button";
                removeButton.addEventListener("click", function(e) {
                    if ((0, _sdotrafficSigns.USED_SIGN_TYPES).includes(e.target.value)) {
                        (0, _sdotrafficSigns.USED_SIGN_TYPES).splice((0, _sdotrafficSigns.USED_SIGN_TYPES).indexOf(e.target.value), 1);
                        (0, _sdotrafficSigns.UNUSED_SIGN_TYPES).push(e.target.value);
                        this_.set("remove_sign", e.target.value + String(Math.random()));
                        renderSignTypes();
                    }
                });
                removeButton.innerHTML = "X";
                removeButton.value = value;
                const signSpan = document.createElement("span");
                signSpan.innerHTML = value + " ";
                const signSpanDiv = document.createElement("div");
                signSpanDiv.className = "sdo-sign-span-div";
                signSpanDiv.value = value;
                signSpanDiv.appendChild(signSpan);
                signSpanDiv.appendChild(removeButton);
                signSearch.appendChild(signSpanDiv);
            });
        }
    }
}

},{"ol/control/Control":"8KSMn","../SDOTrafficSigns":"2bXw4","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2bXw4":[function(require,module,exports,__globalThis) {
// List of traffic signs: https://github.com/tomtom-internal/fcd-trace/blob/edi-develop/trace-fcd/src/main/java/com/tomtom/trace/fcd/event/TrafficSign.java
// List of traffic sign icons: https://github.com/tomtom-internal/fcd-trace/tree/edi-develop/trace-render/src/main/resources/public/tomtom/icons/signs
// ! Change this array to set the default TrafficSigns to fetch from the API.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNUSED_SIGN_TYPES", ()=>UNUSED_SIGN_TYPES);
parcelHelpers.export(exports, "USED_SIGN_TYPES", ()=>USED_SIGN_TYPES);
var UNUSED_SIGN_TYPES = [
    "SPEED_LIMIT",
    "SPEED_LIMIT_END",
    "SPEED_LIMIT_CHANGE_UPCOMING",
    "NO_OVERTAKING",
    "NO_OVERTAKING_END",
    "NO_OVERTAKING_TRUCK",
    "NO_OVERTAKING_TRUCK_END",
    "ALL_RESTRICTIONS_END",
    "CITY_START",
    "CITY_END",
    "HIGHWAY",
    "HIGHWAY_END",
    "MOTORWAY",
    "MOTORWAY_END",
    "CONSTRUCTION",
    "CONSTRUCTION_END",
    "LANE_MERGE_ON_RIGHT",
    "LANE_MERGE_ON_LEFT",
    "RAILWAY_CROSSING_GENERAL",
    "RAILWAY_CROSSING_PROTECTED",
    "RAILWAY_CROSSING_UNPROTECTED",
    "ROAD_NARROWS",
    "ROAD_NARROWS_LEFT",
    "ROAD_NARROWS_RIGHT",
    "SHARP_CURVE_LEFT",
    "SHARP_CURVE_RIGHT",
    "WINDING_ROAD",
    "WINDING_ROAD_STARTING_LEFT",
    "WINDING_ROAD_STARTING_RIGHT",
    "STEEP_HILL_UPWARDS",
    "STEEP_HILL_DOWNWARDS",
    "STOP_SIGN",
    "LATERAL_WIND",
    "GENERAL_WARNING",
    "ANIMAL",
    "ICY_CONDITIONS",
    "SLIPPERY_ROAD",
    "UNEVEN_ROAD",
    "SCHOOL_ZONE",
    "CONGESTION_HAZARD",
    "ACCIDENT_HAZARD",
    "BICYCLE_CROSSING",
    "PRIORITY_OVER_ONCOMING_TRAFFIC",
    "YIELD",
    "PRIORITY_ROAD",
    "PRIORITY_ROAD_END",
    "TRAFFIC_CALMING",
    "TRAFFIC_CALMING_END",
    "ENVIRONMENTAL_AREA",
    "ENVIRONMENTAL_AREA_END",
    "INTERSECTION",
    "ROUNDABOUT",
    "PASSING_ON_LEFT",
    "PASSING_ON_RIGHT",
    "PASSING_ON_LEFT_OR_RIGHT",
    "MANDATORY_TURN_RIGHT_ONLY",
    "MANDATORY_TURN_LEFT_ONLY",
    "MANDATORY_STRAIGHT_ONLY",
    "MANDATORY_TURN_LEFT_OR_RIGHT",
    "MANDATORY_STRAIGHT_OR_LEFT",
    "MANDATORY_STRAIGHT_OR_RIGHT",
    "NO_LEFT_TURN",
    "NO_RIGHT_TURN",
    "NO_U_TURN",
    "U_TURN_ALLOWED",
    "NO_ENTRY",
    "DEAD_END",
    "HIGH_OCCUPANCY_VEHICLE_LANE",
    "TOLL",
    "SHOULDER_OPEN_FOR_TRAFFIC",
    "SHOULDER_CLOSED_FOR_TRAFFIC",
    "LANE_CLOSED",
    "LANE_CLOSED_RIGHT_MOST_LANE",
    "LANE_CLOSED_LEFT_MOST_LANE",
    "WARNING_PEDESTRIAN",
    "WARNING_CHILDREN",
    "WARNING_BUS",
    "PUBLIC_TRANSPORTATION_STOP",
    "PEDESTRIAN_CROSSING",
    "WEIGHT_RESTRICTION",
    "HEIGHT_RESTRICTION",
    "WIDTH_RESTRICTION",
    "WARNING_TRUCK_ROLLOVER",
    "SIGNAL_AHEAD",
    "NO_AGRICULTUR_VEHICLE",
    "NO_BICYCLE",
    "NO_BUS",
    "NO_HAUL_EXPLOSIVES",
    "NO_HAUL_HARMFUL_TO_WATER",
    "NO_HAUL_HAZARDOUS_MATERIAL",
    "NO_MOTORCYCLE",
    "ROAD_DISTANCE",
    "EMERGENCY_PHONE",
    "BOARD_DIRECTION",
    "TRUCK_SPEED_LIMIT",
    "TRUCK_SPEED_LIMIT_END",
    "SPEED_LIMIT_NIGHT",
    "SPEED_LIMIT_NIGHT_END",
    "MINIMUM_SPEED",
    "PEDESTRIAN_PATH",
    "PEDESTRIAN_BICYCLE_PATH",
    "BICYCLE_PATH",
    "BICYCLE_PATH_END",
    "BICYCLE_STREET",
    "BICYCLE_STREET_END",
    "CURVE_LEFT_THEN_RIGHT",
    "CURVE_RIGHT_THEN_LEFT",
    "NO_HORSE_RIDING",
    "FALLING_ROCKS",
    "YIELD_TO_ONCOMING_TRAFFIC",
    "ONEWAY_TRAFFIC",
    "ONEWAY_TRAFFIC_TO_LEFT",
    "ONEWAY_TRAFFIC_TO_RIGHT",
    "NO_VEHICLE",
    "NO_MOTOR_VEHICLE",
    "NO_PEDESTRIAN",
    "TIRE_CHAINS_MANDATORY",
    "TUNNEL",
    "NARROW_BRIDGE",
    "HUMPBACK_BRIDGE",
    "EMBANKMENT",
    "CROSSING_WITH_PRIORITY_OVER_MINOR_ROAD",
    "BRANCH_TO_THE_LEFT",
    "BRANCH_TO_THE_RIGHT",
    "TWO_WAY_TRAFFIC",
    "BUMP",
    "DIP",
    "MOVABLE_BRIDGE",
    "SLOW_DOWN",
    "INTERSECTION_T_LEFT",
    "INTERSECTION_T_RIGHT",
    "INTERSECTION_T_LEFT_RIGHT",
    "INTERSECTION_Y",
    "HONKING_PROHIBITED",
    "HIGHWAY_MARKER_1_STRIPE",
    "HIGHWAY_MARKER_2_STRIPES",
    "HIGHWAY_MARKER_3_STRIPES",
    "DIVERSION_ROUTE_END",
    "NO_STOPPING",
    "NO_STOPPING_LEFT_AND_RIGHT",
    "NO_PARKING",
    "NO_PARKING_LEFT_AND_RIGHT",
    "NO_TURN_ON_RED",
    "SPEED_LIMIT_ZONE",
    "SPEED_LIMIT_ZONE_END",
    "NO_PARKING_ZONE_END",
    "PARKING",
    "SAFETY_DISTANCE",
    "DETOUR",
    "MOTORWAY_EXIT",
    "HIGHWAY_EXIT",
    "LOW_FLYING",
    "LANE_SHIFT",
    "LANE_SHIFT_TO_LEFT",
    "LANE_SHIFT_TO_RIGHT",
    "BUS_LANE",
    "PEDESTRIAN_BICYCLE_SHARED_PATH",
    "OVERHEAD_LANE_CONTROL_CLOSING_LEFT",
    "TRINATURE",
    "GRAVEL",
    "WARNING_RIDER",
    "STOP_AHEAD",
    "YIELD_AHEAD",
    "NO_CAR_OR_BIKE",
    "ROUNDABOUT_AHEAD",
    "MANDATORY_LEFT_OR_STRAIGHT_OR_RIGHT",
    "AXLE_WEIGHT_RESTRICTION",
    "TOLL_END",
    "CHILDREN_END_TT",
    "FIRESTATION_TT",
    "NO_OUTLET_TT",
    "CANCELED_SIGN_TT",
    "EXIT_RIGHT_TT",
    "CAMERA_TT",
    "LANE_SPLIT_RIGHT_TT",
    "LOOSE_SHOULDER_TT",
    "BRIDGE_ICE_TT",
    "SCHOOL_ZONE_END_TT",
    "BUILT_UP_AREA_TT",
    "BUILT_UP_AREA_END_TT",
    "NO_PEDESTRIAN_CYCLING_TT",
    "ROAD_NUMBER_TT",
    "TUNNEL_EXIT_TT",
    "NO_TRACTOR_HORSE_TT",
    "TRAM_LANE_TT",
    "BUS_LANE_END_TT",
    "HIGH_BEAM_TT",
    "NO_HAUL_HAZARDOUS_MATERIAL_END_TT",
    "CONSTRUCTION_RIGHT_TT",
    "CONSTRUCTION_LEFT_TT",
    "LANES_TOPOLOGY_TT",
    "LANE_OPEN_TT",
    "EXIT_LEFT_TT",
    "FLAGGERS_AHEAD_TT",
    "PLAYGROUND_TT",
    "UNEVEN_LANES_TT",
    "SCHOOL_BUS_STOP_AHEAD_TT",
    "FLOOD_AREA_TT",
    "BE_PREPARED_TO_STOP_TT",
    "HIDDEN_DRIVEWAY_TT",
    "SPECIAL_NEEDS_CHILD_AREA_TT",
    "TRUCK_CROSSING_TT",
    "HAIRPIN_TURN_LEFT_TT",
    "HAIRPIN_TURN_RIGHT_TT",
    "LANE_SPLIT_LEFT_TT",
    "ENTRANCE_LEFT_TT",
    "ENTRANCE_RIGHT_TT",
    "RAILWAY_CROSSING_LEFT_TT",
    "RAILWAY_CROSSING_RIGHT_TT",
    "THRU_TRAFFIC_MERGE_LEFT_TT",
    "THRU_TRAFFIC_MERGE_RIGHT_TT",
    "SHARED_ROAD_PEDESTRIANS_BICYCLE_TT",
    "SHARED_ROAD_CARS_BICYCLE_TT",
    "DIVIDED_HIGHWAY_TT",
    "DIVIDED_HIGHWAY_END_TT",
    "AUTONOMOUS_VEHICLE_TT",
    "MULTI_SPEED_SIGN_TT",
    "TEXT_ONLY_TT",
    "ELECTRONIC_OFF_TT",
    "CONSTRUCTION_WITH_DIST_TT",
    "PEDESTRIAN_AND_BIKE_CROSSING_TT",
    "RAILWAY_CROSSING_1_TT",
    "RAILWAY_CROSSING_2_TT",
    "RAILWAY_CROSSING_3_TT",
    "WATER_COURSE_TT",
    "PARKING_BAY_TT",
    "NO_TURN_TT",
    "END_HIGH_FINE_ZONE_TT",
    "NO_LEFT_OR_RIGHT_TT",
    "NEW_LANE_RIGHT_TT",
    "NEW_LANE_LEFT_TT",
    "SHOULDER_MERGE_TT",
    "ADD_LEFT_TT",
    "ADD_RIGHT_TT",
    "ADD_FROM_LEFT_TT",
    "ADD_FROM_RIGHT_TT",
    "WRONG_WAY_TT",
    "NO_STRAIGHT_TT",
    "TRUCK_LANE_TT",
    "INTERCHANGE_TT",
    "OBSTRUCTION_ABOVE_TT",
    "BOARD_DIRECTION_ADVANCE_TT",
    "BOARD_DIRECTION_COMBINED_TT",
    "SHARED_ROAD_PEDESTRIANS_TT",
    "GATE_TT",
    "EMERGENCY_BAY_TT",
    "INTERSECTION_WITH_RAILWAY_TT",
    "LEFT_ABOVE_TFL_TT",
    "RIGHT_ABOVE_TFL_TT",
    "ALL_WAY_TT",
    "FOUR_WAY_TT",
    "SPLIT_RIGHT_TT",
    "SPLIT_LEFT_TT",
    "ROAD_H_TT",
    "DISABLED_TT",
    "SINGLE_WALKING_MAN_TT",
    "SINGLE_TT",
    "TRUCK_LIMIT_TT",
    "CITY_START_END_TT",
    "U_TURN_RIGHT_TT",
    "U_TURN_LEFT_TT",
    "ONEWAY_TRAFFIC_END_TT",
    "OBSTRUCTION_FISHBONE_LEFT_TT",
    "OBSTRUCTION_FISHBONE_RIGHT_TT",
    "OBSTRUCTION_LEFT_TT",
    "OBSTRUCTION_RIGHT_TT",
    "SHORT_POLE_TT",
    "BARREL_TT",
    "CONE_TT",
    "MANHOLE_TT",
    "LAMP_TT",
    "REFLECTOR_TT",
    "VEHICLE_LANE_TT",
    "SUPP_RECTANGULAR_EU_TT",
    "TRAFFIC_LIGHT_STRUCT_LEFT_TT",
    "TRAFFIC_LIGHT_STRUCT_RIGHT_TT",
    "TRAFFIC_LIGHT_STRUCT_BACK_TT",
    "GREEN_TFL_ARROW_TT",
    "PARKING_NOT_ALLOWED_TT",
    "PRIORITY_TURN_LEFT_TT",
    "GIVE_WAY_LEFT_TT",
    "PRIORITY_TURN_RIGHT_TT",
    "GIVE_WAY_RIGHT_TT",
    "ARROW_RECTANGULAR_TT",
    "CIRCULAR_UNKNOWN_TT",
    "BACK_OF_SIGN_TT",
    "NO_PARKING_START_TT",
    "NO_PARKING_END_TT",
    "NO_STOPPING_START_TT",
    "NO_STOPPING_END_TT",
    "STAGGERED_JUNCTION_LEFT_RIGHT_TT",
    "STAGGERED_JUNCTION_RIGHT_LEFT_TT",
    "MINOR_ROAD_CROSSING_PRIORITY_TT",
    "CURVE_LEFT_TT",
    "CURVE_RIGHT_TT",
    "DEVIATION_RIGHT_TT",
    "DEVIATION_LEFT_TT",
    "ROAD_DIAMOND_TT",
    "ROAD_X_TT",
    "ONEWAY_TRAFFIC_TOPOLOGY_TT",
    "TWO_WAY_TRAFFIC_TOPOLOGY_TT",
    "LANE_SPLIT_LEFT_TOPOLOGY_TT",
    "LANE_SPLIT_RIGHT_TOPOLOGY_TT",
    "LANE_MERGE_ON_LEFT_TOPOLOGY_TT",
    "LANE_MERGE_ON_RIGHT_TOPOLOGY_TT",
    "MERGE_TO_MAIN_FROM_LEFT_TT",
    "MERGE_TO_MAIN_FROM_RIGHT_TT",
    "AT_PEDESTRIAN_AND_BIKE_CROSSING_TT"
];
var USED_SIGN_TYPES = [];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hgUxd":[function(require,module,exports,__globalThis) {
// Everything from OpenLayers
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TrafficSign", ()=>TrafficSign);
/**
 * @param {DateInputControl} dateInputControl
 * @param {SDOControl} sdoControl
 * @param {AzureLoginControl} azureLoginControl
 * @returns
 */ parcelHelpers.export(exports, "getSDOLayer", ()=>getSDOLayer);
var _feature = require("ol/Feature");
var _featureDefault = parcelHelpers.interopDefault(_feature);
var _point = require("ol/geom/Point");
var _pointDefault = parcelHelpers.interopDefault(_point);
var _style = require("ol/style");
var _text = require("ol/style/Text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _vector = require("ol/source/Vector");
var _vectorDefault = parcelHelpers.interopDefault(_vector);
var _vector1 = require("ol/layer/Vector");
var _vectorDefault1 = parcelHelpers.interopDefault(_vector1);
var _proj = require("ol/proj");
var _render = require("ol/render");
var _polygon = require("ol/geom/Polygon");
var _polygonDefault = parcelHelpers.interopDefault(_polygon);
// Everything from luxon
var _luxon = require("luxon");
var _sdotrafficSigns = require("../SDOTrafficSigns");
// API parameters
const SIGN_URL = "/data/signs";
const DATA_SOURCE = "sdo";
const TIMEOUT_MILLIS = 0;
// Change CLUSTERING to true if you want UNCLUSTERED signs.
const CLUSTERING = true;
const CLUSTER_RADIUS = 30;
const SRS = "EPSG:900913";
const VERSION = "1.3";
const PLACEMENT_TYPE = "";
// Some parameters used to render the dial and bearing used to show the direction of the sign.
const DIAL_THICKNESS = 3;
const DIAL_LENGTH = 8;
const DIAL_BORDER = 2;
const DEG_TO_RADIANS = Math.PI / 180;
const BEARING_DIAL_Y_SHIFT = 24;
const BEARING_NEEDLE_POLY = [
    [
        0,
        0
    ],
    [
        0,
        DIAL_LENGTH
    ],
    [
        DIAL_THICKNESS,
        DIAL_LENGTH
    ],
    [
        DIAL_THICKNESS,
        0
    ],
    [
        0,
        0
    ]
];
const IMAGE_SIZE = 20;
const IMAGE_SIZE_LARGER = 30;
const CLUSTERED_ZINDEX = 9;
const UNCLUSTERED_ZINDEX = 8;
const TEXT_OFFSET = 10;
// Global variables used to abort API calls because the user has changed the map.
let abortController, signal;
class TrafficSign {
    /**
   * @param {JSON} feature The JSON object returned by the API call.
   */ constructor(feature){
        this.feature = feature;
        this.sign = feature.properties.sign;
        this.placement = feature.properties.placement;
        this.bearing = feature.properties.bearing; // Optional
        // Clustered traffic sign
        if (feature.geometry.coordinates) {
            this.coordinates = feature.geometry.coordinates;
            this.zIndex = CLUSTERED_ZINDEX;
            this.clusterSize = feature.properties.CLUSTER_SIZE;
        } else if (feature.geometry.geometries[0].coordinates) {
            this.coordinates = feature.geometry.geometries[0].coordinates;
            this.zIndex = UNCLUSTERED_ZINDEX; // We want these to be layered underneath the clustered signs
        }
        this.createSignFeature();
    }
    createSignFeature() {
        this.styles = [];
        this.signFeature = new (0, _featureDefault.default)({
            geometry: new (0, _pointDefault.default)((0, _proj.fromLonLat)(this.coordinates))
        });
        // SignStyle -- The TrafficSign icon.
        const signStyle = this.createSignStyle(), signIcon = signStyle.getImage(), signImage = signIcon.getImage();
        if (signImage.width) signIcon.setScale(IMAGE_SIZE / TrafficSign.calculateLargest(signImage.width, signImage.height));
        signImage.addEventListener("load", function() {
            signIcon.setScale(IMAGE_SIZE / TrafficSign.calculateLargest(signImage.width, signImage.height));
        });
        this.styles.push(signStyle);
        // ClusterStyle -- The cluster number.
        if (this.clusterSize) this.styles.push(this.createClusterStyle());
        // BearingStyle -- The bearing added to show the direction of the sign (hover only).
        if (this.bearing) this.styles = this.styles.concat(this.createBearingStyles());
        // InfoStyle -- The name of the sign (hover only).
        this.styles.push(this.createInfoStyle());
        this.signFeature.setStyle(this.styles);
    }
    createSignStyle() {
        const signStyle = new (0, _style.Style)({
            image: new (0, _style.Icon)({
                src: this.sign + ".png",
                // src: signIcons[this.sign] ? signIcons[this.sign] : signIcons["UNKNOWN"],
                // The initial scale is set to zero, because the size of the image is not known yet.
                scale: 0
            }),
            zIndex: this.zIndex
        });
        signStyle.type = "sign";
        return signStyle;
    }
    createClusterStyle() {
        const clusterStyle = new (0, _style.Style)({
            // The cluster style should always be layered on top of the sign icon.
            zIndex: this.zIndex + 1,
            image: new (0, _style.Circle)({
                fill: new (0, _style.Fill)({
                    color: "#526A8F"
                }),
                stroke: new (0, _style.Stroke)({
                    color: "#FFFFFF",
                    width: 1.25
                }),
                // TODO Add as constants
                radius: 8,
                displacement: [
                    10,
                    -10
                ],
                scale: 1
            }),
            text: new (0, _textDefault.default)({
                text: String(this.clusterSize),
                fill: new (0, _style.Fill)({
                    color: "#FFFFFF"
                }),
                scale: 1,
                offsetX: TEXT_OFFSET,
                offsetY: TEXT_OFFSET
            })
        });
        clusterStyle.type = "cluster";
        return clusterStyle;
    }
    createBearingStyles() {
        const theta = this.bearing * DEG_TO_RADIANS;
        // Creation of the rectangle of the dial.
        let canvas = document.createElement("canvas");
        let vectorContext = (0, _render.toContext)(canvas.getContext("2d"), {
            size: [
                DIAL_THICKNESS,
                DIAL_LENGTH
            ],
            pixelRatio: 1
        });
        vectorContext.setStyle(new (0, _style.Style)({
            fill: new (0, _style.Fill)({
                color: "#006E00"
            })
        }));
        vectorContext.drawGeometry(new (0, _polygonDefault.default)([
            BEARING_NEEDLE_POLY
        ]));
        const dialStyle = new (0, _style.Style)({
            zIndex: CLUSTERED_ZINDEX + 2,
            image: new (0, _style.Circle)({
                radius: DIAL_LENGTH,
                fill: new (0, _style.Fill)({
                    color: "#B4FAB4"
                }),
                stroke: new (0, _style.Stroke)({
                    color: "#009600",
                    width: DIAL_BORDER
                }),
                displacement: [
                    0,
                    24
                ],
                scale: 0
            })
        });
        dialStyle.type = "dial";
        const needleStyle = new (0, _style.Style)({
            zIndex: CLUSTERED_ZINDEX + 5,
            image: new (0, _style.Icon)({
                img: canvas,
                imgSize: [
                    DIAL_THICKNESS,
                    DIAL_LENGTH
                ],
                rotation: theta,
                anchorOrigin: "bottom-left",
                offsetOrigin: "bottom-left",
                anchor: [
                    0.5,
                    0
                ],
                // Because the displacement happens in the direction of the orientation, theta has to be accounted for
                // when placing the needle in the middle of the dial.
                displacement: [
                    -BEARING_DIAL_Y_SHIFT * Math.sin(theta),
                    BEARING_DIAL_Y_SHIFT * Math.cos(theta)
                ],
                scale: 0
            })
        });
        needleStyle.type = "needle";
        return [
            dialStyle,
            needleStyle
        ];
    }
    createInfoStyle() {
        const InfoStyle = new (0, _style.Style)({
            text: new (0, _textDefault.default)({
                text: `${this.sign} (${this.placement})`,
                offsetX: 0,
                offsetY: -50,
                scale: 0,
                fill: new (0, _style.Fill)({
                    color: "#FFFFFF"
                }),
                backgroundFill: new (0, _style.Fill)({
                    color: "rgba(0, 0, 0, 0.4)"
                }),
                padding: 0
            })
        });
        InfoStyle.type = "info";
        return InfoStyle;
    }
    /**
   * @param {number} width Width in pixels
   * @param {number} height Height in pixels
   */ static calculateLargest(width, height) {
        let largest = Math.max(width, height);
        if (Math.min(width, height) <= largest / 2) largest *= 0.75;
        return largest;
    }
    /**
   * @param {SelectEvent} e
   */ static hoverSelectHandler(e) {
        if (e.selected.length !== 0) {
            if (e.selected[0] instanceof (0, _featureDefault.default)) TrafficSign.changeFeatureScale(e.selected[0], true);
        }
        if (e.deselected.length !== 0) {
            if (e.deselected[0] instanceof (0, _featureDefault.default)) TrafficSign.changeFeatureScale(e.deselected[0], false);
        }
        // Force the layer to rerender.
        TrafficSign.sdoLayer.getSource().changed();
    }
    /**
   * @param {Feature} feature
   * @param {boolean} hover
   */ static changeFeatureScale(feature, hover) {
        var featureStyle = feature.getStyle();
        let icon, image;
        // This should only apply to WKT objects, as the SDO features should have styles.
        if (featureStyle == null) return;
        // Forcefully change featureStyle to an array if the feature only has one style.
        // This way, the following map function always succeeds.
        if (!Array.isArray(featureStyle)) featureStyle = [
            featureStyle
        ];
        // This is a useless check but allows the map function to understand the type of 'style'.
        if (Array.isArray(featureStyle)) featureStyle.map(function(style) {
            switch(style.type){
                case "sign":
                    icon = style.getImage();
                    image = icon.getImage();
                    icon.setScale((hover ? IMAGE_SIZE_LARGER : IMAGE_SIZE) / TrafficSign.calculateLargest(image.width, image.height));
                    break;
                case "cluster":
                    icon = style.getImage();
                    icon.setScale(hover ? 1.3 : 1);
                    style.getText().setScale(hover ? 1.3 : 1);
                    style.getText().setOffsetX((hover ? 1.3 : Math.pow(1.3, -1)) * style.getText().getOffsetX());
                    style.getText().setOffsetY((hover ? 1.3 : Math.pow(1.3, -1)) * style.getText().getOffsetY());
                    break;
                case "dial":
                case "needle":
                    icon = style.getImage();
                    icon.setScale(hover ? 1 : 0);
                    break;
                case "info":
                    style.getText().setScale(hover ? 1 : 0);
                    style.getText().setPadding(hover ? [
                        8,
                        8,
                        8,
                        8
                    ] : null);
                    break;
            }
            if (typeof style.getZIndex === "function") style.setZIndex(hover ? style.getZIndex() + 3 : style.getZIndex() - 3);
        });
    }
}
/**
 * @param {string} startDate
 * @param {string} endDate
 */ function convertDateAndTime(startDate, endDate) {
    // https://confluence.tomtomgroup.com/display/FCD/GeoJSON+Observations for date and time formats.
    const TIME = (0, _luxon.DateTime).fromISO(startDate).toISODate() + "/" + (0, _luxon.DateTime).fromISO(endDate).toISODate();
    return {
        TIME: TIME
    };
}
/**
 * @param {SDOControl} sdoControl
 */ function calculateArea(sdoControl) {
    const bbox = sdoControl.get("bbox");
    return Math.abs((bbox[0] - bbox[2]) * Math.abs(bbox[1] - bbox[3]));
}
/**
 * @param {DateInputControl} dateInputControl
 * @param {SDOControl} sdoControl
 * @param {AzureLoginControl} azureLoginControl
 * @param {VectorSource} vectorSource
 * @param {VectorLayer} vectorLayer
 */ function propertyChangeHandler(dateInputControl, sdoControl, azureLoginControl, vectorSource, vectorLayer) {
    if (!azureLoginControl.get("idToken")) {
        vectorLayer.setVisible(false);
        sdoControl.set("idTokenSet", false);
    } else {
        sdoControl.set("idTokenSet", true);
        if (sdoControl.get("sdoToggle") == true) {
            vectorLayer.setVisible(true);
            updateTrafficSigns(dateInputControl, sdoControl, azureLoginControl, vectorSource, vectorLayer);
        } else // When sdoToggle is not set, the checkbox is not checked, and so the layer is made invisible.
        vectorLayer.setVisible(false);
    }
}
/**
 * @param {DateInputControl} dateInputControl
 * @param {SDOControl} sdoControl
 * @param {AzureLoginControl} azureLoginControl
 * @param {VectorSource} vectorSource
 * @param {VectorLayer} vectorLayer
 */ function updateTrafficSigns(dateInputControl, sdoControl, azureLoginControl, vectorSource, vectorLayer) {
    if (abortController) abortController.abort();
    // 'signal' is a global variable used to abort fetch requests when a new request is already made.
    // The API is rather slow, so it would be a waste of recourses to let the fetch continue to work
    // after a new move on the map was made.
    abortController = new AbortController();
    signal = abortController.signal;
    // The area for the traffic signs can be 12 km2 maximum.
    if (calculateArea(sdoControl) <= 12 * Math.pow(10, 6)) {
        if (vectorLayer) vectorLayer.setVisible(true);
        sdoControl.set("tooLarge", false);
        sdoControl.set("loading", true);
        const dateAndTimeParams = convertDateAndTime(dateInputControl.get("startDate"), dateInputControl.get("endDate"));
        const searchParams = new URLSearchParams();
        searchParams.set("DATA_SOURCE", DATA_SOURCE);
        searchParams.set("TIMEOUT_MILLIS", TIMEOUT_MILLIS);
        searchParams.set("SIGN_TYPE", (0, _sdotrafficSigns.USED_SIGN_TYPES));
        searchParams.set("CLUSTERING", CLUSTERING);
        searchParams.set("CLUSTER_RADIUS", CLUSTER_RADIUS);
        searchParams.set("TIME", dateAndTimeParams.TIME);
        searchParams.set("bbox", sdoControl.get("bbox"));
        searchParams.set("SRS", SRS);
        searchParams.set("VERSION", VERSION);
        searchParams.set("PLACEMENT_TYPE", PLACEMENT_TYPE);
        const headers = {
            Authorization: "Bearer " + azureLoginControl.get("idToken")
        };
        fetch(SIGN_URL + "?" + searchParams.toString(), {
            signal,
            headers
        }).then(function(response) {
            return response.json();
        }).then(function(jsonResponse) {
            // All TrafficSigns are removed from the map upon a new JSON response from the API.
            vectorSource.clear();
            jsonResponse.features.map(function(feature) {
                const trafficSign = new TrafficSign(feature, vectorSource);
                vectorSource.addFeature(trafficSign.signFeature);
            });
            sdoControl.set("loading", false);
        }).catch(function(error) {
            if (error.name === "AbortError") ;
            else if (error.name === "SyntaxError") {
                // No data is available.
                console.error("No SDO data is available for this date range.");
                sdoControl.set("loading", false);
            } else console.error(error);
        });
    } else {
        sdoControl.set("loading", false);
        sdoControl.set("tooLarge", true);
        if (vectorLayer) vectorLayer.setVisible(false);
    }
}
function getSDOLayer(dateInputControl, sdoControl, azureLoginControl) {
    const vectorSource = new (0, _vectorDefault.default)({
        features: []
    });
    const vectorLayer = new (0, _vectorDefault1.default)({
        source: vectorSource,
        zIndex: 10
    });
    sdoControl.on("propertychange", function(e) {
        if (e.key !== "loading" && e.key !== "tooLarge") propertyChangeHandler(dateInputControl, sdoControl, azureLoginControl, vectorSource, vectorLayer);
    });
    dateInputControl.on("propertychange", function() {
        propertyChangeHandler(dateInputControl, sdoControl, azureLoginControl, vectorSource, vectorLayer);
    });
    azureLoginControl.on("propertychange", function() {
        propertyChangeHandler(dateInputControl, sdoControl, azureLoginControl, vectorSource, vectorLayer);
    });
    return vectorLayer;
}

},{"ol/Feature":"iVSSP","ol/geom/Point":"95T6m","ol/style":[["Circle","3Wl62","default"],["Fill","24G0i","default"],["Icon","ib4Ft","default"],["Stroke","cese4","default"],["Style","gqpPW","default"]],"ol/style/Text":"118sC","ol/source/Vector":"7zHxp","ol/layer/Vector":"7ga2c","ol/proj":"gN0IK","ol/render":"ao3FA","ol/geom/Polygon":"3zws5","luxon":"6apd3","../SDOTrafficSigns":"2bXw4","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ao3FA":[function(require,module,exports,__globalThis) {
/**
 * @module ol/render
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} State
 * @property {CanvasRenderingContext2D} context Canvas context that the layer is being rendered to.
 * @property {import("./Feature.js").FeatureLike} feature Feature.
 * @property {import("./geom/SimpleGeometry.js").default} geometry Geometry.
 * @property {number} pixelRatio Pixel ratio used by the layer renderer.
 * @property {number} resolution Resolution that the render batch was created and optimized for.
 * This is not the view's resolution that is being rendered.
 * @property {number} rotation Rotation of the rendered layer in radians.
 */ /**
 * A function to be used when sorting features before rendering.
 * It takes two instances of {@link module:ol/Feature~Feature} or
 * {@link module:ol/render/Feature~RenderFeature} and returns a `{number}`.
 *
 * @typedef {function(import("./Feature.js").FeatureLike, import("./Feature.js").FeatureLike):number} OrderFunction
 */ /**
 * @typedef {Object} ToContextOptions
 * @property {import("./size.js").Size} [size] Desired size of the canvas in css
 * pixels. When provided, both canvas and css size will be set according to the
 * `pixelRatio`. If not provided, the current canvas and css sizes will not be
 * altered.
 * @property {number} [pixelRatio=window.devicePixelRatio] Pixel ratio (canvas
 * pixel to css pixel ratio) for the canvas.
 */ /**
 * Binds a Canvas Immediate API to a canvas context, to allow drawing geometries
 * to the context's canvas.
 *
 * The units for geometry coordinates are css pixels relative to the top left
 * corner of the canvas element.
 * ```js
 * import {toContext} from 'ol/render.js';
 * import Fill from 'ol/style/Fill.js';
 * import Polygon from 'ol/geom/Polygon.js';
 *
 * const canvas = document.createElement('canvas');
 * const render = toContext(
 *     canvas.getContext('2d'),
 *     {size: [100, 100]}
 * );
 * render.setFillStrokeStyle(new Fill({ color: blue }));
 * render.drawPolygon(
 *     new Polygon([[[0, 0], [100, 100], [100, 0], [0, 0]]])
 * );
 * ```
 *
 * @param {CanvasRenderingContext2D} context Canvas context.
 * @param {ToContextOptions} [options] Options.
 * @return {CanvasImmediateRenderer} Canvas Immediate.
 * @api
 */ parcelHelpers.export(exports, "toContext", ()=>toContext);
/**
 * Gets a vector context for drawing to the event's canvas.
 * @param {import("./render/Event.js").default} event Render event.
 * @return {CanvasImmediateRenderer} Vector context.
 * @api
 */ parcelHelpers.export(exports, "getVectorContext", ()=>getVectorContext);
/**
 * Gets the pixel of the event's canvas context from the map viewport's CSS pixel.
 * @param {import("./render/Event.js").default} event Render event.
 * @param {import("./pixel.js").Pixel} pixel CSS pixel relative to the top-left
 * corner of the map viewport.
 * @return {import("./pixel.js").Pixel} Pixel on the event's canvas context.
 * @api
 */ parcelHelpers.export(exports, "getRenderPixel", ()=>getRenderPixel);
var _hasJs = require("./has.js");
var _projJs = require("./proj.js");
var _immediateJs = require("./render/canvas/Immediate.js");
var _immediateJsDefault = parcelHelpers.interopDefault(_immediateJs);
var _vectorJs = require("./renderer/vector.js");
var _transformJs = require("./transform.js");
function toContext(context, options) {
    const canvas = context.canvas;
    options = options ? options : {};
    const pixelRatio = options.pixelRatio || (0, _hasJs.DEVICE_PIXEL_RATIO);
    const size = options.size;
    if (size) {
        canvas.width = size[0] * pixelRatio;
        canvas.height = size[1] * pixelRatio;
        canvas.style.width = size[0] + 'px';
        canvas.style.height = size[1] + 'px';
    }
    const extent = [
        0,
        0,
        canvas.width,
        canvas.height
    ];
    const transform = (0, _transformJs.scale)((0, _transformJs.create)(), pixelRatio, pixelRatio);
    const squaredTolerance = (0, _vectorJs.getSquaredTolerance)(1, pixelRatio);
    return new (0, _immediateJsDefault.default)(context, pixelRatio, extent, transform, 0, squaredTolerance);
}
function getVectorContext(event) {
    if (!(event.context instanceof CanvasRenderingContext2D)) throw new Error('Only works for render events from Canvas 2D layers');
    // canvas may be at a different pixel ratio than frameState.pixelRatio
    const inversePixelTransform = event.inversePixelTransform;
    const frameState = event.frameState;
    if (!inversePixelTransform || !frameState) throw new Error('Only works for render events from Canvas 2D layers');
    const extent = frameState.extent;
    if (!extent) throw new Error('Missing frame extent');
    const a = inversePixelTransform[0];
    const b = inversePixelTransform[1];
    const canvasPixelRatio = Math.sqrt(a * a + b * b);
    const transform = (0, _transformJs.multiply)(inversePixelTransform.slice(), frameState.coordinateToPixelTransform);
    const squaredTolerance = (0, _vectorJs.getSquaredTolerance)(frameState.viewState.resolution, canvasPixelRatio);
    let userTransform;
    const userProjection = (0, _projJs.getUserProjection)();
    if (userProjection) userTransform = (0, _projJs.getTransformFromProjections)(userProjection, frameState.viewState.projection);
    return new (0, _immediateJsDefault.default)(event.context, canvasPixelRatio, extent, transform, frameState.viewState.rotation, squaredTolerance, userTransform || undefined);
}
function getRenderPixel(event, pixel) {
    const inversePixelTransform = event.inversePixelTransform;
    if (!inversePixelTransform) throw new Error('Missing inversePixelTransform');
    return (0, _transformJs.apply)(inversePixelTransform, pixel.slice(0));
}

},{"./has.js":"hbGE6","./proj.js":"gN0IK","./render/canvas/Immediate.js":"fx7AZ","./renderer/vector.js":"fFxjb","./transform.js":"7TqcG","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6apd3":[function(require,module,exports,__globalThis) {
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateTime", ()=>DateTime);
parcelHelpers.export(exports, "Duration", ()=>Duration);
parcelHelpers.export(exports, "FixedOffsetZone", ()=>FixedOffsetZone);
parcelHelpers.export(exports, "IANAZone", ()=>IANAZone);
parcelHelpers.export(exports, "Info", ()=>Info);
parcelHelpers.export(exports, "Interval", ()=>Interval);
parcelHelpers.export(exports, "InvalidZone", ()=>InvalidZone);
parcelHelpers.export(exports, "Settings", ()=>Settings);
parcelHelpers.export(exports, "SystemZone", ()=>SystemZone);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
parcelHelpers.export(exports, "Zone", ()=>Zone);
class LuxonError extends Error {
}
/**
 * @private
 */ class InvalidDateTimeError extends LuxonError {
    constructor(reason){
        super(`Invalid DateTime: ${reason.toMessage()}`);
    }
}
/**
 * @private
 */ class InvalidIntervalError extends LuxonError {
    constructor(reason){
        super(`Invalid Interval: ${reason.toMessage()}`);
    }
}
/**
 * @private
 */ class InvalidDurationError extends LuxonError {
    constructor(reason){
        super(`Invalid Duration: ${reason.toMessage()}`);
    }
}
/**
 * @private
 */ class ConflictingSpecificationError extends LuxonError {
}
/**
 * @private
 */ class InvalidUnitError extends LuxonError {
    constructor(unit){
        super(`Invalid unit ${unit}`);
    }
}
/**
 * @private
 */ class InvalidArgumentError extends LuxonError {
}
/**
 * @private
 */ class ZoneIsAbstractError extends LuxonError {
    constructor(){
        super("Zone is an abstract class");
    }
}
/**
 * @private
 */ const n = "numeric", s = "short", l = "long";
const DATE_SHORT = {
    year: n,
    month: n,
    day: n
};
const DATE_MED = {
    year: n,
    month: s,
    day: n
};
const DATE_MED_WITH_WEEKDAY = {
    year: n,
    month: s,
    day: n,
    weekday: s
};
const DATE_FULL = {
    year: n,
    month: l,
    day: n
};
const DATE_HUGE = {
    year: n,
    month: l,
    day: n,
    weekday: l
};
const TIME_SIMPLE = {
    hour: n,
    minute: n
};
const TIME_WITH_SECONDS = {
    hour: n,
    minute: n,
    second: n
};
const TIME_WITH_SHORT_OFFSET = {
    hour: n,
    minute: n,
    second: n,
    timeZoneName: s
};
const TIME_WITH_LONG_OFFSET = {
    hour: n,
    minute: n,
    second: n,
    timeZoneName: l
};
const TIME_24_SIMPLE = {
    hour: n,
    minute: n,
    hourCycle: "h23"
};
const TIME_24_WITH_SECONDS = {
    hour: n,
    minute: n,
    second: n,
    hourCycle: "h23"
};
const TIME_24_WITH_SHORT_OFFSET = {
    hour: n,
    minute: n,
    second: n,
    hourCycle: "h23",
    timeZoneName: s
};
const TIME_24_WITH_LONG_OFFSET = {
    hour: n,
    minute: n,
    second: n,
    hourCycle: "h23",
    timeZoneName: l
};
const DATETIME_SHORT = {
    year: n,
    month: n,
    day: n,
    hour: n,
    minute: n
};
const DATETIME_SHORT_WITH_SECONDS = {
    year: n,
    month: n,
    day: n,
    hour: n,
    minute: n,
    second: n
};
const DATETIME_MED = {
    year: n,
    month: s,
    day: n,
    hour: n,
    minute: n
};
const DATETIME_MED_WITH_SECONDS = {
    year: n,
    month: s,
    day: n,
    hour: n,
    minute: n,
    second: n
};
const DATETIME_MED_WITH_WEEKDAY = {
    year: n,
    month: s,
    day: n,
    weekday: s,
    hour: n,
    minute: n
};
const DATETIME_FULL = {
    year: n,
    month: l,
    day: n,
    hour: n,
    minute: n,
    timeZoneName: s
};
const DATETIME_FULL_WITH_SECONDS = {
    year: n,
    month: l,
    day: n,
    hour: n,
    minute: n,
    second: n,
    timeZoneName: s
};
const DATETIME_HUGE = {
    year: n,
    month: l,
    day: n,
    weekday: l,
    hour: n,
    minute: n,
    timeZoneName: l
};
const DATETIME_HUGE_WITH_SECONDS = {
    year: n,
    month: l,
    day: n,
    weekday: l,
    hour: n,
    minute: n,
    second: n,
    timeZoneName: l
};
/**
 * @interface
 */ class Zone {
    /**
   * The type of zone
   * @abstract
   * @type {string}
   */ get type() {
        throw new ZoneIsAbstractError();
    }
    /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */ get name() {
        throw new ZoneIsAbstractError();
    }
    /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */ get ianaName() {
        return this.name;
    }
    /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */ get isUniversal() {
        throw new ZoneIsAbstractError();
    }
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ offsetName(ts, opts) {
        throw new ZoneIsAbstractError();
    }
    /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ formatOffset(ts, format) {
        throw new ZoneIsAbstractError();
    }
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ offset(ts) {
        throw new ZoneIsAbstractError();
    }
    /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ equals(otherZone) {
        throw new ZoneIsAbstractError();
    }
    /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */ get isValid() {
        throw new ZoneIsAbstractError();
    }
}
let singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ class SystemZone extends Zone {
    /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */ static get instance() {
        if (singleton$1 === null) singleton$1 = new SystemZone();
        return singleton$1;
    }
    /** @override **/ get type() {
        return "system";
    }
    /** @override **/ get name() {
        return new Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    /** @override **/ get isUniversal() {
        return false;
    }
    /** @override **/ offsetName(ts, { format, locale }) {
        return parseZoneInfo(ts, format, locale);
    }
    /** @override **/ formatOffset(ts, format) {
        return formatOffset(this.offset(ts), format);
    }
    /** @override **/ offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    }
    /** @override **/ equals(otherZone) {
        return otherZone.type === "system";
    }
    /** @override **/ get isValid() {
        return true;
    }
}
const dtfCache = new Map();
function makeDTF(zoneName) {
    let dtf = dtfCache.get(zoneName);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: zoneName,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            era: "short"
        });
        dtfCache.set(zoneName, dtf);
    }
    return dtf;
}
const typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function hackyOffset(dtf, date) {
    const formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function partsOffset(dtf, date) {
    const formatted = dtf.formatToParts(date);
    const filled = [];
    for(let i = 0; i < formatted.length; i++){
        const { type, value } = formatted[i];
        const pos = typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
const ianaZoneCache = new Map();
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ class IANAZone extends Zone {
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ static create(name) {
        let zone = ianaZoneCache.get(name);
        if (zone === undefined) ianaZoneCache.set(name, zone = new IANAZone(name));
        return zone;
    }
    /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ static resetCache() {
        ianaZoneCache.clear();
        dtfCache.clear();
    }
    /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */ static isValidSpecifier(s) {
        return this.isValidZone(s);
    }
    /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */ static isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    }
    constructor(name){
        super();
        /** @private **/ this.zoneName = name;
        /** @private **/ this.valid = IANAZone.isValidZone(name);
    }
    /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */ get type() {
        return "iana";
    }
    /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */ get name() {
        return this.zoneName;
    }
    /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */ get isUniversal() {
        return false;
    }
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ offsetName(ts, { format, locale }) {
        return parseZoneInfo(ts, format, locale, this.name);
    }
    /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ formatOffset(ts, format) {
        return formatOffset(this.offset(ts), format);
    }
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ offset(ts) {
        if (!this.valid) return NaN;
        const date = new Date(ts);
        if (isNaN(date)) return NaN;
        const dtf = makeDTF(this.name);
        let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        const adjustedHour = hour === 24 ? 0 : hour;
        const asUTC = objToLocalTS({
            year,
            month,
            day,
            hour: adjustedHour,
            minute,
            second,
            millisecond: 0
        });
        let asTS = +date;
        const over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    }
    /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    }
    /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */ get isValid() {
        return this.valid;
    }
}
// todo - remap caching
let intlLFCache = {};
function getCachedLF(locString, opts = {}) {
    const key = JSON.stringify([
        locString,
        opts
    ]);
    let dtf = intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        intlLFCache[key] = dtf;
    }
    return dtf;
}
const intlDTCache = new Map();
function getCachedDTF(locString, opts = {}) {
    const key = JSON.stringify([
        locString,
        opts
    ]);
    let dtf = intlDTCache.get(key);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        intlDTCache.set(key, dtf);
    }
    return dtf;
}
const intlNumCache = new Map();
function getCachedINF(locString, opts = {}) {
    const key = JSON.stringify([
        locString,
        opts
    ]);
    let inf = intlNumCache.get(key);
    if (inf === undefined) {
        inf = new Intl.NumberFormat(locString, opts);
        intlNumCache.set(key, inf);
    }
    return inf;
}
const intlRelCache = new Map();
function getCachedRTF(locString, opts = {}) {
    const { base, ...cacheKeyOpts } = opts; // exclude `base` from the options
    const key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    let inf = intlRelCache.get(key);
    if (inf === undefined) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        intlRelCache.set(key, inf);
    }
    return inf;
}
let sysLocaleCache = null;
function systemLocale() {
    if (sysLocaleCache) return sysLocaleCache;
    else {
        sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return sysLocaleCache;
    }
}
const intlResolvedOptionsCache = new Map();
function getCachedIntResolvedOptions(locString) {
    let opts = intlResolvedOptionsCache.get(locString);
    if (opts === undefined) {
        opts = new Intl.DateTimeFormat(locString).resolvedOptions();
        intlResolvedOptionsCache.set(locString, opts);
    }
    return opts;
}
const weekInfoCache = new Map();
function getCachedWeekInfo(locString) {
    let data = weekInfoCache.get(locString);
    if (!data) {
        const locale = new Intl.Locale(locString);
        // browsers currently implement this as a property, but spec says it should be a getter function
        data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
        // minimalDays was removed from WeekInfo: https://github.com/tc39/proposal-intl-locale-info/issues/86
        if (!("minimalDays" in data)) data = {
            ...fallbackWeekSettings,
            ...data
        };
        weekInfoCache.set(locString, data);
    }
    return data;
}
function parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    const xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    const uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        let options;
        let selectedStr;
        try {
            options = getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            const smaller = localeStr.substring(0, uIndex);
            options = getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        const { numberingSystem, calendar } = options;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += `-ca-${outputCalendar}`;
        if (numberingSystem) localeStr += `-nu-${numberingSystem}`;
        return localeStr;
    } else return localeStr;
}
function mapMonths(f) {
    const ms = [];
    for(let i = 1; i <= 12; i++){
        const dt = DateTime.utc(2009, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function mapWeekdays(f) {
    const ms = [];
    for(let i = 1; i <= 7; i++){
        const dt = DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function listStuff(loc, length, englishFn, intlFn) {
    const mode = loc.listingMode();
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || getCachedIntResolvedOptions(loc.locale).numberingSystem === "latn";
}
/**
 * @private
 */ class PolyNumberFormatter {
    constructor(intl, forceSimple, opts){
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        const { padTo, floor, ...otherOpts } = opts;
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            const intlOpts = {
                useGrouping: false,
                ...opts
            };
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = getCachedINF(intl, intlOpts);
        }
    }
    format(i) {
        if (this.inf) {
            const fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            const fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
            return padStart(fixed, this.padTo);
        }
    }
}
/**
 * @private
 */ class PolyDateFormatter {
    constructor(dt, intl, opts){
        this.opts = opts;
        this.originalZone = undefined;
        let z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            const gmtOffset = -1 * (dt.offset / 60);
            const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
            if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        const intlOpts = {
            ...this.opts
        };
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = getCachedDTF(intl, intlOpts);
    }
    format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(({ value })=>value).join("");
        return this.dtf.format(this.dt.toJSDate());
    }
    formatToParts() {
        const parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map((part)=>{
            if (part.type === "timeZoneName") {
                const offsetName = this.originalZone.offsetName(this.dt.ts, {
                    locale: this.dt.locale,
                    format: this.opts.timeZoneName
                });
                return {
                    ...part,
                    value: offsetName
                };
            } else return part;
        });
        return parts;
    }
    resolvedOptions() {
        return this.dtf.resolvedOptions();
    }
}
/**
 * @private
 */ class PolyRelFormatter {
    constructor(intl, isEnglish, opts){
        this.opts = {
            style: "long",
            ...opts
        };
        if (!isEnglish && hasRelative()) this.rtf = getCachedRTF(intl, opts);
    }
    format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
    formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    }
}
const fallbackWeekSettings = {
    firstDay: 1,
    minimalDays: 4,
    weekend: [
        6,
        7
    ]
};
/**
 * @private
 */ class Locale {
    static fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
    }
    static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
        const specifiedLocale = locale || Settings.defaultLocale;
        // the system locale is useful for human-readable strings but annoying for parsing/formatting known formats
        const localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
        const numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
        const outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
        const weekSettingsR = validateWeekSettings(weekSettings) || Settings.defaultWeekSettings;
        return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
    }
    static resetCache() {
        sysLocaleCache = null;
        intlDTCache.clear();
        intlNumCache.clear();
        intlRelCache.clear();
        intlResolvedOptionsCache.clear();
        weekInfoCache.clear();
    }
    static fromObject({ locale, numberingSystem, outputCalendar, weekSettings } = {}) {
        return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
    }
    constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale){
        const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString(locale);
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.weekSettings = weekSettings;
        this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    get fastNumbers() {
        if (this.fastNumbersCached == null) this.fastNumbersCached = supportsFastNumbers(this);
        return this.fastNumbersCached;
    }
    listingMode() {
        const isActuallyEn = this.isEnglish();
        const hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    }
    clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    }
    redefaultToEN(alts = {}) {
        return this.clone({
            ...alts,
            defaultToEN: true
        });
    }
    redefaultToSystem(alts = {}) {
        return this.clone({
            ...alts,
            defaultToEN: false
        });
    }
    months(length, format = false) {
        return listStuff(this, length, months, ()=>{
            // Workaround for "ja" locale: formatToParts does not label all parts of the month
            // as "month" and for this locale there is no difference between "format" and "non-format".
            // As such, just use format() instead of formatToParts() and take the whole string
            const monthSpecialCase = this.intl === "ja" || this.intl.startsWith("ja-");
            format &= !monthSpecialCase;
            const intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!this.monthsCache[formatStr][length]) {
                const mapper = !monthSpecialCase ? (dt)=>this.extract(dt, intl, "month") : (dt)=>this.dtFormatter(dt, intl).format();
                this.monthsCache[formatStr][length] = mapMonths(mapper);
            }
            return this.monthsCache[formatStr][length];
        });
    }
    weekdays(length, format = false) {
        return listStuff(this, length, weekdays, ()=>{
            const intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!this.weekdaysCache[formatStr][length]) this.weekdaysCache[formatStr][length] = mapWeekdays((dt)=>this.extract(dt, intl, "weekday"));
            return this.weekdaysCache[formatStr][length];
        });
    }
    meridiems() {
        return listStuff(this, undefined, ()=>meridiems, ()=>{
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!this.meridiemCache) {
                const intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                this.meridiemCache = [
                    DateTime.utc(2016, 11, 13, 9),
                    DateTime.utc(2016, 11, 13, 19)
                ].map((dt)=>this.extract(dt, intl, "dayperiod"));
            }
            return this.meridiemCache;
        });
    }
    eras(length) {
        return listStuff(this, length, eras, ()=>{
            const intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!this.eraCache[length]) this.eraCache[length] = [
                DateTime.utc(-40, 1, 1),
                DateTime.utc(2017, 1, 1)
            ].map((dt)=>this.extract(dt, intl, "era"));
            return this.eraCache[length];
        });
    }
    extract(dt, intlOpts, field) {
        const df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find((m)=>m.type.toLowerCase() === field);
        return matching ? matching.value : null;
    }
    numberFormatter(opts = {}) {
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    }
    dtFormatter(dt, intlOpts = {}) {
        return new PolyDateFormatter(dt, this.intl, intlOpts);
    }
    relFormatter(opts = {}) {
        return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
    }
    listFormatter(opts = {}) {
        return getCachedLF(this.intl, opts);
    }
    isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || getCachedIntResolvedOptions(this.intl).locale.startsWith("en-us");
    }
    getWeekSettings() {
        if (this.weekSettings) return this.weekSettings;
        else if (!hasLocaleWeekInfo()) return fallbackWeekSettings;
        else return getCachedWeekInfo(this.locale);
    }
    getStartOfWeek() {
        return this.getWeekSettings().firstDay;
    }
    getMinDaysInFirstWeek() {
        return this.getWeekSettings().minimalDays;
    }
    getWeekendDays() {
        return this.getWeekSettings().weekend;
    }
    equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    }
    toString() {
        return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
    }
}
let singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ class FixedOffsetZone extends Zone {
    /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */ static get utcInstance() {
        if (singleton === null) singleton = new FixedOffsetZone(0);
        return singleton;
    }
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ static instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    }
    /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */ static parseSpecifier(s) {
        if (s) {
            const r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone(signedOffset(r[1], r[2]));
        }
        return null;
    }
    constructor(offset){
        super();
        /** @private **/ this.fixed = offset;
    }
    /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */ get type() {
        return "fixed";
    }
    /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */ get name() {
        return this.fixed === 0 ? "UTC" : `UTC${formatOffset(this.fixed, "narrow")}`;
    }
    /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */ get ianaName() {
        if (this.fixed === 0) return "Etc/UTC";
        else return `Etc/GMT${formatOffset(-this.fixed, "narrow")}`;
    }
    /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */ offsetName() {
        return this.name;
    }
    /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ formatOffset(ts, format) {
        return formatOffset(this.fixed, format);
    }
    /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */ get isUniversal() {
        return true;
    }
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */ offset() {
        return this.fixed;
    }
    /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    }
    /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */ get isValid() {
        return true;
    }
}
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ class InvalidZone extends Zone {
    constructor(zoneName){
        super();
        /**  @private */ this.zoneName = zoneName;
    }
    /** @override **/ get type() {
        return "invalid";
    }
    /** @override **/ get name() {
        return this.zoneName;
    }
    /** @override **/ get isUniversal() {
        return false;
    }
    /** @override **/ offsetName() {
        return null;
    }
    /** @override **/ formatOffset() {
        return "";
    }
    /** @override **/ offset() {
        return NaN;
    }
    /** @override **/ equals() {
        return false;
    }
    /** @override **/ get isValid() {
        return false;
    }
}
/**
 * @private
 */ function normalizeZone(input, defaultZone) {
    if (isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof Zone) return input;
    else if (isString(input)) {
        const lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return SystemZone.instance;
        else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;
        else return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
    } else if (isNumber(input)) return FixedOffsetZone.instance(input);
    else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new InvalidZone(input);
}
const numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
const numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
const hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
    let value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(let i = 0; i < str.length; i++){
            const code = str.charCodeAt(i);
            if (str[i].search(numberingSystems.hanidec) !== -1) value += hanidecChars.indexOf(str[i]);
            else for(const key in numberingSystemsUTF16){
                const [min, max] = numberingSystemsUTF16[key];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
// cache of {numberingSystem: {append: regex}}
const digitRegexCache = new Map();
function resetDigitRegexCache() {
    digitRegexCache.clear();
}
function digitRegex({ numberingSystem }, append = "") {
    const ns = numberingSystem || "latn";
    let appendCache = digitRegexCache.get(ns);
    if (appendCache === undefined) {
        appendCache = new Map();
        digitRegexCache.set(ns, appendCache);
    }
    let regex = appendCache.get(append);
    if (regex === undefined) {
        regex = new RegExp(`${numberingSystems[ns]}${append}`);
        appendCache.set(append, regex);
    }
    return regex;
}
let now = ()=>Date.now(), defaultZone = "system", defaultLocale = null, defaultNumberingSystem = null, defaultOutputCalendar = null, twoDigitCutoffYear = 60, throwOnInvalid, defaultWeekSettings = null;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ class Settings {
    /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */ static get now() {
        return now;
    }
    /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */ static set now(n) {
        now = n;
    }
    /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */ static set defaultZone(zone) {
        defaultZone = zone;
    }
    /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */ static get defaultZone() {
        return normalizeZone(defaultZone, SystemZone.instance);
    }
    /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static get defaultLocale() {
        return defaultLocale;
    }
    /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static set defaultLocale(locale) {
        defaultLocale = locale;
    }
    /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static get defaultNumberingSystem() {
        return defaultNumberingSystem;
    }
    /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static set defaultNumberingSystem(numberingSystem) {
        defaultNumberingSystem = numberingSystem;
    }
    /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static get defaultOutputCalendar() {
        return defaultOutputCalendar;
    }
    /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static set defaultOutputCalendar(outputCalendar) {
        defaultOutputCalendar = outputCalendar;
    }
    /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */ /**
   * @return {WeekSettings|null}
   */ static get defaultWeekSettings() {
        return defaultWeekSettings;
    }
    /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */ static set defaultWeekSettings(weekSettings) {
        defaultWeekSettings = validateWeekSettings(weekSettings);
    }
    /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */ static get twoDigitCutoffYear() {
        return twoDigitCutoffYear;
    }
    /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */ static set twoDigitCutoffYear(cutoffYear) {
        twoDigitCutoffYear = cutoffYear % 100;
    }
    /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */ static get throwOnInvalid() {
        return throwOnInvalid;
    }
    /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */ static set throwOnInvalid(t) {
        throwOnInvalid = t;
    }
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ static resetCaches() {
        Locale.resetCache();
        IANAZone.resetCache();
        DateTime.resetCache();
        resetDigitRegexCache();
    }
}
class Invalid {
    constructor(reason, explanation){
        this.reason = reason;
        this.explanation = explanation;
    }
    toMessage() {
        if (this.explanation) return `${this.reason}: ${this.explanation}`;
        else return this.reason;
    }
}
const nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function unitOutOfRange(unit, value) {
    return new Invalid("unit out of range", `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`);
}
function dayOfWeek(year, month, day) {
    const d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    const js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function computeOrdinal(year, month, day) {
    return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}
function uncomputeOrdinal(year, ordinal) {
    const table = isLeapYear(year) ? leapLadder : nonLeapLadder, month0 = table.findIndex((i)=>i < ordinal), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day
    };
}
function isoWeekdayToLocal(isoWeekday, startOfWeek) {
    return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
/**
 * @private
 */ function gregorianToWeek(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
    const { year, month, day } = gregObj, ordinal = computeOrdinal(year, month, day), weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek);
    let weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
    } else if (weekNumber > weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return {
        weekYear,
        weekNumber,
        weekday,
        ...timeObject(gregObj)
    };
}
function weekToGregorian(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
    const { weekYear, weekNumber, weekday } = weekData, weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = daysInYear(weekYear);
    let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= daysInYear(weekYear);
    } else year = weekYear;
    const { month, day } = uncomputeOrdinal(year, ordinal);
    return {
        year,
        month,
        day,
        ...timeObject(weekData)
    };
}
function gregorianToOrdinal(gregData) {
    const { year, month, day } = gregData;
    const ordinal = computeOrdinal(year, month, day);
    return {
        year,
        ordinal,
        ...timeObject(gregData)
    };
}
function ordinalToGregorian(ordinalData) {
    const { year, ordinal } = ordinalData;
    const { month, day } = uncomputeOrdinal(year, ordinal);
    return {
        year,
        month,
        day,
        ...timeObject(ordinalData)
    };
}
/**
 * Check if local week units like localWeekday are used in obj.
 * If so, validates that they are not mixed with ISO week units and then copies them to the normal week unit properties.
 * Modifies obj in-place!
 * @param obj the object values
 */ function usesLocalWeekValues(obj, loc) {
    const hasLocaleWeekData = !isUndefined(obj.localWeekday) || !isUndefined(obj.localWeekNumber) || !isUndefined(obj.localWeekYear);
    if (hasLocaleWeekData) {
        const hasIsoWeekData = !isUndefined(obj.weekday) || !isUndefined(obj.weekNumber) || !isUndefined(obj.weekYear);
        if (hasIsoWeekData) throw new ConflictingSpecificationError("Cannot mix locale-based week fields with ISO-based week fields");
        if (!isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
        if (!isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
        if (!isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
        delete obj.localWeekday;
        delete obj.localWeekNumber;
        delete obj.localWeekYear;
        return {
            minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
            startOfWeek: loc.getStartOfWeek()
        };
    } else return {
        minDaysInFirstWeek: 4,
        startOfWeek: 1
    };
}
function hasInvalidWeekData(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
    const validYear = isInteger(obj.weekYear), validWeek = integerBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)), validWeekday = integerBetween(obj.weekday, 1, 7);
    if (!validYear) return unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return unitOutOfRange("week", obj.weekNumber);
    else if (!validWeekday) return unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function hasInvalidOrdinalData(obj) {
    const validYear = isInteger(obj.year), validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));
    if (!validYear) return unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function hasInvalidGregorianData(obj) {
    const validYear = isInteger(obj.year), validMonth = integerBetween(obj.month, 1, 12), validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
    if (!validYear) return unitOutOfRange("year", obj.year);
    else if (!validMonth) return unitOutOfRange("month", obj.month);
    else if (!validDay) return unitOutOfRange("day", obj.day);
    else return false;
}
function hasInvalidTimeData(obj) {
    const { hour, minute, second, millisecond } = obj;
    const validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = integerBetween(minute, 0, 59), validSecond = integerBetween(second, 0, 59), validMillisecond = integerBetween(millisecond, 0, 999);
    if (!validHour) return unitOutOfRange("hour", hour);
    else if (!validMinute) return unitOutOfRange("minute", minute);
    else if (!validSecond) return unitOutOfRange("second", second);
    else if (!validMillisecond) return unitOutOfRange("millisecond", millisecond);
    else return false;
}
/*
  This is just a junk drawer, containing anything used across multiple classes.
  Because Luxon is small(ish), this should stay small and we won't worry about splitting
  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
*/ /**
 * @private
 */ // TYPES
function isUndefined(o) {
    return typeof o === "undefined";
}
function isNumber(o) {
    return typeof o === "number";
}
function isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function isString(o) {
    return typeof o === "string";
}
function isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
// CAPABILITIES
function hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
function hasLocaleWeekInfo() {
    try {
        return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
    } catch (e) {
        return false;
    }
}
// OBJECTS AND ARRAYS
function maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce((best, next)=>{
        const pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function pick(obj, keys) {
    return keys.reduce((a, k)=>{
        a[k] = obj[k];
        return a;
    }, {});
}
function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function validateWeekSettings(settings) {
    if (settings == null) return null;
    else if (typeof settings !== "object") throw new InvalidArgumentError("Week settings must be an object");
    else {
        if (!integerBetween(settings.firstDay, 1, 7) || !integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some((v)=>!integerBetween(v, 1, 7))) throw new InvalidArgumentError("Invalid week settings");
        return {
            firstDay: settings.firstDay,
            minimalDays: settings.minimalDays,
            weekend: Array.from(settings.weekend)
        };
    }
}
// NUMBERS AND STRINGS
function integerBetween(thing, bottom, top) {
    return isInteger(thing) && thing >= bottom && thing <= top;
}
// x % n but takes the sign of n instead of x
function floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function padStart(input, n = 2) {
    const isNeg = input < 0;
    let padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function parseInteger(string) {
    if (isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function parseFloating(string) {
    if (isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if (isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        const f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function roundTo(number, digits, rounding = "round") {
    const factor = 10 ** digits;
    switch(rounding){
        case "expand":
            return number > 0 ? Math.ceil(number * factor) / factor : Math.floor(number * factor) / factor;
        case "trunc":
            return Math.trunc(number * factor) / factor;
        case "round":
            return Math.round(number * factor) / factor;
        case "floor":
            return Math.floor(number * factor) / factor;
        case "ceil":
            return Math.ceil(number * factor) / factor;
        default:
            throw new RangeError(`Value rounding ${rounding} is out of range`);
    }
}
// DATE BASICS
function isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}
function daysInMonth(year, month) {
    const modMonth = floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function objToLocalTS(obj) {
    let d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
    const fwdlw = isoWeekdayToLocal(dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
    return -fwdlw + minDaysInFirstWeek - 1;
}
function weeksInWeekYear(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
    const weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
    const weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
    return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function untruncateYear(year) {
    if (year > 99) return year;
    else return year > Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
// PARSING
function parseZoneInfo(ts, offsetFormat, locale, timeZone = null) {
    const date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    const modified = {
        timeZoneName: offsetFormat,
        ...intlOpts
    };
    const parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find((m)=>m.type.toLowerCase() === "timezonename");
    return parsed ? parsed.value : null;
}
// signedOffset('-5', '30') -> -330
function signedOffset(offHourStr, offMinuteStr) {
    let offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    const offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
// COERCION
function asNumber(value) {
    const numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || !Number.isFinite(numericValue)) throw new InvalidArgumentError(`Invalid unit value ${value}`);
    return numericValue;
}
function normalizeObject(obj, normalizer) {
    const normalized = {};
    for(const u in obj)if (hasOwnProperty(obj, u)) {
        const v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = asNumber(v);
    }
    return normalized;
}
/**
 * Returns the offset's value as a string
 * @param {number} ts - Epoch milliseconds for which to get the offset
 * @param {string} format - What style of offset to return.
 *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
 * @return {string}
 */ function formatOffset(offset, format) {
    const hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return `${sign}${padStart(hours, 2)}:${padStart(minutes, 2)}`;
        case "narrow":
            return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
        case "techie":
            return `${sign}${padStart(hours, 2)}${padStart(minutes, 2)}`;
        default:
            throw new RangeError(`Value format ${format} is out of range for property format`);
    }
}
function timeObject(obj) {
    return pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
/**
 * @private
 */ const monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function months(length) {
    switch(length){
        case "narrow":
            return [
                ...monthsNarrow
            ];
        case "short":
            return [
                ...monthsShort
            ];
        case "long":
            return [
                ...monthsLong
            ];
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
const weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
const weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
const weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function weekdays(length) {
    switch(length){
        case "narrow":
            return [
                ...weekdaysNarrow
            ];
        case "short":
            return [
                ...weekdaysShort
            ];
        case "long":
            return [
                ...weekdaysLong
            ];
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
const meridiems = [
    "AM",
    "PM"
];
const erasLong = [
    "Before Christ",
    "Anno Domini"
];
const erasShort = [
    "BC",
    "AD"
];
const erasNarrow = [
    "B",
    "A"
];
function eras(length) {
    switch(length){
        case "narrow":
            return [
                ...erasNarrow
            ];
        case "short":
            return [
                ...erasShort
            ];
        case "long":
            return [
                ...erasLong
            ];
        default:
            return null;
    }
}
function meridiemForDateTime(dt) {
    return meridiems[dt.hour < 12 ? 0 : 1];
}
function weekdayForDateTime(dt, length) {
    return weekdays(length)[dt.weekday - 1];
}
function monthForDateTime(dt, length) {
    return months(length)[dt.month - 1];
}
function eraForDateTime(dt, length) {
    return eras(length)[dt.year < 0 ? 0 : 1];
}
function formatRelativeTime(unit, count, numeric = "always", narrow = false) {
    const units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    const lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        const isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : `next ${units[unit][0]}`;
            case -1:
                return isDay ? "yesterday" : `last ${units[unit][0]}`;
            case 0:
                return isDay ? "today" : `this ${units[unit][0]}`;
        }
    }
    const isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}
function stringifyTokens(splits, tokenToString) {
    let s = "";
    for (const token of splits)if (token.literal) s += token.val;
    else s += tokenToString(token.val);
    return s;
}
const macroTokenToFormatOpts = {
    D: DATE_SHORT,
    DD: DATE_MED,
    DDD: DATE_FULL,
    DDDD: DATE_HUGE,
    t: TIME_SIMPLE,
    tt: TIME_WITH_SECONDS,
    ttt: TIME_WITH_SHORT_OFFSET,
    tttt: TIME_WITH_LONG_OFFSET,
    T: TIME_24_SIMPLE,
    TT: TIME_24_WITH_SECONDS,
    TTT: TIME_24_WITH_SHORT_OFFSET,
    TTTT: TIME_24_WITH_LONG_OFFSET,
    f: DATETIME_SHORT,
    ff: DATETIME_MED,
    fff: DATETIME_FULL,
    ffff: DATETIME_HUGE,
    F: DATETIME_SHORT_WITH_SECONDS,
    FF: DATETIME_MED_WITH_SECONDS,
    FFF: DATETIME_FULL_WITH_SECONDS,
    FFFF: DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ class Formatter {
    static create(locale, opts = {}) {
        return new Formatter(locale, opts);
    }
    static parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        let current = null, currentFull = "", bracketed = false;
        const splits = [];
        for(let i = 0; i < fmt.length; i++){
            const c = fmt.charAt(i);
            if (c === "'") {
                // turn '' into a literal signal quote instead of just skipping the empty literal
                if (currentFull.length > 0 || bracketed) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull === "" ? "'" : currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    }
    static macroTokenToFormatOpts(token) {
        return macroTokenToFormatOpts[token];
    }
    constructor(locale, formatOpts){
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        const df = this.systemLoc.dtFormatter(dt, {
            ...this.opts,
            ...opts
        });
        return df.format();
    }
    dtFormatter(dt, opts = {}) {
        return this.loc.dtFormatter(dt, {
            ...this.opts,
            ...opts
        });
    }
    formatDateTime(dt, opts) {
        return this.dtFormatter(dt, opts).format();
    }
    formatDateTimeParts(dt, opts) {
        return this.dtFormatter(dt, opts).formatToParts();
    }
    formatInterval(interval, opts) {
        const df = this.dtFormatter(interval.start, opts);
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    }
    resolvedOptions(dt, opts) {
        return this.dtFormatter(dt, opts).resolvedOptions();
    }
    num(n, p = 0, signDisplay) {
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return padStart(n, p);
        const opts = {
            ...this.opts
        };
        if (p > 0) opts.padTo = p;
        if (signDisplay) opts.signDisplay = signDisplay;
        return this.loc.numberFormatter(opts).format(n);
    }
    formatDateTimeFromString(dt, fmt) {
        const knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = (opts, extract)=>this.loc.extract(dt, opts, extract), formatOffset = (opts)=>{
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = ()=>knownEnglish ? meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod"), month = (length, standalone)=>knownEnglish ? monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month"), weekday = (length, standalone)=>knownEnglish ? weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday"), maybeMacro = (token)=>{
            const formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = (length)=>knownEnglish ? eraForDateTime(dt, length) : string({
                era: length
            }, "era"), tokenToString = (token)=>{
            // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
            switch(token){
                // ms
                case "S":
                    return this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return this.num(dt.second);
                case "ss":
                    return this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return this.num(dt.minute);
                case "mm":
                    return this.num(dt.minute, 2);
                // hours
                case "h":
                    return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return this.num(dt.hour);
                case "HH":
                    return this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return this.num(dt.weekYear, 4);
                case "W":
                    return this.num(dt.weekNumber);
                case "WW":
                    return this.num(dt.weekNumber, 2);
                case "n":
                    return this.num(dt.localWeekNumber);
                case "nn":
                    return this.num(dt.localWeekNumber, 2);
                case "ii":
                    return this.num(dt.localWeekYear.toString().slice(-2), 2);
                case "iiii":
                    return this.num(dt.localWeekYear, 4);
                case "o":
                    return this.num(dt.ordinal);
                case "ooo":
                    return this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return this.num(dt.quarter);
                case "qq":
                    // like 01
                    return this.num(dt.quarter, 2);
                case "X":
                    return this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    }
    formatDurationFromString(dur, fmt) {
        const invertLargest = this.opts.signMode === "negativeLargestOnly" ? -1 : 1;
        const tokenToField = (token)=>{
            switch(token[0]){
                case "S":
                    return "milliseconds";
                case "s":
                    return "seconds";
                case "m":
                    return "minutes";
                case "h":
                    return "hours";
                case "d":
                    return "days";
                case "w":
                    return "weeks";
                case "M":
                    return "months";
                case "y":
                    return "years";
                default:
                    return null;
            }
        }, tokenToString = (lildur, info)=>(token)=>{
                const mapped = tokenToField(token);
                if (mapped) {
                    const inversionFactor = info.isNegativeDuration && mapped !== info.largestUnit ? invertLargest : 1;
                    let signDisplay;
                    if (this.opts.signMode === "negativeLargestOnly" && mapped !== info.largestUnit) signDisplay = "never";
                    else if (this.opts.signMode === "all") signDisplay = "always";
                    else // "auto" and "negative" are the same, but "auto" has better support
                    signDisplay = "auto";
                    return this.num(lildur.get(mapped) * inversionFactor, token.length, signDisplay);
                } else return token;
            }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce((found, { literal, val })=>literal ? found : found.concat(val), []), collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t)=>t)), durationInfo = {
            isNegativeDuration: collapsed < 0,
            // this relies on "collapsed" being based on "shiftTo", which builds up the object
            // in order
            largestUnit: Object.keys(collapsed.values)[0]
        };
        return stringifyTokens(tokens, tokenToString(collapsed, durationInfo));
    }
}
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ const ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes(...regexes) {
    const full = regexes.reduce((f, r)=>f + r.source, "");
    return RegExp(`^${full}$`);
}
function combineExtractors(...extractors) {
    return (m)=>extractors.reduce(([mergedVals, mergedZone, cursor], ex)=>{
            const [val, zone, next] = ex(m, cursor);
            return [
                {
                    ...mergedVals,
                    ...val
                },
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
}
function parse(s, ...patterns) {
    if (s == null) return [
        null,
        null
    ];
    for (const [regex, extractor] of patterns){
        const m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function simpleParse(...keys) {
    return (match, cursor)=>{
        const ret = {};
        let i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
const offsetRegex = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/;
const isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`;
const isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
const isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`);
const isoTimeExtensionRegex = RegExp(`(?:[Tt]${isoTimeRegex.source})?`);
const isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
const isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
const isoOrdinalRegex = /(\d{4})-?(\d{3})/;
const extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
const extractISOOrdinalData = simpleParse("year", "ordinal");
const sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
const sqlTimeRegex = RegExp(`${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`);
const sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);
function int(match, pos, fallback) {
    const m = match[pos];
    return isUndefined(m) ? fallback : parseInteger(m);
}
function extractISOYmd(match, cursor) {
    const item = {
        year: int(match, cursor),
        month: int(match, cursor + 1, 1),
        day: int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function extractISOTime(match, cursor) {
    const item = {
        hours: int(match, cursor, 0),
        minutes: int(match, cursor + 1, 0),
        seconds: int(match, cursor + 2, 0),
        milliseconds: parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function extractISOOffset(match, cursor) {
    const local = !match[cursor] && !match[cursor + 1], fullOffset = signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function extractIANAZone(match, cursor) {
    const zone = match[cursor] ? IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
const isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex.source}$`);
// ISO duration parsing
const isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration(match) {
    const [s, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] = match;
    const hasNegativePrefix = s[0] === "-";
    const negativeSeconds = secondStr && secondStr[0] === "-";
    const maybeNegate = (num, force = false)=>num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    return [
        {
            years: maybeNegate(parseFloating(yearStr)),
            months: maybeNegate(parseFloating(monthStr)),
            weeks: maybeNegate(parseFloating(weekStr)),
            days: maybeNegate(parseFloating(dayStr)),
            hours: maybeNegate(parseFloating(hourStr)),
            minutes: maybeNegate(parseFloating(minuteStr)),
            seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
const obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    const result = {
        year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
        month: monthsShort.indexOf(monthStr) + 1,
        day: parseInteger(dayStr),
        hour: parseInteger(hourStr),
        minute: parseInteger(minuteStr)
    };
    if (secondStr) result.second = parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
const rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822(match) {
    const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr, obsOffset, milOffset, offHourStr, offMinuteStr] = match, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    let offset;
    if (obsOffset) offset = obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new FixedOffsetZone(offset)
    ];
}
function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
const rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850(match) {
    const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        FixedOffsetZone.utcInstance
    ];
}
function extractASCII(match) {
    const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        FixedOffsetZone.utcInstance
    ];
}
const isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
const isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
const isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
const isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
const extractISOYmdTimeAndOffset = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset, extractIANAZone);
const extractISOWeekTimeAndOffset = combineExtractors(extractISOWeekData, extractISOTime, extractISOOffset, extractIANAZone);
const extractISOOrdinalDateAndTime = combineExtractors(extractISOOrdinalData, extractISOTime, extractISOOffset, extractIANAZone);
const extractISOTimeAndOffset = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
/*
 * @private
 */ function parseISODate(s) {
    return parse(s, [
        isoYmdWithTimeExtensionRegex,
        extractISOYmdTimeAndOffset
    ], [
        isoWeekWithTimeExtensionRegex,
        extractISOWeekTimeAndOffset
    ], [
        isoOrdinalWithTimeExtensionRegex,
        extractISOOrdinalDateAndTime
    ], [
        isoTimeCombinedRegex,
        extractISOTimeAndOffset
    ]);
}
function parseRFC2822Date(s) {
    return parse(preprocessRFC2822(s), [
        rfc2822,
        extractRFC2822
    ]);
}
function parseHTTPDate(s) {
    return parse(s, [
        rfc1123,
        extractRFC1123Or850
    ], [
        rfc850,
        extractRFC1123Or850
    ], [
        ascii,
        extractASCII
    ]);
}
function parseISODuration(s) {
    return parse(s, [
        isoDuration,
        extractISODuration
    ]);
}
const extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s) {
    return parse(s, [
        isoTimeOnly,
        extractISOTimeOnly
    ]);
}
const sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
const sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
const extractISOTimeOffsetAndIANAZone = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
function parseSQL(s) {
    return parse(s, [
        sqlYmdWithTimeExtensionRegex,
        extractISOYmdTimeAndOffset
    ], [
        sqlTimeCombinedRegex,
        extractISOTimeOffsetAndIANAZone
    ]);
}
const INVALID$2 = "Invalid Duration";
// unit conversion constants
const lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, casualMatrix = {
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    },
    ...lowOrderMatrix
}, daysInYearAccurate = 365.2425, daysInMonthAccurate = 30.436875, accurateMatrix = {
    years: {
        quarters: 4,
        months: 12,
        weeks: daysInYearAccurate / 7,
        days: daysInYearAccurate,
        hours: daysInYearAccurate * 24,
        minutes: daysInYearAccurate * 1440,
        seconds: daysInYearAccurate * 86400,
        milliseconds: daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: daysInYearAccurate / 28,
        days: daysInYearAccurate / 4,
        hours: daysInYearAccurate * 24 / 4,
        minutes: daysInYearAccurate * 1440 / 4,
        seconds: daysInYearAccurate * 86400 / 4,
        milliseconds: daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: daysInMonthAccurate / 7,
        days: daysInMonthAccurate,
        hours: daysInMonthAccurate * 24,
        minutes: daysInMonthAccurate * 1440,
        seconds: daysInMonthAccurate * 86400,
        milliseconds: daysInMonthAccurate * 86400000
    },
    ...lowOrderMatrix
};
// units ordered by size
const orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
const reverseUnits = orderedUnits$1.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function clone$1(dur, alts, clear = false) {
    // deep merge for vals
    const conf = {
        values: clear ? alts.values : {
            ...dur.values,
            ...alts.values || {}
        },
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new Duration(conf);
}
function durationToMillis(matrix, vals) {
    let sum = vals.milliseconds ?? 0;
    for (const unit of reverseUnits.slice(1))if (vals[unit]) sum += vals[unit] * matrix[unit]["milliseconds"];
    return sum;
}
// NB: mutates parameters
function normalizeValues(matrix, vals) {
    // the logic below assumes the overall value of the duration is positive
    // if this is not the case, factor is used to make it so
    const factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;
    orderedUnits$1.reduceRight((previous, current)=>{
        if (!isUndefined(vals[current])) {
            if (previous) {
                const previousVal = vals[previous] * factor;
                const conv = matrix[current][previous];
                // if (previousVal < 0):
                // lower order unit is negative (e.g. { years: 2, days: -2 })
                // normalize this by reducing the higher order unit by the appropriate amount
                // and increasing the lower order unit
                // this can never make the higher order unit negative, because this function only operates
                // on positive durations, so the amount of time represented by the lower order unit cannot
                // be larger than the higher order unit
                // else:
                // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
                // in this case we attempt to convert as much as possible from the lower order unit into
                // the higher order one
                //
                // Math.floor takes care of both of these cases, rounding away from 0
                // if previousVal < 0 it makes the absolute value larger
                // if previousVal >= it makes the absolute value smaller
                const rollUp = Math.floor(previousVal / conv);
                vals[current] += rollUp * factor;
                vals[previous] -= rollUp * conv * factor;
            }
            return current;
        } else return previous;
    }, null);
    // try to convert any decimals into smaller units if possible
    // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
    orderedUnits$1.reduce((previous, current)=>{
        if (!isUndefined(vals[current])) {
            if (previous) {
                const fraction = vals[previous] % 1;
                vals[previous] -= fraction;
                vals[current] += fraction * matrix[previous][current];
            }
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function removeZeroes(vals) {
    const newVals = {};
    for (const [key, value] of Object.entries(vals))if (value !== 0) newVals[key] = value;
    return newVals;
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ class Duration {
    /**
   * @private
   */ constructor(config){
        const accurate = config.conversionAccuracy === "longterm" || false;
        let matrix = accurate ? accurateMatrix : casualMatrix;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ static fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    }
    /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */ static fromObject(obj, opts = {}) {
        if (obj == null || typeof obj !== "object") throw new InvalidArgumentError(`Duration.fromObject: argument expected to be an object, got ${obj === null ? "null" : typeof obj}`);
        return new Duration({
            values: normalizeObject(obj, Duration.normalizeUnit),
            loc: Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    }
    /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */ static fromDurationLike(durationLike) {
        if (isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new InvalidArgumentError(`Unknown duration argument ${durationLike} of type ${typeof durationLike}`);
    }
    /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */ static fromISO(text, opts) {
        const [parsed] = parseISODuration(text);
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
    /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */ static fromISOTime(text, opts) {
        const [parsed] = parseISOTimeOnly(text);
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
    /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */ static invalid(reason, explanation = null) {
        if (!reason) throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
        const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
        if (Settings.throwOnInvalid) throw new InvalidDurationError(invalid);
        else return new Duration({
            invalid
        });
    }
    /**
   * @private
   */ static normalizeUnit(unit) {
        const normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new InvalidUnitError(unit);
        return normalized;
    }
    /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ static isDuration(o) {
        return o && o.isLuxonDuration || false;
    }
    /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */ get locale() {
        return this.isValid ? this.loc.locale : null;
    }
    /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */ get numberingSystem() {
        return this.isValid ? this.loc.numberingSystem : null;
    }
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */ toFormat(fmt, opts = {}) {
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        const fmtOpts = {
            ...opts,
            floor: opts.round !== false && opts.floor !== false
        };
        return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID$2;
    }
    /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @param {boolean} [opts.showZeros=true] - Show all units previously used by the duration even if they are zero
   * @example
   * ```js
   * var dur = Duration.fromObject({ months: 1, weeks: 0, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 month, 0 weeks, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 month, 0 weeks, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 mth, 0 wks, 5 hr, 6 min'
   * dur.toHuman({ showZeros: false }) //=> '1 month, 5 hours, 6 minutes'
   * ```
   */ toHuman(opts = {}) {
        if (!this.isValid) return INVALID$2;
        const showZeros = opts.showZeros !== false;
        const l = orderedUnits$1.map((unit)=>{
            const val = this.values[unit];
            if (isUndefined(val) || val === 0 && !showZeros) return null;
            return this.loc.numberFormatter({
                style: "unit",
                unitDisplay: "long",
                ...opts,
                unit: unit.slice(0, -1)
            }).format(val);
        }).filter((n)=>n);
        return this.loc.listFormatter({
            type: "conjunction",
            style: opts.listStyle || "narrow",
            ...opts
        }).format(l);
    }
    /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */ toObject() {
        if (!this.isValid) return {};
        return {
            ...this.values
        };
    }
    /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */ toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        let s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    }
    /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */ toISOTime(opts = {}) {
        if (!this.isValid) return null;
        const millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = {
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended",
            ...opts,
            includeOffset: false
        };
        const dateTime = DateTime.fromMillis(millis, {
            zone: "UTC"
        });
        return dateTime.toISOTime(opts);
    }
    /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */ toJSON() {
        return this.toISO();
    }
    /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */ toString() {
        return this.toISO();
    }
    /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */ [Symbol.for("nodejs.util.inspect.custom")]() {
        if (this.isValid) return `Duration { values: ${JSON.stringify(this.values)} }`;
        else return `Duration { Invalid, reason: ${this.invalidReason} }`;
    }
    /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */ toMillis() {
        if (!this.isValid) return NaN;
        return durationToMillis(this.matrix, this.values);
    }
    /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */ valueOf() {
        return this.toMillis();
    }
    /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ plus(duration) {
        if (!this.isValid) return this;
        const dur = Duration.fromDurationLike(duration), result = {};
        for (const k of orderedUnits$1)if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        return clone$1(this, {
            values: result
        }, true);
    }
    /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ minus(duration) {
        if (!this.isValid) return this;
        const dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    }
    /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */ mapUnits(fn) {
        if (!this.isValid) return this;
        const result = {};
        for (const k of Object.keys(this.values))result[k] = asNumber(fn(this.values[k], k));
        return clone$1(this, {
            values: result
        }, true);
    }
    /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */ get(unit) {
        return this[Duration.normalizeUnit(unit)];
    }
    /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */ set(values) {
        if (!this.isValid) return this;
        const mixed = {
            ...this.values,
            ...normalizeObject(values, Duration.normalizeUnit)
        };
        return clone$1(this, {
            values: mixed
        });
    }
    /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */ reconfigure({ locale, numberingSystem, conversionAccuracy, matrix } = {}) {
        const loc = this.loc.clone({
            locale,
            numberingSystem
        });
        const opts = {
            loc,
            matrix,
            conversionAccuracy
        };
        return clone$1(this, opts);
    }
    /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */ as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    }
    /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */ normalize() {
        if (!this.isValid) return this;
        const vals = this.toObject();
        normalizeValues(this.matrix, vals);
        return clone$1(this, {
            values: vals
        }, true);
    }
    /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */ rescale() {
        if (!this.isValid) return this;
        const vals = removeZeroes(this.normalize().shiftToAll().toObject());
        return clone$1(this, {
            values: vals
        }, true);
    }
    /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */ shiftTo(...units) {
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map((u)=>Duration.normalizeUnit(u));
        const built = {}, accumulated = {}, vals = this.toObject();
        let lastUnit;
        for (const k of orderedUnits$1){
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                let own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(const ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if (isNumber(vals[k])) own += vals[k];
                // only keep the integer part for now in the hopes of putting any decimal part
                // into a smaller unit later
                const i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
            // otherwise, keep it in the wings to boil it later
            } else if (isNumber(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(const key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        normalizeValues(this.matrix, built);
        return clone$1(this, {
            values: built
        }, true);
    }
    /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */ shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    }
    /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */ negate() {
        if (!this.isValid) return this;
        const negated = {};
        for (const k of Object.keys(this.values))negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        return clone$1(this, {
            values: negated
        }, true);
    }
    /**
   * Removes all units with values equal to 0 from this Duration.
   * @example Duration.fromObject({ years: 2, days: 0, hours: 0, minutes: 0 }).removeZeros().toObject() //=> { years: 2 }
   * @return {Duration}
   */ removeZeros() {
        if (!this.isValid) return this;
        const vals = removeZeroes(this.values);
        return clone$1(this, {
            values: vals
        }, true);
    }
    /**
   * Get the years.
   * @type {number}
   */ get years() {
        return this.isValid ? this.values.years || 0 : NaN;
    }
    /**
   * Get the quarters.
   * @type {number}
   */ get quarters() {
        return this.isValid ? this.values.quarters || 0 : NaN;
    }
    /**
   * Get the months.
   * @type {number}
   */ get months() {
        return this.isValid ? this.values.months || 0 : NaN;
    }
    /**
   * Get the weeks
   * @type {number}
   */ get weeks() {
        return this.isValid ? this.values.weeks || 0 : NaN;
    }
    /**
   * Get the days.
   * @type {number}
   */ get days() {
        return this.isValid ? this.values.days || 0 : NaN;
    }
    /**
   * Get the hours.
   * @type {number}
   */ get hours() {
        return this.isValid ? this.values.hours || 0 : NaN;
    }
    /**
   * Get the minutes.
   * @type {number}
   */ get minutes() {
        return this.isValid ? this.values.minutes || 0 : NaN;
    }
    /**
   * Get the seconds.
   * @return {number}
   */ get seconds() {
        return this.isValid ? this.values.seconds || 0 : NaN;
    }
    /**
   * Get the milliseconds.
   * @return {number}
   */ get milliseconds() {
        return this.isValid ? this.values.milliseconds || 0 : NaN;
    }
    /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */ get isValid() {
        return this.invalid === null;
    }
    /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */ get invalidReason() {
        return this.invalid ? this.invalid.reason : null;
    }
    /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */ get invalidExplanation() {
        return this.invalid ? this.invalid.explanation : null;
    }
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for (const u of orderedUnits$1){
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    }
}
const INVALID$1 = "Invalid Interval";
// checks if the start is equal to or before the end
function validateStartEnd(start, end) {
    if (!start || !start.isValid) return Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return Interval.invalid("missing or invalid end");
    else if (end < start) return Interval.invalid("end before start", `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`);
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ class Interval {
    /**
   * @private
   */ constructor(config){
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ static invalid(reason, explanation = null) {
        if (!reason) throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
        const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
        if (Settings.throwOnInvalid) throw new InvalidIntervalError(invalid);
        else return new Interval({
            invalid
        });
    }
    /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */ static fromDateTimes(start, end) {
        const builtStart = friendlyDateTime(start), builtEnd = friendlyDateTime(end);
        const validateError = validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    }
    /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ static after(start, duration) {
        const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    }
    /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ static before(end, duration) {
        const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    }
    /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */ static fromISO(text, opts) {
        const [s, e] = (text || "").split("/", 2);
        if (s && e) {
            let start, startIsValid;
            try {
                start = DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            let end, endIsValid;
            try {
                end = DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                const dur = Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                const dur = Duration.fromISO(s, opts);
                if (dur.isValid) return Interval.before(end, dur);
            }
        }
        return Interval.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
    /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ static isInterval(o) {
        return o && o.isLuxonInterval || false;
    }
    /**
   * Returns the start of the Interval
   * @type {DateTime}
   */ get start() {
        return this.isValid ? this.s : null;
    }
    /**
   * Returns the end of the Interval. This is the first instant which is not part of the interval
   * (Interval is half-open).
   * @type {DateTime}
   */ get end() {
        return this.isValid ? this.e : null;
    }
    /**
   * Returns the last DateTime included in the interval (since end is not part of the interval)
   * @type {DateTime}
   */ get lastDateTime() {
        return this.isValid ? this.e ? this.e.minus(1) : null : null;
    }
    /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */ get isValid() {
        return this.invalidReason === null;
    }
    /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */ get invalidReason() {
        return this.invalid ? this.invalid.reason : null;
    }
    /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */ get invalidExplanation() {
        return this.invalid ? this.invalid.explanation : null;
    }
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ length(unit = "milliseconds") {
        return this.isValid ? this.toDuration(...[
            unit
        ]).get(unit) : NaN;
    }
    /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */ count(unit = "milliseconds", opts) {
        if (!this.isValid) return NaN;
        const start = this.start.startOf(unit, opts);
        let end;
        if (opts?.useLocaleWeeks) end = this.end.reconfigure({
            locale: start.locale
        });
        else end = this.end;
        end = end.startOf(unit, opts);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    }
    /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */ hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    }
    /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */ isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    }
    /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    }
    /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    }
    /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    }
    /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */ set({ start, end } = {}) {
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    }
    /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */ splitAt(...dateTimes) {
        if (!this.isValid) return [];
        const sorted = dateTimes.map(friendlyDateTime).filter((d)=>this.contains(d)).sort((a, b)=>a.toMillis() - b.toMillis()), results = [];
        let { s } = this, i = 0;
        while(s < this.e){
            const added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    }
    /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */ splitBy(duration) {
        const dur = Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        let { s } = this, idx = 1, next;
        const results = [];
        while(s < this.e){
            const added = this.start.plus(dur.mapUnits((x)=>x * idx));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    }
    /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */ divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    }
    /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */ overlaps(other) {
        return this.e > other.s && this.s < other.e;
    }
    /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */ abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    }
    /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */ abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    }
    /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */ engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    }
    /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    }
    /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */ intersection(other) {
        if (!this.isValid) return this;
        const s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    }
    /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */ union(other) {
        if (!this.isValid) return this;
        const s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    }
    /**
   * Merge an array of Intervals into an equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * The resulting array will contain the Intervals in ascending order, that is, starting with the earliest Interval
   * and ending with the latest.
   *
   * @param {Array} intervals
   * @return {Array}
   */ static merge(intervals) {
        const [found, final] = intervals.sort((a, b)=>a.s - b.s).reduce(([sofar, current], item)=>{
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]);
        if (final) found.push(final);
        return found;
    }
    /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ static xor(intervals) {
        let start = null, currentCount = 0;
        const results = [], ends = intervals.map((i)=>[
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ]), flattened = Array.prototype.concat(...ends), arr = flattened.sort((a, b)=>a.time - b.time);
        for (const i of arr){
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    }
    /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */ difference(...intervals) {
        return Interval.xor([
            this
        ].concat(intervals)).map((i)=>this.intersection(i)).filter((i)=>i && !i.isEmpty());
    }
    /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */ toString() {
        if (!this.isValid) return INVALID$1;
        return `[${this.s.toISO()} \u{2013} ${this.e.toISO()})`;
    }
    /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */ [Symbol.for("nodejs.util.inspect.custom")]() {
        if (this.isValid) return `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }`;
        else return `Interval { Invalid, reason: ${this.invalidReason} }`;
    }
    /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */ toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
        return this.isValid ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : INVALID$1;
    }
    /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ toISO(opts) {
        if (!this.isValid) return INVALID$1;
        return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
    }
    /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */ toISODate() {
        if (!this.isValid) return INVALID$1;
        return `${this.s.toISODate()}/${this.e.toISODate()}`;
    }
    /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ toISOTime(opts) {
        if (!this.isValid) return INVALID$1;
        return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
    }
    /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */ toFormat(dateFormat, { separator = " \u2013 " } = {}) {
        if (!this.isValid) return INVALID$1;
        return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
    }
    /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */ toDuration(unit, opts) {
        if (!this.isValid) return Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    }
    /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */ mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    }
}
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ class Info {
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ static hasDST(zone = Settings.defaultZone) {
        const proto = DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    }
    /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */ static isValidIANAZone(zone) {
        return IANAZone.isValidZone(zone);
    }
    /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */ static normalizeZone(input) {
        return normalizeZone(input, Settings.defaultZone);
    }
    /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */ static getStartOfWeek({ locale = null, locObj = null } = {}) {
        return (locObj || Locale.create(locale)).getStartOfWeek();
    }
    /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */ static getMinimumDaysInFirstWeek({ locale = null, locObj = null } = {}) {
        return (locObj || Locale.create(locale)).getMinDaysInFirstWeek();
    }
    /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */ static getWeekendWeekdays({ locale = null, locObj = null } = {}) {
        // copy the array, because we cache it internally
        return (locObj || Locale.create(locale)).getWeekendDays().slice();
    }
    /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */ static months(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
        return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    }
    /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */ static monthsFormat(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
        return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    }
    /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */ static weekdays(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
        return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
    }
    /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */ static weekdaysFormat(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
        return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    }
    /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */ static meridiems({ locale = null } = {}) {
        return Locale.create(locale).meridiems();
    }
    /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */ static eras(length = "short", { locale = null } = {}) {
        return Locale.create(locale, null, "gregory").eras(length);
    }
    /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */ static features() {
        return {
            relative: hasRelative(),
            localeWeek: hasLocaleWeekInfo()
        };
    }
}
function dayDiff(earlier, later) {
    const utcDayStart = (dt)=>dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf(), ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor(Duration.fromMillis(ms).as("days"));
}
function highOrderDiffs(cursor, later, units) {
    const differs = [
        [
            "years",
            (a, b)=>b.year - a.year
        ],
        [
            "quarters",
            (a, b)=>b.quarter - a.quarter + (b.year - a.year) * 4
        ],
        [
            "months",
            (a, b)=>b.month - a.month + (b.year - a.year) * 12
        ],
        [
            "weeks",
            (a, b)=>{
                const days = dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            dayDiff
        ]
    ];
    const results = {};
    const earlier = cursor;
    let lowestOrder, highWater;
    /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */ for (const [unit, differ] of differs)if (units.indexOf(unit) >= 0) {
        lowestOrder = unit;
        results[unit] = differ(cursor, later);
        highWater = earlier.plus(results);
        if (highWater > later) {
            // we overshot the end point, backtrack cursor by 1
            results[unit]--;
            cursor = earlier.plus(results);
            // if we are still overshooting now, we need to backtrack again
            // this happens in certain situations when diffing times in different zones,
            // because this calculation ignores time zones
            if (cursor > later) {
                // keep the "overshot by 1" around as highWater
                highWater = cursor;
                // backtrack cursor by 1
                results[unit]--;
                cursor = earlier.plus(results);
            }
        } else cursor = highWater;
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function diff(earlier, later, units, opts) {
    let [cursor, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units);
    const remainingMillis = later - cursor;
    const lowerOrderUnits = units.filter((u)=>[
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0);
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) highWater = cursor.plus({
            [lowestOrder]: 1
        });
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    const duration = Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) return Duration.fromMillis(remainingMillis, opts).shiftTo(...lowerOrderUnits).plus(duration);
    else return duration;
}
const MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function intUnit(regex, post = (i)=>i) {
    return {
        regex,
        deser: ([s])=>post(parseDigits(s))
    };
}
const NBSP = String.fromCharCode(160);
const spaceOrNBSP = `[ ${NBSP}]`;
const spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");
function fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}
function stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace(spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map(fixListRegex).join("|")),
        deser: ([s])=>strings.findIndex((i)=>stripInsensitivities(s) === stripInsensitivities(i)) + startIndex
    };
}
function offset(regex, groups) {
    return {
        regex,
        deser: ([, h, m])=>signedOffset(h, m),
        groups
    };
}
function simple(regex) {
    return {
        regex,
        deser: ([s])=>s
    };
}
function escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
/**
 * @param token
 * @param {Locale} loc
 */ function unitForToken(token, loc) {
    const one = digitRegex(loc), two = digitRegex(loc, "{2}"), three = digitRegex(loc, "{3}"), four = digitRegex(loc, "{4}"), six = digitRegex(loc, "{6}"), oneOrTwo = digitRegex(loc, "{1,2}"), oneToThree = digitRegex(loc, "{1,3}"), oneToSix = digitRegex(loc, "{1,6}"), oneToNine = digitRegex(loc, "{1,9}"), twoToFour = digitRegex(loc, "{2,4}"), fourToSix = digitRegex(loc, "{4,6}"), literal = (t)=>({
            regex: RegExp(escapeToken(t.val)),
            deser: ([s])=>s,
            literal: true
        }), unitate = (t)=>{
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return oneOf(loc.eras("short"), 0);
            case "GG":
                return oneOf(loc.eras("long"), 0);
            // years
            case "y":
                return intUnit(oneToSix);
            case "yy":
                return intUnit(twoToFour, untruncateYear);
            case "yyyy":
                return intUnit(four);
            case "yyyyy":
                return intUnit(fourToSix);
            case "yyyyyy":
                return intUnit(six);
            // months
            case "M":
                return intUnit(oneOrTwo);
            case "MM":
                return intUnit(two);
            case "MMM":
                return oneOf(loc.months("short", true), 1);
            case "MMMM":
                return oneOf(loc.months("long", true), 1);
            case "L":
                return intUnit(oneOrTwo);
            case "LL":
                return intUnit(two);
            case "LLL":
                return oneOf(loc.months("short", false), 1);
            case "LLLL":
                return oneOf(loc.months("long", false), 1);
            // dates
            case "d":
                return intUnit(oneOrTwo);
            case "dd":
                return intUnit(two);
            // ordinals
            case "o":
                return intUnit(oneToThree);
            case "ooo":
                return intUnit(three);
            // time
            case "HH":
                return intUnit(two);
            case "H":
                return intUnit(oneOrTwo);
            case "hh":
                return intUnit(two);
            case "h":
                return intUnit(oneOrTwo);
            case "mm":
                return intUnit(two);
            case "m":
                return intUnit(oneOrTwo);
            case "q":
                return intUnit(oneOrTwo);
            case "qq":
                return intUnit(two);
            case "s":
                return intUnit(oneOrTwo);
            case "ss":
                return intUnit(two);
            case "S":
                return intUnit(oneToThree);
            case "SSS":
                return intUnit(three);
            case "u":
                return simple(oneToNine);
            case "uu":
                return simple(oneOrTwo);
            case "uuu":
                return intUnit(one);
            // meridiem
            case "a":
                return oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return intUnit(four);
            case "kk":
                return intUnit(twoToFour, untruncateYear);
            // weekNumber (W)
            case "W":
                return intUnit(oneOrTwo);
            case "WW":
                return intUnit(two);
            // weekdays
            case "E":
            case "c":
                return intUnit(one);
            case "EEE":
                return oneOf(loc.weekdays("short", false), 1);
            case "EEEE":
                return oneOf(loc.weekdays("long", false), 1);
            case "ccc":
                return oneOf(loc.weekdays("short", true), 1);
            case "cccc":
                return oneOf(loc.weekdays("long", true), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
            case "ZZZ":
                return offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    const unit = unitate(token) || {
        invalidReason: MISSING_FTP
    };
    unit.token = token;
    return unit;
}
const partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour12: {
        numeric: "h",
        "2-digit": "hh"
    },
    hour24: {
        numeric: "H",
        "2-digit": "HH"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function tokenForPart(part, formatOpts, resolvedOpts) {
    const { type, value } = part;
    if (type === "literal") {
        const isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    const style = formatOpts[type];
    // The user might have explicitly specified hour12 or hourCycle
    // if so, respect their decision
    // if not, refer back to the resolvedOpts, which are based on the locale
    let actualType = type;
    if (type === "hour") {
        if (formatOpts.hour12 != null) actualType = formatOpts.hour12 ? "hour12" : "hour24";
        else if (formatOpts.hourCycle != null) {
            if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") actualType = "hour12";
            else actualType = "hour24";
        } else // tokens only differentiate between 24 hours or not,
        // so we do not need to check hourCycle here, which is less supported anyways
        actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
    let val = partTypeStyleToTokenVal[actualType];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val
    };
    return undefined;
}
function buildRegex(units) {
    const re = units.map((u)=>u.regex).reduce((f, r)=>`${f}(${r.source})`, "");
    return [
        `^${re}$`,
        units
    ];
}
function match(input, regex, handlers) {
    const matches = input.match(regex);
    if (matches) {
        const all = {};
        let matchIndex = 1;
        for(const i in handlers)if (hasOwnProperty(handlers, i)) {
            const h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function dateTimeFromMatches(matches) {
    const toField = (token)=>{
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    let zone = null;
    let specificOffset;
    if (!isUndefined(matches.z)) zone = IANAZone.create(matches.z);
    if (!isUndefined(matches.Z)) {
        if (!zone) zone = new FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!isUndefined(matches.u)) matches.S = parseMillis(matches.u);
    const vals = Object.keys(matches).reduce((r, k)=>{
        const f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
let dummyDateTimeCache = null;
function getDummyDateTime() {
    if (!dummyDateTimeCache) dummyDateTimeCache = DateTime.fromMillis(1555555555555);
    return dummyDateTimeCache;
}
function maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    const formatOpts = Formatter.macroTokenToFormatOpts(token.val);
    const tokens = formatOptsToTokens(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function expandMacroTokens(tokens, locale) {
    return Array.prototype.concat(...tokens.map((t)=>maybeExpandMacroToken(t, locale)));
}
/**
 * @private
 */ class TokenParser {
    constructor(locale, format){
        this.locale = locale;
        this.format = format;
        this.tokens = expandMacroTokens(Formatter.parseFormat(format), locale);
        this.units = this.tokens.map((t)=>unitForToken(t, locale));
        this.disqualifyingUnit = this.units.find((t)=>t.invalidReason);
        if (!this.disqualifyingUnit) {
            const [regexString, handlers] = buildRegex(this.units);
            this.regex = RegExp(regexString, "i");
            this.handlers = handlers;
        }
    }
    explainFromTokens(input) {
        if (!this.isValid) return {
            input,
            tokens: this.tokens,
            invalidReason: this.invalidReason
        };
        else {
            const [rawMatches, matches] = match(input, this.regex, this.handlers), [result, zone, specificOffset] = matches ? dateTimeFromMatches(matches) : [
                null,
                null,
                undefined
            ];
            if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) throw new ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
            return {
                input,
                tokens: this.tokens,
                regex: this.regex,
                rawMatches,
                matches,
                result,
                zone,
                specificOffset
            };
        }
    }
    get isValid() {
        return !this.disqualifyingUnit;
    }
    get invalidReason() {
        return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
    }
}
function explainFromTokens(locale, input, format) {
    const parser = new TokenParser(locale, format);
    return parser.explainFromTokens(input);
}
function parseFromTokens(locale, input, format) {
    const { result, zone, specificOffset, invalidReason } = explainFromTokens(locale, input, format);
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function formatOptsToTokens(formatOpts, locale) {
    if (!formatOpts) return null;
    const formatter = Formatter.create(locale, formatOpts);
    const df = formatter.dtFormatter(getDummyDateTime());
    const parts = df.formatToParts();
    const resolvedOpts = df.resolvedOptions();
    return parts.map((p)=>tokenForPart(p, formatOpts, resolvedOpts));
}
const INVALID = "Invalid DateTime";
const MAX_DATE = 8.64e15;
function unsupportedZone(zone) {
    return new Invalid("unsupported zone", `the zone "${zone.name}" is not supported`);
}
// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */ function possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = gregorianToWeek(dt.c);
    return dt.weekData;
}
/**
 * @param {DateTime} dt
 */ function possiblyCachedLocalWeekData(dt) {
    if (dt.localWeekData === null) dt.localWeekData = gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
    return dt.localWeekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function clone(inst, alts) {
    const current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new DateTime({
        ...current,
        ...alts,
        old: current
    });
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    let utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    const o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    const o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function tsToObj(ts, offset) {
    ts += offset * 60000;
    const d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function objToTS(obj, offset, zone) {
    return fixOffset(objToLocalTS(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function adjustTime(inst, dur) {
    const oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = {
        ...inst.c,
        year,
        month,
        day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }, millisToAdd = Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = objToLocalTS(c);
    let [ts, o] = fixOffset(localTS, oPre, inst.zone);
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts,
        o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    const { setZone, zone } = opts;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        const interpretationZone = parsedZone || zone, inst = DateTime.fromObject(parsed, {
            ...opts,
            zone: interpretationZone,
            specificOffset
        });
        return setZone ? inst : inst.setZone(zone);
    } else return DateTime.invalid(new Invalid("unparsable", `the input "${text}" can't be parsed as ${format}`));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function toTechFormat(dt, format, allowZ = true) {
    return dt.isValid ? Formatter.create(Locale.create("en-US"), {
        allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function toISODate(o, extended, precision) {
    const longFormat = o.c.year > 9999 || o.c.year < 0;
    let c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += padStart(o.c.year, longFormat ? 6 : 4);
    if (precision === "year") return c;
    if (extended) {
        c += "-";
        c += padStart(o.c.month);
        if (precision === "month") return c;
        c += "-";
    } else {
        c += padStart(o.c.month);
        if (precision === "month") return c;
    }
    c += padStart(o.c.day);
    return c;
}
function toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision) {
    let showSeconds = !suppressSeconds || o.c.millisecond !== 0 || o.c.second !== 0, c = "";
    switch(precision){
        case "day":
        case "month":
        case "year":
            break;
        default:
            c += padStart(o.c.hour);
            if (precision === "hour") break;
            if (extended) {
                c += ":";
                c += padStart(o.c.minute);
                if (precision === "minute") break;
                if (showSeconds) {
                    c += ":";
                    c += padStart(o.c.second);
                }
            } else {
                c += padStart(o.c.minute);
                if (precision === "minute") break;
                if (showSeconds) c += padStart(o.c.second);
            }
            if (precision === "second") break;
            if (showSeconds && (!suppressMilliseconds || o.c.millisecond !== 0)) {
                c += ".";
                c += padStart(o.c.millisecond, 3);
            }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += padStart(Math.trunc(o.o / 60));
            c += ":";
            c += padStart(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
const defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
const orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function normalizeUnit(unit) {
    const normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new InvalidUnitError(unit);
    return normalized;
}
function normalizeUnitWithLocalWeeks(unit) {
    switch(unit.toLowerCase()){
        case "localweekday":
        case "localweekdays":
            return "localWeekday";
        case "localweeknumber":
        case "localweeknumbers":
            return "localWeekNumber";
        case "localweekyear":
        case "localweekyears":
            return "localWeekYear";
        default:
            return normalizeUnit(unit);
    }
}
// cache offsets for zones based on the current timestamp when this function is
// first called. When we are handling a datetime from components like (year,
// month, day, hour) in a time zone, we need a guess about what the timezone
// offset is so that we can convert into a UTC timestamp. One way is to find the
// offset of now in the zone. The actual date may have a different offset (for
// example, if we handle a date in June while we're in December in a zone that
// observes DST), but we can check and adjust that.
//
// When handling many dates, calculating the offset for now every time is
// expensive. It's just a guess, so we can cache the offset to use even if we
// are right on a time change boundary (we'll just correct in the other
// direction). Using a timestamp from first read is a slight optimization for
// handling dates close to the current date, since those dates will usually be
// in the same offset (we could set the timestamp statically, instead). We use a
// single timestamp for all zones to make things a bit more predictable.
//
// This is safe for quickDT (used by local() and utc()) because we don't fill in
// higher-order units from tsNow (as we do in fromObject, this requires that
// offset is calculated from tsNow).
/**
 * @param {Zone} zone
 * @return {number}
 */ function guessOffsetForZone(zone) {
    if (zoneOffsetTs === undefined) zoneOffsetTs = Settings.now();
    // Do not cache anything but IANA zones, because it is not safe to do so.
    // Guessing an offset which is not present in the zone can cause wrong results from fixOffset
    if (zone.type !== "iana") return zone.offset(zoneOffsetTs);
    const zoneName = zone.name;
    let offsetGuess = zoneOffsetGuessCache.get(zoneName);
    if (offsetGuess === undefined) {
        offsetGuess = zone.offset(zoneOffsetTs);
        zoneOffsetGuessCache.set(zoneName, offsetGuess);
    }
    return offsetGuess;
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function quickDT(obj, opts) {
    const zone = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zone.isValid) return DateTime.invalid(unsupportedZone(zone));
    const loc = Locale.fromObject(opts);
    let ts, o;
    // assume we have the higher-order units
    if (!isUndefined(obj.year)) {
        for (const u of orderedUnits)if (isUndefined(obj[u])) obj[u] = defaultUnitValues[u];
        const invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
        if (invalid) return DateTime.invalid(invalid);
        const offsetProvis = guessOffsetForZone(zone);
        [ts, o] = objToTS(obj, offsetProvis, zone);
    } else ts = Settings.now();
    return new DateTime({
        ts,
        zone,
        loc,
        o
    });
}
function diffRelative(start, end, opts) {
    const round = isUndefined(opts.round) ? true : opts.round, rounding = isUndefined(opts.rounding) ? "trunc" : opts.rounding, format = (c, unit)=>{
        c = roundTo(c, round || opts.calendary ? 0 : 2, opts.calendary ? "round" : rounding);
        const formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = (unit)=>{
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for (const unit of opts.units){
        const count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function lastOpts(argList) {
    let opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * Timestamp to use for cached zone offset guesses (exposed for test)
 */ let zoneOffsetTs;
/**
 * Cache for zone offset guesses (exposed for test).
 *
 * This optimizes quickDT via guessOffsetForZone to avoid repeated calls of
 * zone.offset().
 */ const zoneOffsetGuessCache = new Map();
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ class DateTime {
    /**
   * @access private
   */ constructor(config){
        const zone = config.zone || Settings.defaultZone;
        let invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
        let c = null, o = null;
        if (!invalid) {
            const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) [c, o] = [
                config.old.c,
                config.old.o
            ];
            else {
                // If an offset has been passed and we have not been called from
                // clone(), we can trust it and avoid the offset calculation.
                const ot = isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
                c = tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.localWeekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ static now() {
        return new DateTime({});
    }
    /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */ static local() {
        const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
        return quickDT({
            year,
            month,
            day,
            hour,
            minute,
            second,
            millisecond
        }, opts);
    }
    /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */ static utc() {
        const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
        opts.zone = FixedOffsetZone.utcInstance;
        return quickDT({
            year,
            month,
            day,
            hour,
            minute,
            second,
            millisecond
        }, opts);
    }
    /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */ static fromJSDate(date, options = {}) {
        const ts = isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        const zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid(unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: Locale.fromObject(options)
        });
    }
    /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */ static fromMillis(milliseconds, options = {}) {
        if (!isNumber(milliseconds)) throw new InvalidArgumentError(`fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`);
        else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) // this isn't perfect because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: normalizeZone(options.zone, Settings.defaultZone),
            loc: Locale.fromObject(options)
        });
    }
    /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */ static fromSeconds(seconds, options = {}) {
        if (!isNumber(seconds)) throw new InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: normalizeZone(options.zone, Settings.defaultZone),
            loc: Locale.fromObject(options)
        });
    }
    /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */ static fromObject(obj, opts = {}) {
        obj = obj || {};
        const zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid(unsupportedZone(zoneToUse));
        const loc = Locale.fromObject(opts);
        const normalized = normalizeObject(obj, normalizeUnitWithLocalWeeks);
        const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, loc);
        const tsNow = Settings.now(), offsetProvis = !isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        const useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        let units, defaultValues, objNow = tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = orderedWeekUnits;
            defaultValues = defaultWeekUnitValues;
            objNow = gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
        } else if (containsOrdinal) {
            units = orderedOrdinalUnits;
            defaultValues = defaultOrdinalUnitValues;
            objNow = gregorianToOrdinal(objNow);
        } else {
            units = orderedUnits;
            defaultValues = defaultUnitValues;
        }
        // set default values for missing stuff
        let foundFirst = false;
        for (const u of units){
            const v = normalized[u];
            if (!isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        const higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
        // compute the actual time
        const gregorian = useWeekData ? weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? ordinalToGregorian(normalized) : normalized, [tsFinal, offsetFinal] = objToTS(gregorian, offsetProvis, zoneToUse), inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`);
        if (!inst.isValid) return DateTime.invalid(inst.invalid);
        return inst;
    }
    /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */ static fromISO(text, opts = {}) {
        const [vals, parsedZone] = parseISODate(text);
        return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    }
    /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */ static fromRFC2822(text, opts = {}) {
        const [vals, parsedZone] = parseRFC2822Date(text);
        return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    }
    /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */ static fromHTTP(text, opts = {}) {
        const [vals, parsedZone] = parseHTTPDate(text);
        return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    }
    /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */ static fromFormat(text, fmt, opts = {}) {
        if (isUndefined(text) || isUndefined(fmt)) throw new InvalidArgumentError("fromFormat requires an input string and a format");
        const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
            locale,
            numberingSystem,
            defaultToEN: true
        }), [vals, parsedZone, specificOffset, invalid] = parseFromTokens(localeToUse, text, fmt);
        if (invalid) return DateTime.invalid(invalid);
        else return parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
    /**
   * @deprecated use fromFormat instead
   */ static fromString(text, fmt, opts = {}) {
        return DateTime.fromFormat(text, fmt, opts);
    }
    /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */ static fromSQL(text, opts = {}) {
        const [vals, parsedZone] = parseSQL(text);
        return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    }
    /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */ static invalid(reason, explanation = null) {
        if (!reason) throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
        const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
        if (Settings.throwOnInvalid) throw new InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid
        });
    }
    /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ static isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    }
    /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */ static parseFormatForOpts(formatOpts, localeOpts = {}) {
        const tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
        return !tokenList ? null : tokenList.map((t)=>t ? t.val : null).join("");
    }
    /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */ static expandFormat(fmt, localeOpts = {}) {
        const expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
        return expanded.map((t)=>t.val).join("");
    }
    static resetCache() {
        zoneOffsetTs = undefined;
        zoneOffsetGuessCache.clear();
    }
    // INFO
    /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */ get(unit) {
        return this[unit];
    }
    /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */ get isValid() {
        return this.invalid === null;
    }
    /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */ get invalidReason() {
        return this.invalid ? this.invalid.reason : null;
    }
    /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */ get invalidExplanation() {
        return this.invalid ? this.invalid.explanation : null;
    }
    /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */ get locale() {
        return this.isValid ? this.loc.locale : null;
    }
    /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */ get numberingSystem() {
        return this.isValid ? this.loc.numberingSystem : null;
    }
    /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */ get outputCalendar() {
        return this.isValid ? this.loc.outputCalendar : null;
    }
    /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */ get zone() {
        return this._zone;
    }
    /**
   * Get the name of the time zone.
   * @type {string}
   */ get zoneName() {
        return this.isValid ? this.zone.name : null;
    }
    /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */ get year() {
        return this.isValid ? this.c.year : NaN;
    }
    /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */ get quarter() {
        return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
    }
    /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */ get month() {
        return this.isValid ? this.c.month : NaN;
    }
    /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */ get day() {
        return this.isValid ? this.c.day : NaN;
    }
    /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */ get hour() {
        return this.isValid ? this.c.hour : NaN;
    }
    /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */ get minute() {
        return this.isValid ? this.c.minute : NaN;
    }
    /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */ get second() {
        return this.isValid ? this.c.second : NaN;
    }
    /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */ get millisecond() {
        return this.isValid ? this.c.millisecond : NaN;
    }
    /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */ get weekYear() {
        return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
    }
    /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */ get weekNumber() {
        return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
    }
    /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */ get weekday() {
        return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
    }
    /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */ get isWeekend() {
        return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
    }
    /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */ get localWeekday() {
        return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
    }
    /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */ get localWeekNumber() {
        return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
    }
    /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */ get localWeekYear() {
        return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
    }
    /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */ get ordinal() {
        return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
    }
    /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */ get monthShort() {
        return this.isValid ? Info.months("short", {
            locObj: this.loc
        })[this.month - 1] : null;
    }
    /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */ get monthLong() {
        return this.isValid ? Info.months("long", {
            locObj: this.loc
        })[this.month - 1] : null;
    }
    /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */ get weekdayShort() {
        return this.isValid ? Info.weekdays("short", {
            locObj: this.loc
        })[this.weekday - 1] : null;
    }
    /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */ get weekdayLong() {
        return this.isValid ? Info.weekdays("long", {
            locObj: this.loc
        })[this.weekday - 1] : null;
    }
    /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */ get offset() {
        return this.isValid ? +this.o : NaN;
    }
    /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */ get offsetNameShort() {
        if (this.isValid) return this.zone.offsetName(this.ts, {
            format: "short",
            locale: this.locale
        });
        else return null;
    }
    /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */ get offsetNameLong() {
        if (this.isValid) return this.zone.offsetName(this.ts, {
            format: "long",
            locale: this.locale
        });
        else return null;
    }
    /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */ get isOffsetFixed() {
        return this.isValid ? this.zone.isUniversal : null;
    }
    /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */ get isInDST() {
        if (this.isOffsetFixed) return false;
        else return this.offset > this.set({
            month: 1,
            day: 1
        }).offset || this.offset > this.set({
            month: 5
        }).offset;
    }
    /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */ getPossibleOffsets() {
        if (!this.isValid || this.isOffsetFixed) return [
            this
        ];
        const dayMs = 86400000;
        const minuteMs = 60000;
        const localTS = objToLocalTS(this.c);
        const oEarlier = this.zone.offset(localTS - dayMs);
        const oLater = this.zone.offset(localTS + dayMs);
        const o1 = this.zone.offset(localTS - oEarlier * minuteMs);
        const o2 = this.zone.offset(localTS - oLater * minuteMs);
        if (o1 === o2) return [
            this
        ];
        const ts1 = localTS - o1 * minuteMs;
        const ts2 = localTS - o2 * minuteMs;
        const c1 = tsToObj(ts1, o1);
        const c2 = tsToObj(ts2, o2);
        if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) return [
            clone(this, {
                ts: ts1
            }),
            clone(this, {
                ts: ts2
            })
        ];
        return [
            this
        ];
    }
    /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */ get isInLeapYear() {
        return isLeapYear(this.year);
    }
    /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */ get daysInMonth() {
        return daysInMonth(this.year, this.month);
    }
    /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */ get daysInYear() {
        return this.isValid ? daysInYear(this.year) : NaN;
    }
    /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */ get weeksInWeekYear() {
        return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
    }
    /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */ get weeksInLocalWeekYear() {
        return this.isValid ? weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
    }
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ resolvedLocaleOptions(opts = {}) {
        const { locale, numberingSystem, calendar } = Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this);
        return {
            locale,
            numberingSystem,
            outputCalendar: calendar
        };
    }
    // TRANSFORM
    /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */ toUTC(offset = 0, opts = {}) {
        return this.setZone(FixedOffsetZone.instance(offset), opts);
    }
    /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */ toLocal() {
        return this.setZone(Settings.defaultZone);
    }
    /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */ setZone(zone, { keepLocalTime = false, keepCalendarTime = false } = {}) {
        zone = normalizeZone(zone, Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid(unsupportedZone(zone));
        else {
            let newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                const offsetGuess = zone.offset(this.ts);
                const asObj = this.toObject();
                [newTS] = objToTS(asObj, offsetGuess, zone);
            }
            return clone(this, {
                ts: newTS,
                zone
            });
        }
    }
    /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */ reconfigure({ locale, numberingSystem, outputCalendar } = {}) {
        const loc = this.loc.clone({
            locale,
            numberingSystem,
            outputCalendar
        });
        return clone(this, {
            loc
        });
    }
    /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */ setLocale(locale) {
        return this.reconfigure({
            locale
        });
    }
    /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */ set(values) {
        if (!this.isValid) return this;
        const normalized = normalizeObject(values, normalizeUnitWithLocalWeeks);
        const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, this.loc);
        const settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        let mixed;
        if (settingWeekStuff) mixed = weekToGregorian({
            ...gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek),
            ...normalized
        }, minDaysInFirstWeek, startOfWeek);
        else if (!isUndefined(normalized.ordinal)) mixed = ordinalToGregorian({
            ...gregorianToOrdinal(this.c),
            ...normalized
        });
        else {
            mixed = {
                ...this.toObject(),
                ...normalized
            };
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if (isUndefined(normalized.day)) mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        const [ts, o] = objToTS(mixed, this.o, this.zone);
        return clone(this, {
            ts,
            o
        });
    }
    /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */ plus(duration) {
        if (!this.isValid) return this;
        const dur = Duration.fromDurationLike(duration);
        return clone(this, adjustTime(this, dur));
    }
    /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */ minus(duration) {
        if (!this.isValid) return this;
        const dur = Duration.fromDurationLike(duration).negate();
        return clone(this, adjustTime(this, dur));
    }
    /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */ startOf(unit, { useLocaleWeeks = false } = {}) {
        if (!this.isValid) return this;
        const o = {}, normalizedUnit = Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") {
            if (useLocaleWeeks) {
                const startOfWeek = this.loc.getStartOfWeek();
                const { weekday } = this;
                if (weekday < startOfWeek) o.weekNumber = this.weekNumber - 1;
                o.weekday = startOfWeek;
            } else o.weekday = 1;
        }
        if (normalizedUnit === "quarters") {
            const q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    }
    /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */ endOf(unit, opts) {
        return this.isValid ? this.plus({
            [unit]: 1
        }).startOf(unit, opts).minus(1) : this;
    }
    // OUTPUT
    /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */ toFormat(fmt, opts = {}) {
        return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID;
    }
    /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */ toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
        return this.isValid ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : INVALID;
    }
    /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */ toLocaleParts(opts = {}) {
        return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'years', 'months', 'days', 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @example DateTime.now().toISO({ precision: 'day' }) //=> '2017-04-22Z'
   * @example DateTime.now().toISO({ precision: 'minute' }) //=> '2017-04-22T20:47Z'
   * @return {string|null}
   */ toISO({ format = "extended", suppressSeconds = false, suppressMilliseconds = false, includeOffset = true, extendedZone = false, precision = "milliseconds" } = {}) {
        if (!this.isValid) return null;
        precision = normalizeUnit(precision);
        const ext = format === "extended";
        let c = toISODate(this, ext, precision);
        if (orderedUnits.indexOf(precision) >= 3) c += "T";
        c += toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision);
        return c;
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='day'] - truncate output to desired precision: 'years', 'months', or 'days'.
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @example DateTime.utc(1982, 5, 25).toISODate({ precision: 'month' }) //=> '1982-05'
   * @return {string|null}
   */ toISODate({ format = "extended", precision = "day" } = {}) {
        if (!this.isValid) return null;
        return toISODate(this, format === "extended", normalizeUnit(precision));
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */ toISOWeekDate() {
        return toTechFormat(this, "kkkk-'W'WW-c");
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, second: 56 }).toISOTime({ precision: 'minute' }) //=> '07:34Z'
   * @return {string}
   */ toISOTime({ suppressMilliseconds = false, suppressSeconds = false, includeOffset = true, includePrefix = false, extendedZone = false, format = "extended", precision = "milliseconds" } = {}) {
        if (!this.isValid) return null;
        precision = normalizeUnit(precision);
        let c = includePrefix && orderedUnits.indexOf(precision) >= 3 ? "T" : "";
        return c + toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision);
    }
    /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */ toRFC2822() {
        return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */ toHTTP() {
        return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string|null}
   */ toSQLDate() {
        if (!this.isValid) return null;
        return toISODate(this, true);
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */ toSQLTime({ includeOffset = true, includeZone = false, includeOffsetSpace = true } = {}) {
        let fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return toTechFormat(this, fmt, true);
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */ toSQL(opts = {}) {
        if (!this.isValid) return null;
        return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
    }
    /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */ toString() {
        return this.isValid ? this.toISO() : INVALID;
    }
    /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */ [Symbol.for("nodejs.util.inspect.custom")]() {
        if (this.isValid) return `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }`;
        else return `DateTime { Invalid, reason: ${this.invalidReason} }`;
    }
    /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */ valueOf() {
        return this.toMillis();
    }
    /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */ toMillis() {
        return this.isValid ? this.ts : NaN;
    }
    /**
   * Returns the epoch seconds (including milliseconds in the fractional part) of this DateTime.
   * @return {number}
   */ toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    }
    /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */ toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    }
    /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */ toJSON() {
        return this.toISO();
    }
    /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */ toBSON() {
        return this.toJSDate();
    }
    /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */ toObject(opts = {}) {
        if (!this.isValid) return {};
        const base = {
            ...this.c
        };
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    }
    /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */ toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    }
    // COMPARE
    /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */ diff(otherDateTime, unit = "milliseconds", opts = {}) {
        if (!this.isValid || !otherDateTime.isValid) return Duration.invalid("created by diffing an invalid DateTime");
        const durOpts = {
            locale: this.locale,
            numberingSystem: this.numberingSystem,
            ...opts
        };
        const units = maybeArray(unit).map(Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    }
    /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ diffNow(unit = "milliseconds", opts = {}) {
        return this.diff(DateTime.now(), unit, opts);
    }
    /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval|DateTime}
   */ until(otherDateTime) {
        return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
    }
    /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */ hasSame(otherDateTime, unit, opts) {
        if (!this.isValid) return false;
        const inputMs = otherDateTime.valueOf();
        const adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
    }
    /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */ equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    }
    /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds towards zero by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {string} [options.rounding="trunc"] - rounding method to use when rounding the numbers in the output. Can be "trunc" (toward zero), "expand" (away from zero), "round", "floor", or "ceil".
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */ toRelative(options = {}) {
        if (!this.isValid) return null;
        const base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        let units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        let unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return diffRelative(base, this.plus(padding), {
            ...options,
            numeric: "always",
            units,
            unit
        });
    }
    /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */ toRelativeCalendar(options = {}) {
        if (!this.isValid) return null;
        return diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, {
            ...options,
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        });
    }
    /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */ static min(...dateTimes) {
        if (!dateTimes.every(DateTime.isDateTime)) throw new InvalidArgumentError("min requires all arguments be DateTimes");
        return bestBy(dateTimes, (i)=>i.valueOf(), Math.min);
    }
    /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */ static max(...dateTimes) {
        if (!dateTimes.every(DateTime.isDateTime)) throw new InvalidArgumentError("max requires all arguments be DateTimes");
        return bestBy(dateTimes, (i)=>i.valueOf(), Math.max);
    }
    // MISC
    /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */ static fromFormatExplain(text, fmt, options = {}) {
        const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
            locale,
            numberingSystem,
            defaultToEN: true
        });
        return explainFromTokens(localeToUse, text, fmt);
    }
    /**
   * @deprecated use fromFormatExplain instead
   */ static fromStringExplain(text, fmt, options = {}) {
        return DateTime.fromFormatExplain(text, fmt, options);
    }
    /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */ static buildFormatParser(fmt, options = {}) {
        const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
            locale,
            numberingSystem,
            defaultToEN: true
        });
        return new TokenParser(localeToUse, fmt);
    }
    /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */ static fromFormatParser(text, formatParser, opts = {}) {
        if (isUndefined(text) || isUndefined(formatParser)) throw new InvalidArgumentError("fromFormatParser requires an input string and a format parser");
        const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
            locale,
            numberingSystem,
            defaultToEN: true
        });
        if (!localeToUse.equals(formatParser.locale)) throw new InvalidArgumentError(`fromFormatParser called with a locale of ${localeToUse}, ` + `but the format parser was created for ${formatParser.locale}`);
        const { result, zone, specificOffset, invalidReason } = formatParser.explainFromTokens(text);
        if (invalidReason) return DateTime.invalid(invalidReason);
        else return parseDataToDateTime(result, zone, opts, `format ${formatParser.format}`, text, specificOffset);
    }
    // FORMAT PRESETS
    /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */ static get DATE_SHORT() {
        return DATE_SHORT;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */ static get DATE_MED() {
        return DATE_MED;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */ static get DATE_MED_WITH_WEEKDAY() {
        return DATE_MED_WITH_WEEKDAY;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */ static get DATE_FULL() {
        return DATE_FULL;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */ static get DATE_HUGE() {
        return DATE_HUGE;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_SIMPLE() {
        return TIME_SIMPLE;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_WITH_SECONDS() {
        return TIME_WITH_SECONDS;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_WITH_SHORT_OFFSET() {
        return TIME_WITH_SHORT_OFFSET;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_WITH_LONG_OFFSET() {
        return TIME_WITH_LONG_OFFSET;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */ static get TIME_24_SIMPLE() {
        return TIME_24_SIMPLE;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */ static get TIME_24_WITH_SECONDS() {
        return TIME_24_WITH_SECONDS;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */ static get TIME_24_WITH_SHORT_OFFSET() {
        return TIME_24_WITH_SHORT_OFFSET;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */ static get TIME_24_WITH_LONG_OFFSET() {
        return TIME_24_WITH_LONG_OFFSET;
    }
    /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_SHORT() {
        return DATETIME_SHORT;
    }
    /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_SHORT_WITH_SECONDS() {
        return DATETIME_SHORT_WITH_SECONDS;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_MED() {
        return DATETIME_MED;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_MED_WITH_SECONDS() {
        return DATETIME_MED_WITH_SECONDS;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_MED_WITH_WEEKDAY() {
        return DATETIME_MED_WITH_WEEKDAY;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_FULL() {
        return DATETIME_FULL;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_FULL_WITH_SECONDS() {
        return DATETIME_FULL_WITH_SECONDS;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_HUGE() {
        return DATETIME_HUGE;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_HUGE_WITH_SECONDS() {
        return DATETIME_HUGE_WITH_SECONDS;
    }
}
/**
 * @private
 */ function friendlyDateTime(dateTimeish) {
    if (DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) return DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return DateTime.fromObject(dateTimeish);
    else throw new InvalidArgumentError(`Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`);
}
const VERSION = "3.7.2";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"76s4u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addLatLongControl", ()=>addLatLongControl);
var _proj = require("ol/proj");
var _latLongControl = require("../controls/LatLongControl");
function addLatLongControl(map, view, target) {
    const latLongControl = new (0, _latLongControl.LatLongControl)(view, {
        target: target
    });
    view.on("change:center", (event)=>{
        const lonLatCenter = (0, _proj.toLonLat)(event.target.getCenter(), event.target.getProjection());
        latLongControl.set("latLong", `${lonLatCenter[1].toFixed(7)}, ${lonLatCenter[0].toFixed(7)}`);
    });
    map.addControl(latLongControl);
}

},{"ol/proj":"gN0IK","../controls/LatLongControl":"2xqhH","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2xqhH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LatLongControl", ()=>LatLongControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
var _proj = require("ol/proj");
class LatLongControl extends (0, _controlDefault.default) {
    constructor(view, opt_options){
        const options = opt_options || {};
        const element = document.createElement("ul");
        super({
            element: element,
            target: options.target
        });
        const this_ = this;
        element.className = "lat-long-input ol-unselectable";
        const latLongInput = document.createElement("input");
        element.appendChild(latLongInput);
        const swapBtn = document.createElement("button");
        swapBtn.type = "button";
        swapBtn.className = "swap-coords-btn";
        swapBtn.textContent = "\u21C4";
        swapBtn.title = "Swap coordinate order and recenter";
        swapBtn.addEventListener("click", ()=>{
            const val = latLongInput.value;
            const match = val.match(/^\s*(-?\d*(?:\.\d+)?)\s*([,\s])\s*(-?\d*(?:\.\d+)?)\s*$/);
            if (!match) return;
            const sep = match[2] === "," ? ", " : " ";
            const newLat = Number(match[3]);
            const newLon = Number(match[1]);
            latLongInput.value = match[3] + sep + match[1];
            if (Number.isFinite(newLat) && Number.isFinite(newLon)) view.setCenter((0, _proj.transform)([
                newLon,
                newLat
            ], "EPSG:4326", "EPSG:3857"));
        });
        element.appendChild(swapBtn);
        const cajBtn = document.createElement("button");
        cajBtn.type = "button";
        cajBtn.className = "caj-nav-btn";
        cajBtn.style.marginLeft = "auto";
        cajBtn.textContent = "CaJ";
        cajBtn.title = "Open this view in the CaJ editor";
        cajBtn.addEventListener("click", ()=>{
            const center = view.getCenter();
            const zoom = view.getZoom();
            if (!center || zoom == null) return;
            const [lon, lat] = (0, _proj.toLonLat)(center);
            const params = new URLSearchParams();
            params.set("center", `${lon.toFixed(6)},${lat.toFixed(6)}`);
            params.set("zoom", zoom.toFixed(4));
            // APIM serves /caj-editor from the caj-editor.html blob; the Parcel
            // dev server doesn't do that stripping, so fall back to the extension
            // locally.
            const path = window.location.hostname === "localhost" ? "caj-editor.html" : "/caj-editor";
            window.location.href = `${path}?${params.toString()}`;
        });
        element.appendChild(cajBtn);
        const vertexBtn = document.createElement("button");
        vertexBtn.type = "button";
        vertexBtn.className = "caj-nav-btn";
        vertexBtn.textContent = "Vertex";
        vertexBtn.title = "Open this view in Vertex";
        vertexBtn.addEventListener("click", ()=>{
            const center = view.getCenter();
            const zoom = view.getZoom();
            if (!center || zoom == null) return;
            const [lon, lat] = (0, _proj.toLonLat)(center);
            window.open(`https://orbis.vertex.tomtom.com/#map=${zoom.toFixed(2)}/${lat.toFixed(6)}/${lon.toFixed(6)}`, "_blank", "noopener,noreferrer");
        });
        element.appendChild(vertexBtn);
        const ndsBtn = document.createElement("button");
        ndsBtn.type = "button";
        ndsBtn.className = "caj-nav-btn";
        ndsBtn.textContent = "NDS";
        ndsBtn.title = "Open this view in NDS.live viewer";
        ndsBtn.addEventListener("click", ()=>{
            const center = view.getCenter();
            const zoom = view.getZoom();
            if (!center || zoom == null) return;
            const [lon, lat] = (0, _proj.toLonLat)(center);
            // Calibrated from two data points: zoom 10→alt 185697, zoom 19→alt 226
            const alt = Math.round(Math.exp(19.59 - 0.746 * zoom));
            const params = new URLSearchParams();
            params.set("lon", lon.toFixed(6));
            params.set("lat", lat.toFixed(6));
            params.set("alt", alt);
            params.set("m2d", "1");
            window.open(`https://mapviewer.delivery-umd-acc.maps.az.tt3.com/?${params.toString()}`, "_blank", "noopener,noreferrer");
        });
        element.appendChild(ndsBtn);
        latLongInput.addEventListener("keyup", function(event) {
            if (event.code === "Enter") {
                let pattern = new RegExp("^\\s*-?\\d*(?:\\.\\d+)?\\s*([,\\s])\\s*-?\\d*(?:\\.\\d+)?\\s*$", "m");
                let inputValue = latLongInput.value;
                if (pattern.test(inputValue)) {
                    let delimiter = inputValue.match(pattern)[1];
                    let [lat, ...long] = inputValue.trimStart().split(delimiter);
                    let latLong = [
                        lat,
                        long.join("")
                    ].map(Number);
                    view.setCenter((0, _proj.transform)([
                        latLong[1],
                        latLong[0]
                    ], "EPSG:4326", "EPSG:3857"));
                    view.setZoom(20);
                } else {
                    alert("Please enter latlong in format: lat, long");
                    latLongInput.focus();
                }
            }
        });
        // listen to changes
        this.on("propertychange", ()=>{
            latLongInput.value = this_.get("latLong");
        });
    }
}

},{"ol/control/Control":"8KSMn","ol/proj":"gN0IK","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9IQmt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addBoundaryCodesControl", ()=>addBoundaryCodesControl);
var _proj = require("ol/proj");
var _boundaryCodesControl = require("../controls/BoundaryCodesControl");
async function fetchBoundaryCodes(lon, lat, idToken) {
    const url = `${"/boundary-codes-prod"}?lon=${lon}&lat=${lat}`;
    const headers = idToken ? {
        Authorization: `Bearer ${idToken}`
    } : {};
    const response = await fetch(url, {
        headers
    });
    if (!response.ok) throw new Error(`Failed to fetch boundary codes: ${response.statusText}`);
    return await response.text();
}
function addBoundaryCodesControl(map, view, target, azureLoginControl) {
    const boundaryCodesControl = new (0, _boundaryCodesControl.BoundaryCodesControl)({
        target: target
    });
    let debounceTimer;
    view.on("change:center", (event)=>{
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(async ()=>{
            const lonLatCenter = (0, _proj.toLonLat)(event.target.getCenter(), event.target.getProjection());
            const lon = lonLatCenter[0].toFixed(7);
            const lat = lonLatCenter[1].toFixed(7);
            try {
                const idToken = azureLoginControl?.get("idToken");
                // Only fetch if we have a valid token
                if (!idToken) {
                    console.warn("No authentication token available");
                    boundaryCodesControl.setError("Not authenticated");
                    return;
                }
                const codes = await fetchBoundaryCodes(lon, lat, idToken);
                boundaryCodesControl.setBoundaryCodes(codes);
            } catch (error) {
                console.error("Error fetching boundary codes:", error);
                boundaryCodesControl.setError(error.message);
            }
        }, 1000);
    });
    map.addControl(boundaryCodesControl);
}

},{"ol/proj":"gN0IK","../controls/BoundaryCodesControl":"dtoAa","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dtoAa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BoundaryCodesControl", ()=>BoundaryCodesControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
class BoundaryCodesControl extends (0, _controlDefault.default) {
    constructor(opt_options){
        const options = opt_options || {};
        const element = document.createElement("ul");
        super({
            element: element,
            target: options.target
        });
        element.className = "boundary-codes-display ol-unselectable";
        const codesDiv = document.createElement("div");
        codesDiv.className = "boundary-codes-list";
        element.appendChild(codesDiv);
        this.codesDiv = codesDiv;
    }
    setBoundaryCodes(codes) {
        if (codes && codes.length > 0) {
            this.codesDiv.textContent = codes;
            this.codesDiv.style.display = "block";
        } else this.codesDiv.style.display = "none";
    }
    setError(errorMessage) {
        // Silently hide on error - no error messages shown
        console.error("Boundary codes error:", errorMessage);
        this.codesDiv.style.display = "none";
    }
}

},{"ol/control/Control":"8KSMn","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gEHhK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addDateInputControl", ()=>addDateInputControl);
var _handleURL = require("../handleURL");
var _dateInputControl = require("../controls/DateInputControl");
var _urlstateManager = require("../state/URLStateManager");
function addDateInputControl(map, target) {
    const dateInputControl = new (0, _dateInputControl.DateInputControl)({
        target: target
    });
    map.addControl(dateInputControl);
    (0, _handleURL.handleURLForDate)(dateInputControl);
    (0, _urlstateManager.registerDateControl)(dateInputControl);
    return dateInputControl;
}

},{"../handleURL":"53YIf","../controls/DateInputControl":"8OG6J","../state/URLStateManager":"7Lluw","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"53YIf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleURLForWKT", ()=>handleURLForWKT);
parcelHelpers.export(exports, "handleURLForDate", ()=>handleURLForDate);
function handleURLForWKT(wktInputControl) {
    const wkt = getWKTURL();
    if (wkt != null && wkt != "") {
        // If the URL has no center/zoom, zoom to the WKT extent so the feature
        // is visible. When the URL also specifies a view, respect it instead.
        const params = new URLSearchParams(window.location.search);
        if (!params.get("center") || !params.get("zoom")) wktInputControl.set("zoomToExtent", true);
        wktInputControl.set("wkt", wkt);
    }
}
function handleURLForDate(dateInputControl) {
    if (getStartDateURL() != null && getEndDateURL() != null) dateInputControl.setProperties({
        startDate: getStartDateURL(),
        endDate: getEndDateURL()
    });
}
function getWKTURL() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("wkt");
}
function getStartDateURL() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("startDate");
}
function getEndDateURL() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("endDate");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8OG6J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateInputControl", ()=>DateInputControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
var _luxon = require("luxon");
class DateInputControl extends (0, _controlDefault.default) {
    constructor(opt_options){
        const options = opt_options || {};
        const element = document.createElement("ul");
        super({
            element: element,
            target: options.target
        });
        const this_ = this;
        element.className = "date-input ol-unselectable";
        let li;
        // dates
        const inputStart = document.createElement("input");
        inputStart.type = "date";
        inputStart.value = (0, _luxon.DateTime).utc().startOf("month").minus({
            weeks: 1
        }).toISODate();
        li = document.createElement("li");
        li.appendChild(inputStart);
        element.appendChild(li);
        const inputEnd = document.createElement("input");
        inputEnd.type = "date";
        inputEnd.value = (0, _luxon.DateTime).utc().startOf("month").toISODate();
        li = document.createElement("li");
        li.appendChild(inputEnd);
        element.appendChild(li);
        const button = document.createElement("button");
        button.innerHTML = "Update";
        button.addEventListener("click", function() {
            this_.setProperties({
                startDate: inputStart.value,
                endDate: inputEnd.value
            });
        }, false);
        li = document.createElement("li");
        li.appendChild(button);
        element.appendChild(li);
        // initialize values
        this.setProperties({
            startDate: inputStart.value,
            endDate: inputEnd.value
        });
        // listen to changes
        this.on("propertychange", ()=>{
            inputStart.value = this_.get("startDate");
            inputEnd.value = this_.get("endDate");
        });
    }
}

},{"ol/control/Control":"8KSMn","luxon":"6apd3","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2FOUV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addHeatmapLayersAndControls", ()=>addHeatmapLayersAndControls);
var _directionalHeatmapControl = require("../controls/DirectionalHeatmapControl");
var _dataSourceControl = require("../controls/DataSourceControl");
var _directionalLayers = require("../layers/DirectionalLayers");
var _directionalMotion = require("../layers/DirectionalMotion");
var _colorScale = require("../layers/style/util/colorScale");
var _urlstateManager = require("../state/URLStateManager");
function addHeatmapLayersAndControls(map, azureLoginControl, dateInputControl, target, layerGroup, featureInfoControl) {
    // Heatmap layer Controls
    const directionalHeatmapControl = new (0, _directionalHeatmapControl.DirectionalHeatmapControl)({
        target: target
    });
    const dataSourceControl = new (0, _dataSourceControl.DataSourceControl)({
        target: target
    });
    map.addControl(directionalHeatmapControl);
    map.addControl(dataSourceControl);
    directionalHeatmapControl.restoreState((0, _urlstateManager.getFCDToggleFromURL)(), (0, _urlstateManager.getFCDModeFromURL)(), (0, _urlstateManager.getFCDDirectionsFromURL)());
    (0, _urlstateManager.registerHeatmapControl)(directionalHeatmapControl);
    const fcdDataSource = (0, _urlstateManager.getFCDDataSourceFromURL)();
    if (fcdDataSource != null) dataSourceControl.set("dataSource", fcdDataSource);
    (0, _urlstateManager.registerDataSourceControl)(dataSourceControl);
    // Created once: AzureLoginControl refreshes the token every few minutes and
    // the WMS loader reads it per request, so a refresh must not rebuild layers.
    let directionalLayers;
    azureLoginControl.on("propertychange", function() {
        const authorized = azureLoginControl.get("idToken") && azureLoginControl.get("idTokenClaims") && azureLoginControl.get("idTokenClaims").roles && azureLoginControl.get("idTokenClaims").roles.includes("FCD.Reader");
        if (authorized && !directionalLayers) {
            directionalLayers = (0, _directionalLayers.getDirectionalLayers)(dateInputControl, azureLoginControl, dataSourceControl, directionalHeatmapControl);
            directionalHeatmapControl.set("directionalLayers", directionalLayers);
            const isMotionMode = ()=>directionalHeatmapControl.get("displayMode") === "motion";
            directionalLayers.forEach(function(layer) {
                (0, _directionalMotion.attachMotionRecolor)(layer, isMotionMode);
                layerGroup.getLayers().push(layer);
            });
            layerGroup.getLayers().push((0, _directionalMotion.createMotionOverlayLayer)(directionalLayers, map, isMotionMode));
        }
    });
    map.on("moveend", function() {
        directionalHeatmapControl.set("zoom", map.getView().getZoom());
        dataSourceControl.set("zoom", map.getView().getZoom());
    });
    let hoverFrame = null;
    let lastSpeedsKey = null;
    map.on("pointermove", function(e) {
        if (e.dragging || e.originalEvent.target.tagName !== "CANVAS") return;
        if (hoverFrame !== null) return;
        hoverFrame = requestAnimationFrame(function() {
            hoverFrame = null;
            // Motion mode also renders the WMS speed image, so it can be sampled.
            const mode = directionalHeatmapControl.get("displayMode");
            const inSpeedMode = mode === "speed" || mode === "motion";
            const fcdOn = directionalHeatmapControl.get("heatmapToggle") === true;
            const active = directionalHeatmapControl.get("active") === true;
            let speeds = null;
            if (inSpeedMode && fcdOn && active && directionalLayers) {
                const sampled = {};
                directionalLayers.forEach(function(layer, id) {
                    if (!layer.getVisible() || layer.getOpacity() === 0) return;
                    const data = layer.getData(e.pixel);
                    if (!data || data[3] === 0) return;
                    sampled[id] = (0, _colorScale.interpolatedSpeedFromColor)([
                        data[0],
                        data[1],
                        data[2]
                    ], (0, _directionalLayers.SPEED_BREAKPOINTS));
                });
                if (Object.keys(sampled).length > 0) speeds = sampled;
            }
            const key = speeds === null ? null : Object.keys(speeds).map(Number).sort((a, b)=>a - b).map((id)=>id + ":" + speeds[id]).join(",");
            if (key === lastSpeedsKey) return;
            lastSpeedsKey = key;
            featureInfoControl.set("fcdSpeeds", speeds);
        });
    });
}

},{"../controls/DirectionalHeatmapControl":"hO7Hz","../controls/DataSourceControl":"fXIgK","../layers/DirectionalLayers":"ffH8s","../layers/DirectionalMotion":"eKqIN","../layers/style/util/colorScale":"dOPOB","../state/URLStateManager":"7Lluw","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hO7Hz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DirectionalHeatmapControl", ()=>DirectionalHeatmapControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
var _directionalLayers = require("../layers/DirectionalLayers");
var _directionalMotion = require("../layers/DirectionalMotion");
var _colorScale = require("../layers/style/util/colorScale");
class DirectionalHeatmapControl extends (0, _controlDefault.default) {
    constructor(opt_options){
        const options = opt_options || {};
        const element = document.createElement("div");
        super({
            element: element,
            target: options.target
        });
        const this_ = this;
        element.className = "directional-control ol-unselectable ol-control";
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.className = "heatmap-checkbox";
        checkbox.id = "heatmap-input";
        checkbox.checked = false;
        const label = document.createElement("label");
        label.htmlFor = "heatmap-input";
        label.className = "heatmap-text";
        label.innerText = "FCD";
        checkbox.addEventListener("change", function() {
            this_.set("heatmapToggle", checkbox.checked);
        });
        this_.set("heatmapToggle", checkbox.checked);
        let _pendingDirections = null;
        function updateActiveDirections() {
            const layers = this_.get("directionalLayers");
            if (!layers) return;
            const active = [];
            layers.forEach(function(layer, id) {
                if (layer.getOpacity() > 0) active.push(id);
            });
            this_.set("activeDirections", active.join(","));
        }
        this.restoreState = function(fcdToggle, fcdMode, fcdDirs) {
            if (fcdToggle) {
                checkbox.checked = true;
                this_.set("heatmapToggle", true);
            }
            if (fcdMode === "speed") {
                speedRadio.checked = true;
                onModeChange();
            } else if (fcdMode === "motion") {
                motionRadio.checked = true;
                onModeChange();
            }
            if (fcdDirs) _pendingDirections = fcdDirs;
        };
        const modeContainer = document.createElement("div");
        const densityRadio = document.createElement("input");
        densityRadio.type = "radio";
        densityRadio.name = "fcd-mode";
        densityRadio.id = "fcd-mode-density";
        densityRadio.value = "density";
        densityRadio.checked = true;
        const densityLabel = document.createElement("label");
        densityLabel.htmlFor = "fcd-mode-density";
        densityLabel.innerText = "Density";
        const speedRadio = document.createElement("input");
        speedRadio.type = "radio";
        speedRadio.name = "fcd-mode";
        speedRadio.id = "fcd-mode-speed";
        speedRadio.value = "speed";
        const speedLabel = document.createElement("label");
        speedLabel.htmlFor = "fcd-mode-speed";
        speedLabel.innerText = "Speed";
        const motionRadio = document.createElement("input");
        motionRadio.type = "radio";
        motionRadio.name = "fcd-mode";
        motionRadio.id = "fcd-mode-motion";
        motionRadio.value = "motion";
        const motionLabel = document.createElement("label");
        motionLabel.htmlFor = "fcd-mode-motion";
        motionLabel.innerText = "Motion";
        modeContainer.appendChild(densityRadio);
        modeContainer.appendChild(densityLabel);
        modeContainer.appendChild(speedRadio);
        modeContainer.appendChild(speedLabel);
        modeContainer.appendChild(motionRadio);
        modeContainer.appendChild(motionLabel);
        const speedLegend = document.createElement("div");
        speedLegend.style.cssText = "display:none; flex-direction:column; margin-left:4px; padding-top:4px;";
        const legendWrapper = document.createElement("div");
        legendWrapper.style.cssText = "display:flex; align-items:stretch;";
        const gradientBar = document.createElement("div");
        gradientBar.style.cssText = "width:10px; height:140px;background: " + (0, _colorScale.speedGradient)("to top", (0, _directionalLayers.SPEED_BREAKPOINTS)) + ";";
        const legendLabels = document.createElement("div");
        legendLabels.style.cssText = "position:relative; margin-left:2px; font-size:9px; height:140px; width:1.6em;";
        const minSpeed = (0, _directionalLayers.SPEED_BREAKPOINTS)[0];
        const maxSpeed = (0, _directionalLayers.SPEED_BREAKPOINTS)[(0, _directionalLayers.SPEED_BREAKPOINTS).length - 1];
        const speedRange = maxSpeed - minSpeed;
        (0, _directionalLayers.SPEED_BREAKPOINTS).forEach(function(speed, i) {
            const topPct = (maxSpeed - speed) / speedRange * 100;
            const span = document.createElement("span");
            span.style.cssText = "position:absolute; left:0; top:" + topPct.toFixed(2) + "%; transform:translateY(-50%);";
            span.innerText = i === (0, _directionalLayers.SPEED_BREAKPOINTS).length - 1 ? speed + "+" : speed;
            legendLabels.appendChild(span);
        });
        const legendUnit = document.createElement("div");
        legendUnit.style.cssText = "font-size:9px; text-align:center; margin-top:2px;";
        legendUnit.innerText = "km/h";
        legendWrapper.appendChild(gradientBar);
        legendWrapper.appendChild(legendLabels);
        speedLegend.appendChild(legendWrapper);
        speedLegend.appendChild(legendUnit);
        const modeOpacity = {
            density: (0, _directionalLayers.DIRECTIONAL_OPACITY),
            speed: (0, _directionalLayers.SPEED_OPACITY),
            motion: (0, _directionalMotion.MOTION_OPACITY)
        };
        function currentOpacity() {
            return modeOpacity[this_.get("displayMode")];
        }
        function wheelFill(mode, i) {
            if (mode === "speed") return "#808080";
            if (mode === "motion") return 0, _directionalMotion.MOTION_COLOR;
            return originalFills[i];
        }
        function onModeChange() {
            const mode = [
                densityRadio,
                speedRadio,
                motionRadio
            ].find((radio)=>radio.checked).value;
            this_.set("displayMode", mode);
            speedLegend.style.display = mode === "speed" ? "flex" : "none";
            const opacity = modeOpacity[mode];
            [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ].forEach(function(i) {
                wheel.getElementById("svg-" + i).setAttribute("fill", wheelFill(mode, i));
            });
            const layers = this_.get("directionalLayers");
            if (layers) layers.forEach(function(layer) {
                if (layer.getOpacity() > 0) layer.setOpacity(opacity);
            });
        }
        densityRadio.addEventListener("change", onModeChange);
        speedRadio.addEventListener("change", onModeChange);
        motionRadio.addEventListener("change", onModeChange);
        this_.set("displayMode", "density");
        const wheel = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        wheel.style.display = "block";
        wheel.setAttribute("width", 150);
        wheel.setAttribute("heigth", 150);
        wheel.innerHTML = `
       <g transform="translate(80,80) rotate(90)">
        <circle id="svg-1" fill="#FFFF00" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(-43.10070037841797,0)"></circle>
        <circle id="svg-2" fill="#FF8000" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(-37.32630144861153,-21.55035018920898)"></circle>
        <circle id="svg-3" fill="#FF0000" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(-21.550350189208988,-37.326301448611524)"></circle>
        <circle id="svg-4" fill="#FF0080" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(-2.639156737971934e-15,-43.10070037841797)"></circle>
        <circle id="svg-5" fill="#FF00FF" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(21.550350189208974,-37.32630144861153)"></circle>
        <circle id="svg-6" fill="#8000FF" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(37.32630144861153,-21.55035018920898)"></circle>
        <circle id="svg-7" fill="#0000FF" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(43.10070037841797,-5.278313475943868e-15)"></circle>
        <circle id="svg-8" fill="#0080FF" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(37.326301448611524,21.550350189208988)"></circle>
        <circle id="svg-9" fill="#00FFFF" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(21.550350189209002,37.326301448611524)"></circle>
        <circle id="svg-10" fill="#00FF80" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(7.917470213915802e-15,43.10070037841797)"></circle>
        <circle id="svg-11" fill="#00FF00" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(-21.550350189208988,37.326301448611524)"></circle>
        <circle id="svg-12" fill="#80FF00" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(-37.32630144861152,21.550350189209002)"></circle>
        <text refx="50%" refy="50%" id="select-clear-svg" class="select-clear" transform="rotate(-90)" style="text-anchor: middle;">Clear All</text>
        <text id="N-pole-svg" class="pole" transform="translate(-66.99347993601923,0) rotate(-90)" style="text-anchor: middle;">N</text>
        <text id="E-pole-svg" class="pole" transform="translate(-4.102167538369419e-15,-66.99347993601923) rotate(-90)" style="text-anchor: middle;">E</text>
        <text id="S-pole-svg" class="pole" transform="translate(66.99347993601923,-8.204335076738838e-15) rotate(-90)" style="text-anchor: middle;">S</text>
        <text id="W-pole-svg" class="pole" transform="translate(1.2306502615108255e-14,66.99347993601923) rotate(-90)" style="text-anchor: middle;">W</text>
      </g>`;
        function buttonCleared(button) {
            button.setAttribute("fill-opacity", 0.2);
            button.setAttribute("stroke-width", 0);
        }
        function buttonSelected(button) {
            button.setAttribute("fill-opacity", 1);
            button.setAttribute("stroke-width", 2);
        }
        function toggleDirectionalHeatmap(button) {
            const layer = button._layer;
            if (layer.getOpacity() > 0) {
                layer.setOpacity(0);
                buttonCleared(button);
            } else {
                layer.setOpacity(currentOpacity());
                buttonSelected(button);
            }
            updateActiveDirections();
        }
        [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ].forEach(function(i) {
            const button = wheel.getElementById("svg-" + i);
            button.addEventListener("click", toggleDirectionalHeatmap.bind(null, button), false);
        });
        const originalFills = {};
        [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ].forEach(function(i) {
            originalFills[i] = wheel.getElementById("svg-" + i).getAttribute("fill");
        });
        const wheelRow = document.createElement("div");
        wheelRow.style.cssText = "display:flex; align-items:flex-start;";
        wheelRow.appendChild(wheel);
        wheelRow.appendChild(speedLegend);
        this.on("propertychange", function(e) {
            const buttons = [];
            function selectClear(el, buttons, directionalLayers) {
                if (el.textContent == "Clear All") {
                    for (const id of directionalLayers.keys())directionalLayers.get(id).setOpacity(0);
                    buttons.forEach((button)=>buttonCleared(button));
                    el.textContent = "Select All";
                } else {
                    for (const id of directionalLayers.keys())directionalLayers.get(id).setOpacity(currentOpacity());
                    buttons.forEach((button)=>buttonSelected(button));
                    el.textContent = "Clear All";
                }
                updateActiveDirections();
            }
            if (e.key === "zoom") {
                const zoom = e.target.get("zoom");
                if (zoom >= 17) this_.set("active", true);
                else this_.set("active", false);
            }
            const layers = this_.get("directionalLayers");
            if (layers !== undefined) layers.forEach(function(layer, i) {
                const button = wheel.getElementById("svg-" + i);
                buttons.push(button);
                if (this_.get("heatmapToggle") === false) layer.setVisible(false);
                else {
                    layer.setVisible(true);
                    layer.changed();
                }
                button._layer = layer;
                layer.getSource().on("imageloadstart", ()=>{
                    button.setAttribute("stroke", "white");
                });
                layer.on("rendercomplete", ()=>{
                    button.setAttribute("stroke", "black");
                });
                layer.getSource().on("imageloaderror", ()=>{
                    button.setAttribute("stroke", "red");
                });
                layer.on("change", ()=>{
                    button.setAttribute("stroke", "black");
                });
            });
            if (_pendingDirections && layers) {
                const opacity = currentOpacity();
                const activeSet = new Set(_pendingDirections);
                layers.forEach(function(layer, id) {
                    const button = wheel.getElementById("svg-" + id);
                    if (!activeSet.has(id)) {
                        layer.setOpacity(0);
                        buttonCleared(button);
                    } else layer.setOpacity(opacity);
                });
                _pendingDirections = null;
                updateActiveDirections();
            } else if (layers && this_.get("displayMode") !== "density") {
                const opacity = currentOpacity();
                layers.forEach(function(layer) {
                    if (layer.getOpacity() > 0) layer.setOpacity(opacity);
                });
            }
            if (this_.get("active")) {
                label.style.color = "black";
                wheel.style.opacity = "100%";
            } else {
                label.style.color = "grey";
                wheel.style.opacity = "20%";
            }
            // Clear all, select all
            const selectClearButton = wheel.getElementById("select-clear-svg");
            selectClearButton.addEventListener("click", selectClear.bind(null, selectClearButton, buttons, this_.get("directionalLayers")), false);
            element.appendChild(checkbox);
            element.appendChild(label);
            element.appendChild(modeContainer);
            element.appendChild(wheelRow);
        });
    }
}

},{"ol/control/Control":"8KSMn","../layers/DirectionalLayers":"ffH8s","../layers/DirectionalMotion":"eKqIN","../layers/style/util/colorScale":"dOPOB","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ffH8s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DIRECTIONAL_OPACITY", ()=>DIRECTIONAL_OPACITY);
parcelHelpers.export(exports, "SPEED_OPACITY", ()=>SPEED_OPACITY);
parcelHelpers.export(exports, "SPEED_BREAKPOINTS", ()=>SPEED_BREAKPOINTS);
parcelHelpers.export(exports, "getDirectionalLayers", ()=>getDirectionalLayers);
var _imageWMS = require("ol/source/ImageWMS");
var _imageWMSDefault = parcelHelpers.interopDefault(_imageWMS);
var _image = require("ol/layer/Image");
var _imageDefault = parcelHelpers.interopDefault(_image);
var _proj = require("ol/proj");
var _luxon = require("luxon");
var _colorScale = require("./style/util/colorScale");
const DIRECTIONAL_OPACITY = 0.4;
const SPEED_OPACITY = 0.99;
const SPEED_BREAKPOINTS = [
    0,
    15,
    30,
    50,
    70,
    90,
    120,
    130
];
const imageURLMap = {};
function getParams(direction, startDateISO, endDateISO, dataSource, displayMode) {
    // Motion mode animates at the FCD speed, so it needs the speed image too.
    if (displayMode === "speed" || displayMode === "motion") return {
        LAYERS: "speed",
        SPEED_STYLE: (0, _colorScale.wmsSpeedStyle)(SPEED_BREAKPOINTS),
        STYLES: null,
        VERSION: "1.1.1",
        TIME: `${startDateISO}/${endDateISO}`,
        DATE_RANGE: null,
        ONLY_ALLOW_DIRECTIONS: "" + direction,
        DATA_SOURCE: dataSource
    };
    const startDate = (0, _luxon.DateTime).fromISO(startDateISO).toFormat("yyooo");
    const endDate = (0, _luxon.DateTime).fromISO(endDateISO).toFormat("yyooo");
    return {
        LAYERS: "averagedtrf",
        VERSION: "1.1.1",
        DATE_RANGE: `${startDate}-${endDate}`,
        TIME: null,
        SPEED_STYLE: null,
        STYLES: null,
        ONLY_ALLOW_DIRECTIONS: "" + direction,
        DATA_SOURCE: dataSource
    };
}
function getImageWMS(direction, startDateISO, endDateISO, azureLoginControl, dataSource) {
    return new (0, _imageWMSDefault.default)({
        url: "/wms/multi?",
        params: getParams(direction, startDateISO, endDateISO, dataSource, "density"),
        ratio: 1,
        projection: (0, _proj.get)("EPSG:900913"),
        imageLoadFunction: function(image, url) {
            // Read per request: the token is refreshed periodically and the layers
            // are created only once.
            const headers = {
                Authorization: "Bearer " + azureLoginControl.get("idToken")
            };
            fetch(url, {
                headers
            }).then((response)=>response.blob().then((imageData)=>{
                    let objectUrl = window.URL.createObjectURL(imageData);
                    image.getImage().src = objectUrl;
                    // cleanup
                    if (imageURLMap[direction]) window.URL.revokeObjectURL(imageURLMap[direction]);
                    imageURLMap[direction] = objectUrl;
                }));
            image.getImage().onchange = function(event) {
                console.log("change on heatmap layer event: " + event);
            };
        }
    });
}
function updateLayer(layer, direction, dateInputControl, dataSourceControl, directionalHeatmapControl) {
    layer.getSource().updateParams(getParams(direction, dateInputControl.get("startDate"), dateInputControl.get("endDate"), dataSourceControl.get("dataSource"), directionalHeatmapControl.get("displayMode")));
    layer.getSource().refresh();
}
function getDirectionalLayers(dateInputControl, azureLoginControl, dataSourceControl, directionalHeatmapControl) {
    var layers = new Map();
    for(var direction = 1; direction < 13; direction++){
        const layer = new (0, _imageDefault.default)({
            // Unique className = own canvas per direction, required by the motion
            // mode's per-layer `source-atop` compositing (see DirectionalMotion.js).
            className: "ol-layer fcd-direction-" + direction,
            opacity: DIRECTIONAL_OPACITY,
            minZoom: 17,
            source: getImageWMS(direction, dateInputControl.get("startDate"), dateInputControl.get("endDate"), azureLoginControl, dataSourceControl.get("dataSource"))
        });
        layers.set(direction + "", layer);
        const boundUpdate = updateLayer.bind(this, layer, direction, dateInputControl, dataSourceControl, directionalHeatmapControl);
        dateInputControl.on("propertychange", boundUpdate);
        dataSourceControl.on("propertychange", boundUpdate);
        directionalHeatmapControl.on("propertychange", boundUpdate);
    }
    return layers;
}

},{"ol/source/ImageWMS":"6M5Jy","ol/layer/Image":"516lS","ol/proj":"gN0IK","luxon":"6apd3","./style/util/colorScale":"dOPOB","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6M5Jy":[function(require,module,exports,__globalThis) {
/**
 * @module ol/source/ImageWMS
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _imageJs = require("../Image.js");
var _projJs = require("../proj.js");
var _reprojJs = require("../reproj.js");
var _imageJs1 = require("./Image.js");
var _imageJsDefault = parcelHelpers.interopDefault(_imageJs1);
var _wmsJs = require("./wms.js");
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy] The `referrerPolicy` property for loaded images.
 * @property {boolean} [hidpi=true] Use the `ol/Map#pixelRatio` value when requesting
 * the image from the remote server.
 * @property {import("./wms.js").ServerType} [serverType] The type of
 * the remote WMS server: `mapserver`, `geoserver`, `carmentaserver`, or `qgis`.
 * Only needed if `hidpi` is `true`.
 * @property {import("../Image.js").LoadFunction} [imageLoadFunction] Optional function to load an image given a URL.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {Object<string,*>} [params] WMS request parameters.
 * At least a `LAYERS` param is required. `STYLES` is
 * `''` by default. `VERSION` is `1.3.0` by default. `WIDTH`, `HEIGHT`, `BBOX`
 * and `CRS` (`SRS` for WMS version < 1.3.0) will be set dynamically.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [ratio=1.5] Ratio. `1` means image requests are the size of the map viewport, `2` means
 * twice the width and height of the map viewport, and so on. Must be `1` or higher.
 * @property {Array<number>} [resolutions] Resolutions.
 * If specified, requests will be made for these resolutions only.
 * @property {string} [url] WMS service URL.
 */ /**
 * @classdesc
 * Source for WMS servers providing single, untiled images.
 *
 * @fires module:ol/source/Image.ImageSourceEvent
 * @api
 */ class ImageWMS extends (0, _imageJsDefault.default) {
    /**
   * @param {Options} [options] ImageWMS options.
   */ constructor(options){
        options = options ? options : {};
        super({
            attributions: options.attributions,
            interpolate: options.interpolate,
            projection: options.projection,
            resolutions: options.resolutions
        });
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
     * @private
     * @type {ReferrerPolicy|undefined}
     */ this.referrerPolicy_ = options.referrerPolicy;
        /**
     * @private
     * @type {string|undefined}
     */ this.url_ = options.url;
        /**
     * @private
     * @type {import("../Image.js").LoadFunction}
     */ this.imageLoadFunction_ = options.imageLoadFunction !== undefined ? options.imageLoadFunction : (0, _imageJs1.defaultImageLoadFunction);
        /**
     * @private
     * @type {!Object}
     */ this.params_ = Object.assign({}, options.params);
        /**
     * @private
     * @type {import("./wms.js").ServerType|undefined}
     */ this.serverType_ = options.serverType;
        /**
     * @private
     * @type {boolean}
     */ this.hidpi_ = options.hidpi !== undefined ? options.hidpi : true;
        /**
     * @private
     * @type {number}
     */ this.renderedRevision_ = 0;
        /**
     * @private
     * @type {number}
     */ this.ratio_ = options.ratio !== undefined ? options.ratio : 1.5;
        /**
     * @private
     * @type {import("../proj/Projection.js").default|undefined}
     */ this.loaderProjection_ = undefined;
    }
    /**
   * Return the GetFeatureInfo URL for the passed coordinate, resolution, and
   * projection. Return `undefined` if the GetFeatureInfo URL cannot be
   * constructed.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {!Object} params GetFeatureInfo params. `INFO_FORMAT` at least should
   *     be provided. If `QUERY_LAYERS` is not provided then the layers specified
   *     in the `LAYERS` parameter will be used. `VERSION` should not be
   *     specified here.
   * @return {string|undefined} GetFeatureInfo URL.
   * @api
   */ getFeatureInfoUrl(coordinate, resolution, projection, params) {
        const projectionObj = /** @type {import("../proj/Projection.js").default} */ (0, _projJs.get)(projection);
        const sourceProjectionObj = this.getProjection();
        if (sourceProjectionObj && sourceProjectionObj !== projectionObj) {
            resolution = (0, _reprojJs.calculateSourceResolution)(sourceProjectionObj, projectionObj, coordinate, resolution);
            coordinate = (0, _projJs.transform)(coordinate, projectionObj, sourceProjectionObj);
        }
        const url = this.url_;
        if (!url) return undefined;
        const options = {
            url: url,
            params: {
                ...this.params_,
                ...params
            },
            projection: sourceProjectionObj || projectionObj
        };
        return (0, _wmsJs.getFeatureInfoUrl)(options, coordinate, resolution);
    }
    /**
   * Return the GetLegendGraphic URL, optionally optimized for the passed
   * resolution and possibly including any passed specific parameters. Returns
   * `undefined` if the GetLegendGraphic URL cannot be constructed.
   *
   * @param {number} [resolution] Resolution. If set to undefined, `SCALE`
   *     will not be calculated and included in URL.
   * @param {Object} [params] GetLegendGraphic params. If `LAYER` is set, the
   *     request is generated for this wms layer, else it will try to use the
   *     configured wms layer. Default `FORMAT` is `image/png`.
   *     `VERSION` should not be specified here.
   * @return {string|undefined} GetLegendGraphic URL.
   * @api
   */ getLegendUrl(resolution, params) {
        const url = this.url_;
        if (!url) return undefined;
        return (0, _wmsJs.getLegendUrl)({
            url: url,
            params: {
                ...this.params_,
                ...params
            }
        }, resolution);
    }
    /**
   * Get the user-provided params, i.e. those passed to the constructor through
   * the "params" option, and possibly updated using the updateParams method.
   * @return {Object} Params.
   * @api
   */ getParams() {
        return this.params_;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../Image.js").default|null} Single image.
   * @override
   */ getImageInternal(extent, resolution, pixelRatio, projection) {
        if (this.url_ === undefined) return null;
        if (!this.loader || this.loaderProjection_ !== projection) {
            // Lazily create loader to pick up the view projection and to allow `params` updates
            this.loaderProjection_ = projection;
            this.loader = (0, _wmsJs.createLoader)({
                crossOrigin: this.crossOrigin_,
                referrerPolicy: this.referrerPolicy_,
                params: this.params_,
                projection: projection,
                serverType: this.serverType_,
                hidpi: this.hidpi_,
                url: this.url_,
                ratio: this.ratio_,
                load: (image, src)=>{
                    const wrapper = this.image;
                    if (wrapper) {
                        wrapper.setImage(image);
                        this.imageLoadFunction_(wrapper, src);
                    }
                    return (0, _imageJs.decode)(image);
                }
            });
        }
        return super.getImageInternal(extent, resolution, pixelRatio, projection);
    }
    /**
   * Return the image load function of the source.
   * @return {import("../Image.js").LoadFunction} The image load function.
   * @api
   */ getImageLoadFunction() {
        return this.imageLoadFunction_;
    }
    /**
   * Return the URL used for this WMS source.
   * @return {string|undefined} URL.
   * @api
   */ getUrl() {
        return this.url_;
    }
    /**
   * Set the image load function of the source.
   * @param {import("../Image.js").LoadFunction} imageLoadFunction Image load function.
   * @api
   */ setImageLoadFunction(imageLoadFunction) {
        this.imageLoadFunction_ = imageLoadFunction;
        this.changed();
    }
    /**
   * Set the URL to use for requests.
   * @param {string|undefined} url URL.
   * @api
   */ setUrl(url) {
        if (url != this.url_) {
            this.url_ = url;
            this.loader = null;
            this.changed();
        }
    }
    /**
   * Set the user-provided params.
   * @param {Object} params Params.
   * @api
   */ setParams(params) {
        this.params_ = Object.assign({}, params);
        // Reset loader to pick up new params
        this.loader = null;
        this.changed();
    }
    /**
   * Update the user-provided params.
   * @param {Object} params Params.
   * @api
   */ updateParams(params) {
        Object.assign(this.params_, params);
        this.changed();
    }
    /**
   * @override
   */ changed() {
        this.image = null;
        super.changed();
    }
}
exports.default = ImageWMS;

},{"../Image.js":"dfn7g","../proj.js":"gN0IK","../reproj.js":"3M9kW","./Image.js":"enYGk","./wms.js":"e24t4","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"e24t4":[function(require,module,exports,__globalThis) {
/**
 * @module ol/source/wms
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_VERSION", ()=>DEFAULT_VERSION);
/**
 * @api
 * @typedef {'carmentaserver' | 'geoserver' | 'mapserver' | 'qgis'} ServerType
 * Set the server type to use implementation-specific parameters beyond the WMS specification.
 *  - `'carmentaserver'`: HiDPI support for [Carmenta Server](https://www.carmenta.com/en/products/carmenta-server)
 *  - `'geoserver'`: HiDPI support for [GeoServer](https://geoserver.org/)
 *  - `'mapserver'`: HiDPI support for [MapServer](https://mapserver.org/)
 *  - `'qgis'`: HiDPI support for [QGIS](https://qgis.org/)
 */ /**
 * @param {string} baseUrl Base URL.
 * @param {import("../extent.js").Extent} extent Extent.
 * @param {import("../size.js").Size} size Size.
 * @param {import("../proj/Projection.js").default} projection Projection.
 * @param {Object<string, *>} params WMS params. Will be modified in place.
 * @return {string} Request URL.
 */ parcelHelpers.export(exports, "getRequestUrl", ()=>getRequestUrl);
/**
 * @param {import("../extent.js").Extent} extent Extent.
 * @param {number} resolution Resolution.
 * @param {number} pixelRatio pixel ratio.
 * @param {import("../proj.js").Projection} projection Projection.
 * @param {string} url WMS service url.
 * @param {Object<string, *>} params WMS params.
 * @param {import("./wms.js").ServerType} serverType The type of the remote WMS server.
 * @return {string} Image src.
 */ parcelHelpers.export(exports, "getImageSrc", ()=>getImageSrc);
/**
 * @param {Object<string, *>} params WMS params.
 * @param {string} request WMS `REQUEST`.
 * @return {Object<string, *>} WMS params with required properties set.
 */ parcelHelpers.export(exports, "getRequestParams", ()=>getRequestParams);
/**
 * @typedef {Object} LoaderOptions
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy] The `referrerPolicy` property for loaded images.
 * @property {boolean} [hidpi=true] Use the `ol/Map#pixelRatio` value when requesting
 * the image from the remote server.
 * @property {Object<string,*>} [params] WMS request parameters.
 * At least a `LAYERS` param is required. `STYLES` is
 * `''` by default. `VERSION` is `1.3.0` by default. `WIDTH`, `HEIGHT` and `BBOX` will be set
 * dynamically. `CRS` (`SRS` for WMS version < 1.3.0) will is derived from the `proection` config.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is 'EPSG:3857'.
 * @property {number} [ratio=1.5] Ratio. `1` means image requests are the size of the map viewport, `2` means
 * twice the width and height of the map viewport, and so on. Must be `1` or higher.
 * @property {import("./wms.js").ServerType} [serverType] The type of
 * the remote WMS server: `mapserver`, `geoserver`, `carmentaserver`, or `qgis`.
 * Only needed if `hidpi` is `true`.
 * @property {string} url WMS service URL.
 * @property {function(HTMLImageElement, string): Promise<import('../DataTile.js').ImageLike>} [load] Function
 * to perform loading of the image. Receives the created `HTMLImageElement` and the desired `src` as argument and
 * returns a promise resolving to the loaded or decoded image. Default is {@link module:ol/Image.decode}.
 */ /**
 * Creates a loader for WMS images.
 * @param {LoaderOptions} options Loader options.
 * @return {import("../Image.js").ImageObjectPromiseLoader} Loader.
 * @api
 */ parcelHelpers.export(exports, "createLoader", ()=>createLoader);
/**
 * Get the GetFeatureInfo URL for the passed coordinate and resolution. Returns `undefined` if the
 * GetFeatureInfo URL cannot be constructed.
 * @param {LoaderOptions} options Options passed the `createWMSLoader()` function. In addition to
 * the params required by the loader, `INFO_FORMAT` should be specified, it defaults to
 * `application/json`. If `QUERY_LAYERS` is not provided, then the layers specified in the `LAYERS`
 * parameter will be used.
 * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {number} resolution Resolution.
 * @return {string|undefined} GetFeatureInfo URL.
 * @api
 */ parcelHelpers.export(exports, "getFeatureInfoUrl", ()=>getFeatureInfoUrl);
/**
 * Get the GetLegendGraphic URL, optionally optimized for the passed resolution and possibly
 * including any passed specific parameters. Returns `undefined` if the GetLegendGraphic URL
 * cannot be constructed.
 *
 * @param {LoaderOptions} options Options passed the `createWMSLoader()` function.
 * @param {number} [resolution] Resolution. If not provided, `SCALE` will not be calculated and
 * included in URL.
 * @return {string|undefined} GetLegendGraphic URL.
 * @api
 */ parcelHelpers.export(exports, "getLegendUrl", ()=>getLegendUrl);
var _imageJs = require("../Image.js");
var _extentJs = require("../extent.js");
var _mathJs = require("../math.js");
var _projJs = require("../proj.js");
var _stringJs = require("../string.js");
var _uriJs = require("../uri.js");
var _imageJs1 = require("./Image.js");
var _commonJs = require("./common.js");
const DEFAULT_VERSION = '1.3.0';
/**
 * @const
 * @type {import("../size.js").Size}
 */ const GETFEATUREINFO_IMAGE_SIZE = [
    101,
    101
];
function getRequestUrl(baseUrl, extent, size, projection, params) {
    params['WIDTH'] = size[0];
    params['HEIGHT'] = size[1];
    const axisOrientation = projection.getAxisOrientation();
    const v13 = (0, _stringJs.compareVersions)(params['VERSION'], '1.3') >= 0;
    params[v13 ? 'CRS' : 'SRS'] = projection.getCode();
    const bbox = v13 && axisOrientation.startsWith('ne') ? [
        extent[1],
        extent[0],
        extent[3],
        extent[2]
    ] : extent;
    params['BBOX'] = bbox.join(',');
    return (0, _uriJs.appendParams)(baseUrl, params);
}
function getImageSrc(extent, resolution, pixelRatio, projection, url, params, serverType) {
    params = Object.assign({
        REQUEST: 'GetMap'
    }, params);
    const imageResolution = resolution / pixelRatio;
    const imageSize = [
        (0, _mathJs.round)((0, _extentJs.getWidth)(extent) / imageResolution, (0, _commonJs.DECIMALS)),
        (0, _mathJs.round)((0, _extentJs.getHeight)(extent) / imageResolution, (0, _commonJs.DECIMALS))
    ];
    if (pixelRatio != 1) switch(serverType){
        case 'geoserver':
            const dpi = 90 * pixelRatio + 0.5 | 0;
            if ('FORMAT_OPTIONS' in params) params['FORMAT_OPTIONS'] += ';dpi:' + dpi;
            else params['FORMAT_OPTIONS'] = 'dpi:' + dpi;
            break;
        case 'mapserver':
            params['MAP_RESOLUTION'] = 90 * pixelRatio;
            break;
        case 'carmentaserver':
        case 'qgis':
            params['DPI'] = 90 * pixelRatio;
            break;
        default:
            throw new Error('Unknown `serverType` configured');
    }
    const src = getRequestUrl(url, extent, imageSize, projection, params);
    return src;
}
function getRequestParams(params, request) {
    return Object.assign({
        'REQUEST': request,
        'SERVICE': 'WMS',
        'VERSION': DEFAULT_VERSION,
        'FORMAT': 'image/png',
        'STYLES': '',
        'TRANSPARENT': 'TRUE'
    }, params || {});
}
function createLoader(options) {
    const hidpi = options.hidpi === undefined ? true : options.hidpi;
    const projection = /** @type {import("../proj/Projection.js").default} */ (0, _projJs.get)(options.projection || 'EPSG:3857');
    const ratio = options.ratio || 1.5;
    const load = options.load || (0, _imageJs.decode);
    const crossOrigin = options.crossOrigin ?? null;
    const referrerPolicy = options.referrerPolicy;
    return (extent, resolution, pixelRatio)=>{
        extent = (0, _imageJs1.getRequestExtent)(extent, resolution, pixelRatio, ratio);
        if (pixelRatio != 1 && (!hidpi || options.serverType === undefined)) pixelRatio = 1;
        const src = getImageSrc(extent, resolution, pixelRatio, projection, options.url, getRequestParams(options.params || {}, 'GetMap'), /** @type {import("./wms.js").ServerType} */ options.serverType);
        const image = new Image();
        image.crossOrigin = crossOrigin;
        if (referrerPolicy !== undefined) image.referrerPolicy = referrerPolicy;
        return load(image, src).then((image)=>({
                image,
                extent,
                pixelRatio
            }));
    };
}
function getFeatureInfoUrl(options, coordinate, resolution) {
    if (options.url === undefined) return undefined;
    const projectionObj = /** @type {import("../proj/Projection.js").default} */ (0, _projJs.get)(options.projection || 'EPSG:3857');
    const params = options.params || {};
    const extent = (0, _extentJs.getForViewAndSize)(coordinate, resolution, 0, GETFEATUREINFO_IMAGE_SIZE);
    /** @type {Object<string, *>} */ const baseParams = {
        'QUERY_LAYERS': params['LAYERS'],
        'INFO_FORMAT': 'application/json'
    };
    Object.assign(baseParams, getRequestParams(params, 'GetFeatureInfo'), params);
    const x = (0, _mathJs.floor)((coordinate[0] - extent[0]) / resolution, (0, _commonJs.DECIMALS));
    const y = (0, _mathJs.floor)((extent[3] - coordinate[1]) / resolution, (0, _commonJs.DECIMALS));
    const v13 = (0, _stringJs.compareVersions)(baseParams['VERSION'], '1.3') >= 0;
    baseParams[v13 ? 'I' : 'X'] = x;
    baseParams[v13 ? 'J' : 'Y'] = y;
    return getRequestUrl(options.url, extent, GETFEATUREINFO_IMAGE_SIZE, projectionObj, baseParams);
}
function getLegendUrl(options, resolution) {
    if (options.url === undefined) return undefined;
    /** @type {Object<string, *>} */ const baseParams = {
        'SERVICE': 'WMS',
        'VERSION': DEFAULT_VERSION,
        'REQUEST': 'GetLegendGraphic',
        'FORMAT': 'image/png'
    };
    if (resolution !== undefined) {
        const projection = /** @type {import("../proj/Projection.js").default} */ (0, _projJs.get)(options.projection || 'EPSG:3857');
        const mpu = projection.getMetersPerUnit() || 1;
        const pixelSize = 0.00028;
        baseParams['SCALE'] = resolution * mpu / pixelSize;
    }
    Object.assign(baseParams, options.params || {});
    if (options.params !== undefined && baseParams['LAYER'] === undefined) {
        const layers = baseParams['LAYERS'];
        const isSingleLayer = !Array.isArray(layers) || layers.length !== 1;
        if (!isSingleLayer) return undefined;
        baseParams['LAYER'] = layers;
    }
    return (0, _uriJs.appendParams)(options.url, baseParams);
}

},{"../Image.js":"dfn7g","../extent.js":"MPjK5","../math.js":"b3dOZ","../proj.js":"gN0IK","../string.js":"ladmP","../uri.js":"4bdXc","./Image.js":"enYGk","./common.js":"eDS8y","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"516lS":[function(require,module,exports,__globalThis) {
/**
 * @module ol/layer/Image
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _imageLayerJs = require("../renderer/canvas/ImageLayer.js");
var _imageLayerJsDefault = parcelHelpers.interopDefault(_imageLayerJs);
var _baseImageJs = require("./BaseImage.js");
var _baseImageJsDefault = parcelHelpers.interopDefault(_baseImageJs);
/**
 * @classdesc
 * Server-rendered images that are available for arbitrary extents and
 * resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Image.js").default} ImageSourceType
 * @extends {BaseImageLayer<ImageSourceType, CanvasImageLayerRenderer>}
 * @api
 */ class ImageLayer extends (0, _baseImageJsDefault.default) {
    /**
   * @param {import("./BaseImage.js").Options<ImageSourceType>} [options] Layer options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, _imageLayerJsDefault.default)(this);
    }
    /**
   * Get data for a pixel location.  A four element RGBA array will be returned.  For requests outside the
   * layer extent, `null` will be returned.  Data for an image can only be retrieved if the
   * source's `crossOrigin` property is set.
   *
   * ```js
   * // display layer data on every pointer move
   * map.on('pointermove', (event) => {
   *   console.log(layer.getData(event.pixel));
   * });
   * ```
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   * @api
   * @override
   */ getData(pixel) {
        return super.getData(pixel);
    }
}
exports.default = ImageLayer;

},{"../renderer/canvas/ImageLayer.js":"5fH6H","./BaseImage.js":"ihijF","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5fH6H":[function(require,module,exports,__globalThis) {
/**
 * @module ol/renderer/canvas/ImageLayer
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _imageStateJs = require("../../ImageState.js");
var _imageStateJsDefault = parcelHelpers.interopDefault(_imageStateJs);
var _viewHintJs = require("../../ViewHint.js");
var _viewHintJsDefault = parcelHelpers.interopDefault(_viewHintJs);
var _extentJs = require("../../extent.js");
var _projJs = require("../../proj.js");
var _transformJs = require("../../transform.js");
var _layerJs = require("./Layer.js");
var _layerJsDefault = parcelHelpers.interopDefault(_layerJs);
/**
 * @classdesc
 * Canvas renderer for image layers.
 * @api
 * @extends {CanvasLayerRenderer<import("../../layer/Image.js").default<import("../../source/Image.js").default>>}
 */ class CanvasImageLayerRenderer extends (0, _layerJsDefault.default) {
    /**
   * @param {import("../../layer/Image.js").default<import("../../source/Image.js").default>} imageLayer Image layer.
   */ constructor(imageLayer){
        super(imageLayer);
        /**
     * @protected
     * @type {?import("../../Image.js").default}
     */ this.image = null;
        /**
     * @private
     * @type {number}
     */ this.renderedSourceRevision_ = 0;
        /**
     * Rotation baked into the current image.
     * @protected
     * @type {number}
     */ this.renderedRotation = 0;
    }
    /**
   * @return {import('../../DataTile.js').ImageLike|null} Image.
   */ getImage() {
        return !this.image ? null : this.image.getImage();
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const pixelRatio = frameState.pixelRatio;
        const viewState = frameState.viewState;
        const viewResolution = viewState.resolution;
        const imageSource = this.getLayer().getSource();
        const hints = frameState.viewHints;
        let renderedExtent = /** @type {import("../../extent.js").Extent} */ frameState.extent;
        if (layerState.extent !== undefined) renderedExtent = (0, _extentJs.getIntersection)(renderedExtent, (0, _projJs.fromUserExtent)(layerState.extent, viewState.projection));
        if (!hints[(0, _viewHintJsDefault.default).ANIMATING] && !hints[(0, _viewHintJsDefault.default).INTERACTING] && !(0, _extentJs.isEmpty)(renderedExtent)) {
            if (imageSource) {
                if (!/** @type {unknown} */ this.getLayer().rendered && this.renderedSourceRevision_ !== imageSource.getRevision()) this.image = null;
                this.renderedSourceRevision_ = imageSource.getRevision();
                const projection = viewState.projection;
                const image = imageSource.getImage(renderedExtent, viewResolution, pixelRatio, projection);
                if (image) {
                    if (this.loadImage(image)) {
                        this.image = image;
                        this.renderedRotation = this.sourceRotates() ? viewState.rotation : 0;
                    } else if (image.getState() === (0, _imageStateJsDefault.default).EMPTY) this.image = null;
                }
            } else this.image = null;
        }
        return !!this.image;
    }
    /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|null} Data at the pixel location.
   * @override
   */ getData(pixel) {
        const frameState = this.frameState;
        if (!frameState || !this.image) return null;
        const layer = this.getLayer();
        const coordinate = (0, _transformJs.apply)(frameState.pixelToCoordinateTransform, pixel.slice());
        const layerExtent = layer.getExtent();
        if (layerExtent) {
            if (!(0, _extentJs.containsCoordinate)(layerExtent, coordinate)) return null;
        }
        const imageExtent = this.image.getExtent();
        const img = this.image.getImage();
        if (!img) return null;
        const imageRotation = this.renderedRotation;
        if (imageRotation !== 0) {
            const imageCenter = (0, _extentJs.getCenter)(imageExtent);
            const cosRotation = Math.cos(-imageRotation);
            const sinRotation = Math.sin(-imageRotation);
            const deltaX = coordinate[0] - imageCenter[0];
            const deltaY = coordinate[1] - imageCenter[1];
            coordinate[0] = imageCenter[0] + cosRotation * deltaX - sinRotation * deltaY;
            coordinate[1] = imageCenter[1] + sinRotation * deltaX + cosRotation * deltaY;
        }
        const imageMapWidth = (0, _extentJs.getWidth)(imageExtent);
        const col = Math.floor(img.width * ((coordinate[0] - imageExtent[0]) / imageMapWidth));
        if (col < 0 || col >= img.width) return null;
        const imageMapHeight = (0, _extentJs.getHeight)(imageExtent);
        const row = Math.floor(img.height * ((imageExtent[3] - coordinate[1]) / imageMapHeight));
        if (row < 0 || row >= img.height) return null;
        return this.getImageData(img, col, row);
    }
    /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        const image = this.image;
        if (!image) return this.getContainerElement();
        const imageExtent = image.getExtent();
        const imageResolution = image.getResolution();
        const [imageResolutionX, imageResolutionY] = Array.isArray(imageResolution) ? imageResolution : [
            imageResolution,
            imageResolution
        ];
        const imagePixelRatio = image.getPixelRatio();
        const imageRotation = this.renderedRotation;
        const imageSource = this.getLayer().getSource();
        const sourceRotates = this.sourceRotates();
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const pixelRatio = frameState.pixelRatio;
        const viewState = frameState.viewState;
        const viewCenter = viewState.center;
        const viewResolution = viewState.resolution;
        const viewRotation = viewState.rotation;
        const scaleX = pixelRatio * imageResolutionX / (viewResolution * imagePixelRatio);
        const scaleY = pixelRatio * imageResolutionY / (viewResolution * imagePixelRatio);
        this.prepareContainer(frameState, target);
        // desired dimensions of the canvas in pixels
        const width = this.getCanvasContext().canvas.width;
        const height = this.getCanvasContext().canvas.height;
        const context = this.getRenderContext(frameState);
        // clipped rendering if layer extent is set
        let clipped = false;
        let render = true;
        if (layerState.extent) {
            const layerExtent = (0, _projJs.fromUserExtent)(layerState.extent, viewState.projection);
            const frameExtent = /** @type {import("../../extent.js").Extent} */ frameState.extent;
            render = (0, _extentJs.intersects)(layerExtent, frameExtent);
            clipped = render && !(0, _extentJs.containsExtent)(layerExtent, frameExtent);
            if (clipped) this.clipUnrotated(context, frameState, layerExtent);
        }
        const img = image.getImage();
        if (!img) return this.getContainerElement();
        let transform, dw, dh;
        if (!sourceRotates) {
            transform = (0, _transformJs.compose)(this.tempTransform, width / 2, height / 2, scaleX, scaleY, 0, imagePixelRatio * (imageExtent[0] - viewCenter[0]) / imageResolutionX, imagePixelRatio * (viewCenter[1] - imageExtent[3]) / imageResolutionY);
            dw = img.width * transform[0];
            dh = img.height * transform[3];
        } else {
            // The image content is already rotated by imageRotation. Rotate by the
            // remaining delta around the image center; when the view is settled at
            // the image's rotation this reduces to a whole-pixel translation.
            const scale = pixelRatio / viewResolution;
            const cosRotation = Math.cos(viewRotation);
            const sinRotation = Math.sin(viewRotation);
            const imageCenter = (0, _extentJs.getCenter)(imageExtent);
            const centerX = imageCenter[0] - viewCenter[0];
            const centerY = imageCenter[1] - viewCenter[1];
            transform = (0, _transformJs.compose)(this.tempTransform, width / 2 + scale * (cosRotation * centerX + sinRotation * centerY), height / 2 + scale * (sinRotation * centerX - cosRotation * centerY), scaleX, scaleY, viewRotation - imageRotation, -img.width / 2, -img.height / 2);
            // The transform diagonal shrinks with the rotation delta; guard the draw
            // with the true scale instead.
            dw = img.width * scaleX;
            dh = img.height * scaleY;
        }
        this.renderedResolution = imageResolutionY * pixelRatio / imagePixelRatio;
        if (!imageSource?.getInterpolate() && (!sourceRotates || viewRotation === imageRotation)) context.imageSmoothingEnabled = false;
        this.preRender(context, frameState);
        if (render && dw >= 0.5 && dh >= 0.5) {
            const opacity = layerState.opacity;
            if (!sourceRotates) {
                const dx = transform[4];
                const dy = transform[5];
                if (opacity !== 1) {
                    context.save();
                    context.globalAlpha = opacity;
                }
                context.drawImage(img, 0, 0, img.width, img.height, dx, dy, dw, dh);
                if (opacity !== 1) context.restore();
            } else {
                context.save();
                if (opacity !== 1) context.globalAlpha = opacity;
                context.setTransform(transform[0], transform[1], transform[2], transform[3], transform[4], transform[5]);
                context.drawImage(img, 0, 0);
                context.restore();
            }
        }
        this.postRender(this.getCanvasContext(), frameState);
        if (clipped) context.restore();
        context.imageSmoothingEnabled = true;
        return this.getContainerElement();
    }
}
exports.default = CanvasImageLayerRenderer;

},{"../../ImageState.js":"7kySV","../../ViewHint.js":"fb2qR","../../extent.js":"MPjK5","../../proj.js":"gN0IK","../../transform.js":"7TqcG","./Layer.js":"h3JnK","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ihijF":[function(require,module,exports,__globalThis) {
/**
 * @module ol/layer/BaseImage
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _layerJs = require("./Layer.js");
var _layerJsDefault = parcelHelpers.interopDefault(_layerJs);
/**
 * @template {import("../source/Image.js").default} ImageSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../Map.js").default#addLayer map.addLayer()}.
 * @property {ImageSourceType} [source] Source for this layer.
 * @property {import('./Base.js').BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Server-rendered images that are available for arbitrary extents and
 * resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Image.js").default} ImageSourceType
 * @template {import("../renderer/Layer.js").default<*>} RendererType
 * @extends {Layer<ImageSourceType, RendererType>}
 * @api
 */ class BaseImageLayer extends (0, _layerJsDefault.default) {
    /**
   * @param {Options<ImageSourceType>} [options] Layer options.
   */ constructor(options){
        options = options ? options : {};
        super(options);
    }
}
exports.default = BaseImageLayer;

},{"./Layer.js":"aZQOw","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"eKqIN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MOTION_COLOR", ()=>MOTION_COLOR);
parcelHelpers.export(exports, "MOTION_OPACITY", ()=>MOTION_OPACITY);
// Recolors a directional FCD layer to a single color. Each layer has its own
// canvas (unique className), so `source-atop` only paints that layer's pixels.
parcelHelpers.export(exports, "attachMotionRecolor", ()=>attachMotionRecolor);
// A single overlay layer above the 12 directional layers that draws white
// stripes moving along each direction, at a pace set by each pixel's FCD speed
// band. Motion mode requests the WMS *speed* image for the directional layers,
// so their pixels give both the road mask and the speed.
parcelHelpers.export(exports, "createMotionOverlayLayer", ()=>createMotionOverlayLayer);
var _layer = require("ol/layer/Layer");
var _layerDefault = parcelHelpers.interopDefault(_layer);
var _imageState = require("ol/ImageState");
var _imageStateDefault = parcelHelpers.interopDefault(_imageState);
var _directionalLayers = require("./DirectionalLayers");
var _colorScale = require("./style/util/colorScale");
var _directionalMotionGeometryMjs = require("./directionalMotionGeometry.mjs");
const MOTION_COLOR = "#1e5aff";
const MOTION_OPACITY = 0.6;
// CSS pixels / CSS pixels per second
const STRIPE_SPACING = 28;
const STRIPE_HEAD = 6;
const STRIPE_SPEED_AT_50_KMH = 35;
const STRIPE_MIN_SPEED = 4;
const PROFILE_SAMPLES_PER_PX = 4;
const BANDS = (0, _directionalMotionGeometryMjs.speedBands)((0, _directionalLayers.SPEED_BREAKPOINTS));
const BAND_PX_PER_SEC = BANDS.map((band)=>(0, _directionalMotionGeometryMjs.stripeSpeedForKmh)(band.kmh, STRIPE_SPEED_AT_50_KMH, STRIPE_MIN_SPEED));
const PROFILE = (0, _directionalMotionGeometryMjs.stripeProfile)(STRIPE_SPACING, STRIPE_HEAD, PROFILE_SAMPLES_PER_PX);
function attachMotionRecolor(layer, isMotionMode) {
    layer.on("postrender", function(event) {
        if (!isMotionMode() || layer.getOpacity() === 0) return;
        const context = event.context;
        context.save();
        context.globalCompositeOperation = "source-atop";
        context.setTransform(1, 0, 0, 1, 0, 0);
        context.fillStyle = MOTION_COLOR;
        context.fillRect(0, 0, context.canvas.width, context.canvas.height);
        context.restore();
    });
}
const speedByColor = new Map();
function speedForColor(r, g, b) {
    const key = r << 16 | g << 8 | b;
    let speed = speedByColor.get(key);
    if (speed === undefined) {
        speed = (0, _colorScale.interpolatedSpeedFromColor)([
            r,
            g,
            b
        ], (0, _directionalLayers.SPEED_BREAKPOINTS));
        speedByColor.set(key, speed);
    }
    return speed;
}
// Per loaded WMS speed image: its non-transparent pixels with their speed band,
// sampled at ~CSS resolution (every `step`-th pixel on hidpi images). Built
// once per image; the per-frame loop only touches these pixels.
const roadPixelsCache = new WeakMap();
function getRoadPixels(image) {
    let cached = roadPixelsCache.get(image);
    if (cached) return cached;
    const img = image.getImage();
    const step = Math.max(1, Math.round(image.getPixelRatio()));
    const width = Math.floor(img.width / step);
    const height = Math.floor(img.height / step);
    if (width === 0 || height === 0) return null;
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const context = canvas.getContext("2d", {
        willReadFrequently: true
    });
    context.drawImage(img, 0, 0);
    const rgba = context.getImageData(0, 0, img.width, img.height).data;
    const xs = [];
    const ys = [];
    const alphas = [];
    const bands = [];
    for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
        const i = (y * step * img.width + x * step) * 4;
        const alpha = rgba[i + 3];
        if (alpha === 0) continue;
        xs.push(x);
        ys.push(y);
        alphas.push(alpha);
        bands.push((0, _directionalMotionGeometryMjs.bandIndexForSpeed)(BANDS, speedForColor(rgba[i], rgba[i + 1], rgba[i + 2])));
    }
    const extent = image.getExtent();
    cached = {
        width,
        height,
        extent,
        // map units per sampled pixel
        unit: step * image.getResolution() / image.getPixelRatio(),
        key: extent.join(",") + "|" + width + "x" + height,
        xs: Uint16Array.from(xs),
        ys: Uint16Array.from(ys),
        alphas: Uint8Array.from(alphas),
        bands: Uint8Array.from(bands)
    };
    roadPixelsCache.set(image, cached);
    return cached;
}
// One stripe buffer per image geometry. All 12 directions are normally
// requested for the same view and share one; mid-reload they can briefly differ.
function getBuffer(buffers, pixels) {
    let buffer = buffers.get(pixels.key);
    if (!buffer) {
        const canvas = document.createElement("canvas");
        canvas.width = pixels.width;
        canvas.height = pixels.height;
        const imageData = new ImageData(pixels.width, pixels.height);
        buffer = {
            pixels,
            canvas,
            imageData,
            data32: new Uint32Array(imageData.data.buffer)
        };
        buffers.set(pixels.key, buffer);
    }
    return buffer;
}
function paintStripes(buffer, pixels, frameState, heading) {
    const T = frameState.coordinateToPixelTransform;
    const { kx, ky } = (0, _directionalMotionGeometryMjs.stripeAxis)(T, heading);
    const unit = pixels.unit;
    // Along-heading distance of sampled pixel (x, y) = s0 + x * sx + y * sy.
    const s0 = kx * (pixels.extent[0] + unit / 2) + ky * (pixels.extent[3] - unit / 2);
    const sx = kx * unit;
    const sy = -ky * unit;
    const timeSec = frameState.time / 1000;
    const bandShift = BAND_PX_PER_SEC.map((pxPerSec)=>(0, _directionalMotionGeometryMjs.wrap)(timeSec * pxPerSec, STRIPE_SPACING));
    const { xs, ys, alphas, bands } = pixels;
    const data32 = buffer.data32;
    const width = pixels.width;
    for(let i = 0; i < xs.length; i++){
        const s = s0 + xs[i] * sx + ys[i] * sy - bandShift[bands[i]];
        const phase = (0, _directionalMotionGeometryMjs.wrap)(s, STRIPE_SPACING);
        const intensity = PROFILE[phase * PROFILE_SAMPLES_PER_PX | 0];
        if (intensity === 0) continue;
        const alpha = intensity * alphas[i] | 0;
        const idx = ys[i] * width + xs[i];
        // Overlapping directions: keep the brightest stripe (little-endian ABGR).
        if (alpha > data32[idx] >>> 24) data32[idx] = (alpha << 24 | 0xffffff) >>> 0;
    }
}
function createMotionOverlayLayer(directionalLayers, map, isMotionMode) {
    const canvas = document.createElement("canvas");
    canvas.style.cssText = "position:absolute; left:0; top:0; width:100%; height:100%;";
    const context = canvas.getContext("2d");
    const buffers = new Map();
    return new (0, _layerDefault.default)({
        minZoom: 17,
        render: function(frameState) {
            const pixelRatio = frameState.pixelRatio;
            const width = Math.round(frameState.size[0] * pixelRatio);
            const height = Math.round(frameState.size[1] * pixelRatio);
            if (canvas.width !== width || canvas.height !== height) {
                canvas.width = width;
                canvas.height = height;
            } else context.clearRect(0, 0, width, height);
            if (!isMotionMode()) return canvas;
            const used = new Set();
            directionalLayers.forEach(function(layer, id) {
                if (!layer.getVisible() || layer.getOpacity() === 0) return;
                const image = layer.getRenderer().image;
                if (!image || image.getState() !== (0, _imageStateDefault.default).LOADED) return;
                const pixels = getRoadPixels(image);
                if (!pixels) return;
                const buffer = getBuffer(buffers, pixels);
                if (!used.has(buffer)) {
                    buffer.data32.fill(0);
                    used.add(buffer);
                }
                paintStripes(buffer, pixels, frameState, (0, _directionalMotionGeometryMjs.directionHeadingRadians)(Number(id)));
            });
            const T = frameState.coordinateToPixelTransform;
            used.forEach(function(buffer) {
                const { extent, unit } = buffer.pixels;
                buffer.canvas.getContext("2d").putImageData(buffer.imageData, 0, 0);
                // sampled pixel -> device px
                context.setTransform(pixelRatio * T[0] * unit, pixelRatio * T[1] * unit, -pixelRatio * T[2] * unit, -pixelRatio * T[3] * unit, pixelRatio * (T[0] * extent[0] + T[2] * extent[3] + T[4]), pixelRatio * (T[1] * extent[0] + T[3] * extent[3] + T[5]));
                context.drawImage(buffer.canvas, 0, 0);
            });
            context.setTransform(1, 0, 0, 1, 0, 0);
            // Drop buffers for geometries no longer on screen.
            buffers.forEach(function(buffer, key) {
                if (!used.has(buffer)) buffers.delete(key);
            });
            if (used.size > 0) map.render();
            return canvas;
        }
    });
}

},{"ol/layer/Layer":"aZQOw","ol/ImageState":"7kySV","./DirectionalLayers":"ffH8s","./style/util/colorScale":"dOPOB","./directionalMotionGeometry.mjs":"8JFqg","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8JFqg":[function(require,module,exports,__globalThis) {
// Pure geometry for the FCD "motion" mode: stripes perpendicular to a driving
// heading that travel along it, at a pace set by the FCD speed. Kept free of OpenLayers imports so it can be
// unit-tested with `node --test`.
// FCD direction ids 1..12 are 30° heading buckets clockwise from north, matching
// the layout of the DirectionalHeatmapControl wheel (1 = N, 4 = E, 7 = S, 10 = W).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "directionHeadingRadians", ()=>directionHeadingRadians);
// Projection onto the on-screen driving direction.
//   T        OL coordinateToPixelTransform [a, b, c, d, e, f] (map -> CSS px;
//            carries view rotation and the y flip)
//   heading  driving heading in radians, clockwise from north
// Returns the screen unit vector `dir` and `kx`, `ky` such that
// `kx * X + ky * Y` is the CSS-pixel distance along `dir` of map coordinate
// (X, Y), measured from the map origin. Measuring from the origin (not the
// viewport) keeps the stripes attached to the roads while panning.
parcelHelpers.export(exports, "stripeAxis", ()=>stripeAxis);
parcelHelpers.export(exports, "wrap", ()=>wrap);
// Stripe intensity (0..1) over one period of `spacing` CSS px, sampled
// `samplesPerPx` times per px: a fading tail then a bright `head` at the
// leading (+dir) end, so the stripe reads as moving forward.
parcelHelpers.export(exports, "stripeProfile", ()=>stripeProfile);
// Speed bands between consecutive breakpoints plus an open-ended top band.
// Stripes animate per band rather than per pixel: a per-pixel speed would shear
// the stripe pattern more every second, a band only breaks it at band edges.
parcelHelpers.export(exports, "speedBands", ()=>speedBands);
parcelHelpers.export(exports, "bandIndexForSpeed", ()=>bandIndexForSpeed);
// Screen speed of the stripes: proportional to km/h (`pxPerSecAt50` at 50 km/h)
// with a floor so standing traffic still visibly crawls.
parcelHelpers.export(exports, "stripeSpeedForKmh", ()=>stripeSpeedForKmh);
function directionHeadingRadians(direction) {
    return (direction - 1) * Math.PI / 6;
}
function stripeAxis(T, heading) {
    const ux = Math.sin(heading);
    const uy = Math.cos(heading);
    const vx = T[0] * ux + T[2] * uy;
    const vy = T[1] * ux + T[3] * uy;
    const len = Math.hypot(vx, vy);
    const dx = vx / len;
    const dy = vy / len;
    return {
        dir: [
            dx,
            dy
        ],
        kx: T[0] * dx + T[1] * dy,
        ky: T[2] * dx + T[3] * dy
    };
}
function wrap(value, period) {
    const r = value % period;
    return r < 0 ? r + period : r;
}
function stripeProfile(spacing, head, samplesPerPx) {
    const n = spacing * samplesPerPx;
    const profile = new Float32Array(n);
    const tailStart = spacing * 0.4;
    const headStart = spacing - head;
    for(let i = 0; i < n; i++){
        const px = i / samplesPerPx;
        if (px >= headStart) profile[i] = 0.95;
        else if (px >= tailStart) profile[i] = 0.55 * (px - tailStart) / (headStart - tailStart);
    }
    return profile;
}
function speedBands(breakpoints) {
    const bands = [];
    for(let i = 0; i < breakpoints.length - 1; i++){
        const min = breakpoints[i];
        const max = breakpoints[i + 1];
        bands.push({
            min,
            max,
            kmh: (min + max) / 2
        });
    }
    const top = breakpoints[breakpoints.length - 1];
    bands.push({
        min: top,
        max: Infinity,
        kmh: top
    });
    return bands;
}
function bandIndexForSpeed(bands, kmh) {
    for(let i = 0; i < bands.length; i++){
        if (kmh < bands[i].max) return i;
    }
    return bands.length - 1;
}
function stripeSpeedForKmh(kmh, pxPerSecAt50, minPxPerSec) {
    return Math.max(minPxPerSec, kmh / 50 * pxPerSecAt50);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fXIgK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataSourceControl", ()=>DataSourceControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
class DataSourceControl extends (0, _controlDefault.default) {
    constructor(opt_options){
        const options = opt_options || {};
        const div = document.createElement("div");
        super({
            element: div,
            target: options.target
        });
        const this_ = this;
        div.className = "data-source";
        const label = document.createElement("p");
        label.innerText = "Data source selection";
        label.className = "data-source-label";
        div.appendChild(label);
        const radios = [];
        for(let i = 0; i < 6; i++){
            const radio = document.createElement("input");
            radio.type = "radio";
            radio.name = "data-source";
            radio.value = i;
            radio.id = "radio-" + i;
            radios.push(radio);
            if (i == 4) {
                radio.checked = true;
                this_.set("dataSource", i);
            }
            radio.addEventListener("change", function() {
                this_.set("dataSource", i);
            });
            const radioLabel = document.createElement("label");
            radioLabel.htmlFor = "radio-" + i;
            radioLabel.innerText = i;
            div.appendChild(radio);
            div.appendChild(radioLabel);
        }
        this.on("propertychange", function(e) {
            if (e.key === "dataSource") {
                const val = this_.get("dataSource");
                radios.forEach(function(r, i) {
                    r.checked = i === val;
                });
            }
        });
    }
}

},{"ol/control/Control":"8KSMn","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6bJVZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addGeocoderControl", ()=>addGeocoderControl);
var _olGeocoder = require("ol-geocoder");
var _olGeocoderDefault = parcelHelpers.interopDefault(_olGeocoder);
function addGeocoderControl(map) {
    const geocoder = new (0, _olGeocoderDefault.default)("nominatim", {
        provider: "osm",
        lang: "en",
        targetType: "glass-button",
        placeholder: "Search for ...",
        limit: 5,
        debug: false,
        autoComplete: true,
        keepOpen: false,
        preventMarker: true
    });
    map.addControl(geocoder);
}

},{"ol-geocoder":"1bUp3","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1bUp3":[function(require,module,exports,__globalThis) {
/*!
 * ol-geocoder - v4.3.3
 * A geocoder extension compatible with OpenLayers v6.x to v9.0
 * https://github.com/Dominique92/ol-geocoder
 * Built: 15/03/2024 08:57:04
 */ !function(e, t) {
    module.exports = t(require("d44e0263994d8518"), require("e7c81622ced83b7e"), require("f8b796a0e43051de"), require("ad8d699790cf7c67"), require("81f5340139bc0735"), require("cdb3cbf620ffc78"), require("7a530b3a437d556a"), require("1f8863aa812eebec"));
}(this, function(e, t, s, r, n, o, a, i) {
    "use strict";
    function l(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    function c(e) {
        if (e && e.__esModule) return e;
        var t = Object.create(null);
        return e && Object.keys(e).forEach(function(s) {
            if ("default" !== s) {
                var r = Object.getOwnPropertyDescriptor(e, s);
                Object.defineProperty(t, s, r.get ? r : {
                    enumerable: !0,
                    get: function() {
                        return e[s];
                    }
                });
            }
        }), t.default = e, Object.freeze(t);
    }
    var d = l(e), u = l(t), p = l(s), h = l(r), g = l(n), m = l(o), y = l(a), f = c(i), b = "gcd-container", v = "gcd-button-control", w = "gcd-input-query", x = "gcd-input-label", $ = "gcd-input-search", k = {
        namespace: "ol-geocoder",
        spin: "gcd-pseudo-rotate",
        hidden: "gcd-hidden",
        address: "gcd-address",
        country: "gcd-country",
        city: "gcd-city",
        road: "gcd-road",
        olControl: "ol-control",
        glass: {
            container: "gcd-gl-container",
            control: "gcd-gl-control",
            button: "gcd-gl-btn",
            input: "gcd-gl-input",
            expanded: "gcd-gl-expanded",
            search: "gcd-gl-search",
            result: "gcd-gl-result"
        },
        inputText: {
            container: "gcd-txt-container",
            control: "gcd-txt-control",
            label: "gcd-txt-label",
            input: "gcd-txt-input",
            search: "gcd-txt-search",
            icon: "gcd-txt-glass",
            result: "gcd-txt-result"
        }
    }, S = {
        containerId: b,
        buttonControlId: v,
        inputQueryId: w,
        inputLabelId: x,
        inputSearchId: $,
        cssClasses: k
    };
    const q = Object.freeze({
        __proto__: null,
        containerId: b,
        buttonControlId: v,
        inputQueryId: w,
        inputLabelId: x,
        inputSearchId: $,
        cssClasses: k,
        default: S
    }), L = "addresschosen", C = "nominatim", E = "reverse", T = "glass-button", j = "text-input", I = "bing", N = "mapquest", P = "opencage", A = "osm", R = "photon", F = "https://dev.virtualearth.net/REST/v1/Locations", _ = "https://nominatim.openstreetmap.org/search", M = "https://api.opencagedata.com/geocode/v1/json?", O = "https://nominatim.openstreetmap.org/search", D = "https://photon.komoot.io/api/", V = {
        provider: A,
        label: "",
        placeholder: "Search for an address",
        featureStyle: null,
        targetType: T,
        lang: "en-US",
        limit: 5,
        keepOpen: !1,
        preventDefault: !1,
        preventPanning: !1,
        preventMarker: !1,
        defaultFlyResolution: 10,
        debug: !1
    };
    function B(e, t = "Assertion failed") {
        if (!e) {
            if ("undefined" != typeof Error) throw new Error(t);
            throw t;
        }
    }
    function U(e) {
        const t = (function() {
            if ("performance" in window == 0 && (window.performance = {}), "now" in window.performance == 0) {
                let e = Date.now();
                performance.timing && performance.timing.navigationStart && (e = performance.timing.navigationStart), window.performance.now = ()=>Date.now() - e;
            }
            return window.performance.now();
        })().toString(36);
        return e ? e + t : t;
    }
    function G(e) {
        return /^\d+$/u.test(e);
    }
    function Q(e, t, s) {
        if (Array.isArray(e)) return void e.forEach((e)=>Q(e, t));
        const r = Array.isArray(t) ? t : t.split(/\s+/u);
        let n = r.length;
        for(; n--;)H(e, r[n]) || Y(e, r[n], s);
    }
    function z(e, t, s) {
        if (Array.isArray(e)) return void e.forEach((e)=>z(e, t, s));
        const r = Array.isArray(t) ? t : t.split(/\s+/u);
        let n = r.length;
        for(; n--;)H(e, r[n]) && Z(e, r[n], s);
    }
    function H(e, t) {
        return e.classList ? e.classList.contains(t) : X(t).test(e.className);
    }
    function K(e) {
        for(; e.firstChild;)e.firstChild.remove();
    }
    function J(e, t) {
        return e.replace(/\{\s*([\w-]+)\s*\}/gu, (e, s)=>{
            const r = void 0 === t[s] ? "" : t[s];
            return String(r).replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;").replaceAll('"', "&quot;").replaceAll("'", "&#039;");
        });
    }
    function W(e, t) {
        let s;
        if (Array.isArray(e)) {
            if (s = document.createElement(e[0]), e[1].id && (s.id = e[1].id), e[1].classname && (s.className = e[1].classname), e[1].attr) {
                const { attr: t } = e[1];
                if (Array.isArray(t)) {
                    let e = -1;
                    for(; ++e < t.length;)s.setAttribute(t[e].name, t[e].value);
                } else s.setAttribute(t.name, t.value);
            }
        } else s = document.createElement(e);
        s.innerHTML = t;
        const r = document.createDocumentFragment();
        for(; s.childNodes[0];)r.append(s.childNodes[0]);
        return s.append(r), s;
    }
    function X(e) {
        return new RegExp(`(^|\\s+) ${e} (\\s+|$)`, "u");
    }
    function Y(e, t, s) {
        e.classList ? e.classList.add(t) : e.className = `${e.className} ${t}`.trim(), s && G(s) && window.setTimeout(()=>Z(e, t), s);
    }
    function Z(e, t, s) {
        e.classList ? e.classList.remove(t) : e.className = e.className.replace(X(t), " ").trim(), s && G(s) && window.setTimeout(()=>Y(e, t), s);
    }
    const ee = q.cssClasses;
    class te {
        constructor(e){
            this.options = e, this.els = this.createControl();
        }
        createControl() {
            let e, t, s;
            return this.options.targetType === j ? (t = `${ee.namespace} ${ee.inputText.container}`, e = W([
                "div",
                {
                    id: q.containerId,
                    classname: t
                }
            ], te.input), s = {
                container: e,
                control: e.querySelector(`.${ee.inputText.control}`),
                label: e.querySelector(`.${ee.inputText.label}`),
                input: e.querySelector(`.${ee.inputText.input}`),
                search: e.querySelector(`.${ee.inputText.search}`),
                result: e.querySelector(`.${ee.inputText.result}`)
            }, s.label.innerHTML = this.options.label) : (t = `${ee.namespace} ${ee.glass.container}`, e = W([
                "div",
                {
                    id: q.containerId,
                    classname: t
                }
            ], te.glass), s = {
                container: e,
                control: e.querySelector(`.${ee.glass.control}`),
                button: e.querySelector(`.${ee.glass.button}`),
                input: e.querySelector(`.${ee.glass.input}`),
                search: e.querySelector(`.${ee.glass.search}`),
                result: e.querySelector(`.${ee.glass.result}`)
            }), s.input.placeholder = this.options.placeholder, s;
        }
    }
    function se(e) {
        return new Promise((t, s)=>{
            const r = function(e, t) {
                t && "object" == typeof t && (e += (/\?/u.test(e) ? "&" : "?") + re(t));
                return e;
            }(e.url, e.data), n = {
                method: "GET",
                mode: "cors",
                credentials: "same-origin"
            };
            e.jsonp ? function(e, t, s) {
                const { head: r } = document, n = document.createElement("script"), o = `f${Math.round(Math.random() * Date.now())}`;
                n.setAttribute("src", `${e + (e.indexOf("?") > 0 ? "&" : "?") + t}=${o}`), window[o] = (e)=>{
                    window[o] = void 0, setTimeout(()=>r.removeChild(n), 0), s(e);
                }, r.append(n);
            }(r, e.callbackName, t) : fetch(r, n).then((e)=>e.json()).then(t).catch(s);
        });
    }
    function re(e) {
        return Object.keys(e).reduce((t, s)=>(t.push("object" == typeof e[s] ? re(e[s]) : `${encodeURIComponent(s)}=${encodeURIComponent(e[s])}`), t), []).join("&");
    }
    te.glass = `\n  <div class="${ee.glass.control} ${ee.olControl}">\n    <button type="button" id="${q.buttonControlId}" class="${ee.glass.button}"></button>\n    <input type="text" id="${q.inputQueryId}" class="${ee.glass.input}" autocomplete="off" placeholder="Search ...">\n    <a id="${q.inputSearchId}" class="${ee.glass.search} ${ee.hidden}"></a>\n  </div>\n  <ul class="${ee.glass.result}"></ul>\n`, te.input = `\n  <div class="${ee.inputText.control}">\n    <label type="button" id="${q.inputSearchId}" class="${ee.inputText.label}"></label>\n    <input type="text" id="${q.inputQueryId}" class="${ee.inputText.input}" autocomplete="off" placeholder="Search ...">\n    <span class="${ee.inputText.icon}"></span>\n    <button type="button" id="${q.inputSearchId}" class="${ee.inputText.search} ${ee.hidden}"></button>\n  </div>\n  <ul class="${ee.inputText.result}"></ul>\n`;
    class ne {
        constructor(){
            this.settings = {
                url: D,
                params: {
                    q: "",
                    limit: 10,
                    lang: "en"
                },
                langs: [
                    "de",
                    "it",
                    "fr",
                    "en"
                ]
            };
        }
        getParameters(e) {
            return e.lang = e.lang.toLowerCase(), {
                url: this.settings.url,
                params: {
                    q: e.query,
                    limit: e.limit || this.settings.params.limit,
                    lang: this.settings.langs.includes(e.lang) ? e.lang : this.settings.params.lang
                }
            };
        }
        handleResponse(e) {
            return 0 === e.features.length ? [] : e.features.map((e)=>({
                    lon: e.geometry.coordinates[0],
                    lat: e.geometry.coordinates[1],
                    address: {
                        name: e.properties.name,
                        postcode: e.properties.postcode,
                        city: e.properties.city,
                        state: e.properties.state,
                        country: e.properties.country
                    },
                    original: {
                        formatted: e.properties.name,
                        details: e.properties
                    }
                }));
        }
    }
    class oe {
        constructor(e){
            this.settings = {
                url: O,
                ...e,
                params: {
                    q: "",
                    format: "json",
                    addressdetails: 1,
                    limit: 10,
                    countrycodes: "",
                    viewbox: "",
                    "accept-language": "en-US"
                }
            };
        }
        getParameters(e) {
            return {
                url: this.settings.url,
                params: {
                    q: e.query,
                    format: this.settings.params.format,
                    addressdetails: this.settings.params.addressdetails,
                    limit: e.limit || this.settings.params.limit,
                    countrycodes: e.countrycodes || this.settings.params.countrycodes,
                    viewbox: e.viewbox || this.settings.params.viewbox,
                    "accept-language": e.lang || this.settings.params["accept-language"]
                }
            };
        }
        handleResponse(e) {
            return 0 === e.length ? [] : e.map((e)=>({
                    lon: e.lon,
                    lat: e.lat,
                    bbox: e.boundingbox,
                    address: {
                        name: e.display_name,
                        road: e.address.road || "",
                        houseNumber: e.address.house_number || "",
                        postcode: e.address.postcode,
                        city: e.address.city || e.address.town,
                        state: e.address.state,
                        country: e.address.country
                    },
                    original: {
                        formatted: e.display_name,
                        details: e.address
                    }
                }));
        }
    }
    class ae {
        constructor(){
            this.settings = {
                url: _,
                params: {
                    q: "",
                    key: "",
                    format: "json",
                    addressdetails: 1,
                    limit: 10,
                    countrycodes: "",
                    "accept-language": "en-US"
                }
            };
        }
        getParameters(e) {
            return {
                url: this.settings.url,
                params: {
                    q: e.query,
                    key: e.key,
                    format: "json",
                    addressdetails: 1,
                    limit: e.limit || this.settings.params.limit,
                    countrycodes: e.countrycodes || this.settings.params.countrycodes,
                    "accept-language": e.lang || this.settings.params["accept-language"]
                }
            };
        }
        handleResponse(e) {
            return 0 === e.length ? [] : e.map((e)=>({
                    lon: e.lon,
                    lat: e.lat,
                    address: {
                        name: e.address.neighbourhood || "",
                        road: e.address.road || "",
                        postcode: e.address.postcode,
                        city: e.address.city || e.address.town,
                        state: e.address.state,
                        country: e.address.country
                    },
                    original: {
                        formatted: e.display_name,
                        details: e.address
                    }
                }));
        }
    }
    class ie {
        constructor(){
            this.settings = {
                url: F,
                callbackName: "jsonp",
                params: {
                    query: "",
                    key: "",
                    includeNeighborhood: 0,
                    maxResults: 10
                }
            };
        }
        getParameters(e) {
            return {
                url: this.settings.url,
                callbackName: this.settings.callbackName,
                params: {
                    query: e.query,
                    key: e.key,
                    includeNeighborhood: e.includeNeighborhood || this.settings.params.includeNeighborhood,
                    maxResults: e.maxResults || this.settings.params.maxResults
                }
            };
        }
        handleResponse(e) {
            const { resources: t } = e.resourceSets[0];
            return 0 === t.length ? [] : t.map((e)=>({
                    lon: e.point.coordinates[1],
                    lat: e.point.coordinates[0],
                    address: {
                        name: e.name
                    },
                    original: {
                        formatted: e.address.formattedAddress,
                        details: e.address
                    }
                }));
        }
    }
    class le {
        constructor(){
            this.settings = {
                url: M,
                params: {
                    q: "",
                    key: "",
                    limit: 10,
                    countrycode: "",
                    pretty: 1,
                    no_annotations: 1
                }
            };
        }
        getParameters(e) {
            return {
                url: this.settings.url,
                params: {
                    q: e.query,
                    key: e.key,
                    limit: e.limit || this.settings.params.limit,
                    countrycode: e.countrycodes || this.settings.params.countrycodes
                }
            };
        }
        handleResponse(e) {
            return 0 === e.results.length ? [] : e.results.map((e)=>({
                    lon: e.geometry.lng,
                    lat: e.geometry.lat,
                    address: {
                        name: e.components.house_number || "",
                        road: e.components.road || "",
                        postcode: e.components.postcode,
                        city: e.components.city || e.components.town,
                        state: e.components.state,
                        country: e.components.country
                    },
                    original: {
                        formatted: e.formatted,
                        details: e.components
                    }
                }));
        }
    }
    const ce = q.cssClasses;
    class de {
        constructor(e, t){
            this.Base = e, this.layerName = U("geocoder-layer-"), this.layer = new h.default({
                background: "transparent",
                name: this.layerName,
                source: new g.default,
                displayInLayerSwitcher: !1
            }), this.options = e.options, this.options.provider = "string" == typeof this.options.provider ? this.options.provider.toLowerCase() : this.options.provider, this.provider = this.newProvider(), this.els = t, this.container = this.els.container, this.registeredListeners = {
                mapClick: !1
            }, this.setListeners();
        }
        setListeners() {
            const e = (e)=>{
                e.stopPropagation(), H(this.els.control, ce.glass.expanded) ? this.collapse() : this.expand();
            };
            this.els.input.addEventListener("keypress", (e)=>{
                const t = e.target.value.trim();
                (e.key ? "Enter" === e.key : e.which ? 13 === e.which : !!e.keyCode && 13 === e.keyCode) && (e.preventDefault(), this.query(t));
            }, !1), this.els.input.addEventListener("click", (e)=>e.stopPropagation(), !1), this.els.input.addEventListener("input", (e)=>{
                0 !== e.target.value.trim().length ? z(this.els.search, ce.hidden) : Q(this.els.search, ce.hidden);
            }, !1), this.els.search.addEventListener("click", ()=>{
                this.els.input.focus(), this.query(this.els.input.value);
            }, !1), this.options.targetType === T && this.els.button.addEventListener("click", e, !1);
        }
        query(e) {
            this.provider || (this.provider = this.newProvider());
            const t = this.provider.getParameters({
                query: e,
                key: this.options.key,
                lang: this.options.lang,
                countrycodes: this.options.countrycodes,
                viewbox: this.options.viewbox,
                limit: this.options.limit
            });
            this.clearResults(!1 === this.options.keepOpen), Q(this.els.search, ce.spin);
            const s = {
                url: t.url,
                data: t.params
            };
            t.callbackName && (s.jsonp = !0, s.callbackName = t.callbackName), se(s).then((e)=>{
                this.options.debug && console.info(e), z(this.els.search, ce.spin);
                const t = this.provider.handleResponse(e);
                t && (this.createList(t), this.listenMapClick());
            }).catch(()=>{
                z(this.els.search, ce.spin);
                const e = W("li", "<h5>Error! No internet connection?</h5>");
                this.els.result.append(e);
            });
        }
        createList(e) {
            const t = this.els.result;
            e.forEach((s)=>{
                let r;
                if (this.options.provider === A) r = `<span class="${ce.road}">${s.address.name}</span>`;
                else r = this.addressTemplate(s.address);
                if (1 == e.length) this.chosen(s, r, s.address, s.original);
                else {
                    const e = W("li", `<a href="#">${r}</a>`);
                    e.addEventListener("click", (e)=>{
                        e.preventDefault(), this.chosen(s, r, s.address, s.original);
                    }, !1), t.append(e);
                }
            });
        }
        chosen(e, t, s, r) {
            const n = this.Base.getMap(), o = [
                Number.parseFloat(e.lon),
                Number.parseFloat(e.lat)
            ], a = n.getView().getProjection(), i = f.transform(o, "EPSG:4326", a);
            let { bbox: l } = e;
            l && (l = f.transformExtent([
                parseFloat(l[2]),
                parseFloat(l[0]),
                parseFloat(l[3]),
                parseFloat(l[1])
            ], "EPSG:4326", a));
            const c = {
                formatted: t,
                details: s,
                original: r
            };
            if (this.clearResults(!0), !0 === this.options.preventDefault || !0 === this.options.preventMarker) this.Base.dispatchEvent({
                type: L,
                address: c,
                coordinate: i,
                bbox: l,
                place: e
            });
            else {
                const t = this.createFeature(i, c);
                this.Base.dispatchEvent({
                    type: L,
                    address: c,
                    feature: t,
                    coordinate: i,
                    bbox: l,
                    place: e
                });
            }
            !0 !== this.options.preventDefault && !0 !== this.options.preventPanning && (l ? n.getView().fit(l, {
                duration: 500
            }) : n.getView().animate({
                center: i,
                resolution: this.options.defaultFlyResolution,
                duration: 500
            }));
        }
        createFeature(e) {
            const t = new y.default(new m.default(e));
            return this.addLayer(), t.setStyle(this.options.featureStyle), t.setId(U("geocoder-ft-")), this.getSource().addFeature(t), t;
        }
        addressTemplate(e) {
            const t = [];
            return e.name && t.push([
                '<span class="',
                ce.road,
                '">{name}</span>'
            ].join("")), (e.road || e.building || e.house_number) && t.push([
                '<span class="',
                ce.road,
                '">{building} {road} {house_number}</span>'
            ].join("")), (e.city || e.town || e.village) && t.push([
                '<span class="',
                ce.city,
                '">{postcode} {city} {town} {village}</span>'
            ].join("")), (e.state || e.country) && t.push([
                '<span class="',
                ce.country,
                '">{state} {country}</span>'
            ].join("")), J(t.join("<br>"), e);
        }
        newProvider() {
            switch(this.options.provider){
                case A:
                    return new oe(this.options);
                case N:
                    return new ae;
                case R:
                    return new ne;
                case I:
                    return new ie;
                case P:
                    return new le;
                default:
                    return this.options.provider;
            }
        }
        expand() {
            z(this.els.input, ce.spin), Q(this.els.control, ce.glass.expanded), window.setTimeout(()=>this.els.input.focus(), 100), this.listenMapClick();
        }
        collapse() {
            this.els.input.value = "", this.els.input.blur(), Q(this.els.search, ce.hidden), z(this.els.control, ce.glass.expanded), K(this.els.result);
        }
        listenMapClick() {
            if (this.registeredListeners.mapClick) return;
            const e = this, t = this.Base.getMap().getTargetElement();
            this.registeredListeners.mapClick = !0, t.addEventListener("click", {
                handleEvent (s) {
                    t.removeEventListener(s.type, this, !1), e.registeredListeners.mapClick = !1;
                }
            }, !1);
        }
        clearResults(e) {
            e && this.options.targetType === T ? this.collapse() : K(this.els.result);
        }
        getSource() {
            return this.layer.getSource();
        }
        addLayer() {
            let e = !1;
            const t = this.Base.getMap();
            t.getLayers().forEach((t)=>{
                t === this.layer && (e = !0);
            }), e || t.addLayer(this.layer);
        }
    }
    class ue extends d.default {
        constructor(e = C, t){
            B("string" == typeof e, "@param `type` should be string!"), B(e === C || e === E, `@param 'type' should be '${C}'\n      or '${E}'!`);
            const s = {
                ...V,
                featureStyle: [
                    new u.default({
                        image: new p.default({
                            anchor: [
                                .5,
                                1
                            ],
                            src: 'data:image/svg+xml;charset=utf-8,<svg width="26" height="42" viewBox="0 0 26 42" xmlns="http://www.w3.org/2000/svg"><polygon points="1,18 14,42 25,18" fill="rgb(75,75,75)" /><ellipse cx="13" cy="13" rx="13" ry="13" fill="rgb(75,75,75)" /><ellipse cx="13" cy="14" rx="6" ry="6" fill="yellow" /></svg>'
                        })
                    })
                ],
                ...t
            };
            let r, n;
            const o = new te(s);
            if (e === C && (r = o.els.container), super({
                element: r,
                ...s
            }), !(this instanceof ue)) return new ue;
            this.options = s, this.container = r, e === C && (n = new de(this, o.els), this.layer = n.layer);
        }
        getLayer() {
            return this.layer;
        }
        getSource() {
            return this.getLayer().getSource();
        }
        setProvider(e) {
            this.options.provider = e;
        }
        setProviderKey(e) {
            this.options.key = e;
        }
    }
    return ue;
});

},{"d44e0263994d8518":"8KSMn","e7c81622ced83b7e":"gqpPW","f8b796a0e43051de":"ib4Ft","ad8d699790cf7c67":"7ga2c","81f5340139bc0735":"7zHxp","cdb3cbf620ffc78":"95T6m","7a530b3a437d556a":"iVSSP","1f8863aa812eebec":"gN0IK"}],"cLPMT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addBasemapLayersAndControls", ()=>addBasemapLayersAndControls);
var _group = require("ol/layer/Group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _olLayerswitcher = require("ol-layerswitcher");
var _olLayerswitcherDefault = parcelHelpers.interopDefault(_olLayerswitcher);
var _basemapTileLayers = require("../layers/basemapTileLayers");
var _urlstateManager = require("../state/URLStateManager");
function addBasemapLayersAndControls(map, azureLoginControl) {
    const layerSwitcher = new (0, _olLayerswitcherDefault.default)({
        tipLabel: "Basemaps",
        groupSelectStyle: "none"
    });
    const tileLayers = (0, _basemapTileLayers.createBasemapTileLayers)(azureLoginControl);
    // The main viewer drives basemap selection via ol-layerswitcher, which needs
    // `title` + `type: "base"`. With no basemap in the URL, all layers start
    // visible and the switcher keeps the last one (Orbis). If the URL pins a
    // basemap, show only that one so the switcher keeps it instead.
    const initial = (0, _urlstateManager.resolveInitialBasemap)(tileLayers.map(({ name })=>name), (0, _urlstateManager.getBasemapFromURL)());
    tileLayers.forEach(({ name, layer })=>{
        layer.set("title", name);
        layer.set("type", "base");
        layer.setVisible(initial ? name === initial : true);
    });
    (0, _urlstateManager.registerBasemapLayers)(tileLayers);
    map.addLayer(new (0, _groupDefault.default)({
        title: "Base maps",
        layers: tileLayers.map(({ layer })=>layer)
    }));
    map.addControl(layerSwitcher);
}

},{"ol/layer/Group":"6DIkJ","ol-layerswitcher":"hhkWj","../layers/basemapTileLayers":"3mhEo","../state/URLStateManager":"7Lluw","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hhkWj":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    module.exports = factory(require("2f1f65643b836f7d"), require("ca02aeb924cb46c7"), require("4d8e01a82b9017e0"));
})(this, function(Control, ol_Observable, LayerGroup) {
    'use strict';
    Control = 'default' in Control ? Control['default'] : Control;
    LayerGroup = 'default' in LayerGroup ? LayerGroup['default'] : LayerGroup;
    /**
 * @protected
 */ const CSS_PREFIX = 'layer-switcher-';
    /**
 * OpenLayers LayerSwitcher Control, displays a list of layers and groups
 * associated with a map which have a `title` property.
 *
 * To be shown in the LayerSwitcher panel layers must have a `title` property;
 * base map layers should have a `type` property set to `base`. Group layers
 * (`LayerGroup`) can be used to visually group layers together; a group
 * with a `fold` property set to either `'open'` or `'close'` will be displayed
 * with a toggle.
 *
 * See [BaseLayerOptions](#baselayeroptions) for a full list of LayerSwitcher
 * properties for layers (`TileLayer`, `ImageLayer`, `VectorTile` etc.) and
 * [GroupLayerOptions](#grouplayeroptions) for group layer (`LayerGroup`)
 * LayerSwitcher properties.
 *
 * Layer and group properties can either be set by adding extra properties
 * to their options when they are created or via their set method.
 *
 * Specify a `title` for a Layer by adding a `title` property to it's options object:
 * ```javascript
 * var lyr = new ol.layer.Tile({
 *   // Specify a title property which will be displayed by the layer switcher
 *   title: 'OpenStreetMap',
 *   visible: true,
 *   source: new ol.source.OSM()
 * })
 * ```
 *
 * Alternatively the properties can be set via the `set` method after a layer has been created:
 * ```javascript
 * var lyr = new ol.layer.Tile({
 *   visible: true,
 *   source: new ol.source.OSM()
 * })
 * // Specify a title property which will be displayed by the layer switcher
 * lyr.set('title', 'OpenStreetMap');
 * ```
 *
 * To create a LayerSwitcher and add it to a map, create a new instance then pass it to the map's [`addControl` method](https://openlayers.org/en/latest/apidoc/module-ol_Map-Map.html#addControl).
 * ```javascript
 * var layerSwitcher = new LayerSwitcher({
 *   reverse: true,
 *   groupSelectStyle: 'group'
 * });
 * map.addControl(layerSwitcher);
 * ```
 *
 * @constructor
 * @extends {ol/control/Control~Control}
 * @param opt_options LayerSwitcher options, see  [LayerSwitcher Options](#options) and [RenderOptions](#renderoptions) which LayerSwitcher `Options` extends for more details.
 */ class LayerSwitcher extends Control {
        constructor(opt_options){
            const options = Object.assign({}, opt_options);
            const element = document.createElement('div');
            super({
                element: element,
                target: options.target
            });
            this.activationMode = options.activationMode || 'mouseover';
            this.startActive = options.startActive === true;
            // TODO Next: Rename to showButtonContent
            this.label = options.label !== undefined ? options.label : '';
            // TODO Next: Rename to hideButtonContent
            this.collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : '\u00BB';
            // TODO Next: Rename to showButtonTitle
            this.tipLabel = options.tipLabel ? options.tipLabel : 'Legend';
            // TODO Next: Rename to hideButtonTitle
            this.collapseTipLabel = options.collapseTipLabel ? options.collapseTipLabel : 'Collapse legend';
            this.groupSelectStyle = LayerSwitcher.getGroupSelectStyle(options.groupSelectStyle);
            this.reverse = options.reverse !== false;
            this.mapListeners = [];
            this.hiddenClassName = 'ol-unselectable ol-control layer-switcher';
            if (LayerSwitcher.isTouchDevice_()) this.hiddenClassName += ' touch';
            this.shownClassName = 'shown';
            element.className = this.hiddenClassName;
            this.button = document.createElement('button');
            element.appendChild(this.button);
            this.panel = document.createElement('div');
            this.panel.className = 'panel';
            element.appendChild(this.panel);
            LayerSwitcher.enableTouchScroll_(this.panel);
            element.classList.add(CSS_PREFIX + 'group-select-style-' + this.groupSelectStyle);
            element.classList.add(CSS_PREFIX + 'activation-mode-' + this.activationMode);
            if (this.activationMode === 'click') {
                // TODO Next: Remove in favour of layer-switcher-activation-mode-click
                element.classList.add('activationModeClick');
                this.button.onclick = (e)=>{
                    const evt = e || window.event;
                    if (this.element.classList.contains(this.shownClassName)) this.hidePanel();
                    else this.showPanel();
                    evt.preventDefault();
                };
            } else {
                this.button.onmouseover = ()=>{
                    this.showPanel();
                };
                this.button.onclick = (e)=>{
                    const evt = e || window.event;
                    this.showPanel();
                    evt.preventDefault();
                };
                this.panel.onmouseout = (evt)=>{
                    if (!this.panel.contains(evt.relatedTarget)) this.hidePanel();
                };
            }
            this.updateButton();
        }
        /**
     * Set the map instance the control is associated with.
     * @param map The map instance.
     */ setMap(map) {
            // Clean up listeners associated with the previous map
            for(let i = 0; i < this.mapListeners.length; i++)ol_Observable.unByKey(this.mapListeners[i]);
            this.mapListeners.length = 0;
            // Wire up listeners etc. and store reference to new map
            super.setMap(map);
            if (map) {
                if (this.startActive) this.showPanel();
                else this.renderPanel();
                if (this.activationMode !== 'click') this.mapListeners.push(map.on('pointerdown', ()=>{
                    this.hidePanel();
                }));
            }
        }
        /**
     * Show the layer panel. Fires `'show'` event.
     * @fires LayerSwitcher#show
     */ showPanel() {
            if (!this.element.classList.contains(this.shownClassName)) {
                this.element.classList.add(this.shownClassName);
                this.updateButton();
                this.renderPanel();
            }
            /**
         * Event triggered after the panel has been shown.
         * Listen to the event via the `on` or `once` methods; for example:
         * ```js
         * var layerSwitcher = new LayerSwitcher();
         * map.addControl(layerSwitcher);
         *
         * layerSwitcher.on('show', evt => {
         *   console.log('show', evt);
         * });
         * @event LayerSwitcher#show
         */ this.dispatchEvent('show');
        }
        /**
     * Hide the layer panel. Fires `'hide'` event.
     * @fires LayerSwitcher#hide
     */ hidePanel() {
            if (this.element.classList.contains(this.shownClassName)) {
                this.element.classList.remove(this.shownClassName);
                this.updateButton();
            }
            /**
         * Event triggered after the panel has been hidden.
         * @event LayerSwitcher#hide
         */ this.dispatchEvent('hide');
        }
        /**
     * Update button text content and attributes based on current
     * state
     */ updateButton() {
            if (this.element.classList.contains(this.shownClassName)) {
                this.button.textContent = this.collapseLabel;
                this.button.setAttribute('title', this.collapseTipLabel);
                this.button.setAttribute('aria-label', this.collapseTipLabel);
            } else {
                this.button.textContent = this.label;
                this.button.setAttribute('title', this.tipLabel);
                this.button.setAttribute('aria-label', this.tipLabel);
            }
        }
        /**
     * Re-draw the layer panel to represent the current state of the layers.
     */ renderPanel() {
            this.dispatchEvent('render');
            LayerSwitcher.renderPanel(this.getMap(), this.panel, {
                groupSelectStyle: this.groupSelectStyle,
                reverse: this.reverse
            });
            this.dispatchEvent('rendercomplete');
        }
        /**
     * **_[static]_** - Re-draw the layer panel to represent the current state of the layers.
     * @param map The OpenLayers Map instance to render layers for
     * @param panel The DOM Element into which the layer tree will be rendered
     * @param options Options for panel, group, and layers
     */ static renderPanel(map, panel, options) {
            // Create the event.
            const render_event = new Event('render');
            // Dispatch the event.
            panel.dispatchEvent(render_event);
            options = options || {};
            options.groupSelectStyle = LayerSwitcher.getGroupSelectStyle(options.groupSelectStyle);
            LayerSwitcher.ensureTopVisibleBaseLayerShown(map, options.groupSelectStyle);
            while(panel.firstChild)panel.removeChild(panel.firstChild);
            // Reset indeterminate state for all layers and groups before
            // applying based on groupSelectStyle
            LayerSwitcher.forEachRecursive(map, function(l, _idx, _a) {
                l.set('indeterminate', false);
            });
            if (options.groupSelectStyle === 'children' || options.groupSelectStyle === 'none') // Set visibile and indeterminate state of groups based on
            // their children's visibility
            LayerSwitcher.setGroupVisibility(map);
            else if (options.groupSelectStyle === 'group') // Set child indetermiate state based on their parent's visibility
            LayerSwitcher.setChildVisibility(map);
            const ul = document.createElement('ul');
            panel.appendChild(ul);
            // passing two map arguments instead of lyr as we're passing the map as the root of the layers tree
            LayerSwitcher.renderLayers_(map, map, ul, options, function render(_changedLyr) {
                LayerSwitcher.renderPanel(map, panel, options);
            });
            // Create the event.
            const rendercomplete_event = new Event('rendercomplete');
            // Dispatch the event.
            panel.dispatchEvent(rendercomplete_event);
        }
        /**
     * **_[static]_** - Determine if a given layer group contains base layers
     * @param grp Group to test
     */ static isBaseGroup(grp) {
            if (grp instanceof LayerGroup) {
                const lyrs = grp.getLayers().getArray();
                return lyrs.length && lyrs[0].get('type') === 'base';
            } else return false;
        }
        static setGroupVisibility(map) {
            // Get a list of groups, with the deepest first
            const groups = LayerSwitcher.getGroupsAndLayers(map, function(l) {
                return l instanceof LayerGroup && !l.get('combine') && !LayerSwitcher.isBaseGroup(l);
            }).reverse();
            // console.log(groups.map(g => g.get('title')));
            groups.forEach(function(grp) {
                // TODO Can we use getLayersArray, is it public in the esm build?
                const descendantVisibility = grp.getLayersArray().map(function(l) {
                    const state = l.getVisible();
                    // console.log('>', l.get('title'), state);
                    return state;
                });
                // console.log(descendantVisibility);
                if (descendantVisibility.every(function(v) {
                    return v === true;
                })) {
                    grp.setVisible(true);
                    grp.set('indeterminate', false);
                } else if (descendantVisibility.every(function(v) {
                    return v === false;
                })) {
                    grp.setVisible(false);
                    grp.set('indeterminate', false);
                } else {
                    grp.setVisible(true);
                    grp.set('indeterminate', true);
                }
            });
        }
        static setChildVisibility(map) {
            // console.log('setChildVisibility');
            const groups = LayerSwitcher.getGroupsAndLayers(map, function(l) {
                return l instanceof LayerGroup && !l.get('combine') && !LayerSwitcher.isBaseGroup(l);
            });
            groups.forEach(function(grp) {
                const group = grp;
                // console.log(group.get('title'));
                const groupVisible = group.getVisible();
                const groupIndeterminate = group.get('indeterminate');
                group.getLayers().getArray().forEach(function(l) {
                    l.set('indeterminate', false);
                    if ((!groupVisible || groupIndeterminate) && l.getVisible()) l.set('indeterminate', true);
                });
            });
        }
        /**
     * Ensure only the top-most base layer is visible if more than one is visible.
     * @param map The map instance.
     * @param groupSelectStyle
     * @protected
     */ static ensureTopVisibleBaseLayerShown(map, groupSelectStyle) {
            let lastVisibleBaseLyr;
            LayerSwitcher.forEachRecursive(map, function(lyr, _idx, _arr) {
                if (lyr.get('type') === 'base' && lyr.getVisible()) lastVisibleBaseLyr = lyr;
            });
            if (lastVisibleBaseLyr) LayerSwitcher.setVisible_(map, lastVisibleBaseLyr, true, groupSelectStyle);
        }
        /**
     * **_[static]_** - Get an Array of all layers and groups displayed by the LayerSwitcher (has a `'title'` property)
     * contained by the specified map or layer group; optionally filtering via `filterFn`
     * @param grp The map or layer group for which layers are found.
     * @param filterFn Optional function used to filter the returned layers
     */ static getGroupsAndLayers(grp, filterFn) {
            const layers = [];
            filterFn = filterFn || function(_lyr, _idx, _arr) {
                return true;
            };
            LayerSwitcher.forEachRecursive(grp, function(lyr, idx, arr) {
                if (lyr.get('title')) {
                    if (filterFn(lyr, idx, arr)) layers.push(lyr);
                }
            });
            return layers;
        }
        /**
     * Toggle the visible state of a layer.
     * Takes care of hiding other layers in the same exclusive group if the layer
     * is toggle to visible.
     * @protected
     * @param map The map instance.
     * @param lyr layer whose visibility will be toggled.
     * @param visible Set whether the layer is shown
     * @param groupSelectStyle
     * @protected
     */ static setVisible_(map, lyr, visible, groupSelectStyle) {
            // console.log(lyr.get('title'), visible, groupSelectStyle);
            lyr.setVisible(visible);
            if (visible && lyr.get('type') === 'base') // Hide all other base layers regardless of grouping
            LayerSwitcher.forEachRecursive(map, function(l, _idx, _arr) {
                if (l != lyr && l.get('type') === 'base') l.setVisible(false);
            });
            if (lyr instanceof LayerGroup && !lyr.get('combine') && groupSelectStyle === 'children') lyr.getLayers().forEach((l)=>{
                LayerSwitcher.setVisible_(map, l, lyr.getVisible(), groupSelectStyle);
            });
        }
        /**
     * Render all layers that are children of a group.
     * @param map The map instance.
     * @param lyr Layer to be rendered (should have a title property).
     * @param idx Position in parent group list.
     * @param options Options for groups and layers
     * @protected
     */ static renderLayer_(map, lyr, idx, options, render) {
            const li = document.createElement('li');
            const lyrTitle = lyr.get('title');
            const checkboxId = LayerSwitcher.uuid();
            const label = document.createElement('label');
            if (lyr instanceof LayerGroup && !lyr.get('combine')) {
                const isBaseGroup = LayerSwitcher.isBaseGroup(lyr);
                li.classList.add('group');
                if (isBaseGroup) li.classList.add(CSS_PREFIX + 'base-group');
                // Group folding
                if (lyr.get('fold')) {
                    li.classList.add(CSS_PREFIX + 'fold');
                    li.classList.add(CSS_PREFIX + lyr.get('fold'));
                    const btn = document.createElement('button');
                    btn.onclick = function(e) {
                        const evt = e || window.event;
                        LayerSwitcher.toggleFold_(lyr, li);
                        evt.preventDefault();
                    };
                    li.appendChild(btn);
                }
                if (!isBaseGroup && options.groupSelectStyle != 'none') {
                    const input = document.createElement('input');
                    input.type = 'checkbox';
                    input.id = checkboxId;
                    input.checked = lyr.getVisible();
                    input.indeterminate = lyr.get('indeterminate');
                    input.onchange = function(e) {
                        const target = e.target;
                        LayerSwitcher.setVisible_(map, lyr, target.checked, options.groupSelectStyle);
                        render(lyr);
                    };
                    li.appendChild(input);
                    label.htmlFor = checkboxId;
                }
                label.innerHTML = lyrTitle;
                li.appendChild(label);
                const ul = document.createElement('ul');
                li.appendChild(ul);
                LayerSwitcher.renderLayers_(map, lyr, ul, options, render);
            } else {
                li.className = 'layer';
                const input = document.createElement('input');
                if (lyr.get('type') === 'base') input.type = 'radio';
                else input.type = 'checkbox';
                input.id = checkboxId;
                input.checked = lyr.get('visible');
                input.indeterminate = lyr.get('indeterminate');
                input.onchange = function(e) {
                    const target = e.target;
                    LayerSwitcher.setVisible_(map, lyr, target.checked, options.groupSelectStyle);
                    render(lyr);
                };
                li.appendChild(input);
                label.htmlFor = checkboxId;
                label.innerHTML = lyrTitle;
                const rsl = map.getView().getResolution();
                if (rsl >= lyr.getMaxResolution() || rsl < lyr.getMinResolution()) label.className += ' disabled';
                else if (lyr.getMinZoom && lyr.getMaxZoom) {
                    const zoom = map.getView().getZoom();
                    if (zoom <= lyr.getMinZoom() || zoom > lyr.getMaxZoom()) label.className += ' disabled';
                }
                li.appendChild(label);
            }
            return li;
        }
        /**
     * Render all layers that are children of a group.
     * @param map The map instance.
     * @param lyr Group layer whose children will be rendered.
     * @param elm DOM element that children will be appended to.
     * @param options Options for groups and layers
     * @protected
     */ static renderLayers_(map, lyr, elm, options, render) {
            let lyrs = lyr.getLayers().getArray().slice();
            if (options.reverse) lyrs = lyrs.reverse();
            for(let i = 0, l; i < lyrs.length; i++){
                l = lyrs[i];
                if (l.get('title')) elm.appendChild(LayerSwitcher.renderLayer_(map, l, i, options, render));
            }
        }
        /**
     * **_[static]_** - Call the supplied function for each layer in the passed layer group
     * recursing nested groups.
     * @param lyr The layer group to start iterating from.
     * @param fn Callback which will be called for each layer
     * found under `lyr`.
     */ static forEachRecursive(lyr, fn) {
            lyr.getLayers().forEach(function(lyr, idx, a) {
                fn(lyr, idx, a);
                if (lyr instanceof LayerGroup) LayerSwitcher.forEachRecursive(lyr, fn);
            });
        }
        /**
     * **_[static]_** - Generate a UUID
     * Adapted from http://stackoverflow.com/a/2117523/526860
     * @returns {String} UUID
     */ static uuid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
                return v.toString(16);
            });
        }
        /**
     * Apply workaround to enable scrolling of overflowing content within an
     * element. Adapted from https://gist.github.com/chrismbarr/4107472
     * @param elm Element on which to enable touch scrolling
     * @protected
     */ static enableTouchScroll_(elm) {
            if (LayerSwitcher.isTouchDevice_()) {
                let scrollStartPos = 0;
                elm.addEventListener('touchstart', function(event) {
                    scrollStartPos = this.scrollTop + event.touches[0].pageY;
                }, false);
                elm.addEventListener('touchmove', function(event) {
                    this.scrollTop = scrollStartPos - event.touches[0].pageY;
                }, false);
            }
        }
        /**
     * Determine if the current browser supports touch events. Adapted from
     * https://gist.github.com/chrismbarr/4107472
     * @returns {Boolean} True if client can have 'TouchEvent' event
     * @protected
     */ static isTouchDevice_() {
            try {
                document.createEvent('TouchEvent');
                return true;
            } catch (e) {
                return false;
            }
        }
        /**
     * Fold/unfold layer group
     * @param lyr Layer group to fold/unfold
     * @param li List item containing layer group
     * @protected
     */ static toggleFold_(lyr, li) {
            li.classList.remove(CSS_PREFIX + lyr.get('fold'));
            lyr.set('fold', lyr.get('fold') === 'open' ? 'close' : 'open');
            li.classList.add(CSS_PREFIX + lyr.get('fold'));
        }
        /**
     * If a valid groupSelectStyle value is not provided then return the default
     * @param groupSelectStyle The string to check for validity
     * @returns The value groupSelectStyle, if valid, the default otherwise
     * @protected
     */ static getGroupSelectStyle(groupSelectStyle) {
            return [
                'none',
                'children',
                'group'
            ].indexOf(groupSelectStyle) >= 0 ? groupSelectStyle : 'children';
        }
    }
    // Expose LayerSwitcher as ol.control.LayerSwitcher if using a full build of
    // OpenLayers
    if (window['ol'] && window['ol']['control']) window['ol']['control']['LayerSwitcher'] = LayerSwitcher;
    return LayerSwitcher;
});

},{"2f1f65643b836f7d":"8KSMn","ca02aeb924cb46c7":"jiDvm","4d8e01a82b9017e0":"6DIkJ"}],"73XNr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addWKTLayerAndControl", ()=>addWKTLayerAndControl);
var _handleURL = require("../handleURL");
var _wktinputControl = require("../controls/WKTInputControl");
var _wktlayer = require("../layers/WKTLayer");
var _urlstateManager = require("../state/URLStateManager");
function addWKTLayerAndControl(map, target, view, azureLoginControl) {
    const wktInputControl = new (0, _wktinputControl.WKTInputControl)({
        target: target
    });
    const wktLayer = (0, _wktlayer.getWKTLayer)(wktInputControl, view, azureLoginControl);
    map.addLayer(wktLayer);
    map.addControl(wktInputControl);
    (0, _handleURL.handleURLForWKT)(wktInputControl);
    // Restore wktToggle from URL (default is true; only stored when false)
    if (!(0, _urlstateManager.getWKTToggleFromURL)()) wktInputControl.set("wktToggle", false);
    (0, _urlstateManager.registerWKTControl)(wktInputControl);
    return [
        wktLayer,
        wktInputControl
    ];
}

},{"../handleURL":"53YIf","../controls/WKTInputControl":"6h6QW","../layers/WKTLayer":"1BLFu","../state/URLStateManager":"7Lluw","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6h6QW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WKTInputControl", ()=>WKTInputControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
class WKTInputControl extends (0, _controlDefault.default) {
    constructor(opt_options){
        const options = opt_options || {};
        const element = document.createElement("div");
        element.className = "wkt-input ol-unselectable";
        super({
            element: element,
            target: options.target
        });
        const this_ = this;
        this_.set("validWkt", true);
        const textarea = document.createElement("textarea");
        textarea.placeholder = "Enter WKT strings or boundary codes. e.g.:POINT (12.3403085 45.4340351) deu LINESTRING (12.3403085 45.4340351, 12.3385887 45.4335411)";
        textarea.rows = 4;
        element.appendChild(textarea);
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.checked = true;
        checkbox.id = "wkt";
        element.appendChild(checkbox);
        this_.set("wktToggle", checkbox.checked);
        checkbox.addEventListener("change", function() {
            this_.set("wktToggle", checkbox.checked);
        });
        const label = document.createElement("label");
        label.htmlFor = checkbox.id;
        element.appendChild(label);
        const button = document.createElement("button");
        button.className = "caj-nav-btn";
        button.textContent = "Map It";
        button.addEventListener("click", function() {
            // Set before "wkt" so the WKTLayer's propertychange listener sees the
            // request to zoom to the feature extent. URL restoration never sets
            // this flag, so reloads preserve the URL's center/zoom instead.
            this_.set("zoomToExtent", true);
            this_.set("wkt", textarea.value);
        }, false);
        label.appendChild(button);
        // Error message element
        const errorMessage = document.createElement("span");
        errorMessage.className = "wkt-error-message";
        errorMessage.style.display = "none";
        label.appendChild(errorMessage);
        // listen to changes
        this.on("propertychange", (e)=>{
            // Only sync the textarea when the `wkt` property itself changed. Any
            // other propertychange (zoomToExtent / validWkt / errorMessage) would
            // otherwise clobber in-progress edits with the previously-mapped value.
            if (e.key === "wkt" && this_.get("wkt") !== undefined) textarea.value = this_.get("wkt");
            if (e.key === "wktToggle") checkbox.checked = this_.get("wktToggle") ?? true;
            if (this_.get("validWkt")) {
                textarea.classList.remove("error");
                errorMessage.style.display = "none";
                errorMessage.textContent = "";
            } else {
                textarea.classList.add("error");
                const error = this_.get("errorMessage");
                if (error) {
                    errorMessage.textContent = error;
                    errorMessage.style.display = "inline";
                }
            }
        });
    }
}

},{"ol/control/Control":"8KSMn","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1BLFu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWKTLayer", ()=>getWKTLayer);
var _style = require("ol/style");
var _point = require("ol/geom/Point");
var _pointDefault = parcelHelpers.interopDefault(_point);
var _vector = require("ol/layer/Vector");
var _vectorDefault = parcelHelpers.interopDefault(_vector);
var _vector1 = require("ol/source/Vector");
var _vectorDefault1 = parcelHelpers.interopDefault(_vector1);
var _wkt = require("ol/format/WKT");
var _wktDefault = parcelHelpers.interopDefault(_wkt);
var _extent = require("ol/extent");
var _mortonTile = require("../util/mortonTile");
async function fetchBoundaryWKT(boundaryCode, idToken) {
    const url = `${"/boundary-geom-prod"}?country=${encodeURIComponent(boundaryCode)}`;
    const headers = idToken ? {
        Authorization: `Bearer ${idToken}`
    } : {};
    const response = await fetch(url, {
        headers
    });
    if (!response.ok) throw new Error(`Boundary code not found: ${boundaryCode}`);
    const wkt = await response.text();
    if (!wkt || wkt.trim().length === 0) throw new Error(`Boundary code returned empty result: ${boundaryCode}`);
    return wkt;
}
/**
 * Parse mixed input containing WKT strings and boundary codes
 * @param {string} input - Mixed input with WKT geometries and boundary codes
 * @returns {Object} - { wktStrings: string[], boundaryCodes: string[], mortonCodes: string[], valid: boolean, error: string }
 */ function parseInputTokens(input) {
    const result = {
        wktStrings: [],
        boundaryCodes: [],
        mortonCodes: [],
        valid: true,
        error: null
    };
    if (!input || input.trim().length === 0) return result;
    // Check for balanced parentheses first
    let balance = 0;
    for (let char of input){
        if (char === "(") balance++;
        if (char === ")") balance--;
        if (balance < 0) {
            result.valid = false;
            result.error = "Unbalanced parentheses: closing parenthesis without opening";
            return result;
        }
    }
    if (balance !== 0) {
        result.valid = false;
        result.error = "Unbalanced parentheses: unclosed parenthesis";
        return result;
    }
    // Find all parenthesis groups with their preceding text
    const segments = [];
    let i = 0;
    while(i < input.length){
        // Skip whitespace
        while(i < input.length && /\s/.test(input[i]))i++;
        if (i >= input.length) break;
        // Check if we're at the start of a potential WKT geometry
        const remainingText = input.substring(i);
        // Look for WKT type keywords (POINT, LINESTRING, POLYGON, MULTIPOINT, MULTILINESTRING, MULTIPOLYGON, GEOMETRYCOLLECTION)
        // with optional Z, M, or ZM modifiers
        const wktPattern = /^(POINT|LINESTRING|POLYGON|MULTIPOINT|MULTILINESTRING|MULTIPOLYGON|GEOMETRYCOLLECTION)(\s+Z|\s+M|\s+ZM)?\s*\(/i;
        const match = remainingText.match(wktPattern);
        if (match) {
            // This is a WKT geometry - find the matching closing parenthesis
            const startIdx = i;
            let parenDepth = 0;
            let foundStart = false;
            let endIdx = i;
            for(let j = i; j < input.length; j++){
                if (input[j] === "(") {
                    parenDepth++;
                    foundStart = true;
                } else if (input[j] === ")") {
                    parenDepth--;
                    if (foundStart && parenDepth === 0) {
                        endIdx = j + 1;
                        break;
                    }
                }
            }
            const wktString = input.substring(startIdx, endIdx).trim();
            if (wktString) segments.push({
                type: "wkt",
                value: wktString
            });
            i = endIdx;
        } else {
            // This is not a WKT geometry - treat as potential boundary code
            // Extract until next WKT geometry or end of string
            let nextWktStart = input.length;
            // Find the next WKT geometry start
            for(let j = i + 1; j < input.length; j++){
                const testText = input.substring(j);
                if (wktPattern.test(testText)) {
                    nextWktStart = j;
                    break;
                }
            }
            const tokenEnd = nextWktStart;
            const token = input.substring(i, tokenEnd).trim();
            if (token) {
                // Split by whitespace into individual codes; canonical Morton tile
                // codes are resolved to polygons, anything else stays a boundary code.
                const codes = token.split(/\s+/).filter((c)=>c.length > 0);
                codes.forEach((code)=>{
                    if ((0, _mortonTile.looksLikeMortonCode)(code)) segments.push({
                        type: "morton",
                        value: code
                    });
                    else segments.push({
                        type: "boundary",
                        value: code
                    });
                });
            }
            i = tokenEnd;
        }
    }
    // Separate WKT strings, Morton tile codes and boundary codes
    segments.forEach((seg)=>{
        if (seg.type === "wkt") result.wktStrings.push(seg.value);
        else if (seg.type === "morton") result.mortonCodes.push(seg.value);
        else result.boundaryCodes.push(seg.value);
    });
    return result;
}
/**
 * Convert WKT string to OpenLayers features
 * @param {string} wktString - WKT geometry string
 * @param {number} index - Feature index for labeling
 * @param {string} [boundaryCode] - Optional boundary code for label suffix
 * @returns {Feature} - OpenLayers feature
 */ function wktStringToFeature(wktString, index, boundaryCode) {
    const format = new (0, _wktDefault.default)();
    const feature = format.readFeature(wktString, {
        dataProjection: "EPSG:4326",
        featureProjection: "EPSG:3857"
    });
    const suffix = boundaryCode ? `: ${boundaryCode}` : "";
    feature.set("label", `${index}${suffix}`);
    return feature;
}
/**
 * Process mixed input (WKT strings and boundary codes) into features
 * @param {string} input - Mixed input string
 * @param {string} idToken - Authentication token for boundary service
 * @returns {Promise<Array>} - Array of OpenLayers features
 */ async function parseInputToFeatures(input, idToken) {
    const parsed = parseInputTokens(input);
    if (!parsed.valid) throw new Error(parsed.error);
    const features = [];
    let featureIndex = 0;
    // Process WKT strings
    for (const wktString of parsed.wktStrings)try {
        const feature = wktStringToFeature(wktString, featureIndex);
        features.push(feature);
        featureIndex++;
    } catch (err) {
        throw new Error(`Invalid WKT geometry: ${wktString.substring(0, 50)}... - ${err.message}`, {
            cause: err
        });
    }
    // Process Morton tile codes into tile polygons
    for (const code of parsed.mortonCodes)try {
        const feature = wktStringToFeature((0, _mortonTile.mortonWktFromCode)(code), featureIndex, code);
        feature.set("mortonCode", code);
        features.push(feature);
        featureIndex++;
    } catch (err) {
        throw new Error(`Invalid Morton tile code '${code}': ${err.message}`, {
            cause: err
        });
    }
    // Process boundary codes
    for (const boundaryCode of parsed.boundaryCodes)try {
        const wkt = await fetchBoundaryWKT(boundaryCode, idToken);
        // The boundary service might return multiple WKT strings
        const boundaryParsed = parseInputTokens(wkt);
        for (const wktString of boundaryParsed.wktStrings){
            const feature = wktStringToFeature(wktString, featureIndex, boundaryCode);
            feature.set("boundaryCode", boundaryCode);
            features.push(feature);
            featureIndex++;
        }
    } catch (err) {
        throw new Error(`Failed to fetch boundary code '${boundaryCode}': ${err.message}`, {
            cause: err
        });
    }
    return features;
}
function getWKTLayer(wktInputControl, view, azureLoginControl) {
    const vectorSource = new (0, _vectorDefault1.default)({});
    const styleFunction = function(feature) {
        const geometry = feature.getGeometry();
        const LINE_COLOR = "red";
        const FILL_COLOR = "white";
        const styles = [
            // linestring
            new (0, _style.Style)({
                stroke: new (0, _style.Stroke)({
                    color: LINE_COLOR,
                    width: 10
                })
            }),
            new (0, _style.Style)({
                stroke: new (0, _style.Stroke)({
                    color: FILL_COLOR,
                    width: 8
                })
            }),
            new (0, _style.Style)({
                image: new (0, _style.Circle)({
                    fill: new (0, _style.Fill)({
                        color: FILL_COLOR
                    }),
                    stroke: new (0, _style.Stroke)({
                        color: LINE_COLOR,
                        width: 1
                    }),
                    radius: 10
                })
            })
        ];
        if (feature.get("label") != undefined) styles.push(new (0, _style.Style)({
            text: new (0, _style.Text)({
                text: feature.get("label"),
                fill: new (0, _style.Fill)({
                    color: LINE_COLOR
                }),
                stroke: new (0, _style.Stroke)({
                    color: FILL_COLOR,
                    width: 3
                })
            })
        }));
        if (typeof geometry.forEachSegment === "function") geometry.forEachSegment(function(start, end) {
            const mid = [
                (start[0] + end[0]) / 2,
                (start[1] + end[1]) / 2
            ];
            const dx = end[0] - start[0];
            const dy = end[1] - start[1];
            const rotation = Math.atan2(dy, dx);
            // arrows
            styles.push(new (0, _style.Style)({
                geometry: new (0, _pointDefault.default)(mid),
                image: new (0, _style.Icon)({
                    src: "icon-arrow.png",
                    anchor: [
                        0.75,
                        0.5
                    ],
                    rotateWithView: true,
                    rotation: -rotation,
                    color: LINE_COLOR,
                    scale: [
                        0.5,
                        0.5
                    ]
                })
            }));
        });
        return styles;
    };
    const vectorLayer = new (0, _vectorDefault.default)({
        source: vectorSource,
        style: styleFunction
    });
    // Generation counter so stale async parses (e.g. a previous Map It whose
    // boundary-code fetch is still in flight) discard themselves when a newer
    // `wkt` value arrives.
    let wktRunId = 0;
    wktInputControl.on("propertychange", async (event)=>{
        // Only react to the keys we care about. Other propertychange events
        // (zoomToExtent / validWkt / errorMessage / anything the handler itself
        // sets) would otherwise re-enter this block with stale inputs.
        if (event.key === "wkt") {
            const input = event.target.get("wkt");
            if (input === undefined) return;
            const myRun = ++wktRunId;
            try {
                const idToken = azureLoginControl ? azureLoginControl.get("idToken") : null;
                // Parse input and fetch features (handles both WKT and boundary codes)
                const features = await parseInputToFeatures(input, idToken);
                // Bail if another `wkt` change started after us.
                if (myRun !== wktRunId) return;
                vectorSource.clear();
                vectorSource.addFeatures(features);
                // Only zoom to the WKT extent when the user explicitly clicked
                // "Map It". URL restoration sets "wkt" without the flag, so the
                // saved center/zoom in the URL is respected on reload.
                if (wktInputControl.get("zoomToExtent") === true) {
                    wktInputControl.set("zoomToExtent", false);
                    const extent = vectorLayer.getSource().getExtent();
                    if (!(0, _extent.isEmpty)(extent)) view.fit((0, _extent.buffer)(extent, (0, _extent.getHeight)(extent) * 0.2), {
                        maxZoom: 19
                    });
                }
                wktInputControl.set("validWkt", true);
                wktInputControl.set("errorMessage", null);
            } catch (err) {
                if (myRun !== wktRunId) return;
                console.error(err);
                wktInputControl.set("validWkt", false);
                wktInputControl.set("errorMessage", err.message);
            }
            return;
        }
        if (event.key === "wktToggle") vectorLayer.setVisible(event.target.get("wktToggle") === true);
    });
    return vectorLayer;
}

},{"ol/style":[["Circle","3Wl62","default"],["Fill","24G0i","default"],["Icon","ib4Ft","default"],["Stroke","cese4","default"],["Style","gqpPW","default"],["Text","118sC","default"]],"ol/geom/Point":"95T6m","ol/layer/Vector":"7ga2c","ol/source/Vector":"7zHxp","ol/format/WKT":"34shs","ol/extent":"MPjK5","../util/mortonTile":"2CSvZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2CSvZ":[function(require,module,exports,__globalThis) {
/**
 * TomTom Morton tile encode + decode (EPSG:4326).
 *
 * This is NOT Web Mercator. It's a simple linear partition of lon/lat:
 *   X: longitude [-180, +180] -> [0, 2^level]
 *   Y: latitude  [-90,  +90]  -> [0, 2^level]
 *
 * Encode pieces (MORTON_LEVEL_DIVISORS, HALF/QUARTER_CIRCLE_UNITS_MD,
 * mortonTileFromCoordinate, interlace, interlaceLong) are ported from
 * com.tomtom.maps.mortontile (MortonTile.fromCoordinate / Interlacer.interlace).
 *
 * Decode (uninterlace + bounds) is the verified inverse, ported from
 * com.tomtom.maps:morton-tile 7.4.
 */ // ---------- Morton Tile encode (ported from com.tomtom.maps.mortontile) ----------
/**
 * MORTON_LEVEL_DIVISORS[i] = 3.6e9 / 2^i
 *
 * Java static initializer:
 *   for (int i = 0; i <= 32; ++i) {
 *       MORTON_LEVEL_DIVISORS[i] = 3.6e9 / (1L << i);
 *   }
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Parse a canonical TomTom Morton tile code.
 *
 * @param {string} code - Morton tile code in `M<level>:<hex>` format
 * @returns {{level: number, morton: bigint}} Parsed level and Morton code
 * @throws {Error} If `code` is not canonical or is out of range for its level
 */ parcelHelpers.export(exports, "parseMortonCode", ()=>parseMortonCode);
/**
 * Quick syntactic check for whether a token looks like a Morton tile code.
 *
 * @param {string} token - Candidate string
 * @returns {boolean} True when `token` has `M<level>:<hex>` shape
 */ parcelHelpers.export(exports, "looksLikeMortonCode", ()=>looksLikeMortonCode);
/**
 * Check whether a token is a valid Morton tile code.
 *
 * @param {string} token - Candidate string
 * @returns {boolean} True when `token` is a valid `M<level>:<hex>` code
 */ parcelHelpers.export(exports, "isMortonCode", ()=>isMortonCode);
/**
 * Encode a coordinate to a canonical TomTom Morton tile code.
 *
 * @param {number} lon - Longitude in degrees (EPSG:4326)
 * @param {number} lat - Latitude in degrees (EPSG:4326)
 * @param {number} level - Morton level
 * @returns {string} Morton tile code in `M<level>:<hex>` format
 */ parcelHelpers.export(exports, "mortonCodeFromCoordinate", ()=>mortonCodeFromCoordinate);
/**
 * Decode a canonical Morton tile code to its geographic bounds (EPSG:4326).
 *
 * @param {string} code - Morton tile code in `M<level>:<hex>` format
 * @returns {{minLon: number, minLat: number, maxLon: number, maxLat: number}}
 *   Tile bounds in degrees
 */ parcelHelpers.export(exports, "mortonBoundsFromCode", ()=>mortonBoundsFromCode);
/**
 * Decode a canonical Morton tile code to a closed lon/lat ring.
 *
 * @param {string} code - Morton tile code in `M<level>:<hex>` format
 * @returns {number[][]} Closed ring
 */ parcelHelpers.export(exports, "mortonRingFromCode", ()=>mortonRingFromCode);
/**
 * Decode a canonical Morton tile code to a WKT POLYGON string in EPSG:4326.
 *
 * @param {string} code - Morton tile code in `M<level>:<hex>` format
 * @returns {string} WKT POLYGON
 */ parcelHelpers.export(exports, "mortonWktFromCode", ()=>mortonWktFromCode);
const MORTON_LEVEL_DIVISORS = new Float64Array(33);
for(let i = 0; i <= 32; i++)// Java: (double)(1L << i) — use Math.pow to avoid 32-bit overflow at i >= 31
MORTON_LEVEL_DIVISORS[i] = 3.6e9 / Math.pow(2, i);
const HALF_CIRCLE_UNITS_MD = 1800000000; // 180° × 1e7
const QUARTER_CIRCLE_UNITS_MD = 900000000; // 90° × 1e7
const MORTON_CODE_PATTERN = /^M(\d+):([0-9a-f]+)$/i;
/**
 * Port of MortonTile.fromCoordinate(longitude, latitude, level).
 *
 * This is NOT Web Mercator. It's a simple linear partition:
 *   X: longitude  [-180, +180] → [0, 2^level]  (divisor = 3.6e9 / 2^level)
 *   Y: latitude   [-90,  +90]  → [0, 2^level]  (divisor = 3.6e9 / 2^(level+1))
 *
 * Note: Y uses MORTON_LEVEL_DIVISORS[level + 1] because the lat range (180°)
 * is half the lon range (360°), so needs double the divisor to get same tile count.
 *
 * @param {number} lon - Longitude in degrees
 * @param {number} lat - Latitude in degrees
 * @param {number} level - Morton level (23 for anchor IDs)
 * @returns {bigint} Morton code
 */ function mortonTileFromCoordinate(lon, lat, level) {
    level = assertMortonLevel(level);
    const xMd = Math.round(lon * 1e7);
    const yMd = Math.round(lat * 1e7);
    let tileX;
    if (xMd >= HALF_CIRCLE_UNITS_MD) // Boundary case: exactly +180°
    tileX = mortonMax(level);
    else tileX = Math.trunc((xMd + HALF_CIRCLE_UNITS_MD) / MORTON_LEVEL_DIVISORS[level]);
    let tileY;
    if (yMd >= QUARTER_CIRCLE_UNITS_MD) // Boundary case: exactly +90°
    tileY = mortonMax(level);
    else tileY = Math.trunc((yMd + QUARTER_CIRCLE_UNITS_MD) / MORTON_LEVEL_DIVISORS[level + 1]);
    return interlace(tileX, tileY);
}
// ---------- Interlacer (ported from com.tomtom.maps.mortontile.internal.Interlacer) ----------
/**
 * Port of Interlacer.interlace(int x, int y).
 *
 * Java: interlace((long)y << 32 | (long)x)
 * Then applies 5 rounds of swap-and-mask to interleave the bits.
 *
 * All operations use BigInt because JavaScript doesn't have 64-bit integers.
 */ function interlace(x, y) {
    // Pack y into upper 32 bits, x into lower 32 bits
    // Java: interlace(((long) y << 32) + (long) x)
    let raw = BigInt(y) << 32n | BigInt(x) & 0xffffffffn;
    return interlaceLong(raw);
}
/**
 * Port of Interlacer.interlace(long raw).
 *
 * Java swap-and-mask chain:
 *   swapAndMask(raw, 16, 0x00000000FFFF0000L)
 *   swapAndMask(..  , 8,  0x0000FF000000FF00L)
 *   swapAndMask(..  , 4,  0x00F000F000F000F0L)
 *   swapAndMask(..  , 2,  0x0C0C0C0C0C0C0C0CL)
 *   swapAndMask(..  , 1,  0x2222222222222222L)
 *
 * swapAndMask(val, shift, mask):
 *   changes = ((val >>> shift) ^ val) & mask
 *   return val ^ changes + (changes << shift)
 *
 * Note: Java operator precedence: ^ binds lower than +,
 * so "val ^ changes + (changes << shift)" = "val ^ (changes + (changes << shift))"
 */ function interlaceLong(raw) {
    const MASK_64 = 0xffffffffffffffffn;
    function swapAndMask(val, shift, mask) {
        val = val & MASK_64;
        // Java: long changes = (val >>> shift ^ val) & mask;
        // In Java >>> is unsigned right shift. For BigInt, we mask to 64 bits first.
        const shifted = val >> BigInt(shift) & MASK_64;
        const changes = (shifted ^ val) & mask;
        // Java: return val ^ changes + (changes << shift);
        // Java precedence: ^ has lower precedence than +
        // So this is: val ^ (changes + (changes << shift))
        const sum = changes + (changes << BigInt(shift) & MASK_64) & MASK_64;
        return (val ^ sum) & MASK_64;
    }
    let v = raw & MASK_64;
    v = swapAndMask(v, 16, 0x00000000ffff0000n);
    v = swapAndMask(v, 8, 0x0000ff000000ff00n);
    v = swapAndMask(v, 4, 0x00f000f000f000f0n);
    v = swapAndMask(v, 2, 0x0c0c0c0c0c0c0c0cn);
    v = swapAndMask(v, 1, 0x2222222222222222n);
    return v;
}
// ---------- Morton Tile decode (verified inverse, ported from morton-tile 7.4) ----------
const SCALE = 1e7;
const MASK_64 = 0xffffffffffffffffn;
/**
 * One swap-and-mask round, identical to the encode helper but reused for decode.
 *
 * @param {bigint} val - 64-bit value
 * @param {number} shift - Bit shift distance
 * @param {bigint} mask - Bit mask selecting the swap group
 * @returns {bigint} Transformed 64-bit value
 */ function swapAndMask(val, shift, mask) {
    val &= MASK_64;
    const changes = (val >> BigInt(shift) & MASK_64 ^ val) & mask;
    const sum = changes + (changes << BigInt(shift) & MASK_64) & MASK_64;
    return (val ^ sum) & MASK_64;
}
/**
 * Inverse of interlaceLong: de-interleaves the packed Morton code back into
 * tileX (lower 32 bits) and tileY (upper 32 bits).
 *
 * The swap-and-mask shifts ascend 1 -> 16 (the reverse order of interlace).
 *
 * @param {bigint} morton - Morton code
 * @returns {bigint} Packed value where tileY occupies the upper 32 bits
 */ function uninterlace(morton) {
    // shifts ASCEND 1->16 (reverse of interlace)
    let v = BigInt(morton) & MASK_64;
    v = swapAndMask(v, 1, 0x2222222222222222n);
    v = swapAndMask(v, 2, 0x0c0c0c0c0c0c0c0cn);
    v = swapAndMask(v, 4, 0x00f000f000f000f0n);
    v = swapAndMask(v, 8, 0x0000ff000000ff00n);
    v = swapAndMask(v, 16, 0x00000000ffff0000n);
    return v;
}
/**
 * Maximum tile index along one axis at a given level: 2^level - 1.
 *
 * @param {number} level - Morton level
 * @returns {number} Largest valid tile index
 */ function mortonMax(level) {
    return Number(2n ** BigInt(level) - 1n);
}
/**
 * Validate and normalize a TomTom Morton tile level.
 *
 * @param {number} level - Morton level
 * @returns {number} Normalized integer level
 * @throws {Error} If `level` is outside the supported library range
 */ function assertMortonLevel(level) {
    if (!Number.isInteger(level) || level < 0 || level > 31) throw new Error(`Morton level out of range (0-31): ${level}`);
    return level;
}
function maxMortonValueExclusive(level) {
    return 1n << 2n * BigInt(level);
}
function mortonBase4FromValue(morton, level) {
    // Level 0 is the single world tile; its quadkey is the empty string. Without
    // this, padStart(0) leaves "0" (length 1), which mortonBoundsFromBase4 would
    // misread as a level-1 tile and decode to the wrong (origin-corner) box.
    if (level === 0) return "";
    return morton.toString(4).padStart(level, "0");
}
function mortonHexWidth(level) {
    return Math.max(1, Math.ceil(level / 2));
}
function parseMortonCode(code) {
    if (typeof code !== "string") throw new Error(`Invalid Morton tile code: "${code}"`);
    const normalized = code.trim();
    const match = normalized.match(MORTON_CODE_PATTERN);
    if (!match) throw new Error(`Invalid Morton tile code: "${code}"`);
    const level = assertMortonLevel(Number(match[1]));
    const morton = BigInt(`0x${match[2]}`);
    if (morton >= maxMortonValueExclusive(level)) throw new Error(`Morton code out of range for level ${level}: ${match[2]}`);
    return {
        level,
        morton
    };
}
function looksLikeMortonCode(token) {
    return typeof token === "string" && MORTON_CODE_PATTERN.test(token.trim());
}
function isMortonCode(token) {
    try {
        parseMortonCode(token);
        return true;
    } catch  {
        return false;
    }
}
function mortonCodeFromCoordinate(lon, lat, level) {
    level = assertMortonLevel(level);
    const morton = mortonTileFromCoordinate(lon, lat, level);
    return `M${level}:${morton.toString(16).padStart(mortonHexWidth(level), "0")}`;
}
/**
 * Convert a canonical Morton tile code to the equivalent base-4 quadkey.
 *
 * @param {string} code - Morton tile code in `M<level>:<hex>` format
 * @returns {string} Base-4 quadkey, left-zero-padded to `level` characters
 */ function mortonBase4FromCode(code) {
    const { level, morton } = parseMortonCode(code);
    return mortonBase4FromValue(morton, level);
}
/**
 * Decode a base-4 Morton quadkey to its geographic bounds (EPSG:4326).
 *
 * Bounds use excludeBorder=true so adjacent tiles do not overlap: the max
 * edges are pulled in by one map unit, except at the +180/+90 world edge
 * where they snap to exactly 180 / 90.
 *
 * @param {string} base4 - Base-4 quadkey ("" means level 0, the whole world)
 * @returns {{minLon: number, minLat: number, maxLon: number, maxLat: number}}
 *   Tile bounds in degrees
 * @throws {Error} If `base4` is not a base-4 string or its level exceeds 31
 */ function mortonBoundsFromBase4(base4) {
    if (!/^[0-3]*$/.test(base4)) throw new Error(`Invalid Morton base-4 quadkey: "${base4}"`);
    const level = assertMortonLevel(base4.length); // "" => level 0
    // base4 string -> morton BigInt
    const morton = base4.split("").reduce((a, c)=>a * 4n + BigInt(c), 0n);
    const v = uninterlace(morton);
    const tileX = Number(v & 0xffffffffn);
    const tileY = Number(v >> 32n);
    const max = mortonMax(level);
    const minLon = Math.ceil(tileX * MORTON_LEVEL_DIVISORS[level] - HALF_CIRCLE_UNITS_MD) / SCALE;
    const minLat = Math.ceil(tileY * MORTON_LEVEL_DIVISORS[level + 1] - QUARTER_CIRCLE_UNITS_MD) / SCALE;
    const maxLon = tileX === max ? 180 : Math.ceil((tileX + 1) * MORTON_LEVEL_DIVISORS[level] - HALF_CIRCLE_UNITS_MD - 1) / SCALE;
    const maxLat = tileY === max ? 90 : Math.ceil((tileY + 1) * MORTON_LEVEL_DIVISORS[level + 1] - QUARTER_CIRCLE_UNITS_MD - 1) / SCALE;
    return {
        minLon,
        minLat,
        maxLon,
        maxLat
    };
}
function mortonBoundsFromCode(code) {
    return mortonBoundsFromBase4(mortonBase4FromCode(code));
}
/**
 * Decode a base-4 Morton quadkey to a closed lon/lat ring suitable for a polygon.
 *
 * @param {string} base4 - Base-4 quadkey
 * @returns {number[][]} Closed ring:
 *   [[minLon,minLat],[maxLon,minLat],[maxLon,maxLat],[minLon,maxLat],[minLon,minLat]]
 */ function mortonRingFromBase4(base4) {
    const { minLon, minLat, maxLon, maxLat } = mortonBoundsFromBase4(base4);
    return [
        [
            minLon,
            minLat
        ],
        [
            maxLon,
            minLat
        ],
        [
            maxLon,
            maxLat
        ],
        [
            minLon,
            maxLat
        ],
        [
            minLon,
            minLat
        ]
    ];
}
function mortonRingFromCode(code) {
    return mortonRingFromBase4(mortonBase4FromCode(code));
}
function mortonWktFromCode(code) {
    const ring = mortonRingFromCode(code).map(([lon, lat])=>`${lon} ${lat}`).join(", ");
    return `POLYGON ((${ring}))`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"e6A2s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultStyleNormal", ()=>getDefaultStyleNormal);
parcelHelpers.export(exports, "getDefaultStyleClick", ()=>getDefaultStyleClick);
parcelHelpers.export(exports, "getDefaultStyleHover", ()=>getDefaultStyleHover);
parcelHelpers.export(exports, "getDefaultColorStyle", ()=>getDefaultColorStyle);
var _style = require("ol/style");
function getDefaultStyleNormal(feature) {
    return getDefaultColorStyle(feature);
}
function getDefaultStyleClick(feature) {
    return getDefaultColorStyle(feature, true, false);
}
function getDefaultStyleHover(feature) {
    return getDefaultColorStyle(feature, false, true);
}
function getDefaultColorStyle(feature, click, hover) {
    let color, width, backgroundColor, backgroundWidth;
    color = "grey";
    backgroundColor = "white";
    width = 2;
    backgroundWidth = 4;
    if (hover || click) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: backgroundColor,
                width: backgroundWidth
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width
            })
        })
    ];
    return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width
            })
        })
    ];
}

},{"ol/style":[["Stroke","cese4","default"],["Style","gqpPW","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8WCJV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCrosslinkStyleNormal", ()=>getCrosslinkStyleNormal);
parcelHelpers.export(exports, "getCrosslinkStyleClick", ()=>getCrosslinkStyleClick);
parcelHelpers.export(exports, "getCrosslinkStyleHover", ()=>getCrosslinkStyleHover);
parcelHelpers.export(exports, "getCrosslinkStyleSDSelected", ()=>getCrosslinkStyleSDSelected);
parcelHelpers.export(exports, "getCrosslinkStyleSDDeselected", ()=>getCrosslinkStyleSDDeselected);
parcelHelpers.export(exports, "getCrosslinkStyleHDSelected", ()=>getCrosslinkStyleHDSelected);
parcelHelpers.export(exports, "getCrosslinkStyleHDDeselected", ()=>getCrosslinkStyleHDDeselected);
parcelHelpers.export(exports, "isSD", ()=>isSD);
var _style = require("ol/style");
// Lighter resting colours for the sub-sections of a way NOT covered by any
// crosslink relation. CrosslinkCoverageHandler precomputes those sub-sections
// as `crosslinkUncoveredGeoms`; we overlay them on top of the normal colour.
const SD_UNCOVERED_COLOR = "#90ee90"; // lightgreen
const HD_UNCOVERED_COLOR = "#add8e6"; // lightblue
// This way's section that pairs with a crosslink relation whose role overshoots
// the PARTNER member's length (road overshoots → lane segment red, and vice
// versa). A data error, drawn on top in red (CrosslinkCoverageHandler
// precomputes the segments as `crosslinkOutOfBoundsGeoms`).
const OUT_OF_BOUNDS_COLOR = "red";
const LINE_WIDTH = 3;
function getCrosslinkStyleNormal(feature) {
    return getCrosslinkColorStyle(feature);
}
function getCrosslinkStyleClick(feature) {
    return getCrosslinkColorStyle(feature, true, false);
}
function getCrosslinkStyleHover(feature) {
    return getCrosslinkColorStyle(feature, false, true);
}
function getCrosslinkStyleSDSelected() {
    return getCrosslinkStyleSD(true);
}
function getCrosslinkStyleSDDeselected(click, hover) {
    return getCrosslinkStyleSD(false, click, hover);
}
function getCrosslinkStyleHDSelected() {
    return getCrosslinkStyleHD(true);
}
function getCrosslinkStyleHDDeselected() {
    return getCrosslinkStyleHD(false);
}
function isSD(feature) {
    return feature.getId().startsWith("6:");
}
function isHDLaneLine(feature) {
    const hdMapKeys = feature.getKeys().filter((key)=>key.endsWith("-hdmap"));
    if (hdMapKeys.length === 0) return false;
    return [
        "lane_center_line",
        "lane_trajectory_line"
    ].includes(feature.get(hdMapKeys[0]));
}
function getCrosslinkColorStyle(feature, click, hover) {
    const crosslinkType = feature.get("type");
    if (crosslinkType === "ORBIS_RELATION") return [];
    const sd = isSD(feature);
    if (!sd && !isHDLaneLine(feature)) return [];
    const styles = sd ? getCrosslinkStyleSD(false, click, hover) : getCrosslinkStyleHD(false);
    // In the resting state (not hovering/clicking), shade the sub-sections that
    // no crosslink relation covers in a lighter colour, drawn over the base line.
    if (!click && !hover) {
        const uncoveredGeoms = feature.get("crosslinkUncoveredGeoms");
        if (uncoveredGeoms) {
            const lighter = sd ? SD_UNCOVERED_COLOR : HD_UNCOVERED_COLOR;
            uncoveredGeoms.forEach((geometry)=>{
                styles.push(new (0, _style.Style)({
                    geometry: geometry,
                    stroke: new (0, _style.Stroke)({
                        color: lighter,
                        width: LINE_WIDTH
                    }),
                    zIndex: 2
                }));
            });
        }
    }
    // Partner-overshoot segment in red — always shown (even on hover/click) so
    // the data error stays visible, and on top of everything.
    const outOfBoundsGeoms = feature.get("crosslinkOutOfBoundsGeoms");
    if (outOfBoundsGeoms) outOfBoundsGeoms.forEach((geometry)=>{
        styles.push(new (0, _style.Style)({
            geometry: geometry,
            stroke: new (0, _style.Stroke)({
                color: OUT_OF_BOUNDS_COLOR,
                width: LINE_WIDTH + 1
            }),
            zIndex: 12
        }));
    });
    return styles;
}
function getCrosslinkStyleSD(selected, click, hover) {
    let color = "green";
    let zIndex = 1;
    if (selected) {
        color = "green";
        zIndex = 10;
    } else if (click) color = "orange";
    else if (hover) color = "green";
    return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: LINE_WIDTH
            }),
            zIndex: zIndex
        })
    ];
}
function getCrosslinkStyleHD(selected) {
    let color = "blue";
    let zIndex = 1;
    if (selected) {
        color = "red";
        zIndex = 10;
    }
    return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: LINE_WIDTH
            }),
            zIndex: zIndex
        })
    ];
}

},{"ol/style":[["Stroke","cese4","default"],["Style","gqpPW","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jYIV7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCrosslinkInteractions", ()=>getCrosslinkInteractions);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _crosslink = require("../style/crosslink");
var _crosslinkRelations = require("../crosslinkRelations");
function getCrosslinkInteractions(layer, control) {
    const clickSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.click),
        style: function(feature) {
            return (0, _crosslink.getCrosslinkStyleClick)(feature);
        }
    });
    clickSelect.on("select", function(e) {
        const clickedFeatures = e.target.getFeatures().getArray();
        const position = e.mapBrowserEvent && e.mapBrowserEvent.coordinate;
        if (clickedFeatures.length === 0 || position === undefined) {
            control.set("selectedFeatures", undefined);
            return;
        }
        // Show the crosslink relation(s) under the cursor — not the clicked line's
        // own tags — since that's what's useful for analyzing the SD↔HD match.
        const allFeatures = layer.getSource().getFeatures();
        const relations = [
            ...new Set(clickedFeatures.flatMap((feature)=>(0, _crosslinkRelations.findCrosslinkRelationsAt)(feature, allFeatures, (0, _crosslinkRelations.distanceAlongFeatureCm)(feature, position))))
        ];
        control.set("selectedFeatures", relations.length > 0 ? relations : undefined);
    });
    clickSelect.on("select", function(e) {
        const allFeatures = layer.getSource().getFeatures();
        e.deselected.flatMap((selectedFeature)=>findSDFeatures(selectedFeature, allFeatures)).forEach((sdFeature)=>{
            sdFeature.setStyle((0, _crosslink.getCrosslinkStyleSDDeselected)());
        });
        e.selected.flatMap((selectedFeature)=>findSDFeatures(selectedFeature, allFeatures)).forEach((sdFeature)=>{
            sdFeature.setStyle((0, _crosslink.getCrosslinkStyleSDSelected)());
        });
    });
    return [
        clickSelect,
        new (0, _selectDefault.default)({
            layers: [
                layer
            ],
            condition: (0, _condition.pointerMove),
            style: function(feature) {
                return (0, _crosslink.getCrosslinkStyleHover)(feature);
            }
        })
    ];
}
function findSDFeatures(selectedFeature, features) {
    return features.filter((feature)=>feature.getId() === selectedFeature.get("relation-member-1-id"));
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/crosslink":"8WCJV","../crosslinkRelations":"gH9IJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gH9IJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Distance (cm, on the GK plane) of a map position projected onto a feature's
// line geometry — the linear-reference offset of the cursor along the feature.
parcelHelpers.export(exports, "distanceAlongFeatureCm", ()=>distanceAlongFeatureCm);
// Crosslink relation features in `allFeatures` that reference `feature` and
// are active at `distanceAtFeatureCm` along it — i.e. the relations under the
// cursor.
parcelHelpers.export(exports, "findCrosslinkRelationsAt", ()=>findCrosslinkRelationsAt);
var _helpers = require("@turf/helpers");
var _nearestPointOnLine = require("@turf/nearest-point-on-line");
var _nearestPointOnLineDefault = parcelHelpers.interopDefault(_nearestPointOnLine);
var _orbisLrSdk = require("@orbis-lr-sdk/orbis-lr-sdk");
var _util = require("../util");
function distanceAlongFeatureCm(feature, position) {
    const latLonGeometry = (0, _util.toLatLon)((0, _helpers.lineString)(feature.getGeometry().getCoordinates()).geometry);
    const closestPointLatLon = (0, _nearestPointOnLineDefault.default)(latLonGeometry, (0, _util.toLatLon)((0, _helpers.point)(position).geometry));
    return (0, _util.distanceAlongCm)(latLonGeometry, closestPointLatLon);
}
function findCrosslinkRelationsAt(feature, allFeatures, distanceAtFeatureCm) {
    const featureId = feature.getId();
    return allFeatures.filter((relation)=>{
        const memberIdKeys = memberIdKeysOf(relation);
        if (memberIdKeys.length === 0) return false;
        return memberIdKeys.filter((memberIdKey)=>relation.get(memberIdKey) === featureId).map((memberIdKey)=>relation.get(memberIdKey.replace("-id", "-role"))).some((role)=>roleInvolvedAt(role, distanceAtFeatureCm));
    });
}
// Whether a relation member's role covers `distanceCm` along the member. A
// plain role (no `=`, no LR) means the member is involved along its whole
// geometry — e.g. a lane fully covered by the crosslink has role "lane" — so it
// matches at any distance. An LR-ed role matches only where its value is
// defined.
function roleInvolvedAt(role, distanceCm) {
    if (typeof role !== "string") return false;
    if (!role.includes("=")) return true;
    const [tagKey, tagValue] = role.split("=", 2);
    return roleValueAt(tagKey, tagValue, distanceCm) !== undefined;
}
// ValueAtProducer.getValueAt throws on step chains when queried before the
// first breakpoint (e.g. distance 0) — it can't build a segment there. Treat a
// throw as "no value at this distance" so a cursor at the start of a line, or
// any unparseable role, doesn't crash the hover/click handlers.
function roleValueAt(tagKey, tagValue, distanceCm) {
    try {
        return (0, _orbisLrSdk.ValueAtProducer).getValueAt(tagKey, tagValue, distanceCm, (0, _orbisLrSdk.InterpolationSpecType).ROLE);
    } catch  {
        return undefined;
    }
}
function memberIdKeysOf(relation) {
    return relation.getKeys().filter((key)=>key.startsWith("relation-member-") && key.endsWith("-id"));
}

},{"@turf/helpers":"ityOQ","@turf/nearest-point-on-line":"bwWlY","@orbis-lr-sdk/orbis-lr-sdk":"04bfk","../util":"4IC9E","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hMgEt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHDMapInteractions", ()=>getHDMapInteractions);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _hdmap = require("../style/hdmap");
function getHDMapInteractions(layer, control) {
    const clickSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.click),
        style: function(feature, resolution) {
            return (0, _hdmap.getHDMapStyleClick)(feature, resolution);
        }
    });
    clickSelect.on("select", function(e) {
        if (e.target.getFeatures().getLength() > 0) control.set("selectedFeatures", Array.from(e.target.getFeatures().getArray())); // create new array so that the event gets triggered
        else control.set("selectedFeatures", undefined);
    });
    return [
        clickSelect,
        new (0, _selectDefault.default)({
            layers: [
                layer
            ],
            condition: (0, _condition.pointerMove),
            style: function(feature, resolution) {
                return (0, _hdmap.getHDMapStyleHover)(feature, resolution);
            }
        })
    ];
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/hdmap":"B4rqX","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ghYyc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VectorFeatureControl", ()=>VectorFeatureControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
var _wktJs = require("ol/format/WKT.js");
var _wktJsDefault = parcelHelpers.interopDefault(_wktJs);
var _util = require("../util");
class VectorFeatureControl extends (0, _controlDefault.default) {
    constructor(opt_options){
        const options = opt_options || {};
        const div = document.createElement("div");
        div.className = "vector-feature-layer-row";
        const wkt = new (0, _wktJsDefault.default)();
        super({
            element: div,
            target: options.target
        });
        const this_ = this;
        const random = Math.floor(Math.random() * 10000);
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.className = "vector-feature-checkbox";
        checkbox.id = "vector-feature-input-" + random;
        checkbox.checked = false;
        checkbox.addEventListener("change", function() {
            this_.set("vectorToggle", checkbox.checked);
        });
        this._checkbox = checkbox;
        const label = document.createElement("label");
        label.htmlFor = checkbox.id;
        label.className = "vector-feature-text";
        label.innerText = options.layer_name;
        const statusIndicator = document.createElement("span");
        statusIndicator.className = "vector-feature-status";
        // Optional view dropdown: rows whose flavours share one WFS (`options.views`,
        // [{ id, label }]) switch style through `view` instead of being separate rows.
        let viewSelect = null;
        if (options.views) {
            viewSelect = document.createElement("select");
            viewSelect.className = "vector-feature-view-select";
            viewSelect.title = "View";
            options.views.forEach(({ id, label })=>{
                viewSelect.appendChild(new Option(label, id));
            });
            viewSelect.addEventListener("change", function() {
                this_.set("view", viewSelect.value);
            });
        }
        const errorMessage = document.createElement("div");
        errorMessage.className = "vector-feature-error-message";
        const attributes = document.createElement("table");
        attributes.className = "ol-selectable vector-feature-attributes-list";
        // Header line: checkbox + label (+ revision icon appended by RevisionControl)
        const header = document.createElement("div");
        header.className = "vector-feature-header";
        div.appendChild(header);
        header.appendChild(checkbox);
        header.appendChild(label);
        header.appendChild(statusIndicator);
        if (viewSelect) header.appendChild(viewSelect);
        div.appendChild(errorMessage);
        div.append(attributes);
        // Expose so RevisionControl can append its icon into the header
        // and its panel between the header and the attributes table.
        this.headerEl = header;
        this.bodyEl = div;
        this.on("propertychange", ()=>{
            // roles
            if (this_.get("enabled") == false) {
                div.style.display = "none";
                checkbox.checked = false;
            } else div.style.display = "block";
            // loading / error status
            if (this_.get("loading") === true) {
                statusIndicator.className = "vector-feature-status vector-feature-status--loading";
                statusIndicator.title = "Loading\u2026";
                errorMessage.textContent = "";
                errorMessage.style.display = "none";
            } else if (this_.get("loadError") === true) {
                statusIndicator.className = "vector-feature-status vector-feature-status--error";
                statusIndicator.title = "Loading failed";
                const reason = this_.get("loadErrorReason");
                errorMessage.textContent = reason ? `Failed to load: ${reason}` : "Failed to load";
                errorMessage.style.display = "block";
            } else {
                statusIndicator.className = "vector-feature-status";
                statusIndicator.title = "";
                errorMessage.textContent = "";
                errorMessage.style.display = "none";
            }
            // attributes
            if (this_.get("vectorToggle") == false) // unset selected feature if disabled
            this_.set("selectedFeatures", undefined);
            attributes.innerHTML = "";
            const colGroup = document.createElement("colgroup");
            const colLabel = document.createElement("col");
            colLabel.classList.add("label");
            const colValue = document.createElement("col");
            colValue.classList.add("value");
            colGroup.appendChild(colLabel);
            colGroup.appendChild(colValue);
            attributes.appendChild(colGroup);
            const selectedFeatures = this_.get("selectedFeatures");
            if (selectedFeatures !== undefined) {
                attributes.style = "display: table;";
                Array.from(selectedFeatures).sort((f1, f2)=>{
                    if (f2.get(options.sort_field)) return f2.get(options.sort_field).localeCompare(f1.get(options.sort_field));
                }).forEach((feature)=>{
                    if (options.header_field) attributes.append((0, _util.rowHeader)(feature.get(options.header_field)));
                    else attributes.append((0, _util.rowHeader)(feature.getId()));
                    if (feature.get("geometry")) {
                        const wktInput = document.createElement("input");
                        wktInput.disabled = true;
                        wktInput.value = wkt.writeGeometry(feature.get("geometry"), {
                            dataProjection: "EPSG:4326",
                            featureProjection: "EPSG:3857"
                        });
                        attributes.append((0, _util.row)("wkt", wktInput));
                    }
                    feature.getKeys().forEach((key)=>{
                        const value = feature.get(key);
                        if (key === "geometry") return;
                        if (typeof value === "object") {
                            const subAttributes = document.createElement("table");
                            subAttributes.className = "ol-selectable vector-feature-subattributes-list";
                            for (const [subKey, subValue] of Object.entries(value))subAttributes.append((0, _util.row)(subKey, subValue));
                            attributes.append((0, _util.row)(key, subAttributes));
                        } else attributes.append((0, _util.row)(key, value));
                    });
                });
            } else attributes.style = "display: block;";
            // sync checkbox with vectorToggle property
            checkbox.checked = !!this_.get("vectorToggle");
            const view = this_.get("view");
            if (viewSelect && view && viewSelect.value !== view) viewSelect.value = view;
            // active
            if (this_.get("active")) {
                div.classList.add("layer-active");
                div.classList.remove("layer-inactive");
            } else {
                div.classList.remove("layer-active");
                div.classList.add("layer-inactive");
            }
        });
    }
    setToggle(value) {
        this.set("vectorToggle", value);
    }
}

},{"ol/control/Control":"8KSMn","ol/format/WKT.js":"34shs","../util":"4IC9E","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bZM8z":[function(require,module,exports,__globalThis) {
// Pure helpers for LR *step* tags — values like "0-1000#yes;5000-7000#no",
// where each `startCm-endCm#value` section applies to one stretch of the
// feature's own geometry. No OpenLayers / orbis-lr-sdk imports so this is
// unit-testable with `node --test`; the decoding + geometry slicing adapter
// lives next door in `stepSections.js`.
//
// A step tag differs from a `:linear` one in that the value does NOT
// interpolate between offsets — it holds constant over each section and is
// simply absent outside them. "Absent" is meaningful (no restriction there),
// so a gap must render as the unrestricted style, not as the previous value.
// First section of a step chain: "<start>-<end>#" with an optionally omitted
// end ("1000-#no" = from 1000cm to the end of the geometry).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Does this tag value carry per-section offsets, as opposed to a plain scalar
 * ("yes") that applies to the whole feature?
 * @param {unknown} value
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isStepEncodedValue", ()=>isStepEncodedValue);
/**
 * Like isStepEncodedValue, but also accepts the bare-offset form above.
 *
 * Kept separate because that form is **ambiguous on value shape alone**:
 * `1234#yes` is equally the encoding of a `:spot` tag (at 1234cm) and of a
 * `:linear` chain's first point, and gss-wfs strips the `:step` / `:spot`
 * suffix when it decodes, so the key can't disambiguate either. Use this only
 * where the caller knows its tags are step-encoded enumerations — the two
 * lane-restriction styles, whose tags are yes/no. `isStepEncodedValue` stays
 * the conservative test for anything that runs across every layer's tags.
 * @param {unknown} value
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isOffsetSectionedValue", ()=>isOffsetSectionedValue);
/**
 * Close every bare-offset section ("500#3", decoded with no end) at the start of
 * the element after it — what the SDK's getEndDistanceOfOffset does. Left open,
 * each offset would run to the end of the line, so in "0#2;500#3" the first
 * section would cover everything and win on every lookup. A trailing offset stays
 * open: it does run to the end. Explicit ranges are untouched.
 * @param {{startCm: number, endCm: number|null|undefined, value: string}[]} sections
 *   in chain order
 */ parcelHelpers.export(exports, "closeOffsetSections", ()=>closeOffsetSections);
/**
 * Clamp decoded sections onto a geometry of `lengthCm`, dropping the empty
 * ones. An `endCm` of null/undefined/Infinity means "to the end of the
 * geometry" — the LR spec allows the end to be omitted.
 * @param {{startCm: number, endCm: number|null|undefined, value: string}[]} sections
 * @param {number} lengthCm
 */ parcelHelpers.export(exports, "clampSections", ()=>clampSections);
/**
 * The value covering `cm`, or undefined where no section covers it. Sections
 * are half-open [startCm, endCm) so touching sections don't both claim their
 * shared breakpoint.
 * @param {{startCm: number, endCm: number, value: string}[]} sections
 * @param {number} cm
 */ parcelHelpers.export(exports, "valueAtCm", ()=>valueAtCm);
/**
 * Cut [0, lengthCm] at every section boundary of every tag, then resolve each
 * resulting interval to one value per tag. The result is the smallest set of
 * stretches over which *all* the given tags are constant — i.e. exactly the
 * stretches that can be drawn as a single uniformly-styled piece of line.
 *
 * @param {Record<string, {startCm: number, endCm: number|null, value: string}[]>} sectionsByTag
 *   Decoded sections per tag name. Tags that aren't step-encoded are simply
 *   left out by the caller and stay whole-feature values.
 * @param {number} lengthCm
 * @returns {{startCm: number, endCm: number, values: Record<string, string|undefined>}[]}
 */ parcelHelpers.export(exports, "resolveSections", ()=>resolveSections);
/**
 * Collapse neighbouring intervals whose styling key is identical, so a tag
 * that changes without changing the rendered colour doesn't fragment the line.
 * @template {{startCm: number, endCm: number}} T
 * @param {T[]} intervals
 * @param {(interval: T) => string} keyOf
 * @returns {(T & {key: string})[]}
 */ parcelHelpers.export(exports, "mergeAdjacent", ()=>mergeAdjacent);
const STEP_CHAIN_START = /^\d+-\d*#/;
// A single open-ended section can also be written with no range at all —
// "27432#yes" means "from 274.32m to the end of the line". Real HDLR data does
// this: layer 88259 pairs `psv:step=0-27432#yes` with `bus:step=27432#yes`.
const OFFSET_CHAIN_START = /^\d+[-#]/;
function isStepEncodedValue(value) {
    return typeof value === "string" && STEP_CHAIN_START.test(value);
}
function isOffsetSectionedValue(value) {
    return typeof value === "string" && OFFSET_CHAIN_START.test(value);
}
function closeOffsetSections(sections) {
    return sections.map((section, i)=>{
        const next = sections[i + 1];
        const open = section.endCm === null || section.endCm === undefined;
        return open && next && next.startCm > section.startCm ? {
            ...section,
            endCm: next.startCm
        } : section;
    });
}
function clampSections(sections, lengthCm) {
    if (!(lengthCm > 0)) return [];
    return sections.map((section)=>({
            startCm: Math.max(0, Math.min(section.startCm, lengthCm)),
            endCm: section.endCm === null || section.endCm === undefined || !Number.isFinite(section.endCm) ? lengthCm : Math.max(0, Math.min(section.endCm, lengthCm)),
            value: section.value
        })).filter((section)=>section.endCm > section.startCm);
}
function valueAtCm(sections, cm) {
    const hit = sections.find((section)=>cm >= section.startCm && cm < section.endCm);
    return hit === undefined ? undefined : hit.value;
}
// Sub-centimetre slivers are invisible and would only multiply the styles OL
// has to render, so intervals shorter than this are dropped.
const MIN_SECTION_CM = 1;
function resolveSections(sectionsByTag, lengthCm) {
    const names = Object.keys(sectionsByTag);
    if (names.length === 0 || !(lengthCm > 0)) return [];
    const clamped = {};
    const breakpoints = new Set([
        0,
        lengthCm
    ]);
    names.forEach((name)=>{
        clamped[name] = clampSections(sectionsByTag[name], lengthCm);
        clamped[name].forEach((section)=>{
            breakpoints.add(section.startCm);
            breakpoints.add(section.endCm);
        });
    });
    const ordered = Array.from(breakpoints).sort((a, b)=>a - b);
    const intervals = [];
    for(let i = 1; i < ordered.length; i++){
        const startCm = ordered[i - 1];
        const endCm = ordered[i];
        if (endCm - startCm < MIN_SECTION_CM) continue;
        // Sample at the midpoint: it is inside the interval whatever the
        // half-open/closed convention at the shared breakpoints.
        const midCm = (startCm + endCm) / 2;
        const values = {};
        names.forEach((name)=>{
            values[name] = valueAtCm(clamped[name], midCm);
        });
        intervals.push({
            startCm,
            endCm,
            values
        });
    }
    return intervals;
}
function mergeAdjacent(intervals, keyOf) {
    const merged = [];
    intervals.forEach((interval)=>{
        const key = keyOf(interval);
        const previous = merged[merged.length - 1];
        if (previous && previous.key === key) {
            previous.endCm = interval.endCm;
            return;
        }
        merged.push({
            ...interval,
            key
        });
    });
    return merged;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jE3Kv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * If `addFeatureHandlers` includes curvatureLinearHandler, injects a small
 * toggle button into the layer row's header letting the user disable the
 * client-side curvature line reconstruction without hiding the underlying
 * layer.
 *
 * Returns the (possibly wrapped) handlers array to pass to the layer/source
 * factory, and a `bindLayer(layer)` callback that must be called once the
 * layer exists — disabling removes already-reconstructed features from the
 * source, re-enabling re-runs the reconstruction over currently loaded ones.
 */ parcelHelpers.export(exports, "withCurvatureReconstructionToggle", ()=>withCurvatureReconstructionToggle);
var _curvatureLinearHandler = require("./CurvatureLinearHandler");
function withCurvatureReconstructionToggle(addFeatureHandlers, headerEl) {
    if (!addFeatureHandlers.includes((0, _curvatureLinearHandler.curvatureLinearHandler))) return {
        addFeatureHandlers,
        bindLayer: ()=>{}
    };
    const toggleBtn = document.createElement("button");
    toggleBtn.type = "button";
    toggleBtn.className = "curvature-reconstruction-toggle-btn";
    toggleBtn.textContent = "\u223F";
    headerEl.appendChild(toggleBtn);
    let enabled = false;
    const updateTitle = ()=>{
        toggleBtn.title = enabled ? "Curvature line reconstruction is on \u2014 click to disable" : "Curvature line reconstruction is off \u2014 click to enable";
    };
    updateTitle();
    const wrappedHandlers = addFeatureHandlers.map((handler)=>handler === (0, _curvatureLinearHandler.curvatureLinearHandler) ? (event)=>{
            if (enabled) handler(event);
        } : handler);
    const bindLayer = (layer)=>{
        toggleBtn.addEventListener("click", ()=>{
            enabled = !enabled;
            toggleBtn.classList.toggle("curvature-reconstruction-toggle-btn--on", enabled);
            updateTitle();
            const vectorSource = layer.getSource();
            if (enabled) (0, _curvatureLinearHandler.curvatureLinearHandler)({
                target: vectorSource
            });
            else vectorSource.getFeatures().filter((feature)=>feature.get("type") === (0, _curvatureLinearHandler.CURVATURE_LINEAR_RECONSTRUCTED_TYPE)).forEach((feature)=>vectorSource.removeFeature(feature));
        });
    };
    return {
        addFeatureHandlers: wrappedHandlers,
        bindLayer
    };
}

},{"./CurvatureLinearHandler":"1rcYN","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"kFPww":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addFGBLayerAndControl", ()=>addFGBLayerAndControl);
parcelHelpers.export(exports, "getPreviousMonthsUrls", ()=>getPreviousMonthsUrls);
parcelHelpers.export(exports, "enableIfAccessible", ()=>enableIfAccessible);
parcelHelpers.export(exports, "customizeFeatureId", ()=>customizeFeatureId);
parcelHelpers.export(exports, "concatenateFeatureFields", ()=>concatenateFeatureFields);
var _vectorFeatureControl = require("../controls/VectorFeatureControl");
var _fgblayer = require("../layers/FGBLayer");
var _hoverLayer = require("../layers/HoverLayer");
var _curvatureReconstructionToggle = require("../layers/addfeaturehandlers/curvatureReconstructionToggle");
var _urlstateManager = require("../state/URLStateManager");
var _layerSlugMjs = require("./layerSlug.mjs");
function addFGBLayerAndControl({ layerName, slug, target, map, getInteractions, sortField, urls, style, featureInfoControl, transformFeature, minZoom = 17, settingConfigurationFn = function() {}, hoverStyleFunctions, addFeatureHandlers = [] }) {
    // `slug` is the layer's URL identity and is deliberately NOT derived from
    // layerName — see config/layerSlug.mjs for why.
    (0, _layerSlugMjs.assertSlug)(slug, layerName);
    const control = new (0, _vectorFeatureControl.VectorFeatureControl)({
        layer_name: layerName,
        target: target,
        sort_field: sortField,
        header_field: sortField
    });
    // Restore layer visibility from URL. Re-applies when `enabled` becomes true,
    // because `enableIfAccessible` may reset the checkbox before confirming access.
    const shouldRestoreToggle = (0, _urlstateManager.getLayersFromURL)().includes(slug);
    if (shouldRestoreToggle) control.setToggle(true);
    (0, _urlstateManager.registerLayerControl)(slug, control);
    const { addFeatureHandlers: resolvedAddFeatureHandlers, bindLayer } = (0, _curvatureReconstructionToggle.withCurvatureReconstructionToggle)(addFeatureHandlers, control.headerEl);
    settingConfigurationFn(control, urls);
    const layer = (0, _fgblayer.getFGBLayer)(control, urls, style, transformFeature, minZoom, resolvedAddFeatureHandlers);
    bindLayer(layer);
    map.addControl(control);
    map.addLayer(layer);
    hoverStyleFunctions.forEach((hoverStyleFunction)=>{
        const hoverLayer = (0, _hoverLayer.getHoverLayer)(hoverStyleFunction);
        map.addLayer(hoverLayer);
        featureInfoControl.addHoverLayerForLayer(hoverLayer, layer);
    });
    getInteractions(layer, control).forEach((interaction)=>map.addInteraction(interaction));
    map.on("moveend", function() {
        control.set("zoom", map.getView().getZoom());
    });
}
function getPreviousMonthsUrls(prefix, amountOfMonthsBack) {
    return Array.from({
        length: amountOfMonthsBack
    }, (x, i)=>{
        const today = new Date();
        today.setDate(Math.min(today.getDate(), 28));
        today.setMonth(today.getMonth() - i);
        return (prefix + "YYYY-MM.fgb").replace("YYYY", today.getFullYear()).replace("MM", String(today.getMonth() + 1).padStart(2, "0"));
    });
}
function enableIfAccessible(vectorFeatureControl, urls) {
    // Probe each URL by validating just its header. This doubles as the
    // accessibility check (a 401/403 rejects) and, crucially, avoids driving the
    // flatgeobuf reader into `calcTreeSize`'s synchronous infinite loop on a
    // malformed/empty file — which would freeze the tab here, at startup, before
    // any user interaction. See validateFgbHeader in FGBLayer.js.
    const promises = urls.map((url)=>(0, _fgblayer.validateFgbHeader)(url));
    Promise.any(promises).then(()=>{
        vectorFeatureControl.set("enabled", true);
    }).catch(()=>{
        vectorFeatureControl.set("enabled", false);
    });
}
function customizeFeatureId(featureIdFn) {
    return function(feature) {
        feature.setId(featureIdFn(feature));
        return feature;
    };
}
function concatenateFeatureFields(fields) {
    return function(feature) {
        return fields.map((field)=>feature.get(field)).join("-");
    };
}

},{"../controls/VectorFeatureControl":"ghYyc","../layers/FGBLayer":"5mNyT","../layers/HoverLayer":"3Tely","../layers/addfeaturehandlers/curvatureReconstructionToggle":"jE3Kv","../state/URLStateManager":"7Lluw","./layerSlug.mjs":"86yOw","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5mNyT":[function(require,module,exports,__globalThis) {
// Everything from OpenLayers
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Some parameters used to render the dial and bearing used to show the direction of the sign.
// Global variables used to abort API calls because the user has changed the map.
// let abortController, signal;
/**
 * @param {VectorFeatureControl} vectorFeatureControl
 * @param {string[]} urls
 * @param {function} getStyleNormal
 * @param {function} transformFeature
 * @param {number} minZoom
 * @param {string} dataProjection
 * @returns
 */ parcelHelpers.export(exports, "getFGBLayer", ()=>getFGBLayer);
/**
 * Fetches and validates just the FlatGeobuf header via HTTP Range requests,
 * mirroring the checks the library's `HttpReader.open` performs — plus the one
 * it is missing: a finite, positive `featuresCount`. The library feeds the
 * parsed count straight into `calcTreeSize`, whose `do … while (1 !== l)` loop
 * never terminates for 0/NaN/negative counts, hanging the main thread.
 *
 * Throws a descriptive Error (caught by the loader) instead of freezing.
 *
 * @param {string} url
 */ parcelHelpers.export(exports, "validateFgbHeader", ()=>validateFgbHeader);
var _vector = require("ol/source/Vector");
var _vectorDefault = parcelHelpers.interopDefault(_vector);
var _vector1 = require("ol/layer/Vector");
var _vectorDefault1 = parcelHelpers.interopDefault(_vector1);
var _point = require("ol/geom/Point");
var _pointDefault = parcelHelpers.interopDefault(_point);
var _ol = require("flatgeobuf/lib/mjs/ol");
var _loadingstrategy = require("ol/loadingstrategy");
var _flatbuffers = require("flatbuffers");
var _headerMeta = require("flatgeobuf/lib/mjs/header-meta");
var _constants = require("flatgeobuf/lib/mjs/constants");
function getFGBLayer(vectorFeatureControl, urls, getStyleNormal, transformFeature, minZoom = 17, addFeatureHandlers = [], dataProjection = "EPSG:4326") {
    const vectorSource = new (0, _vectorDefault.default)({
        minZoom: minZoom,
        strategy: (0, _loadingstrategy.bbox),
        loader: function(extent, resolution, projection, success, failure) {
            // Use flatgeobuf JavaScript API to iterate features as geojson.
            // Because we specify a bounding box, flatgeobuf will only fetch the relevant subset of data,
            // rather than the entire file.
            if (extent[0] == -Infinity) return;
            async function populate() {
                const rect = fgbBoundingBox(extent, projection.getCode());
                for (const url of urls)try {
                    // Pre-flight: validate the header before handing the URL to the
                    // flatgeobuf reader. A malformed/truncated/empty file whose header
                    // parses to featuresCount <= 0 (or NaN) makes the library's
                    // synchronous `calcTreeSize` loop forever on the main thread,
                    // freezing the whole tab — no error is thrown and the catch below
                    // never runs. Validating here turns that hang into a normal error.
                    await validateFgbHeader(url);
                    let iter = (0, _ol.deserialize)(url, rect);
                    const features = [];
                    for await (let feature of iter){
                        feature.getGeometry().transform(dataProjection, projection.getCode());
                        feature.setProperties(flattenJsonProperties(feature.getProperties()));
                        features.push(transformFeature(feature));
                    }
                    success(features);
                    vectorSource.addFeatures(features);
                } catch (err) {
                    if (err.message != "Not a FlatGeobuf file") console.error("Unable to fetch data for url " + url, err);
                    vectorFeatureControl.set("loadErrorReason", err.message ?? "Unknown error");
                    failure();
                }
            }
            populate();
        }
    });
    addFeatureHandlers.forEach((handler)=>{
        vectorSource.on("featuresloadend", handler);
    });
    vectorSource.on("featuresloadstart", ()=>{
        vectorFeatureControl.set("loading", true);
        vectorFeatureControl.set("loadError", false);
        vectorFeatureControl.set("loadErrorReason", null);
    });
    vectorSource.on("featuresloadend", ()=>{
        vectorFeatureControl.set("loading", false);
    });
    vectorSource.on("featuresloaderror", ()=>{
        vectorFeatureControl.set("loading", false);
        vectorFeatureControl.set("loadError", true);
    });
    const vectorLayer = new (0, _vectorDefault1.default)({
        source: vectorSource,
        minZoom: minZoom,
        zIndex: 8,
        visible: false,
        style: function(feature) {
            return getStyleNormal(feature);
        }
    });
    vectorFeatureControl.set("enabled", true);
    vectorFeatureControl.on("propertychange", function(e) {
        if (e.key !== "loading" && e.key !== "tooLarge" && e.key !== "loadError") propertyChangeHandler(vectorFeatureControl, vectorLayer);
        if (e.key === "zoom") {
            const zoom = e.target.get("zoom");
            if (zoom >= vectorLayer.getMinZoom() && zoom <= vectorLayer.getMaxZoom()) vectorFeatureControl.set("active", true);
            else vectorFeatureControl.set("active", false);
        }
    });
    return vectorLayer;
}
async function validateFgbHeader(url) {
    const getRange = async (start, length)=>{
        const res = await fetch(url, {
            headers: {
                Range: `bytes=${start}-${start + length - 1}`
            }
        });
        if (!res.ok && res.status !== 206) throw new Error(`HTTP ${res.status} fetching FlatGeobuf header`);
        return new Uint8Array(await res.arrayBuffer());
    };
    // Magic bytes (8) + header length prefix (4).
    const prefix = await getRange(0, 12);
    if (prefix.byteLength < 12) throw new Error("Not a FlatGeobuf file");
    if (!prefix.subarray(0, 3).every((b, i)=>(0, _constants.magicbytes)[i] === b)) throw new Error("Not a FlatGeobuf file");
    const headerLength = new DataView(prefix.buffer, prefix.byteOffset + 8, 4).getUint32(0, true);
    if (headerLength > 0xa00000 || headerLength < 8) throw new Error("Invalid header size");
    const headerBytes = await getRange(12, headerLength);
    if (headerBytes.byteLength < headerLength) throw new Error("Truncated FlatGeobuf header");
    const header = (0, _headerMeta.fromByteBuffer)(new _flatbuffers.ByteBuffer(headerBytes));
    const featuresCount = header.featuresCount;
    if (!Number.isFinite(featuresCount) || featuresCount <= 0) throw new Error(`Invalid FlatGeobuf: featuresCount=${featuresCount} (file empty or corrupt)`);
}
function fgbBoundingBox(extent, projectionCode) {
    const minPoint = new (0, _pointDefault.default)([
        extent[0],
        extent[1]
    ]);
    minPoint.transform(projectionCode, "EPSG:4326");
    const maxPoint = new (0, _pointDefault.default)([
        extent[2],
        extent[3]
    ]);
    maxPoint.transform(projectionCode, "EPSG:4326");
    return {
        minX: minPoint.getCoordinates()[0],
        minY: minPoint.getCoordinates()[1],
        maxX: maxPoint.getCoordinates()[0],
        maxY: maxPoint.getCoordinates()[1]
    };
}
function flattenJsonProperties(properties) {
    const newEntries = Object.entries(properties).map((entry)=>{
        try {
            return [
                entry[0],
                JSON.parse(entry[1])
            ];
        } catch  {
            return entry;
        }
    });
    return Object.fromEntries(newEntries);
}
/**
 * @param {VectorFeatureControl} vectorFeatureControl
 * @param {VectorLayer} vectorLayer
 */ function propertyChangeHandler(vectorFeatureControl, vectorLayer) {
    if (vectorFeatureControl.get("vectorToggle") === true) vectorLayer.setVisible(true);
    else // When vectorToggle is not set, the checkbox is not checked, and so the layer is made invisible.
    vectorLayer.setVisible(false);
}

},{"ol/source/Vector":"7zHxp","ol/layer/Vector":"7ga2c","ol/geom/Point":"95T6m","flatgeobuf/lib/mjs/ol":"ktbhl","ol/loadingstrategy":"6eznf","flatbuffers":"4oKPA","flatgeobuf/lib/mjs/header-meta":"eEB1R","flatgeobuf/lib/mjs/constants":"5WAfl","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ktbhl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serialize", ()=>serialize);
parcelHelpers.export(exports, "deserialize", ()=>deserialize);
parcelHelpers.export(exports, "createLoader", ()=>createLoader);
parcelHelpers.export(exports, "tileUrlFunction", ()=>tileUrlFunction);
parcelHelpers.export(exports, "createTileLoadFunction", ()=>createTileLoadFunction);
var _loadingstrategyJs = require("ol/loadingstrategy.js");
var _projJs = require("ol/proj.js");
var _featurecollectionJs = require("./ol/featurecollection.js");
function serialize(e) {
    return (0, _featurecollectionJs.serialize)(e);
}
function deserialize(e, t, i, n = !1) {
    return e instanceof Uint8Array ? (0, _featurecollectionJs.deserialize)(e, i) : e instanceof ReadableStream ? (0, _featurecollectionJs.deserializeStream)(e, i) : (0, _featurecollectionJs.deserializeFiltered)(e, t, i, n);
}
async function n(r, o, a, i, n) {
    if (n === (0, _loadingstrategyJs.all)) return deserialize((await fetch(r)).body);
    let [s, l, c, f] = o && i.getCode() !== o ? (0, _projJs.transformExtent)(a, i.getCode(), o) : a;
    return deserialize(r, {
        minX: s,
        minY: l,
        maxX: c,
        maxY: f
    });
}
function createLoader(t, r, o = "EPSG:4326", a = (0, _loadingstrategyJs.all), i = !1) {
    return async (e, s, l, c, f)=>{
        try {
            i && t.clear();
            let s = await n(r, o, e, l, a), f = [];
            for await (let e of s)o && l.getCode() !== o && e.getGeometry()?.transform(o, l.getCode()), f.push(e), t.addFeature(e);
            c?.(f);
        } catch (e) {
            f?.();
        }
    };
}
const tileUrlFunction = (e)=>JSON.stringify(e);
function createTileLoadFunction(e, r, o = "EPSG:4326") {
    let a = e.getProjection(), i = a?.getCode() ?? "EPSG:3857";
    return (e)=>{
        let a = async (a)=>{
            let [n, s, l, c] = o && i !== o ? (0, _projJs.transformExtent)(a, i, o) : a, f = deserialize(r, {
                minX: n,
                minY: s,
                maxX: l,
                maxY: c
            }), d = [];
            for await (let e of f)d.push(e);
            for (let e of d)e.getGeometry()?.transform(o, i);
            e.setFeatures(d);
        };
        e.setLoader(a);
    };
}

},{"ol/loadingstrategy.js":"6eznf","ol/proj.js":"gN0IK","./ol/featurecollection.js":"5aYX0","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5aYX0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deserialize", ()=>deserialize);
parcelHelpers.export(exports, "deserializeStream", ()=>deserializeStream);
parcelHelpers.export(exports, "deserializeFiltered", ()=>deserializeFiltered);
parcelHelpers.export(exports, "serialize", ()=>(0, _featurecollectionJs.serialize));
var _featurecollectionJs = require("../generic/featurecollection.js");
var _featureJs = require("./feature.js");
function deserialize(r, i) {
    return (0, _featurecollectionJs.deserialize)(r, (0, _featureJs.fromFeature), i);
}
function deserializeStream(e, r) {
    return (0, _featurecollectionJs.deserializeStream)(e, (0, _featureJs.fromFeature), r);
}
function deserializeFiltered(e, i, t, o = !1) {
    return (0, _featurecollectionJs.deserializeFiltered)(e, i, (0, _featureJs.fromFeature), t, o);
}

},{"../generic/featurecollection.js":"eh4qT","./feature.js":"hoFfE","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"eh4qT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serialize", ()=>serialize);
parcelHelpers.export(exports, "deserialize", ()=>deserialize);
parcelHelpers.export(exports, "deserializeStream", ()=>deserializeStream);
parcelHelpers.export(exports, "deserializeFiltered", ()=>deserializeFiltered);
parcelHelpers.export(exports, "buildHeader", ()=>buildHeader);
parcelHelpers.export(exports, "mapColumn", ()=>mapColumn);
var _flatbuffers = require("flatbuffers");
var _sliceSource = require("slice-source");
var _sliceSourceDefault = parcelHelpers.interopDefault(_sliceSource);
var _headerJs = require("../flat-geobuf/header.js");
var _columnTypeJs = require("../flat-geobuf/column-type.js");
var _columnJs = require("../flat-geobuf/column.js");
var _featureJs = require("../flat-geobuf/feature.js");
var _headerMetaJs = require("../header-meta.js");
var _constantsJs = require("../constants.js");
var _crsJs = require("../flat-geobuf/crs.js");
var _httpReaderJs = require("../http-reader.js");
var _packedrtreeJs = require("../packedrtree.js");
var _featureJs1 = require("./feature.js");
var _geometryJs = require("./geometry.js");
var _headerJs1 = require("./header.js");
function serialize(e) {
    let t = function(e) {
        let t = e[0], r = t.getProperties ? t.getProperties() : {}, n = null;
        return r && (n = Object.keys(r).filter((e)=>"geometry" !== e).map((e)=>mapColumn(r, e))), {
            geometryType: (0, _headerJs1.inferGeometryType)(e),
            columns: n,
            envelope: null,
            featuresCount: e.length,
            indexNodeSize: 0,
            crs: null,
            title: null,
            description: null,
            metadata: null
        };
    }(e), r = buildHeader(t), n = e.map((e)=>{
        if (!e.getGeometry) throw Error("Missing getGeometry implementation");
        if (!e.getProperties) throw Error("Missing getProperties implementation");
        return (0, _featureJs1.buildFeature)((0, _geometryJs.parseGeometry)(e.getGeometry(), t.geometryType), e.getProperties(), t);
    }), o = n.map((e)=>e.length).reduce((e, t)=>e + t), a = new Uint8Array((0, _constantsJs.magicbytes).length + r.length + o);
    a.set(r, (0, _constantsJs.magicbytes).length);
    let i = (0, _constantsJs.magicbytes).length + r.length;
    for (let e of n)a.set(e, i), i += e.length;
    return a.set((0, _constantsJs.magicbytes)), a;
}
function deserialize(t, r, n) {
    if (!t.subarray(0, 3).every((e, t)=>(0, _constantsJs.magicbytes)[t] === e)) throw Error("Not a FlatGeobuf file");
    let o = new _flatbuffers.ByteBuffer(t), u = o.readUint32((0, _constantsJs.magicbytes).length);
    o.setPosition((0, _constantsJs.magicbytes).length + (0, _constantsJs.SIZE_PREFIX_LEN));
    let s = (0, _headerMetaJs.fromByteBuffer)(o);
    n && n(s);
    let d = (0, _constantsJs.magicbytes).length + (0, _constantsJs.SIZE_PREFIX_LEN) + u, { indexNodeSize: p, featuresCount: y } = s;
    p > 0 && (d += (0, _packedrtreeJs.calcTreeSize)(y, p));
    let g = [];
    for(; d < o.capacity();){
        let e = o.readUint32(d);
        o.setPosition(d + (0, _constantsJs.SIZE_PREFIX_LEN));
        let t = (0, _featureJs.Feature).getRootAsFeature(o);
        g.push(r(g.length, t, s)), d += (0, _constantsJs.SIZE_PREFIX_LEN) + e;
    }
    return g;
}
async function* deserializeStream(r, n, o) {
    let a, l = (0, _sliceSourceDefault.default)(r), u = async (e)=>await l.slice(e), s = new Uint8Array(await u(8, "magic bytes"));
    if (!s.subarray(0, 3).every((e, t)=>(0, _constantsJs.magicbytes)[t] === e)) throw Error("Not a FlatGeobuf file");
    s = new Uint8Array(await u(4, "header length"));
    let d = new _flatbuffers.ByteBuffer(s), p = d.readUint32(0);
    s = new Uint8Array(await u(p, "header data"));
    let y = (0, _headerMetaJs.fromByteBuffer)(d = new _flatbuffers.ByteBuffer(s));
    o && o(y);
    let { indexNodeSize: c, featuresCount: h } = y;
    if (c > 0) {
        let e = (0, _packedrtreeJs.calcTreeSize)(h, c);
        await u(e, "entire index, w/o rect");
    }
    let w = 0;
    for(; a = await g(u, y, n, w++);)yield a;
}
async function* deserializeFiltered(e, t, r, n, o = !1) {
    let a = await (0, _httpReaderJs.HttpReader).open(e, o);
    for await (let e of (n && n(a.header), a.selectBbox(t)))yield r(e.id, e.feature, a.header);
}
async function g(t, r, n, o) {
    let i = new Uint8Array(await t(4, "feature length"));
    if (0 === i.byteLength) return;
    let f = new _flatbuffers.ByteBuffer(i), u = f.readUint32(0);
    i = new Uint8Array(await t(u, "feature data"));
    let s = new Uint8Array(u + 4);
    return s.set(i, 4), (f = new _flatbuffers.ByteBuffer(s)).setPosition((0, _constantsJs.SIZE_PREFIX_LEN)), n(o, (0, _featureJs.Feature).getRootAsFeature(f), r);
}
function buildHeader(t, n = 0) {
    let a, i = new _flatbuffers.Builder, l = 0;
    t.columns && (l = (0, _headerJs.Header).createColumnsVector(i, t.columns.map((e)=>(function(e, t) {
            let r = e.createString(t.name);
            return (0, _columnJs.Column).startColumn(e), (0, _columnJs.Column).addName(e, r), (0, _columnJs.Column).addType(e, t.type), (0, _columnJs.Column).endColumn(e);
        })(i, e))));
    let f = i.createString("L1");
    n && ((0, _crsJs.Crs).startCrs(i), (0, _crsJs.Crs).addCode(i, n), a = (0, _crsJs.Crs).endCrs(i)), (0, _headerJs.Header).startHeader(i), a && (0, _headerJs.Header).addCrs(i, a), (0, _headerJs.Header).addFeaturesCount(i, BigInt(t.featuresCount)), (0, _headerJs.Header).addGeometryType(i, t.geometryType), (0, _headerJs.Header).addIndexNodeSize(i, 0), l && (0, _headerJs.Header).addColumns(i, l), (0, _headerJs.Header).addName(i, f);
    let s = (0, _headerJs.Header).endHeader(i);
    return i.finishSizePrefixed(s), i.asUint8Array();
}
function mapColumn(e, t) {
    return {
        name: t,
        type: function(e) {
            if ("boolean" == typeof e) return (0, _columnTypeJs.ColumnType).Bool;
            if ("number" == typeof e) return e % 1 == 0 ? (0, _columnTypeJs.ColumnType).Int : (0, _columnTypeJs.ColumnType).Double;
            if ("string" == typeof e || null === e) return (0, _columnTypeJs.ColumnType).String;
            if (e instanceof Uint8Array) return (0, _columnTypeJs.ColumnType).Binary;
            if ("object" == typeof e) return (0, _columnTypeJs.ColumnType).Json;
            throw Error(`Unknown type (value '${e}')`);
        }(e[t]),
        title: null,
        description: null,
        width: -1,
        precision: -1,
        scale: -1,
        nullable: !0,
        unique: !1,
        primary_key: !1
    };
}

},{"flatbuffers":"4oKPA","slice-source":"lsWGv","../flat-geobuf/header.js":"8H9JE","../flat-geobuf/column-type.js":"cK2R8","../flat-geobuf/column.js":"5dD9m","../flat-geobuf/feature.js":"jNs3T","../header-meta.js":"eEB1R","../constants.js":"5WAfl","../flat-geobuf/crs.js":"6SSTl","../http-reader.js":"1drNw","../packedrtree.js":"JJHpi","./feature.js":"7W11D","./geometry.js":"d9Uo0","./header.js":"iP7qh","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4oKPA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SIZEOF_SHORT", ()=>(0, _constantsJs.SIZEOF_SHORT));
parcelHelpers.export(exports, "SIZEOF_INT", ()=>(0, _constantsJs.SIZEOF_INT));
parcelHelpers.export(exports, "FILE_IDENTIFIER_LENGTH", ()=>(0, _constantsJs.FILE_IDENTIFIER_LENGTH));
parcelHelpers.export(exports, "SIZE_PREFIX_LENGTH", ()=>(0, _constantsJs.SIZE_PREFIX_LENGTH));
parcelHelpers.export(exports, "int32", ()=>(0, _utilsJs.int32));
parcelHelpers.export(exports, "float32", ()=>(0, _utilsJs.float32));
parcelHelpers.export(exports, "float64", ()=>(0, _utilsJs.float64));
parcelHelpers.export(exports, "isLittleEndian", ()=>(0, _utilsJs.isLittleEndian));
parcelHelpers.export(exports, "Encoding", ()=>(0, _encodingJs.Encoding));
parcelHelpers.export(exports, "Builder", ()=>(0, _builderJs.Builder));
parcelHelpers.export(exports, "ByteBuffer", ()=>(0, _byteBufferJs.ByteBuffer));
var _constantsJs = require("./constants.js");
var _utilsJs = require("./utils.js");
var _encodingJs = require("./encoding.js");
var _builderJs = require("./builder.js");
var _byteBufferJs = require("./byte-buffer.js");

},{"./constants.js":"6yHPv","./utils.js":"6z1Dq","./encoding.js":"5g4kh","./builder.js":"q59gk","./byte-buffer.js":"im5oE","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6yHPv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SIZEOF_SHORT", ()=>SIZEOF_SHORT);
parcelHelpers.export(exports, "SIZEOF_INT", ()=>SIZEOF_INT);
parcelHelpers.export(exports, "FILE_IDENTIFIER_LENGTH", ()=>FILE_IDENTIFIER_LENGTH);
parcelHelpers.export(exports, "SIZE_PREFIX_LENGTH", ()=>SIZE_PREFIX_LENGTH);
const SIZEOF_SHORT = 2;
const SIZEOF_INT = 4;
const FILE_IDENTIFIER_LENGTH = 4;
const SIZE_PREFIX_LENGTH = 4;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6z1Dq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "int32", ()=>int32);
parcelHelpers.export(exports, "float32", ()=>float32);
parcelHelpers.export(exports, "float64", ()=>float64);
parcelHelpers.export(exports, "isLittleEndian", ()=>isLittleEndian);
const int32 = new Int32Array(2);
const float32 = new Float32Array(int32.buffer);
const float64 = new Float64Array(int32.buffer);
const isLittleEndian = new Uint16Array(new Uint8Array([
    1,
    0
]).buffer)[0] === 1;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5g4kh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Encoding", ()=>Encoding);
var Encoding;
(function(Encoding) {
    Encoding[Encoding["UTF8_BYTES"] = 1] = "UTF8_BYTES";
    Encoding[Encoding["UTF16_STRING"] = 2] = "UTF16_STRING";
})(Encoding || (Encoding = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"q59gk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Builder", ()=>Builder);
var _byteBufferJs = require("./byte-buffer.js");
var _constantsJs = require("./constants.js");
class Builder {
    /**
     * Create a FlatBufferBuilder.
     */ constructor(opt_initial_size){
        /** Minimum alignment encountered so far. */ this.minalign = 1;
        /** The vtable for the current table. */ this.vtable = null;
        /** The amount of fields we're actually using. */ this.vtable_in_use = 0;
        /** Whether we are currently serializing a table. */ this.isNested = false;
        /** Starting offset of the current struct/table. */ this.object_start = 0;
        /** List of offsets of all vtables. */ this.vtables = [];
        /** For the current vector being built. */ this.vector_num_elems = 0;
        /** False omits default values from the serialized data */ this.force_defaults = false;
        this.string_maps = null;
        this.text_encoder = new TextEncoder();
        let initial_size;
        if (!opt_initial_size) initial_size = 1024;
        else initial_size = opt_initial_size;
        /**
         * @type {ByteBuffer}
         * @private
         */ this.bb = (0, _byteBufferJs.ByteBuffer).allocate(initial_size);
        this.space = initial_size;
    }
    clear() {
        this.bb.clear();
        this.space = this.bb.capacity();
        this.minalign = 1;
        this.vtable = null;
        this.vtable_in_use = 0;
        this.isNested = false;
        this.object_start = 0;
        this.vtables = [];
        this.vector_num_elems = 0;
        this.force_defaults = false;
        this.string_maps = null;
    }
    /**
     * In order to save space, fields that are set to their default value
     * don't get serialized into the buffer. Forcing defaults provides a
     * way to manually disable this optimization.
     *
     * @param forceDefaults true always serializes default values
     */ forceDefaults(forceDefaults) {
        this.force_defaults = forceDefaults;
    }
    /**
     * Get the ByteBuffer representing the FlatBuffer. Only call this after you've
     * called finish(). The actual data starts at the ByteBuffer's current position,
     * not necessarily at 0.
     */ dataBuffer() {
        return this.bb;
    }
    /**
     * Get the bytes representing the FlatBuffer. Only call this after you've
     * called finish().
     */ asUint8Array() {
        return this.bb.bytes().subarray(this.bb.position(), this.bb.position() + this.offset());
    }
    /**
     * Prepare to write an element of `size` after `additional_bytes` have been
     * written, e.g. if you write a string, you need to align such the int length
     * field is aligned to 4 bytes, and the string data follows it directly. If all
     * you need to do is alignment, `additional_bytes` will be 0.
     *
     * @param size This is the of the new element to write
     * @param additional_bytes The padding size
     */ prep(size, additional_bytes) {
        // Track the biggest thing we've ever aligned to.
        if (size > this.minalign) this.minalign = size;
        // Find the amount of alignment needed such that `size` is properly
        // aligned after `additional_bytes`
        const align_size = ~(this.bb.capacity() - this.space + additional_bytes) + 1 & size - 1;
        // Reallocate the buffer if needed.
        while(this.space < align_size + size + additional_bytes){
            const old_buf_size = this.bb.capacity();
            this.bb = Builder.growByteBuffer(this.bb);
            this.space += this.bb.capacity() - old_buf_size;
        }
        this.pad(align_size);
    }
    pad(byte_size) {
        for(let i = 0; i < byte_size; i++)this.bb.writeInt8(--this.space, 0);
    }
    writeInt8(value) {
        this.bb.writeInt8(this.space -= 1, value);
    }
    writeInt16(value) {
        this.bb.writeInt16(this.space -= 2, value);
    }
    writeInt32(value) {
        this.bb.writeInt32(this.space -= 4, value);
    }
    writeInt64(value) {
        this.bb.writeInt64(this.space -= 8, value);
    }
    writeFloat32(value) {
        this.bb.writeFloat32(this.space -= 4, value);
    }
    writeFloat64(value) {
        this.bb.writeFloat64(this.space -= 8, value);
    }
    /**
     * Add an `int8` to the buffer, properly aligned, and grows the buffer (if necessary).
     * @param value The `int8` to add the buffer.
     */ addInt8(value) {
        this.prep(1, 0);
        this.writeInt8(value);
    }
    /**
     * Add an `int16` to the buffer, properly aligned, and grows the buffer (if necessary).
     * @param value The `int16` to add the buffer.
     */ addInt16(value) {
        this.prep(2, 0);
        this.writeInt16(value);
    }
    /**
     * Add an `int32` to the buffer, properly aligned, and grows the buffer (if necessary).
     * @param value The `int32` to add the buffer.
     */ addInt32(value) {
        this.prep(4, 0);
        this.writeInt32(value);
    }
    /**
     * Add an `int64` to the buffer, properly aligned, and grows the buffer (if necessary).
     * @param value The `int64` to add the buffer.
     */ addInt64(value) {
        this.prep(8, 0);
        this.writeInt64(value);
    }
    /**
     * Add a `float32` to the buffer, properly aligned, and grows the buffer (if necessary).
     * @param value The `float32` to add the buffer.
     */ addFloat32(value) {
        this.prep(4, 0);
        this.writeFloat32(value);
    }
    /**
     * Add a `float64` to the buffer, properly aligned, and grows the buffer (if necessary).
     * @param value The `float64` to add the buffer.
     */ addFloat64(value) {
        this.prep(8, 0);
        this.writeFloat64(value);
    }
    addFieldInt8(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
            this.addInt8(value);
            this.slot(voffset);
        }
    }
    addFieldInt16(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
            this.addInt16(value);
            this.slot(voffset);
        }
    }
    addFieldInt32(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
            this.addInt32(value);
            this.slot(voffset);
        }
    }
    addFieldInt64(voffset, value, defaultValue) {
        if (this.force_defaults || value !== defaultValue) {
            this.addInt64(value);
            this.slot(voffset);
        }
    }
    addFieldFloat32(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
            this.addFloat32(value);
            this.slot(voffset);
        }
    }
    addFieldFloat64(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
            this.addFloat64(value);
            this.slot(voffset);
        }
    }
    addFieldOffset(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
            this.addOffset(value);
            this.slot(voffset);
        }
    }
    /**
     * Structs are stored inline, so nothing additional is being added. `d` is always 0.
     */ addFieldStruct(voffset, value, defaultValue) {
        if (value != defaultValue) {
            this.nested(value);
            this.slot(voffset);
        }
    }
    /**
     * Structures are always stored inline, they need to be created right
     * where they're used.  You'll get this assertion failure if you
     * created it elsewhere.
     */ nested(obj) {
        if (obj != this.offset()) throw new TypeError('FlatBuffers: struct must be serialized inline.');
    }
    /**
     * Should not be creating any other object, string or vector
     * while an object is being constructed
     */ notNested() {
        if (this.isNested) throw new TypeError('FlatBuffers: object serialization must not be nested.');
    }
    /**
     * Set the current vtable at `voffset` to the current location in the buffer.
     */ slot(voffset) {
        if (this.vtable !== null) this.vtable[voffset] = this.offset();
    }
    /**
     * @returns Offset relative to the end of the buffer.
     */ offset() {
        return this.bb.capacity() - this.space;
    }
    /**
     * Doubles the size of the backing ByteBuffer and copies the old data towards
     * the end of the new buffer (since we build the buffer backwards).
     *
     * @param bb The current buffer with the existing data
     * @returns A new byte buffer with the old data copied
     * to it. The data is located at the end of the buffer.
     *
     * uint8Array.set() formally takes {Array<number>|ArrayBufferView}, so to pass
     * it a uint8Array we need to suppress the type check:
     * @suppress {checkTypes}
     */ static growByteBuffer(bb) {
        const old_buf_size = bb.capacity();
        // Ensure we don't grow beyond what fits in an int.
        if (old_buf_size & 0xC0000000) throw new Error('FlatBuffers: cannot grow buffer beyond 2 gigabytes.');
        const new_buf_size = old_buf_size << 1;
        const nbb = (0, _byteBufferJs.ByteBuffer).allocate(new_buf_size);
        nbb.setPosition(new_buf_size - old_buf_size);
        nbb.bytes().set(bb.bytes(), new_buf_size - old_buf_size);
        return nbb;
    }
    /**
     * Adds on offset, relative to where it will be written.
     *
     * @param offset The offset to add.
     */ addOffset(offset) {
        this.prep((0, _constantsJs.SIZEOF_INT), 0); // Ensure alignment is already done.
        this.writeInt32(this.offset() - offset + (0, _constantsJs.SIZEOF_INT));
    }
    /**
     * Start encoding a new object in the buffer.  Users will not usually need to
     * call this directly. The FlatBuffers compiler will generate helper methods
     * that call this method internally.
     */ startObject(numfields) {
        this.notNested();
        if (this.vtable == null) this.vtable = [];
        this.vtable_in_use = numfields;
        for(let i = 0; i < numfields; i++)this.vtable[i] = 0; // This will push additional elements as needed
        this.isNested = true;
        this.object_start = this.offset();
    }
    /**
     * Finish off writing the object that is under construction.
     *
     * @returns The offset to the object inside `dataBuffer`
     */ endObject() {
        if (this.vtable == null || !this.isNested) throw new Error('FlatBuffers: endObject called without startObject');
        this.addInt32(0);
        const vtableloc = this.offset();
        // Trim trailing zeroes.
        let i = this.vtable_in_use - 1;
        // eslint-disable-next-line no-empty
        for(; i >= 0 && this.vtable[i] == 0; i--);
        const trimmed_size = i + 1;
        // Write out the current vtable.
        for(; i >= 0; i--)// Offset relative to the start of the table.
        this.addInt16(this.vtable[i] != 0 ? vtableloc - this.vtable[i] : 0);
        const standard_fields = 2; // The fields below:
        this.addInt16(vtableloc - this.object_start);
        const len = (trimmed_size + standard_fields) * (0, _constantsJs.SIZEOF_SHORT);
        this.addInt16(len);
        // Search for an existing vtable that matches the current one.
        let existing_vtable = 0;
        const vt1 = this.space;
        outer_loop: for(i = 0; i < this.vtables.length; i++){
            const vt2 = this.bb.capacity() - this.vtables[i];
            if (len == this.bb.readInt16(vt2)) {
                for(let j = (0, _constantsJs.SIZEOF_SHORT); j < len; j += (0, _constantsJs.SIZEOF_SHORT)){
                    if (this.bb.readInt16(vt1 + j) != this.bb.readInt16(vt2 + j)) continue outer_loop;
                }
                existing_vtable = this.vtables[i];
                break;
            }
        }
        if (existing_vtable) {
            // Found a match:
            // Remove the current vtable.
            this.space = this.bb.capacity() - vtableloc;
            // Point table to existing vtable.
            this.bb.writeInt32(this.space, existing_vtable - vtableloc);
        } else {
            // No match:
            // Add the location of the current vtable to the list of vtables.
            this.vtables.push(this.offset());
            // Point table to current vtable.
            this.bb.writeInt32(this.bb.capacity() - vtableloc, this.offset() - vtableloc);
        }
        this.isNested = false;
        return vtableloc;
    }
    /**
     * Finalize a buffer, poiting to the given `root_table`.
     */ finish(root_table, opt_file_identifier, opt_size_prefix) {
        const size_prefix = opt_size_prefix ? (0, _constantsJs.SIZE_PREFIX_LENGTH) : 0;
        if (opt_file_identifier) {
            const file_identifier = opt_file_identifier;
            this.prep(this.minalign, (0, _constantsJs.SIZEOF_INT) + (0, _constantsJs.FILE_IDENTIFIER_LENGTH) + size_prefix);
            if (file_identifier.length != (0, _constantsJs.FILE_IDENTIFIER_LENGTH)) throw new TypeError('FlatBuffers: file identifier must be length ' + (0, _constantsJs.FILE_IDENTIFIER_LENGTH));
            for(let i = (0, _constantsJs.FILE_IDENTIFIER_LENGTH) - 1; i >= 0; i--)this.writeInt8(file_identifier.charCodeAt(i));
        }
        this.prep(this.minalign, (0, _constantsJs.SIZEOF_INT) + size_prefix);
        this.addOffset(root_table);
        if (size_prefix) this.addInt32(this.bb.capacity() - this.space);
        this.bb.setPosition(this.space);
    }
    /**
     * Finalize a size prefixed buffer, pointing to the given `root_table`.
     */ finishSizePrefixed(root_table, opt_file_identifier) {
        this.finish(root_table, opt_file_identifier, true);
    }
    /**
     * This checks a required field has been set in a given table that has
     * just been constructed.
     */ requiredField(table, field) {
        const table_start = this.bb.capacity() - table;
        const vtable_start = table_start - this.bb.readInt32(table_start);
        const ok = field < this.bb.readInt16(vtable_start) && this.bb.readInt16(vtable_start + field) != 0;
        // If this fails, the caller will show what field needs to be set.
        if (!ok) throw new TypeError('FlatBuffers: field ' + field + ' must be set');
    }
    /**
     * Start a new array/vector of objects.  Users usually will not call
     * this directly. The FlatBuffers compiler will create a start/end
     * method for vector types in generated code.
     *
     * @param elem_size The size of each element in the array
     * @param num_elems The number of elements in the array
     * @param alignment The alignment of the array
     */ startVector(elem_size, num_elems, alignment) {
        this.notNested();
        this.vector_num_elems = num_elems;
        this.prep((0, _constantsJs.SIZEOF_INT), elem_size * num_elems);
        this.prep(alignment, elem_size * num_elems); // Just in case alignment > int.
    }
    /**
     * Finish off the creation of an array and all its elements. The array must be
     * created with `startVector`.
     *
     * @returns The offset at which the newly created array
     * starts.
     */ endVector() {
        this.writeInt32(this.vector_num_elems);
        return this.offset();
    }
    /**
     * Encode the string `s` in the buffer using UTF-8. If the string passed has
     * already been seen, we return the offset of the already written string
     *
     * @param s The string to encode
     * @return The offset in the buffer where the encoded string starts
     */ createSharedString(s) {
        if (!s) return 0;
        if (!this.string_maps) this.string_maps = new Map();
        if (this.string_maps.has(s)) return this.string_maps.get(s);
        const offset = this.createString(s);
        this.string_maps.set(s, offset);
        return offset;
    }
    /**
     * Encode the string `s` in the buffer using UTF-8. If a Uint8Array is passed
     * instead of a string, it is assumed to contain valid UTF-8 encoded data.
     *
     * @param s The string to encode
     * @return The offset in the buffer where the encoded string starts
     */ createString(s) {
        if (s === null || s === undefined) return 0;
        let utf8;
        if (s instanceof Uint8Array) utf8 = s;
        else utf8 = this.text_encoder.encode(s);
        this.addInt8(0);
        this.startVector(1, utf8.length, 1);
        this.bb.setPosition(this.space -= utf8.length);
        this.bb.bytes().set(utf8, this.space);
        return this.endVector();
    }
    /**
     * Create a byte vector.
     *
     * @param v The bytes to add
     * @returns The offset in the buffer where the byte vector starts
     */ createByteVector(v) {
        if (v === null || v === undefined) return 0;
        this.startVector(1, v.length, 1);
        this.bb.setPosition(this.space -= v.length);
        this.bb.bytes().set(v, this.space);
        return this.endVector();
    }
    /**
     * A helper function to pack an object
     *
     * @returns offset of obj
     */ createObjectOffset(obj) {
        if (obj === null) return 0;
        if (typeof obj === 'string') return this.createString(obj);
        else return obj.pack(this);
    }
    /**
     * A helper function to pack a list of object
     *
     * @returns list of offsets of each non null object
     */ createObjectOffsetList(list) {
        const ret = [];
        for(let i = 0; i < list.length; ++i){
            const val = list[i];
            if (val !== null) ret.push(this.createObjectOffset(val));
            else throw new TypeError('FlatBuffers: Argument for createObjectOffsetList cannot contain null.');
        }
        return ret;
    }
    createStructOffsetList(list, startFunc) {
        startFunc(this, list.length);
        this.createObjectOffsetList(list.slice().reverse());
        return this.endVector();
    }
}

},{"./byte-buffer.js":"im5oE","./constants.js":"6yHPv","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"im5oE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ByteBuffer", ()=>ByteBuffer);
var _constantsJs = require("./constants.js");
var _utilsJs = require("./utils.js");
var _encodingJs = require("./encoding.js");
class ByteBuffer {
    /**
     * Create a new ByteBuffer with a given array of bytes (`Uint8Array`)
     */ constructor(bytes_){
        this.bytes_ = bytes_;
        this.position_ = 0;
        this.text_decoder_ = new TextDecoder();
    }
    /**
     * Create and allocate a new ByteBuffer with a given size.
     */ static allocate(byte_size) {
        return new ByteBuffer(new Uint8Array(byte_size));
    }
    clear() {
        this.position_ = 0;
    }
    /**
     * Get the underlying `Uint8Array`.
     */ bytes() {
        return this.bytes_;
    }
    /**
     * Get the buffer's position.
     */ position() {
        return this.position_;
    }
    /**
     * Set the buffer's position.
     */ setPosition(position) {
        this.position_ = position;
    }
    /**
     * Get the buffer's capacity.
     */ capacity() {
        return this.bytes_.length;
    }
    readInt8(offset) {
        return this.readUint8(offset) << 24 >> 24;
    }
    readUint8(offset) {
        return this.bytes_[offset];
    }
    readInt16(offset) {
        return this.readUint16(offset) << 16 >> 16;
    }
    readUint16(offset) {
        return this.bytes_[offset] | this.bytes_[offset + 1] << 8;
    }
    readInt32(offset) {
        return this.bytes_[offset] | this.bytes_[offset + 1] << 8 | this.bytes_[offset + 2] << 16 | this.bytes_[offset + 3] << 24;
    }
    readUint32(offset) {
        return this.readInt32(offset) >>> 0;
    }
    readInt64(offset) {
        return BigInt.asIntN(64, BigInt(this.readUint32(offset)) + (BigInt(this.readUint32(offset + 4)) << BigInt(32)));
    }
    readUint64(offset) {
        return BigInt.asUintN(64, BigInt(this.readUint32(offset)) + (BigInt(this.readUint32(offset + 4)) << BigInt(32)));
    }
    readFloat32(offset) {
        (0, _utilsJs.int32)[0] = this.readInt32(offset);
        return (0, _utilsJs.float32)[0];
    }
    readFloat64(offset) {
        (0, _utilsJs.int32)[(0, _utilsJs.isLittleEndian) ? 0 : 1] = this.readInt32(offset);
        (0, _utilsJs.int32)[(0, _utilsJs.isLittleEndian) ? 1 : 0] = this.readInt32(offset + 4);
        return (0, _utilsJs.float64)[0];
    }
    writeInt8(offset, value) {
        this.bytes_[offset] = value;
    }
    writeUint8(offset, value) {
        this.bytes_[offset] = value;
    }
    writeInt16(offset, value) {
        this.bytes_[offset] = value;
        this.bytes_[offset + 1] = value >> 8;
    }
    writeUint16(offset, value) {
        this.bytes_[offset] = value;
        this.bytes_[offset + 1] = value >> 8;
    }
    writeInt32(offset, value) {
        this.bytes_[offset] = value;
        this.bytes_[offset + 1] = value >> 8;
        this.bytes_[offset + 2] = value >> 16;
        this.bytes_[offset + 3] = value >> 24;
    }
    writeUint32(offset, value) {
        this.bytes_[offset] = value;
        this.bytes_[offset + 1] = value >> 8;
        this.bytes_[offset + 2] = value >> 16;
        this.bytes_[offset + 3] = value >> 24;
    }
    writeInt64(offset, value) {
        this.writeInt32(offset, Number(BigInt.asIntN(32, value)));
        this.writeInt32(offset + 4, Number(BigInt.asIntN(32, value >> BigInt(32))));
    }
    writeUint64(offset, value) {
        this.writeUint32(offset, Number(BigInt.asUintN(32, value)));
        this.writeUint32(offset + 4, Number(BigInt.asUintN(32, value >> BigInt(32))));
    }
    writeFloat32(offset, value) {
        (0, _utilsJs.float32)[0] = value;
        this.writeInt32(offset, (0, _utilsJs.int32)[0]);
    }
    writeFloat64(offset, value) {
        (0, _utilsJs.float64)[0] = value;
        this.writeInt32(offset, (0, _utilsJs.int32)[(0, _utilsJs.isLittleEndian) ? 0 : 1]);
        this.writeInt32(offset + 4, (0, _utilsJs.int32)[(0, _utilsJs.isLittleEndian) ? 1 : 0]);
    }
    /**
     * Return the file identifier.   Behavior is undefined for FlatBuffers whose
     * schema does not include a file_identifier (likely points at padding or the
     * start of a the root vtable).
     */ getBufferIdentifier() {
        if (this.bytes_.length < this.position_ + (0, _constantsJs.SIZEOF_INT) + (0, _constantsJs.FILE_IDENTIFIER_LENGTH)) throw new Error('FlatBuffers: ByteBuffer is too short to contain an identifier.');
        let result = "";
        for(let i = 0; i < (0, _constantsJs.FILE_IDENTIFIER_LENGTH); i++)result += String.fromCharCode(this.readInt8(this.position_ + (0, _constantsJs.SIZEOF_INT) + i));
        return result;
    }
    /**
     * Look up a field in the vtable, return an offset into the object, or 0 if the
     * field is not present.
     */ __offset(bb_pos, vtable_offset) {
        const vtable = bb_pos - this.readInt32(bb_pos);
        return vtable_offset < this.readInt16(vtable) ? this.readInt16(vtable + vtable_offset) : 0;
    }
    /**
     * Initialize any Table-derived type to point to the union at the given offset.
     */ __union(t, offset) {
        t.bb_pos = offset + this.readInt32(offset);
        t.bb = this;
        return t;
    }
    /**
     * Create a JavaScript string from UTF-8 data stored inside the FlatBuffer.
     * This allocates a new string and converts to wide chars upon each access.
     *
     * To avoid the conversion to string, pass Encoding.UTF8_BYTES as the
     * "optionalEncoding" argument. This is useful for avoiding conversion when
     * the data will just be packaged back up in another FlatBuffer later on.
     *
     * @param offset
     * @param opt_encoding Defaults to UTF16_STRING
     */ __string(offset, opt_encoding) {
        offset += this.readInt32(offset);
        const length = this.readInt32(offset);
        offset += (0, _constantsJs.SIZEOF_INT);
        const utf8bytes = this.bytes_.subarray(offset, offset + length);
        if (opt_encoding === (0, _encodingJs.Encoding).UTF8_BYTES) return utf8bytes;
        else return this.text_decoder_.decode(utf8bytes);
    }
    /**
     * Handle unions that can contain string as its member, if a Table-derived type then initialize it,
     * if a string then return a new one
     *
     * WARNING: strings are immutable in JS so we can't change the string that the user gave us, this
     * makes the behaviour of __union_with_string different compared to __union
     */ __union_with_string(o, offset) {
        if (typeof o === 'string') return this.__string(offset);
        return this.__union(o, offset);
    }
    /**
     * Retrieve the relative offset stored at "offset"
     */ __indirect(offset) {
        return offset + this.readInt32(offset);
    }
    /**
     * Get the start of data of a vector whose offset is stored at "offset" in this object.
     */ __vector(offset) {
        return offset + this.readInt32(offset) + (0, _constantsJs.SIZEOF_INT); // data starts after the length
    }
    /**
     * Get the length of a vector whose offset is stored at "offset" in this object.
     */ __vector_len(offset) {
        return this.readInt32(offset + this.readInt32(offset));
    }
    __has_identifier(ident) {
        if (ident.length != (0, _constantsJs.FILE_IDENTIFIER_LENGTH)) throw new Error('FlatBuffers: file identifier must be length ' + (0, _constantsJs.FILE_IDENTIFIER_LENGTH));
        for(let i = 0; i < (0, _constantsJs.FILE_IDENTIFIER_LENGTH); i++){
            if (ident.charCodeAt(i) != this.readInt8(this.position() + (0, _constantsJs.SIZEOF_INT) + i)) return false;
        }
        return true;
    }
    /**
     * A helper function for generating list for obj api
     */ createScalarList(listAccessor, listLength) {
        const ret = [];
        for(let i = 0; i < listLength; ++i){
            const val = listAccessor(i);
            if (val !== null) ret.push(val);
        }
        return ret;
    }
    /**
     * A helper function for generating list for obj api
     * @param listAccessor function that accepts an index and return data at that index
     * @param listLength listLength
     * @param res result list
     */ createObjList(listAccessor, listLength) {
        const ret = [];
        for(let i = 0; i < listLength; ++i){
            const val = listAccessor(i);
            if (val !== null) ret.push(val.unpack());
        }
        return ret;
    }
}

},{"./constants.js":"6yHPv","./utils.js":"6z1Dq","./encoding.js":"5g4kh","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"lsWGv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>slice);
var _empty = require("./empty");
var _emptyDefault = parcelHelpers.interopDefault(_empty);
var _cancel = require("./cancel");
var _cancelDefault = parcelHelpers.interopDefault(_cancel);
var _read = require("./read");
var _readDefault = parcelHelpers.interopDefault(_read);
var _slice = require("./slice");
var _sliceDefault = parcelHelpers.interopDefault(_slice);
function slice(source) {
    return typeof source.slice === "function" ? source : new SliceSource(typeof source.read === "function" ? source : source.getReader());
}
function SliceSource(source) {
    this._source = source;
    this._array = (0, _emptyDefault.default);
    this._index = 0;
}
SliceSource.prototype.read = (0, _readDefault.default);
SliceSource.prototype.slice = (0, _sliceDefault.default);
SliceSource.prototype.cancel = (0, _cancelDefault.default);

},{"./empty":"c0GuT","./cancel":"2TDkg","./read":"30VcB","./slice":"gob4C","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"c0GuT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = new Uint8Array(0);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2TDkg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this._source.cancel();
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"30VcB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var that = this, array = that._array.subarray(that._index);
        return that._source.read().then(function(result) {
            that._array = (0, _emptyDefault.default);
            that._index = 0;
            return result.done ? array.length > 0 ? {
                done: false,
                value: array
            } : {
                done: true,
                value: undefined
            } : {
                done: false,
                value: (0, _concatDefault.default)(array, result.value)
            };
        });
    });
var _concat = require("./concat");
var _concatDefault = parcelHelpers.interopDefault(_concat);
var _empty = require("./empty");
var _emptyDefault = parcelHelpers.interopDefault(_empty);

},{"./concat":"bNLI5","./empty":"c0GuT","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bNLI5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>concat);
function concat(a, b) {
    if (!a.length) return b;
    if (!b.length) return a;
    var c = new Uint8Array(a.length + b.length);
    c.set(a);
    c.set(b, a.length);
    return c;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gob4C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(length) {
        if ((length |= 0) < 0) throw new Error("invalid length");
        var that = this, index = this._array.length - this._index;
        // If the request fits within the remaining buffer, resolve it immediately.
        if (this._index + length <= this._array.length) return Promise.resolve(this._array.subarray(this._index, this._index += length));
        // Otherwise, read chunks repeatedly until the request is fulfilled.
        var array = new Uint8Array(length);
        array.set(this._array.subarray(this._index));
        return function read() {
            return that._source.read().then(function(result) {
                // When done, it’s possible the request wasn’t fully fullfilled!
                // If so, the pre-allocated array is too big and needs slicing.
                if (result.done) {
                    that._array = (0, _emptyDefault.default);
                    that._index = 0;
                    return index > 0 ? array.subarray(0, index) : null;
                }
                // If this chunk fulfills the request, return the resulting array.
                if (index + result.value.length >= length) {
                    that._array = result.value;
                    that._index = length - index;
                    array.set(result.value.subarray(0, length - index), index);
                    return array;
                }
                // Otherwise copy this chunk into the array, then read the next chunk.
                array.set(result.value, index);
                index += result.value.length;
                return read();
            });
        }();
    });
var _empty = require("./empty");
var _emptyDefault = parcelHelpers.interopDefault(_empty);

},{"./empty":"c0GuT","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8H9JE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Header", ()=>Header);
var _flatbuffers = require("flatbuffers");
var _columnJs = require("../flat-geobuf/column.js");
var _crsJs = require("../flat-geobuf/crs.js");
var _geometryTypeJs = require("../flat-geobuf/geometry-type.js");
class Header {
    bb = null;
    bb_pos = 0;
    __init(t, s) {
        return this.bb_pos = t, this.bb = s, this;
    }
    static getRootAsHeader(t, s) {
        return (s || new Header).__init(t.readInt32(t.position()) + t.position(), t);
    }
    static getSizePrefixedRootAsHeader(s, e) {
        return s.setPosition(s.position() + _flatbuffers.SIZE_PREFIX_LENGTH), (e || new Header).__init(s.readInt32(s.position()) + s.position(), s);
    }
    name(t) {
        let s = this.bb.__offset(this.bb_pos, 4);
        return s ? this.bb.__string(this.bb_pos + s, t) : null;
    }
    envelope(t) {
        let s = this.bb.__offset(this.bb_pos, 6);
        return s ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + s) + 8 * t) : 0;
    }
    envelopeLength() {
        let t = this.bb.__offset(this.bb_pos, 6);
        return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
    }
    envelopeArray() {
        let t = this.bb.__offset(this.bb_pos, 6);
        return t ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
    }
    geometryType() {
        let t = this.bb.__offset(this.bb_pos, 8);
        return t ? this.bb.readUint8(this.bb_pos + t) : (0, _geometryTypeJs.GeometryType).Unknown;
    }
    hasZ() {
        let t = this.bb.__offset(this.bb_pos, 10);
        return !!t && !!this.bb.readInt8(this.bb_pos + t);
    }
    hasM() {
        let t = this.bb.__offset(this.bb_pos, 12);
        return !!t && !!this.bb.readInt8(this.bb_pos + t);
    }
    hasT() {
        let t = this.bb.__offset(this.bb_pos, 14);
        return !!t && !!this.bb.readInt8(this.bb_pos + t);
    }
    hasTm() {
        let t = this.bb.__offset(this.bb_pos, 16);
        return !!t && !!this.bb.readInt8(this.bb_pos + t);
    }
    columns(t, e) {
        let i = this.bb.__offset(this.bb_pos, 18);
        return i ? (e || new (0, _columnJs.Column)).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + i) + 4 * t), this.bb) : null;
    }
    columnsLength() {
        let t = this.bb.__offset(this.bb_pos, 18);
        return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
    }
    featuresCount() {
        let t = this.bb.__offset(this.bb_pos, 20);
        return t ? this.bb.readUint64(this.bb_pos + t) : BigInt("0");
    }
    indexNodeSize() {
        let t = this.bb.__offset(this.bb_pos, 22);
        return t ? this.bb.readUint16(this.bb_pos + t) : 16;
    }
    crs(t) {
        let s = this.bb.__offset(this.bb_pos, 24);
        return s ? (t || new (0, _crsJs.Crs)).__init(this.bb.__indirect(this.bb_pos + s), this.bb) : null;
    }
    title(t) {
        let s = this.bb.__offset(this.bb_pos, 26);
        return s ? this.bb.__string(this.bb_pos + s, t) : null;
    }
    description(t) {
        let s = this.bb.__offset(this.bb_pos, 28);
        return s ? this.bb.__string(this.bb_pos + s, t) : null;
    }
    metadata(t) {
        let s = this.bb.__offset(this.bb_pos, 30);
        return s ? this.bb.__string(this.bb_pos + s, t) : null;
    }
    static startHeader(t) {
        t.startObject(14);
    }
    static addName(t, s) {
        t.addFieldOffset(0, s, 0);
    }
    static addEnvelope(t, s) {
        t.addFieldOffset(1, s, 0);
    }
    static createEnvelopeVector(t, s) {
        t.startVector(8, s.length, 8);
        for(let e = s.length - 1; e >= 0; e--)t.addFloat64(s[e]);
        return t.endVector();
    }
    static startEnvelopeVector(t, s) {
        t.startVector(8, s, 8);
    }
    static addGeometryType(t, s) {
        t.addFieldInt8(2, s, (0, _geometryTypeJs.GeometryType).Unknown);
    }
    static addHasZ(t, s) {
        t.addFieldInt8(3, +s, 0);
    }
    static addHasM(t, s) {
        t.addFieldInt8(4, +s, 0);
    }
    static addHasT(t, s) {
        t.addFieldInt8(5, +s, 0);
    }
    static addHasTm(t, s) {
        t.addFieldInt8(6, +s, 0);
    }
    static addColumns(t, s) {
        t.addFieldOffset(7, s, 0);
    }
    static createColumnsVector(t, s) {
        t.startVector(4, s.length, 4);
        for(let e = s.length - 1; e >= 0; e--)t.addOffset(s[e]);
        return t.endVector();
    }
    static startColumnsVector(t, s) {
        t.startVector(4, s, 4);
    }
    static addFeaturesCount(t, s) {
        t.addFieldInt64(8, s, BigInt("0"));
    }
    static addIndexNodeSize(t, s) {
        t.addFieldInt16(9, s, 16);
    }
    static addCrs(t, s) {
        t.addFieldOffset(10, s, 0);
    }
    static addTitle(t, s) {
        t.addFieldOffset(11, s, 0);
    }
    static addDescription(t, s) {
        t.addFieldOffset(12, s, 0);
    }
    static addMetadata(t, s) {
        t.addFieldOffset(13, s, 0);
    }
    static endHeader(t) {
        return t.endObject();
    }
    static finishHeaderBuffer(t, s) {
        t.finish(s);
    }
    static finishSizePrefixedHeaderBuffer(t, s) {
        t.finish(s, void 0, !0);
    }
}

},{"flatbuffers":"4oKPA","../flat-geobuf/column.js":"5dD9m","../flat-geobuf/crs.js":"6SSTl","../flat-geobuf/geometry-type.js":"99UDP","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5dD9m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Column", ()=>Column);
var _flatbuffers = require("flatbuffers");
var _columnTypeJs = require("../flat-geobuf/column-type.js");
class Column {
    bb = null;
    bb_pos = 0;
    __init(t, s) {
        return this.bb_pos = t, this.bb = s, this;
    }
    static getRootAsColumn(t, s) {
        return (s || new Column).__init(t.readInt32(t.position()) + t.position(), t);
    }
    static getSizePrefixedRootAsColumn(s, i) {
        return s.setPosition(s.position() + _flatbuffers.SIZE_PREFIX_LENGTH), (i || new Column).__init(s.readInt32(s.position()) + s.position(), s);
    }
    name(t) {
        let s = this.bb.__offset(this.bb_pos, 4);
        return s ? this.bb.__string(this.bb_pos + s, t) : null;
    }
    type() {
        let t = this.bb.__offset(this.bb_pos, 6);
        return t ? this.bb.readUint8(this.bb_pos + t) : (0, _columnTypeJs.ColumnType).Byte;
    }
    title(t) {
        let s = this.bb.__offset(this.bb_pos, 8);
        return s ? this.bb.__string(this.bb_pos + s, t) : null;
    }
    description(t) {
        let s = this.bb.__offset(this.bb_pos, 10);
        return s ? this.bb.__string(this.bb_pos + s, t) : null;
    }
    width() {
        let t = this.bb.__offset(this.bb_pos, 12);
        return t ? this.bb.readInt32(this.bb_pos + t) : -1;
    }
    precision() {
        let t = this.bb.__offset(this.bb_pos, 14);
        return t ? this.bb.readInt32(this.bb_pos + t) : -1;
    }
    scale() {
        let t = this.bb.__offset(this.bb_pos, 16);
        return t ? this.bb.readInt32(this.bb_pos + t) : -1;
    }
    nullable() {
        let t = this.bb.__offset(this.bb_pos, 18);
        return !t || !!this.bb.readInt8(this.bb_pos + t);
    }
    unique() {
        let t = this.bb.__offset(this.bb_pos, 20);
        return !!t && !!this.bb.readInt8(this.bb_pos + t);
    }
    primaryKey() {
        let t = this.bb.__offset(this.bb_pos, 22);
        return !!t && !!this.bb.readInt8(this.bb_pos + t);
    }
    metadata(t) {
        let s = this.bb.__offset(this.bb_pos, 24);
        return s ? this.bb.__string(this.bb_pos + s, t) : null;
    }
    static startColumn(t) {
        t.startObject(11);
    }
    static addName(t, s) {
        t.addFieldOffset(0, s, 0);
    }
    static addType(t, i) {
        t.addFieldInt8(1, i, (0, _columnTypeJs.ColumnType).Byte);
    }
    static addTitle(t, s) {
        t.addFieldOffset(2, s, 0);
    }
    static addDescription(t, s) {
        t.addFieldOffset(3, s, 0);
    }
    static addWidth(t, s) {
        t.addFieldInt32(4, s, -1);
    }
    static addPrecision(t, s) {
        t.addFieldInt32(5, s, -1);
    }
    static addScale(t, s) {
        t.addFieldInt32(6, s, -1);
    }
    static addNullable(t, s) {
        t.addFieldInt8(7, +s, 1);
    }
    static addUnique(t, s) {
        t.addFieldInt8(8, +s, 0);
    }
    static addPrimaryKey(t, s) {
        t.addFieldInt8(9, +s, 0);
    }
    static addMetadata(t, s) {
        t.addFieldOffset(10, s, 0);
    }
    static endColumn(t) {
        let s = t.endObject();
        return t.requiredField(s, 4), s;
    }
    static createColumn(t, s, i, e, b, d, n, a, o, l, r, _) {
        return Column.startColumn(t), Column.addName(t, s), Column.addType(t, i), Column.addTitle(t, e), Column.addDescription(t, b), Column.addWidth(t, d), Column.addPrecision(t, n), Column.addScale(t, a), Column.addNullable(t, o), Column.addUnique(t, l), Column.addPrimaryKey(t, r), Column.addMetadata(t, _), Column.endColumn(t);
    }
}

},{"flatbuffers":"4oKPA","../flat-geobuf/column-type.js":"cK2R8","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"cK2R8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColumnType", ()=>ColumnType);
var o;
var ColumnType = ((o = {})[o.Byte = 0] = "Byte", o[o.UByte = 1] = "UByte", o[o.Bool = 2] = "Bool", o[o.Short = 3] = "Short", o[o.UShort = 4] = "UShort", o[o.Int = 5] = "Int", o[o.UInt = 6] = "UInt", o[o.Long = 7] = "Long", o[o.ULong = 8] = "ULong", o[o.Float = 9] = "Float", o[o.Double = 10] = "Double", o[o.String = 11] = "String", o[o.Json = 12] = "Json", o[o.DateTime = 13] = "DateTime", o[o.Binary = 14] = "Binary", o);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6SSTl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Crs", ()=>Crs);
var _flatbuffers = require("flatbuffers");
class Crs {
    bb = null;
    bb_pos = 0;
    __init(t, s) {
        return this.bb_pos = t, this.bb = s, this;
    }
    static getRootAsCrs(t, s) {
        return (s || new Crs).__init(t.readInt32(t.position()) + t.position(), t);
    }
    static getSizePrefixedRootAsCrs(s, i) {
        return s.setPosition(s.position() + _flatbuffers.SIZE_PREFIX_LENGTH), (i || new Crs).__init(s.readInt32(s.position()) + s.position(), s);
    }
    org(t) {
        let s = this.bb.__offset(this.bb_pos, 4);
        return s ? this.bb.__string(this.bb_pos + s, t) : null;
    }
    code() {
        let t = this.bb.__offset(this.bb_pos, 6);
        return t ? this.bb.readInt32(this.bb_pos + t) : 0;
    }
    name(t) {
        let s = this.bb.__offset(this.bb_pos, 8);
        return s ? this.bb.__string(this.bb_pos + s, t) : null;
    }
    description(t) {
        let s = this.bb.__offset(this.bb_pos, 10);
        return s ? this.bb.__string(this.bb_pos + s, t) : null;
    }
    wkt(t) {
        let s = this.bb.__offset(this.bb_pos, 12);
        return s ? this.bb.__string(this.bb_pos + s, t) : null;
    }
    codeString(t) {
        let s = this.bb.__offset(this.bb_pos, 14);
        return s ? this.bb.__string(this.bb_pos + s, t) : null;
    }
    static startCrs(t) {
        t.startObject(6);
    }
    static addOrg(t, s) {
        t.addFieldOffset(0, s, 0);
    }
    static addCode(t, s) {
        t.addFieldInt32(1, s, 0);
    }
    static addName(t, s) {
        t.addFieldOffset(2, s, 0);
    }
    static addDescription(t, s) {
        t.addFieldOffset(3, s, 0);
    }
    static addWkt(t, s) {
        t.addFieldOffset(4, s, 0);
    }
    static addCodeString(t, s) {
        t.addFieldOffset(5, s, 0);
    }
    static endCrs(t) {
        return t.endObject();
    }
    static createCrs(t, s, i, e, r, b, d) {
        return Crs.startCrs(t), Crs.addOrg(t, s), Crs.addCode(t, i), Crs.addName(t, e), Crs.addDescription(t, r), Crs.addWkt(t, b), Crs.addCodeString(t, d), Crs.endCrs(t);
    }
}

},{"flatbuffers":"4oKPA","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"99UDP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GeometryType", ()=>GeometryType);
var r;
var GeometryType = ((r = {})[r.Unknown = 0] = "Unknown", r[r.Point = 1] = "Point", r[r.LineString = 2] = "LineString", r[r.Polygon = 3] = "Polygon", r[r.MultiPoint = 4] = "MultiPoint", r[r.MultiLineString = 5] = "MultiLineString", r[r.MultiPolygon = 6] = "MultiPolygon", r[r.GeometryCollection = 7] = "GeometryCollection", r[r.CircularString = 8] = "CircularString", r[r.CompoundCurve = 9] = "CompoundCurve", r[r.CurvePolygon = 10] = "CurvePolygon", r[r.MultiCurve = 11] = "MultiCurve", r[r.MultiSurface = 12] = "MultiSurface", r[r.Curve = 13] = "Curve", r[r.Surface = 14] = "Surface", r[r.PolyhedralSurface = 15] = "PolyhedralSurface", r[r.TIN = 16] = "TIN", r[r.Triangle = 17] = "Triangle", r);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jNs3T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Feature", ()=>Feature);
var _flatbuffers = require("flatbuffers");
var _columnJs = require("../flat-geobuf/column.js");
var _geometryJs = require("../flat-geobuf/geometry.js");
class Feature {
    bb = null;
    bb_pos = 0;
    __init(t, e) {
        return this.bb_pos = t, this.bb = e, this;
    }
    static getRootAsFeature(t, e) {
        return (e || new Feature).__init(t.readInt32(t.position()) + t.position(), t);
    }
    static getSizePrefixedRootAsFeature(e, s) {
        return e.setPosition(e.position() + _flatbuffers.SIZE_PREFIX_LENGTH), (s || new Feature).__init(e.readInt32(e.position()) + e.position(), e);
    }
    geometry(t) {
        let e = this.bb.__offset(this.bb_pos, 4);
        return e ? (t || new (0, _geometryJs.Geometry)).__init(this.bb.__indirect(this.bb_pos + e), this.bb) : null;
    }
    properties(t) {
        let e = this.bb.__offset(this.bb_pos, 6);
        return e ? this.bb.readUint8(this.bb.__vector(this.bb_pos + e) + t) : 0;
    }
    propertiesLength() {
        let t = this.bb.__offset(this.bb_pos, 6);
        return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
    }
    propertiesArray() {
        let t = this.bb.__offset(this.bb_pos, 6);
        return t ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
    }
    columns(t, s) {
        let r = this.bb.__offset(this.bb_pos, 8);
        return r ? (s || new (0, _columnJs.Column)).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + r) + 4 * t), this.bb) : null;
    }
    columnsLength() {
        let t = this.bb.__offset(this.bb_pos, 8);
        return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
    }
    static startFeature(t) {
        t.startObject(3);
    }
    static addGeometry(t, e) {
        t.addFieldOffset(0, e, 0);
    }
    static addProperties(t, e) {
        t.addFieldOffset(1, e, 0);
    }
    static createPropertiesVector(t, e) {
        t.startVector(1, e.length, 1);
        for(let s = e.length - 1; s >= 0; s--)t.addInt8(e[s]);
        return t.endVector();
    }
    static startPropertiesVector(t, e) {
        t.startVector(1, e, 1);
    }
    static addColumns(t, e) {
        t.addFieldOffset(2, e, 0);
    }
    static createColumnsVector(t, e) {
        t.startVector(4, e.length, 4);
        for(let s = e.length - 1; s >= 0; s--)t.addOffset(e[s]);
        return t.endVector();
    }
    static startColumnsVector(t, e) {
        t.startVector(4, e, 4);
    }
    static endFeature(t) {
        return t.endObject();
    }
    static finishFeatureBuffer(t, e) {
        t.finish(e);
    }
    static finishSizePrefixedFeatureBuffer(t, e) {
        t.finish(e, void 0, !0);
    }
    static createFeature(t, e, s, r) {
        return Feature.startFeature(t), Feature.addGeometry(t, e), Feature.addProperties(t, s), Feature.addColumns(t, r), Feature.endFeature(t);
    }
}

},{"flatbuffers":"4oKPA","../flat-geobuf/column.js":"5dD9m","../flat-geobuf/geometry.js":"gVFcX","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gVFcX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Geometry", ()=>Geometry);
var _flatbuffers = require("flatbuffers");
var _geometryTypeJs = require("../flat-geobuf/geometry-type.js");
class Geometry {
    bb = null;
    bb_pos = 0;
    __init(t, e) {
        return this.bb_pos = t, this.bb = e, this;
    }
    static getRootAsGeometry(t, e) {
        return (e || new Geometry).__init(t.readInt32(t.position()) + t.position(), t);
    }
    static getSizePrefixedRootAsGeometry(e, s) {
        return e.setPosition(e.position() + _flatbuffers.SIZE_PREFIX_LENGTH), (s || new Geometry).__init(e.readInt32(e.position()) + e.position(), e);
    }
    ends(t) {
        let e = this.bb.__offset(this.bb_pos, 4);
        return e ? this.bb.readUint32(this.bb.__vector(this.bb_pos + e) + 4 * t) : 0;
    }
    endsLength() {
        let t = this.bb.__offset(this.bb_pos, 4);
        return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
    }
    endsArray() {
        let t = this.bb.__offset(this.bb_pos, 4);
        return t ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
    }
    xy(t) {
        let e = this.bb.__offset(this.bb_pos, 6);
        return e ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + e) + 8 * t) : 0;
    }
    xyLength() {
        let t = this.bb.__offset(this.bb_pos, 6);
        return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
    }
    xyArray() {
        let t = this.bb.__offset(this.bb_pos, 6);
        return t ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
    }
    z(t) {
        let e = this.bb.__offset(this.bb_pos, 8);
        return e ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + e) + 8 * t) : 0;
    }
    zLength() {
        let t = this.bb.__offset(this.bb_pos, 8);
        return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
    }
    zArray() {
        let t = this.bb.__offset(this.bb_pos, 8);
        return t ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
    }
    m(t) {
        let e = this.bb.__offset(this.bb_pos, 10);
        return e ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + e) + 8 * t) : 0;
    }
    mLength() {
        let t = this.bb.__offset(this.bb_pos, 10);
        return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
    }
    mArray() {
        let t = this.bb.__offset(this.bb_pos, 10);
        return t ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
    }
    t(t) {
        let e = this.bb.__offset(this.bb_pos, 12);
        return e ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + e) + 8 * t) : 0;
    }
    tLength() {
        let t = this.bb.__offset(this.bb_pos, 12);
        return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
    }
    tArray() {
        let t = this.bb.__offset(this.bb_pos, 12);
        return t ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + t), this.bb.__vector_len(this.bb_pos + t)) : null;
    }
    tm(t) {
        let e = this.bb.__offset(this.bb_pos, 14);
        return e ? this.bb.readUint64(this.bb.__vector(this.bb_pos + e) + 8 * t) : BigInt(0);
    }
    tmLength() {
        let t = this.bb.__offset(this.bb_pos, 14);
        return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
    }
    type() {
        let t = this.bb.__offset(this.bb_pos, 16);
        return t ? this.bb.readUint8(this.bb_pos + t) : (0, _geometryTypeJs.GeometryType).Unknown;
    }
    parts(t, e) {
        let s = this.bb.__offset(this.bb_pos, 18);
        return s ? (e || new Geometry).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + s) + 4 * t), this.bb) : null;
    }
    partsLength() {
        let t = this.bb.__offset(this.bb_pos, 18);
        return t ? this.bb.__vector_len(this.bb_pos + t) : 0;
    }
    static startGeometry(t) {
        t.startObject(8);
    }
    static addEnds(t, e) {
        t.addFieldOffset(0, e, 0);
    }
    static createEndsVector(t, e) {
        t.startVector(4, e.length, 4);
        for(let s = e.length - 1; s >= 0; s--)t.addInt32(e[s]);
        return t.endVector();
    }
    static startEndsVector(t, e) {
        t.startVector(4, e, 4);
    }
    static addXy(t, e) {
        t.addFieldOffset(1, e, 0);
    }
    static createXyVector(t, e) {
        t.startVector(8, e.length, 8);
        for(let s = e.length - 1; s >= 0; s--)t.addFloat64(e[s]);
        return t.endVector();
    }
    static startXyVector(t, e) {
        t.startVector(8, e, 8);
    }
    static addZ(t, e) {
        t.addFieldOffset(2, e, 0);
    }
    static createZVector(t, e) {
        t.startVector(8, e.length, 8);
        for(let s = e.length - 1; s >= 0; s--)t.addFloat64(e[s]);
        return t.endVector();
    }
    static startZVector(t, e) {
        t.startVector(8, e, 8);
    }
    static addM(t, e) {
        t.addFieldOffset(3, e, 0);
    }
    static createMVector(t, e) {
        t.startVector(8, e.length, 8);
        for(let s = e.length - 1; s >= 0; s--)t.addFloat64(e[s]);
        return t.endVector();
    }
    static startMVector(t, e) {
        t.startVector(8, e, 8);
    }
    static addT(t, e) {
        t.addFieldOffset(4, e, 0);
    }
    static createTVector(t, e) {
        t.startVector(8, e.length, 8);
        for(let s = e.length - 1; s >= 0; s--)t.addFloat64(e[s]);
        return t.endVector();
    }
    static startTVector(t, e) {
        t.startVector(8, e, 8);
    }
    static addTm(t, e) {
        t.addFieldOffset(5, e, 0);
    }
    static createTmVector(t, e) {
        t.startVector(8, e.length, 8);
        for(let s = e.length - 1; s >= 0; s--)t.addInt64(e[s]);
        return t.endVector();
    }
    static startTmVector(t, e) {
        t.startVector(8, e, 8);
    }
    static addType(t, s) {
        t.addFieldInt8(6, s, (0, _geometryTypeJs.GeometryType).Unknown);
    }
    static addParts(t, e) {
        t.addFieldOffset(7, e, 0);
    }
    static createPartsVector(t, e) {
        t.startVector(4, e.length, 4);
        for(let s = e.length - 1; s >= 0; s--)t.addOffset(e[s]);
        return t.endVector();
    }
    static startPartsVector(t, e) {
        t.startVector(4, e, 4);
    }
    static endGeometry(t) {
        return t.endObject();
    }
    static createGeometry(t, e, s, b, r, o, i, _, h) {
        return Geometry.startGeometry(t), Geometry.addEnds(t, e), Geometry.addXy(t, s), Geometry.addZ(t, b), Geometry.addM(t, r), Geometry.addT(t, o), Geometry.addTm(t, i), Geometry.addType(t, _), Geometry.addParts(t, h), Geometry.endGeometry(t);
    }
}

},{"flatbuffers":"4oKPA","../flat-geobuf/geometry-type.js":"99UDP","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"eEB1R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromByteBuffer", ()=>fromByteBuffer);
var _headerJs = require("./flat-geobuf/header.js");
function fromByteBuffer(t) {
    let r = (0, _headerJs.Header).getRootAsHeader(t), i = r.featuresCount(), n = r.indexNodeSize(), o = [];
    for(let e = 0; e < r.columnsLength(); e++){
        let t = r.columns(e);
        if (!t) throw Error("Column unexpectedly missing");
        if (!t.name()) throw Error("Column name unexpectedly missing");
        o.push({
            name: t.name(),
            type: t.type(),
            title: t.title(),
            description: t.description(),
            width: t.width(),
            precision: t.precision(),
            scale: t.scale(),
            nullable: t.nullable(),
            unique: t.unique(),
            primary_key: t.primaryKey()
        });
    }
    let l = r.crs(), s = l ? {
        org: l.org(),
        code: l.code(),
        name: l.name(),
        description: l.description(),
        wkt: l.wkt(),
        code_string: l.codeString()
    } : null;
    return {
        geometryType: r.geometryType(),
        columns: o,
        envelope: null,
        featuresCount: Number(i),
        indexNodeSize: n,
        crs: s,
        title: r.title(),
        description: r.description(),
        metadata: r.metadata()
    };
}

},{"./flat-geobuf/header.js":"8H9JE","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5WAfl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "magicbytes", ()=>magicbytes);
parcelHelpers.export(exports, "SIZE_PREFIX_LEN", ()=>SIZE_PREFIX_LEN);
const magicbytes = new Uint8Array([
    102,
    103,
    98,
    3,
    102,
    103,
    98,
    0
]);
const SIZE_PREFIX_LEN = 4;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1drNw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpReader", ()=>HttpReader);
var _repeater = require("@repeaterjs/repeater");
var _flatbuffers = require("flatbuffers");
var _configJs = require("./config.js");
var _configJsDefault = parcelHelpers.interopDefault(_configJs);
var _constantsJs = require("./constants.js");
var _featureJs = require("./flat-geobuf/feature.js");
var _headerMetaJs = require("./header-meta.js");
var _packedrtreeJs = require("./packedrtree.js");
class HttpReader {
    headerClient;
    header;
    headerLength;
    indexLength;
    nocache;
    constructor(e, t, r, a, s){
        this.headerClient = e, this.header = t, this.headerLength = r, this.indexLength = a, this.nocache = s;
    }
    static async open(e, r) {
        let a, n = new u(e, r), f = 2024 + (()=>{
            let e, t = 0;
            for(e = 0; e < 3; e++)t += (0, _packedrtreeJs.DEFAULT_NODE_SIZE) ** e * (0, _packedrtreeJs.NODE_ITEM_BYTE_LEN);
            return t;
        })();
        if (!new Uint8Array(await n.getRange(0, 8, f, "header")).subarray(0, 3).every((e, t)=>(0, _constantsJs.magicbytes)[t] === e)) throw Error("Not a FlatGeobuf file");
        if ((a = new DataView(await n.getRange(8, 4, f, "header")).getUint32(0, !0)) > 0xa00000 || a < 8) throw Error("Invalid header size");
        let d = await n.getRange(12, a, f, "header"), g = (0, _headerMetaJs.fromByteBuffer)(new _flatbuffers.ByteBuffer(new Uint8Array(d))), c = (0, _packedrtreeJs.calcTreeSize)(g.featuresCount, g.indexNodeSize);
        return new HttpReader(n, g, a, c, r);
    }
    async *selectBbox(t) {
        let a = this.lengthBeforeTree(), s = this.headerClient, n = async (e, t)=>s.getRange(a + e, t, 0, "index"), i = [], h = [];
        for await (let e of (0, _packedrtreeJs.streamSearch)(this.header.featuresCount, this.header.indexNodeSize, t, n)){
            let [t, a] = e, [, , s] = e;
            if (s || (s = 4), 0 === h.length) {
                h.push([
                    t,
                    s,
                    a
                ]);
                continue;
            }
            let n = h[h.length - 1];
            t - (n[0] + n[1]) > (0, _configJsDefault.default).global.extraRequestThreshold() && (i.push(h), h = []), h.push([
                t,
                s,
                a
            ]);
        }
        this.headerClient.logUsage("header+index"), h.length > 0 && i.push(h);
        let o = i.flatMap((e)=>this.readFeatureBatch(e, this.nocache));
        yield* (0, _repeater.Repeater).merge(o);
    }
    lengthBeforeTree() {
        return (0, _constantsJs.magicbytes).length + (0, _constantsJs.SIZE_PREFIX_LEN) + this.headerLength;
    }
    lengthBeforeFeatures() {
        return this.lengthBeforeTree() + this.indexLength;
    }
    buildFeatureClient(e) {
        return new u(this.headerClient.httpClient, e);
    }
    async *readFeatureBatch(e, t) {
        let [r] = e[0], [a, s] = e[e.length - 1], n = this.buildFeatureClient(t), i = a + s - r;
        for (let [t, , r] of e){
            let e = await this.readFeature(n, t, i);
            yield {
                id: r,
                feature: e
            }, i = 0;
        }
        n.logUsage("feature");
    }
    async readFeature(e, r, s) {
        let i, h = r + this.lengthBeforeFeatures();
        i = new DataView(await e.getRange(h, 4, s, "feature length")).getUint32(0, !0);
        let o = new Uint8Array(await e.getRange(h + 4, i, s, "feature data")), l = new Uint8Array(i + (0, _constantsJs.SIZE_PREFIX_LEN));
        l.set(o, (0, _constantsJs.SIZE_PREFIX_LEN));
        let f = new _flatbuffers.ByteBuffer(l);
        return f.setPosition((0, _constantsJs.SIZE_PREFIX_LEN)), (0, _featureJs.Feature).getRootAsFeature(f);
    }
}
class u {
    httpClient;
    bytesEverUsed = 0;
    bytesEverFetched = 0;
    buffer = new ArrayBuffer(0);
    head = 0;
    constructor(e, t){
        if ("string" == typeof e) this.httpClient = new d(e, t);
        else if (e instanceof d) this.httpClient = e;
        else throw Error("Unknown source ");
    }
    async getRange(e, t, r, a) {
        this.bytesEverUsed += t;
        let s = e - this.head, n = s + t;
        if (s >= 0 && n <= this.buffer.byteLength) return this.buffer.slice(s, n);
        let i = Math.max(t, r);
        return this.bytesEverFetched += i, this.buffer = await this.httpClient.getRange(e, i, a), this.head = e, this.buffer.slice(0, t);
    }
    logUsage(e) {
        e.split(" ")[0], (100 * this.bytesEverUsed / this.bytesEverFetched).toFixed(2);
    }
}
class d {
    url;
    nocache;
    requestsEverMade = 0;
    bytesEverRequested = 0;
    constructor(e, t){
        this.url = e, this.nocache = t;
    }
    async getRange(e, t, r) {
        this.requestsEverMade += 1, this.bytesEverRequested += t;
        let a = {
            Range: `bytes=${e}-${e + t - 1}`
        };
        this.nocache && (a["Cache-Control"] = "no-cache, no-store");
        let s = await fetch(this.url, {
            headers: a
        });
        return await s.arrayBuffer();
    }
}

},{"@repeaterjs/repeater":"4wYQG","flatbuffers":"4oKPA","./config.js":"5Kw8d","./constants.js":"5WAfl","./flat-geobuf/feature.js":"jNs3T","./header-meta.js":"eEB1R","./packedrtree.js":"JJHpi","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4wYQG":[function(require,module,exports,__globalThis) {
/// <reference types="./repeater.d.ts" />
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DroppingBuffer", ()=>DroppingBuffer);
parcelHelpers.export(exports, "FixedBuffer", ()=>FixedBuffer);
parcelHelpers.export(exports, "MAX_QUEUE_LENGTH", ()=>MAX_QUEUE_LENGTH);
parcelHelpers.export(exports, "Repeater", ()=>Repeater);
parcelHelpers.export(exports, "RepeaterOverflowError", ()=>RepeaterOverflowError);
parcelHelpers.export(exports, "SlidingBuffer", ()=>SlidingBuffer);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
/** An error subclass which is thrown when there are too many pending push or next operations on a single repeater. */ var RepeaterOverflowError = /** @class */ function(_super) {
    __extends(RepeaterOverflowError, _super);
    function RepeaterOverflowError(message) {
        var _this = _super.call(this, message) || this;
        Object.defineProperty(_this, "name", {
            value: "RepeaterOverflowError",
            enumerable: false
        });
        if (typeof Object.setPrototypeOf === "function") Object.setPrototypeOf(_this, _this.constructor.prototype);
        else _this.__proto__ = _this.constructor.prototype;
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(_this, _this.constructor);
        return _this;
    }
    return RepeaterOverflowError;
}(Error);
/** A buffer which allows you to push a set amount of values to the repeater without pushes waiting or throwing errors. */ var FixedBuffer = /** @class */ function() {
    function FixedBuffer(capacity) {
        if (capacity < 0) throw new RangeError("Capacity may not be less than 0");
        this._c = capacity;
        this._q = [];
    }
    Object.defineProperty(FixedBuffer.prototype, "empty", {
        get: function() {
            return this._q.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FixedBuffer.prototype, "full", {
        get: function() {
            return this._q.length >= this._c;
        },
        enumerable: false,
        configurable: true
    });
    FixedBuffer.prototype.add = function(value) {
        if (this.full) throw new Error("Buffer full");
        else this._q.push(value);
    };
    FixedBuffer.prototype.remove = function() {
        if (this.empty) throw new Error("Buffer empty");
        return this._q.shift();
    };
    return FixedBuffer;
}();
// TODO: Use a circular buffer here.
/** Sliding buffers allow you to push a set amount of values to the repeater without pushes waiting or throwing errors. If the number of values exceeds the capacity set in the constructor, the buffer will discard the earliest values added. */ var SlidingBuffer = /** @class */ function() {
    function SlidingBuffer(capacity) {
        if (capacity < 1) throw new RangeError("Capacity may not be less than 1");
        this._c = capacity;
        this._q = [];
    }
    Object.defineProperty(SlidingBuffer.prototype, "empty", {
        get: function() {
            return this._q.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SlidingBuffer.prototype, "full", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    SlidingBuffer.prototype.add = function(value) {
        while(this._q.length >= this._c)this._q.shift();
        this._q.push(value);
    };
    SlidingBuffer.prototype.remove = function() {
        if (this.empty) throw new Error("Buffer empty");
        return this._q.shift();
    };
    return SlidingBuffer;
}();
/** Dropping buffers allow you to push a set amount of values to the repeater without the push function waiting or throwing errors. If the number of values exceeds the capacity set in the constructor, the buffer will discard the latest values added. */ var DroppingBuffer = /** @class */ function() {
    function DroppingBuffer(capacity) {
        if (capacity < 1) throw new RangeError("Capacity may not be less than 1");
        this._c = capacity;
        this._q = [];
    }
    Object.defineProperty(DroppingBuffer.prototype, "empty", {
        get: function() {
            return this._q.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DroppingBuffer.prototype, "full", {
        get: function() {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    DroppingBuffer.prototype.add = function(value) {
        if (this._q.length < this._c) this._q.push(value);
    };
    DroppingBuffer.prototype.remove = function() {
        if (this.empty) throw new Error("Buffer empty");
        return this._q.shift();
    };
    return DroppingBuffer;
}();
/** Makes sure promise-likes don’t cause unhandled rejections. */ function swallow(value) {
    if (value != null && typeof value.then === "function") value.then(NOOP, NOOP);
}
/*** REPEATER STATES ***/ /** The following is an enumeration of all possible repeater states. These states are ordered, and a repeater may only advance to higher states. */ /** The initial state of the repeater. */ var Initial = 0;
/** Repeaters advance to this state the first time the next method is called on the repeater. */ var Started = 1;
/** Repeaters advance to this state when the stop function is called. */ var Stopped = 2;
/** Repeaters advance to this state when there are no values left to be pulled from the repeater. */ var Done = 3;
/** Repeaters advance to this state if an error is thrown into the repeater. */ var Rejected = 4;
/** The maximum number of push or next operations which may exist on a single repeater. */ var MAX_QUEUE_LENGTH = 1024;
var NOOP = function() {};
/** A helper function used to mimic the behavior of async generators where the final iteration is consumed. */ function consumeExecution(r) {
    var err = r.err;
    var execution = Promise.resolve(r.execution).then(function(value) {
        if (err != null) throw err;
        return value;
    });
    r.err = undefined;
    r.execution = execution.then(function() {
        return undefined;
    }, function() {
        return undefined;
    });
    return r.pending === undefined ? execution : r.pending.then(function() {
        return execution;
    });
}
/** A helper function for building iterations from values. Promises are unwrapped, so that iterations never have their value property set to a promise. */ function createIteration(r, value) {
    var done = r.state >= Done;
    return Promise.resolve(value).then(function(value) {
        if (!done && r.state >= Rejected) return consumeExecution(r).then(function(value) {
            return {
                value: value,
                done: true
            };
        });
        return {
            value: value,
            done: done
        };
    });
}
/**
 * This function is bound and passed to the executor as the stop argument.
 *
 * Advances state to Stopped.
 */ function stop(r, err) {
    var e_1, _a;
    if (r.state >= Stopped) return;
    r.state = Stopped;
    r.onnext();
    r.onstop();
    if (r.err == null) r.err = err;
    if (r.pushes.length === 0 && (typeof r.buffer === "undefined" || r.buffer.empty)) finish(r);
    else try {
        for(var _b = __values(r.pushes), _d = _b.next(); !_d.done; _d = _b.next()){
            var push_1 = _d.value;
            push_1.resolve();
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/**
 * The difference between stopping a repeater vs finishing a repeater is that stopping a repeater allows next to continue to drain values from the push queue and buffer, while finishing a repeater will clear all pending values and end iteration immediately. Once, a repeater is finished, all iterations will have the done property set to true.
 *
 * Advances state to Done.
 */ function finish(r) {
    var e_2, _a;
    if (r.state >= Done) return;
    if (r.state < Stopped) stop(r);
    r.state = Done;
    r.buffer = undefined;
    try {
        for(var _b = __values(r.nexts), _d = _b.next(); !_d.done; _d = _b.next()){
            var next = _d.value;
            var execution = r.pending === undefined ? consumeExecution(r) : r.pending.then(function() {
                return consumeExecution(r);
            });
            next.resolve(createIteration(r, execution));
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    r.pushes = [];
    r.nexts = [];
}
/**
 * Called when a promise passed to push rejects, or when a push call is unhandled.
 *
 * Advances state to Rejected.
 */ function reject(r) {
    if (r.state >= Rejected) return;
    if (r.state < Done) finish(r);
    r.state = Rejected;
}
/** This function is bound and passed to the executor as the push argument. */ function push(r, value) {
    swallow(value);
    if (r.pushes.length >= MAX_QUEUE_LENGTH) throw new RepeaterOverflowError("No more than " + MAX_QUEUE_LENGTH + " pending calls to push are allowed on a single repeater.");
    else if (r.state >= Stopped) return Promise.resolve(undefined);
    var valueP = r.pending === undefined ? Promise.resolve(value) : r.pending.then(function() {
        return value;
    });
    valueP = valueP.catch(function(err) {
        if (r.state < Stopped) r.err = err;
        reject(r);
        return undefined; // void :(
    });
    var nextP;
    if (r.nexts.length) {
        var next_1 = r.nexts.shift();
        next_1.resolve(createIteration(r, valueP));
        if (r.nexts.length) nextP = Promise.resolve(r.nexts[0].value);
        else if (typeof r.buffer !== "undefined" && !r.buffer.full) nextP = Promise.resolve(undefined);
        else nextP = new Promise(function(resolve) {
            return r.onnext = resolve;
        });
    } else if (typeof r.buffer !== "undefined" && !r.buffer.full) {
        r.buffer.add(valueP);
        nextP = Promise.resolve(undefined);
    } else nextP = new Promise(function(resolve) {
        return r.pushes.push({
            resolve: resolve,
            value: valueP
        });
    });
    // If an error is thrown into the repeater via the next or throw methods, we give the repeater a chance to handle this by rejecting the promise returned from push. If the push call is not immediately handled we throw the next iteration of the repeater.
    // To check that the promise returned from push is floating, we modify the then and catch methods of the returned promise so that they flip the floating flag. The push function actually does not return a promise, because modern engines do not call the then and catch methods on native promises. By making next a plain old javascript object, we ensure that the then and catch methods will be called.
    var floating = true;
    var next = {};
    var unhandled = nextP.catch(function(err) {
        if (floating) throw err;
        return undefined; // void :(
    });
    next.then = function(onfulfilled, onrejected) {
        floating = false;
        return Promise.prototype.then.call(nextP, onfulfilled, onrejected);
    };
    next.catch = function(onrejected) {
        floating = false;
        return Promise.prototype.catch.call(nextP, onrejected);
    };
    next.finally = nextP.finally.bind(nextP);
    r.pending = valueP.then(function() {
        return unhandled;
    }).catch(function(err) {
        r.err = err;
        reject(r);
    });
    return next;
}
/**
 * Creates the stop callable promise which is passed to the executor
 */ function createStop(r) {
    var stop1 = stop.bind(null, r);
    var stopP = new Promise(function(resolve) {
        return r.onstop = resolve;
    });
    stop1.then = stopP.then.bind(stopP);
    stop1.catch = stopP.catch.bind(stopP);
    stop1.finally = stopP.finally.bind(stopP);
    return stop1;
}
/**
 * Calls the executor passed into the constructor. This function is called the first time the next method is called on the repeater.
 *
 * Advances state to Started.
 */ function execute(r) {
    if (r.state >= Started) return;
    r.state = Started;
    var push1 = push.bind(null, r);
    var stop1 = createStop(r);
    r.execution = new Promise(function(resolve) {
        return resolve(r.executor(push1, stop1));
    });
    // TODO: We should consider stopping all repeaters when the executor settles.
    r.execution.catch(function() {
        return stop(r);
    });
}
var records = new WeakMap();
// NOTE: While repeaters implement and are assignable to the AsyncGenerator interface, and you can use the types interchangeably, we don’t use typescript’s implements syntax here because this would make supporting earlier versions of typescript trickier. This is because TypeScript version 3.6 changed the iterator types by adding the TReturn and TNext type parameters.
var Repeater = /** @class */ function() {
    function Repeater(executor, buffer) {
        records.set(this, {
            executor: executor,
            buffer: buffer,
            err: undefined,
            state: Initial,
            pushes: [],
            nexts: [],
            pending: undefined,
            execution: undefined,
            onnext: NOOP,
            onstop: NOOP
        });
    }
    Repeater.prototype.next = function(value) {
        swallow(value);
        var r = records.get(this);
        if (r === undefined) throw new Error("WeakMap error");
        if (r.nexts.length >= MAX_QUEUE_LENGTH) throw new RepeaterOverflowError("No more than " + MAX_QUEUE_LENGTH + " pending calls to next are allowed on a single repeater.");
        if (r.state <= Initial) execute(r);
        r.onnext(value);
        if (typeof r.buffer !== "undefined" && !r.buffer.empty) {
            var result = createIteration(r, r.buffer.remove());
            if (r.pushes.length) {
                var push_2 = r.pushes.shift();
                r.buffer.add(push_2.value);
                r.onnext = push_2.resolve;
            }
            return result;
        } else if (r.pushes.length) {
            var push_3 = r.pushes.shift();
            r.onnext = push_3.resolve;
            return createIteration(r, push_3.value);
        } else if (r.state >= Stopped) {
            finish(r);
            return createIteration(r, consumeExecution(r));
        }
        return new Promise(function(resolve) {
            return r.nexts.push({
                resolve: resolve,
                value: value
            });
        });
    };
    Repeater.prototype.return = function(value) {
        swallow(value);
        var r = records.get(this);
        if (r === undefined) throw new Error("WeakMap error");
        finish(r);
        // We override the execution because return should always return the value passed in.
        r.execution = Promise.resolve(r.execution).then(function() {
            return value;
        });
        return createIteration(r, consumeExecution(r));
    };
    Repeater.prototype.throw = function(err) {
        var r = records.get(this);
        if (r === undefined) throw new Error("WeakMap error");
        if (r.state <= Initial || r.state >= Stopped || typeof r.buffer !== "undefined" && !r.buffer.empty) {
            finish(r);
            // If r.err is already set, that mean the repeater has already produced an error, so we throw that error rather than the error passed in, because doing so might be more informative for the caller.
            if (r.err == null) r.err = err;
            return createIteration(r, consumeExecution(r));
        }
        return this.next(Promise.reject(err));
    };
    Repeater.prototype[Symbol.asyncIterator] = function() {
        return this;
    };
    // TODO: Remove these static methods from the class.
    Repeater.race = race;
    Repeater.merge = merge;
    Repeater.zip = zip;
    Repeater.latest = latest;
    return Repeater;
}();
/*** COMBINATOR FUNCTIONS ***/ // TODO: move these combinators to their own file.
function getIterators(values, options) {
    var e_3, _a;
    var iters = [];
    var _loop_1 = function(value) {
        if (value != null && typeof value[Symbol.asyncIterator] === "function") iters.push(value[Symbol.asyncIterator]());
        else if (value != null && typeof value[Symbol.iterator] === "function") iters.push(value[Symbol.iterator]());
        else iters.push(function valueToAsyncIterator() {
            return __asyncGenerator(this, arguments, function valueToAsyncIterator_1() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!options.yieldValues) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                __await(value)
                            ];
                        case 1:
                            return [
                                4 /*yield*/ ,
                                _a.sent()
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            if (!options.returnValues) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                __await(value)
                            ];
                        case 4:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        }());
    };
    try {
        for(var values_1 = __values(values), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()){
            var value = values_1_1.value;
            _loop_1(value);
        }
    } catch (e_3_1) {
        e_3 = {
            error: e_3_1
        };
    } finally{
        try {
            if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
        } finally{
            if (e_3) throw e_3.error;
        }
    }
    return iters;
}
// NOTE: whenever you see any variables called `advance` or `advances`, know that it is a hack to get around the fact that `Promise.race` leaks memory. These variables are intended to be set to the resolve function of a promise which is constructed and awaited as an alternative to Promise.race. For more information, see this comment in the Node.js issue tracker: https://github.com/nodejs/node/issues/17469#issuecomment-685216777.
function race(contenders) {
    var _this = this;
    var iters = getIterators(contenders, {
        returnValues: true
    });
    return new Repeater(function(push, stop) {
        return __awaiter(_this, void 0, void 0, function() {
            var advance, stopped, finalIteration, iteration, i_1, _loop_2;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!iters.length) {
                            stop();
                            return [
                                2 /*return*/ 
                            ];
                        }
                        stopped = false;
                        stop.then(function() {
                            advance();
                            stopped = true;
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            5,
                            7
                        ]);
                        iteration = void 0;
                        i_1 = 0;
                        _loop_2 = function() {
                            var j, iters_1, iters_1_1, iter;
                            var e_4, _a;
                            return __generator(this, function(_b) {
                                switch(_b.label){
                                    case 0:
                                        j = i_1;
                                        try {
                                            for(iters_1 = (e_4 = void 0, __values(iters)), iters_1_1 = iters_1.next(); !iters_1_1.done; iters_1_1 = iters_1.next()){
                                                iter = iters_1_1.value;
                                                Promise.resolve(iter.next()).then(function(iteration) {
                                                    if (iteration.done) {
                                                        stop();
                                                        if (finalIteration === undefined) finalIteration = iteration;
                                                    } else if (i_1 === j) {
                                                        // This iterator has won, advance i and resolve the promise.
                                                        i_1++;
                                                        advance(iteration);
                                                    }
                                                }, function(err) {
                                                    return stop(err);
                                                });
                                            }
                                        } catch (e_4_1) {
                                            e_4 = {
                                                error: e_4_1
                                            };
                                        } finally{
                                            try {
                                                if (iters_1_1 && !iters_1_1.done && (_a = iters_1.return)) _a.call(iters_1);
                                            } finally{
                                                if (e_4) throw e_4.error;
                                            }
                                        }
                                        return [
                                            4 /*yield*/ ,
                                            new Promise(function(resolve) {
                                                return advance = resolve;
                                            })
                                        ];
                                    case 1:
                                        iteration = _b.sent();
                                        if (!(iteration !== undefined)) return [
                                            3 /*break*/ ,
                                            3
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            push(iteration.value)
                                        ];
                                    case 2:
                                        _b.sent();
                                        _b.label = 3;
                                    case 3:
                                        return [
                                            2 /*return*/ 
                                        ];
                                }
                            });
                        };
                        _a.label = 2;
                    case 2:
                        if (!!stopped) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            5 /*yield**/ ,
                            _loop_2()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            finalIteration && finalIteration.value
                        ];
                    case 5:
                        stop();
                        return [
                            4 /*yield*/ ,
                            Promise.race(iters.map(function(iter) {
                                return iter.return && iter.return();
                            }))
                        ];
                    case 6:
                        _a.sent();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    });
}
function merge(contenders) {
    var _this = this;
    var iters = getIterators(contenders, {
        yieldValues: true
    });
    return new Repeater(function(push, stop) {
        return __awaiter(_this, void 0, void 0, function() {
            var advances, stopped, finalIteration;
            var _this = this;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!iters.length) {
                            stop();
                            return [
                                2 /*return*/ 
                            ];
                        }
                        advances = [];
                        stopped = false;
                        stop.then(function() {
                            var e_5, _a;
                            stopped = true;
                            try {
                                for(var advances_1 = __values(advances), advances_1_1 = advances_1.next(); !advances_1_1.done; advances_1_1 = advances_1.next()){
                                    var advance = advances_1_1.value;
                                    advance();
                                }
                            } catch (e_5_1) {
                                e_5 = {
                                    error: e_5_1
                                };
                            } finally{
                                try {
                                    if (advances_1_1 && !advances_1_1.done && (_a = advances_1.return)) _a.call(advances_1);
                                } finally{
                                    if (e_5) throw e_5.error;
                                }
                            }
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.all(iters.map(function(iter, i) {
                                return __awaiter(_this, void 0, void 0, function() {
                                    var iteration, _a;
                                    return __generator(this, function(_b) {
                                        switch(_b.label){
                                            case 0:
                                                _b.trys.push([
                                                    0,
                                                    ,
                                                    6,
                                                    9
                                                ]);
                                                _b.label = 1;
                                            case 1:
                                                if (!!stopped) return [
                                                    3 /*break*/ ,
                                                    5
                                                ];
                                                Promise.resolve(iter.next()).then(function(iteration) {
                                                    return advances[i](iteration);
                                                }, function(err) {
                                                    return stop(err);
                                                });
                                                return [
                                                    4 /*yield*/ ,
                                                    new Promise(function(resolve) {
                                                        advances[i] = resolve;
                                                    })
                                                ];
                                            case 2:
                                                iteration = _b.sent();
                                                if (!(iteration !== undefined)) return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                                if (iteration.done) {
                                                    finalIteration = iteration;
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                }
                                                return [
                                                    4 /*yield*/ ,
                                                    push(iteration.value)
                                                ];
                                            case 3:
                                                _b.sent();
                                                _b.label = 4;
                                            case 4:
                                                return [
                                                    3 /*break*/ ,
                                                    1
                                                ];
                                            case 5:
                                                return [
                                                    3 /*break*/ ,
                                                    9
                                                ];
                                            case 6:
                                                _a = iter.return;
                                                if (!_a) return [
                                                    3 /*break*/ ,
                                                    8
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    iter.return()
                                                ];
                                            case 7:
                                                _a = _b.sent();
                                                _b.label = 8;
                                            case 8:
                                                return [
                                                    7 /*endfinally*/ 
                                                ];
                                            case 9:
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            finalIteration && finalIteration.value
                        ];
                    case 3:
                        stop();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    });
}
function zip(contenders) {
    var _this = this;
    var iters = getIterators(contenders, {
        returnValues: true
    });
    return new Repeater(function(push, stop) {
        return __awaiter(_this, void 0, void 0, function() {
            var advance, stopped, iterations, values;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!iters.length) {
                            stop();
                            return [
                                2 /*return*/ ,
                                []
                            ];
                        }
                        stopped = false;
                        stop.then(function() {
                            advance();
                            stopped = true;
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            6,
                            8
                        ]);
                        _a.label = 2;
                    case 2:
                        if (!!stopped) return [
                            3 /*break*/ ,
                            5
                        ];
                        Promise.all(iters.map(function(iter) {
                            return iter.next();
                        })).then(function(iterations) {
                            return advance(iterations);
                        }, function(err) {
                            return stop(err);
                        });
                        return [
                            4 /*yield*/ ,
                            new Promise(function(resolve) {
                                return advance = resolve;
                            })
                        ];
                    case 3:
                        iterations = _a.sent();
                        if (iterations === undefined) return [
                            2 /*return*/ 
                        ];
                        values = iterations.map(function(iteration) {
                            return iteration.value;
                        });
                        if (iterations.some(function(iteration) {
                            return iteration.done;
                        })) return [
                            2 /*return*/ ,
                            values
                        ];
                        return [
                            4 /*yield*/ ,
                            push(values)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        stop();
                        return [
                            4 /*yield*/ ,
                            Promise.all(iters.map(function(iter) {
                                return iter.return && iter.return();
                            }))
                        ];
                    case 7:
                        _a.sent();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    });
}
function latest(contenders) {
    var _this = this;
    var iters = getIterators(contenders, {
        yieldValues: true,
        returnValues: true
    });
    return new Repeater(function(push, stop) {
        return __awaiter(_this, void 0, void 0, function() {
            var advance, advances, stopped, iterations_1, values_2;
            var _this = this;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!iters.length) {
                            stop();
                            return [
                                2 /*return*/ ,
                                []
                            ];
                        }
                        advances = [];
                        stopped = false;
                        stop.then(function() {
                            var e_6, _a;
                            advance();
                            try {
                                for(var advances_2 = __values(advances), advances_2_1 = advances_2.next(); !advances_2_1.done; advances_2_1 = advances_2.next()){
                                    var advance1 = advances_2_1.value;
                                    advance1();
                                }
                            } catch (e_6_1) {
                                e_6 = {
                                    error: e_6_1
                                };
                            } finally{
                                try {
                                    if (advances_2_1 && !advances_2_1.done && (_a = advances_2.return)) _a.call(advances_2);
                                } finally{
                                    if (e_6) throw e_6.error;
                                }
                            }
                            stopped = true;
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            5,
                            7
                        ]);
                        Promise.all(iters.map(function(iter) {
                            return iter.next();
                        })).then(function(iterations) {
                            return advance(iterations);
                        }, function(err) {
                            return stop(err);
                        });
                        return [
                            4 /*yield*/ ,
                            new Promise(function(resolve) {
                                return advance = resolve;
                            })
                        ];
                    case 2:
                        iterations_1 = _a.sent();
                        if (iterations_1 === undefined) return [
                            2 /*return*/ 
                        ];
                        values_2 = iterations_1.map(function(iteration) {
                            return iteration.value;
                        });
                        if (iterations_1.every(function(iteration) {
                            return iteration.done;
                        })) return [
                            2 /*return*/ ,
                            values_2
                        ];
                        // We continuously yield and mutate the same values array so we shallow copy it each time it is pushed.
                        return [
                            4 /*yield*/ ,
                            push(values_2.slice())
                        ];
                    case 3:
                        // We continuously yield and mutate the same values array so we shallow copy it each time it is pushed.
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            Promise.all(iters.map(function(iter, i) {
                                return __awaiter(_this, void 0, void 0, function() {
                                    var iteration;
                                    return __generator(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                if (iterations_1[i].done) return [
                                                    2 /*return*/ ,
                                                    iterations_1[i].value
                                                ];
                                                _a.label = 1;
                                            case 1:
                                                if (!!stopped) return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                                Promise.resolve(iter.next()).then(function(iteration) {
                                                    return advances[i](iteration);
                                                }, function(err) {
                                                    return stop(err);
                                                });
                                                return [
                                                    4 /*yield*/ ,
                                                    new Promise(function(resolve) {
                                                        return advances[i] = resolve;
                                                    })
                                                ];
                                            case 2:
                                                iteration = _a.sent();
                                                if (iteration === undefined) return [
                                                    2 /*return*/ ,
                                                    iterations_1[i].value
                                                ];
                                                else if (iteration.done) return [
                                                    2 /*return*/ ,
                                                    iteration.value
                                                ];
                                                values_2[i] = iteration.value;
                                                return [
                                                    4 /*yield*/ ,
                                                    push(values_2.slice())
                                                ];
                                            case 3:
                                                _a.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    1
                                                ];
                                            case 4:
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 5:
                        stop();
                        return [
                            4 /*yield*/ ,
                            Promise.all(iters.map(function(iter) {
                                return iter.return && iter.return();
                            }))
                        ];
                    case 6:
                        _a.sent();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5Kw8d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class e {
    static global = new e;
    _extraRequestThreshold = 262144;
    extraRequestThreshold() {
        return this._extraRequestThreshold;
    }
    setExtraRequestThreshold(e) {
        if (e < 0) throw Error("extraRequestThreshold cannot be negative");
        this._extraRequestThreshold = e;
    }
}
exports.default = e;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"JJHpi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NODE_ITEM_BYTE_LEN", ()=>NODE_ITEM_BYTE_LEN);
parcelHelpers.export(exports, "NODE_ITEM_LEN", ()=>NODE_ITEM_LEN);
parcelHelpers.export(exports, "DEFAULT_NODE_SIZE", ()=>DEFAULT_NODE_SIZE);
parcelHelpers.export(exports, "calcTreeSize", ()=>calcTreeSize);
parcelHelpers.export(exports, "generateLevelBounds", ()=>generateLevelBounds);
parcelHelpers.export(exports, "streamSearch", ()=>streamSearch);
var _configJs = require("./config.js");
var _configJsDefault = parcelHelpers.interopDefault(_configJs);
const NODE_ITEM_BYTE_LEN = 40;
const NODE_ITEM_LEN = 40;
const DEFAULT_NODE_SIZE = 16;
function calcTreeSize(e, t) {
    t = Math.min(Math.max(+t, 2), 65535);
    let l = e, n = l;
    do n += l = Math.ceil(l / t);
    while (1 !== l);
    return 40 * n;
}
function generateLevelBounds(e, t) {
    if (t < 2) throw Error("Node size must be at least 2");
    if (0 === e) throw Error("Number of items must be greater than 0");
    let l = e, n = l, o = [
        l
    ];
    do n += l = Math.ceil(l / t), o.push(l);
    while (1 !== l);
    let r = [];
    for (let e of (l = n, o))r.push(l - e), l -= e;
    let i = [];
    for(let e = 0; e < o.length; e++)i.push([
        r[e],
        r[e] + o[e]
    ]);
    return i;
}
async function* streamSearch(t, l, n, o) {
    class r {
        _level;
        nodes;
        constructor(e, t){
            this._level = t, this.nodes = e;
        }
        level() {
            return this._level;
        }
        startNodeIdx() {
            return this.nodes[0];
        }
        endNodeIdx() {
            return this.nodes[1];
        }
        extendEndNodeIdx(e) {
            this.nodes[1] = e;
        }
        toString() {
            return `[NodeRange level: ${this._level}, nodes: ${this.nodes[0]}-${this.nodes[1]}]`;
        }
    }
    let { minX: i, minY: s, maxX: d, maxY: u } = n, h = generateLevelBounds(t, l), a = h[0][0], N = [
        new r([
            0,
            1
        ], h.length - 1)
    ];
    for(; 0 !== N.length;){
        let n = N.shift(), c = n.startNodeIdx(), g = c >= a, f = (()=>{
            let [, e] = h[n.level()], t = Math.min(n.endNodeIdx() + l, e);
            return g && t < e ? t + 1 : t;
        })(), x = f - c, v = new DataView(await o(40 * c, 40 * x));
        for(let l = c; l < f; l++){
            let o = l - c, h = 40 * o;
            if (d < v.getFloat64(h + 0, !0) || u < v.getFloat64(h + 8, !0) || i > v.getFloat64(h + 16, !0) || s > v.getFloat64(h + 24, !0)) continue;
            let f = v.getBigUint64(h + 32, !0);
            if (g) {
                let e = (()=>{
                    if (l < t - 1) {
                        let e = (o + 1) * 40;
                        return v.getBigUint64(e + 32, !0) - f;
                    }
                    return null;
                })(), n = l - a;
                yield [
                    Number(f),
                    n,
                    Number(e)
                ];
                continue;
            }
            let x = (0, _configJsDefault.default).global.extraRequestThreshold() / 40, m = N[N.length - 1];
            if (void 0 !== m && m.level() === n.level() - 1 && f < m.endNodeIdx() + x) {
                m.extendEndNodeIdx(Number(f));
                continue;
            }
            let E = (()=>{
                let e = n.level() - 1;
                return new r([
                    Number(f),
                    Number(f) + 1
                ], e);
            })();
            void 0 !== m && (m.level(), E.level()), N.push(E);
        }
    }
}

},{"./config.js":"5Kw8d","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7W11D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromFeature", ()=>fromFeature);
parcelHelpers.export(exports, "buildFeature", ()=>buildFeature);
parcelHelpers.export(exports, "parseProperties", ()=>parseProperties);
var _flatbuffers = require("flatbuffers");
var _columnTypeJs = require("../flat-geobuf/column-type.js");
var _featureJs = require("../flat-geobuf/feature.js");
var _geometryJs = require("./geometry.js");
let n = new TextEncoder, s = new TextDecoder;
function fromFeature(e, t, r, a, n) {
    let s = r.columns;
    return n(e, a(t.geometry(), r.geometryType), parseProperties(t, s));
}
function buildFeature(s, o, i) {
    let l = i.columns, c = new _flatbuffers.Builder, g = 0, b = 1024, f = new Uint8Array(1024), u = new DataView(f.buffer), k = (e)=>{
        if (g + e < b) return;
        let t = new Uint8Array(b = Math.max(b + e, 2 * b));
        t.set(f), u = new DataView((f = t).buffer);
    };
    if (l) for(let e = 0; e < l.length; e++){
        let r = l[e], a = o[r.name];
        if (null !== a) switch(k(2), u.setUint16(g, e, !0), g += 2, r.type){
            case (0, _columnTypeJs.ColumnType).Bool:
                k(1), u.setUint8(g, a), g += 1;
                break;
            case (0, _columnTypeJs.ColumnType).Short:
                k(2), u.setInt16(g, a, !0), g += 2;
                break;
            case (0, _columnTypeJs.ColumnType).UShort:
                k(2), u.setUint16(g, a, !0), g += 2;
                break;
            case (0, _columnTypeJs.ColumnType).Int:
                k(4), u.setInt32(g, a, !0), g += 4;
                break;
            case (0, _columnTypeJs.ColumnType).UInt:
                k(4), u.setUint32(g, a, !0), g += 4;
                break;
            case (0, _columnTypeJs.ColumnType).Long:
                k(8), u.setBigInt64(g, BigInt(a), !0), g += 8;
                break;
            case (0, _columnTypeJs.ColumnType).Float:
                k(4), u.setFloat32(g, a, !0), g += 4;
                break;
            case (0, _columnTypeJs.ColumnType).Double:
                k(8), u.setFloat64(g, a, !0), g += 8;
                break;
            case (0, _columnTypeJs.ColumnType).DateTime:
            case (0, _columnTypeJs.ColumnType).String:
                {
                    let e = n.encode(a);
                    k(4), u.setUint32(g, e.length, !0), g += 4, k(e.length), f.set(e, g), g += e.length;
                    break;
                }
            case (0, _columnTypeJs.ColumnType).Json:
                {
                    let e = n.encode(JSON.stringify(a));
                    k(4), u.setUint32(g, e.length, !0), g += 4, k(e.length), f.set(e, g), g += e.length;
                    break;
                }
            case (0, _columnTypeJs.ColumnType).Binary:
                k(4), u.setUint32(g, a.length, !0), g += 4, k(a.length), f.set(a, g), g += a.length;
                break;
            default:
                throw Error(`Unknown type ${r.type}`);
        }
    }
    let U = 0;
    g > 0 && (U = (0, _featureJs.Feature).createPropertiesVector(c, f.slice(0, g)));
    let p = (0, _geometryJs.buildGeometry)(c, s);
    (0, _featureJs.Feature).startFeature(c), (0, _featureJs.Feature).addGeometry(c, p), U && (0, _featureJs.Feature).addProperties(c, U);
    let y = (0, _featureJs.Feature).endFeature(c);
    return c.finishSizePrefixed(y), c.asUint8Array();
}
function parseProperties(e, r) {
    let a = {};
    if (!r || 0 === r.length) return a;
    let n = e.propertiesArray();
    if (!n) return a;
    let o = new DataView(n.buffer, n.byteOffset), i = e.propertiesLength(), l = 0;
    for(; l < i;){
        let e = o.getUint16(l, !0);
        l += 2;
        let i = r[e], c = i.name;
        switch(i.type){
            case (0, _columnTypeJs.ColumnType).Bool:
                a[c] = !!o.getUint8(l), l += 1;
                break;
            case (0, _columnTypeJs.ColumnType).Byte:
                a[c] = o.getInt8(l), l += 1;
                break;
            case (0, _columnTypeJs.ColumnType).UByte:
                a[c] = o.getUint8(l), l += 1;
                break;
            case (0, _columnTypeJs.ColumnType).Short:
                a[c] = o.getInt16(l, !0), l += 2;
                break;
            case (0, _columnTypeJs.ColumnType).UShort:
                a[c] = o.getUint16(l, !0), l += 2;
                break;
            case (0, _columnTypeJs.ColumnType).Int:
                a[c] = o.getInt32(l, !0), l += 4;
                break;
            case (0, _columnTypeJs.ColumnType).UInt:
                a[c] = o.getUint32(l, !0), l += 4;
                break;
            case (0, _columnTypeJs.ColumnType).Long:
                a[c] = Number(o.getBigInt64(l, !0)), l += 8;
                break;
            case (0, _columnTypeJs.ColumnType).ULong:
                a[c] = Number(o.getBigUint64(l, !0)), l += 8;
                break;
            case (0, _columnTypeJs.ColumnType).Float:
                a[c] = o.getFloat32(l, !0), l += 4;
                break;
            case (0, _columnTypeJs.ColumnType).Double:
                a[c] = o.getFloat64(l, !0), l += 8;
                break;
            case (0, _columnTypeJs.ColumnType).DateTime:
            case (0, _columnTypeJs.ColumnType).String:
                {
                    let e = o.getUint32(l, !0);
                    l += 4, a[c] = s.decode(n.subarray(l, l + e)), l += e;
                    break;
                }
            case (0, _columnTypeJs.ColumnType).Json:
                {
                    let e = o.getUint32(l, !0);
                    l += 4;
                    let t = s.decode(n.subarray(l, l + e));
                    a[c] = JSON.parse(t), l += e;
                    break;
                }
            case (0, _columnTypeJs.ColumnType).Binary:
                {
                    let e = o.getUint32(l, !0);
                    l += 4, a[c] = n.subarray(l, l + e), l += e;
                    break;
                }
            default:
                throw Error(`Unknown type ${i.type}`);
        }
    }
    return a;
}

},{"flatbuffers":"4oKPA","../flat-geobuf/column-type.js":"cK2R8","../flat-geobuf/feature.js":"jNs3T","./geometry.js":"d9Uo0","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"d9Uo0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildGeometry", ()=>buildGeometry);
parcelHelpers.export(exports, "flat", ()=>flat);
parcelHelpers.export(exports, "parseGeometry", ()=>parseGeometry);
parcelHelpers.export(exports, "pairFlatCoordinates", ()=>pairFlatCoordinates);
parcelHelpers.export(exports, "toGeometryType", ()=>toGeometryType);
var _geometryTypeJs = require("../flat-geobuf/geometry-type.js");
var _geometryJs = require("../flat-geobuf/geometry.js");
function buildGeometry(t, r) {
    let o, n, a, { xy: l, z: y, m: d, ends: i, parts: g, type: s } = r;
    if (g) {
        let r = g.map((e)=>buildGeometry(t, e)), o = (0, _geometryJs.Geometry).createPartsVector(t, r);
        return (0, _geometryJs.Geometry).startGeometry(t), (0, _geometryJs.Geometry).addParts(t, o), (0, _geometryJs.Geometry).addType(t, s), (0, _geometryJs.Geometry).endGeometry(t);
    }
    let u = (0, _geometryJs.Geometry).createXyVector(t, l);
    return y && (o = (0, _geometryJs.Geometry).createZVector(t, y)), d && (n = (0, _geometryJs.Geometry).createMVector(t, d)), i && (a = (0, _geometryJs.Geometry).createEndsVector(t, i)), (0, _geometryJs.Geometry).startGeometry(t), a && (0, _geometryJs.Geometry).addEnds(t, a), (0, _geometryJs.Geometry).addXy(t, u), o && (0, _geometryJs.Geometry).addZ(t, o), n && (0, _geometryJs.Geometry).addM(t, n), (0, _geometryJs.Geometry).addType(t, s), (0, _geometryJs.Geometry).endGeometry(t);
}
function flat(t, e, r) {
    if (0 !== t.length) {
        if (Array.isArray(t[0])) for (let o of t)flat(o, e, r);
        else 2 === t.length ? e.push(...t) : (e.push(t[0], t[1]), r.push(t[2]));
    }
}
function r(t) {
    let e = t.length / 3, r = Array(2 * e), o = Array(e);
    for(let e = 0, n = 0; e < t.length; e += 3, n++)r[2 * n] = t[e], r[2 * n + 1] = t[e + 1], o[n] = t[e + 2];
    return [
        r,
        o
    ];
}
function parseGeometry(e, o) {
    let n, a, l, y, d, i, g, s = o;
    s === (0, _geometryTypeJs.GeometryType).Unknown && (s = toGeometryType(e.getType())), s === (0, _geometryTypeJs.GeometryType).MultiLineString ? (e.getFlatCoordinates && (n = e.getFlatCoordinates()), g = e.getEnds()) : s === (0, _geometryTypeJs.GeometryType).Polygon ? (e.getFlatCoordinates && (n = e.getFlatCoordinates()), g = e.getEnds()) : s === (0, _geometryTypeJs.GeometryType).MultiPolygon ? i = e.getPolygons().map((e)=>parseGeometry(e, (0, _geometryTypeJs.GeometryType).Polygon)) : e.getFlatCoordinates && (n = e.getFlatCoordinates());
    let u = e.getLayout?.() ?? "XY";
    if (n && ("XY" === u ? a = n : "XYZ" === u ? [a, l] = r(n) : "XYM" === u ? [a, y] = r(n) : "XYZM" === u && ([a, l, y] = function(t) {
        let e = t.length / 4, r = Array(2 * e), o = Array(e), n = Array(e);
        for(let e = 0, a = 0; e < t.length; e += 4, a++)r[2 * a] = t[e], r[2 * a + 1] = t[e + 1], o[a] = t[e + 2], n[a] = t[e + 3];
        return [
            r,
            o,
            n
        ];
    }(n))), g) {
        let t = 2;
        "XYZ" === u || "XYM" === u ? t = 3 : "XYZM" === u && (t = 4), d = g.map((e)=>e / t);
    }
    return {
        xy: a,
        z: l,
        m: y,
        ends: d,
        type: s,
        parts: i
    };
}
function pairFlatCoordinates(t, e) {
    let r = [];
    for(let o = 0; o < t.length; o += 2){
        let n = [
            t[o],
            t[o + 1]
        ];
        e && n.push(e[o >> 1]), r.push(n);
    }
    return r;
}
function toGeometryType(e) {
    return e ? (0, _geometryTypeJs.GeometryType)[e] : (0, _geometryTypeJs.GeometryType).Unknown;
}

},{"../flat-geobuf/geometry-type.js":"99UDP","../flat-geobuf/geometry.js":"gVFcX","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"iP7qh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inferGeometryType", ()=>inferGeometryType);
var _geometryTypeJs = require("../flat-geobuf/geometry-type.js");
var _geometryJs = require("../generic/geometry.js");
function inferGeometryType(t) {
    let r;
    for (let f of t){
        if (r === (0, _geometryTypeJs.GeometryType).Unknown) break;
        let t = f.getGeometry ? (0, _geometryJs.toGeometryType)(f.getGeometry().getType()) : (0, _geometryJs.toGeometryType)(f.geometry.type);
        void 0 === r ? r = t : r !== t && (r = (0, _geometryTypeJs.GeometryType).Unknown);
    }
    if (void 0 === r) throw Error("Could not infer geometry type for collection of features.");
    return r;
}

},{"../flat-geobuf/geometry-type.js":"99UDP","../generic/geometry.js":"d9Uo0","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hoFfE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromFeature", ()=>fromFeature);
var _featureJs = require("ol/Feature.js");
var _featureJsDefault = parcelHelpers.interopDefault(_featureJs);
var _featureJs1 = require("../generic/feature.js");
var _geometryJs = require("./geometry.js");
function o(r, t, o) {
    let m = new (0, _featureJsDefault.default)(t);
    return m.setId(r), o && m.setProperties && m.setProperties(o), m;
}
function fromFeature(e, m, s) {
    return (0, _featureJs1.fromFeature)(e, m, s, (0, _geometryJs.createGeometry), o);
}

},{"ol/Feature.js":"iVSSP","../generic/feature.js":"7W11D","./geometry.js":"56RTK","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"56RTK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createGeometry", ()=>createGeometry);
var _geometryTypeJs = require("../flat-geobuf/geometry-type.js");
var _lineStringJs = require("ol/geom/LineString.js");
var _lineStringJsDefault = parcelHelpers.interopDefault(_lineStringJs);
var _multiLineStringJs = require("ol/geom/MultiLineString.js");
var _multiLineStringJsDefault = parcelHelpers.interopDefault(_multiLineStringJs);
var _multiPointJs = require("ol/geom/MultiPoint.js");
var _multiPointJsDefault = parcelHelpers.interopDefault(_multiPointJs);
var _multiPolygonJs = require("ol/geom/MultiPolygon.js");
var _multiPolygonJsDefault = parcelHelpers.interopDefault(_multiPolygonJs);
var _pointJs = require("ol/geom/Point.js");
var _pointJsDefault = parcelHelpers.interopDefault(_pointJs);
var _polygonJs = require("ol/geom/Polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
function m(r, t) {
    let e = Array(r.length + t.length);
    for(let o = 0, n = 0, l = 0; o < r.length; o += 2, n++)e[l++] = r[o], e[l++] = r[o + 1], e[l++] = t[n];
    return e;
}
function createGeometry(g, y) {
    let a;
    if (a = y === (0, _geometryTypeJs.GeometryType).Unknown ? g?.type() : y, !g) return;
    let f = g.xyArray();
    if (f) {
        let n = Array.from(f), y = g.zArray(), u = g.mArray(), s = g.endsArray(), p = "XY", A = 2;
        y && u ? (p = "XYZM", n = function(r, t, e) {
            let o = Array(r.length + t.length + e.length);
            for(let n = 0, l = 0, i = 0; n < r.length; n += 2, l++)o[i++] = r[n], o[i++] = r[n + 1], o[i++] = t[l], o[i++] = e[l];
            return o;
        }(n, Array.from(y), Array.from(u)), A = 4) : y ? (p = "XYZ", n = m(n, Array.from(y)), A = 3) : u && (p = "XYM", n = m(n, Array.from(u)), A = 3);
        let c = s ? Array.from(s.map((r)=>r * A)) : [
            n.length
        ];
        switch(a){
            case (0, _geometryTypeJs.GeometryType).Point:
                return new (0, _pointJsDefault.default)(n);
            case (0, _geometryTypeJs.GeometryType).MultiPoint:
                return new (0, _multiPointJsDefault.default)(n, p);
            case (0, _geometryTypeJs.GeometryType).LineString:
                return new (0, _lineStringJsDefault.default)(n, p);
            case (0, _geometryTypeJs.GeometryType).MultiLineString:
                return new (0, _multiLineStringJsDefault.default)(n, p, c);
            case (0, _geometryTypeJs.GeometryType).Polygon:
                return new (0, _polygonJsDefault.default)(n, p, c);
        }
    }
    if (a === (0, _geometryTypeJs.GeometryType).MultiPolygon) {
        let t = g.partsLength(), e = Array(t);
        for(let o = 0; o < t; o++)e[o] = createGeometry(g.parts(o), (0, _geometryTypeJs.GeometryType).Polygon);
        return new (0, _multiPolygonJsDefault.default)(e);
    }
    throw Error("Unknown type");
}

},{"../flat-geobuf/geometry-type.js":"99UDP","ol/geom/LineString.js":"223qD","ol/geom/MultiLineString.js":"5Cre5","ol/geom/MultiPoint.js":"jiQtb","ol/geom/MultiPolygon.js":"6i4VN","ol/geom/Point.js":"95T6m","ol/geom/Polygon.js":"3zws5","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"adIen":[function(require,module,exports,__globalThis) {
// Pure helpers for #Conditional tag values — `<value> @ (<condition>)`, as carried
// by the new-Lanes-spec keys `hov:lanes:conditional` and
// `hov:minimum:lanes:conditional` (per-lane pipe lists whose SLOTS are conditional
// values, e.g. `yes @ (Mo-Fr 05:00-09:00,15:00-19:00)|||`).
//
// No OpenLayers imports so this is unit-testable with `node --test`. The split
// helpers work on one SLOT at a time — splitting the pipe list into slots is
// laneLists' splitLaneList's job, and a time domain never contains `|`, so the two
// splits cannot interfere.
//
// The time-domain evaluator covers the "sharp" subset the Orbis spec recommends and
// the SDLR data actually uses: weekday lists/ranges plus hh:mm-hh:mm ranges,
// multiple rules separated by `;`. Anything it does not understand (months, public
// holidays, fuzzy domains like "dusk-dawn", `off` exclusions) makes parseTimeDomain
// return null — callers must then say "conditional, window not evaluated" rather
// than guessing.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Split one conditional slot value into its base value and its condition.
 * `"yes @ (Mo-Fr 05:00-09:00)"` → `{ value: "yes", condition: "Mo-Fr 05:00-09:00" }`.
 * A plain value without `@` comes back as `{ value, condition: undefined }`, so
 * callers can feed either encoding through the same path.
 * @param {unknown} raw
 * @returns {{value: string, condition: string|undefined}|undefined} undefined for
 *   empty/blank slots ("nothing said about this lane")
 */ parcelHelpers.export(exports, "splitConditionalValue", ()=>splitConditionalValue);
/**
 * Is this whole tag value (a pipe list of slots) conditional in at least one slot?
 * Works on unsplit values so per-way styles can test cheaply.
 * @param {unknown} raw
 * @returns {boolean}
 */ parcelHelpers.export(exports, "hasConditionalSlot", ()=>hasConditionalSlot);
/**
 * Parse a sharp time domain into evaluatable rules.
 *
 * Supported per `;`-separated rule: an optional weekday part (`Mo-Fr`, `Mo,We,Fr`,
 * `Sa-Su` including week wrap `Fr-Mo`) and an optional list of `hh:mm-hh:mm`
 * ranges (overnight ranges like `22:00-06:00` wrap midnight). A rule with only
 * days means all day; only times means every day.
 * @param {string|undefined} condition
 * @returns {{days: boolean[], ranges: {fromMin: number, toMin: number}[]}[]|null}
 *   null when any part of the condition is outside the supported grammar —
 *   callers must treat that as "cannot evaluate", not as never/always.
 */ parcelHelpers.export(exports, "parseTimeDomain", ()=>parseTimeDomain);
/**
 * Evaluate parsed rules at a Date, in that Date's LOCAL time. The restriction's
 * clock times are local to the ROAD, so evaluating at the viewer's clock is only
 * meaningful when the viewer and the road share a timezone — callers must label
 * the result with the timezone they evaluated in.
 * @param {ReturnType<typeof parseTimeDomain>} rules
 * @param {Date} date
 * @returns {boolean|null} null when rules is null (unsupported grammar)
 */ parcelHelpers.export(exports, "isActiveAt", ()=>isActiveAt);
const DAY_NAMES = [
    "Su",
    "Mo",
    "Tu",
    "We",
    "Th",
    "Fr",
    "Sa"
];
// `<value> @ (<condition>)` — the value must be non-empty and the condition sits in
// parentheses per the spec's syntax for conditional restrictions. The spec also
// allows multiple `;`-separated <value> @ <condition> pairs in one tag value; in a
// per-lane slot that form is rare and a `;` there is equally a step-section
// separator, so this parser handles exactly one pair and callers treat anything
// else as opaque.
const CONDITIONAL_VALUE = /^\s*([^@]*?)\s*@\s*\(\s*(.*?)\s*\)\s*$/;
function splitConditionalValue(raw) {
    if (raw === undefined || raw === null) return undefined;
    const text = String(raw).trim();
    if (text === "") return undefined;
    const match = CONDITIONAL_VALUE.exec(text);
    if (match && match[1] !== "") return {
        value: match[1],
        condition: match[2]
    };
    return {
        value: text,
        condition: undefined
    };
}
function hasConditionalSlot(raw) {
    if (typeof raw !== "string") return false;
    return raw.split("|").some((slot)=>splitConditionalValue(slot)?.condition !== undefined);
}
function parseTimeDomain(condition) {
    if (typeof condition !== "string" || condition.trim() === "") return null;
    const rules = [];
    for (const ruleText of condition.split(";")){
        const tokens = ruleText.trim().split(/\s+/).filter(Boolean);
        if (tokens.length === 0) return null;
        const days = new Array(7).fill(false);
        let sawDays = false;
        const ranges = [];
        for (const token of tokens){
            if (parseDayToken(token, days)) sawDays = true;
            else if (!parseTimeToken(token, ranges)) return null;
        }
        if (!sawDays) days.fill(true);
        rules.push({
            days,
            ranges
        });
    }
    return rules.length > 0 ? rules : null;
}
// `Mo-Fr`, `Sa`, `Mo,We,Fr`, `Fr-Mo` (wrapping). Returns false when the token is
// not a day expression at all; throws nothing.
function parseDayToken(token, days) {
    const parts = token.split(",");
    const parsed = [];
    for (const part of parts){
        const range = part.split("-");
        if (range.length > 2) return false;
        const from = DAY_NAMES.indexOf(range[0]);
        const to = range.length === 2 ? DAY_NAMES.indexOf(range[1]) : from;
        if (from < 0 || to < 0) return false;
        parsed.push([
            from,
            to
        ]);
    }
    for (const [from, to] of parsed)for(let d = from;; d = (d + 1) % 7){
        days[d] = true;
        if (d === to) break;
    }
    return true;
}
// `05:00-09:00,15:00-19:00` — one token can carry several comma-separated ranges.
// `24:00` is accepted as an end ("until midnight"). Returns false on anything else.
function parseTimeToken(token, ranges) {
    const parts = token.split(",");
    const parsed = [];
    for (const part of parts){
        const match = /^(\d{1,2}):(\d{2})-(\d{1,2}):(\d{2})$/.exec(part);
        if (!match) return false;
        const fromMin = Number(match[1]) * 60 + Number(match[2]);
        const toMin = Number(match[3]) * 60 + Number(match[4]);
        if (Number(match[1]) > 24 || Number(match[3]) > 24 || Number(match[2]) > 59 || Number(match[4]) > 59 || fromMin > 1440 || toMin > 1440) return false;
        parsed.push({
            fromMin,
            toMin
        });
    }
    ranges.push(...parsed);
    return true;
}
function isActiveAt(rules, date) {
    if (!rules) return null;
    const day = date.getDay();
    const minutes = date.getHours() * 60 + date.getMinutes();
    const previousDay = (day + 6) % 7;
    for (const rule of rules){
        if (rule.ranges.length === 0) {
            if (rule.days[day]) return true;
            continue;
        }
        for (const { fromMin, toMin } of rule.ranges)if (fromMin <= toMin) {
            if (rule.days[day] && minutes >= fromMin && minutes < toMin) return true;
        } else {
            // Overnight range: the stretch before midnight belongs to the rule's day,
            // the stretch after midnight to the following day.
            if (rule.days[day] && minutes >= fromMin) return true;
            if (rule.days[previousDay] && minutes < toMin) return true;
        }
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fzyYi":[function(require,module,exports,__globalThis) {
// Per-lane pipe lists (`no||no`). Pure, so the node tests reach it — both the band
// maths in laneBands.js and the classifier in restrictionClass.mjs split lists here.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Split a per-lane pipe list into one entry per lane. A blank slot is meaningful —
 * "allowed" for an access tag, "not applicable" for hov — so empty entries are
 * kept, including trailing ones ("no|" is two lanes, not one).
 * @param {string|undefined} value
 * @returns {string[]} one entry per lane; [] when there is no value at all
 */ parcelHelpers.export(exports, "splitLaneList", ()=>splitLaneList);
var _stepSectionsMjs = require("./stepSections.mjs");
function splitLaneList(value) {
    if (value === undefined || value === null || value === "") return [];
    // Whitespace-only is nothing, not one blank lane. `" "` used to come back as
    // `[""]`, and since a length of 1 beats the `lanes=N` tier it overrode a correct
    // count with 1. A lone `"|"` survives this — that IS two unspecified lanes.
    if (String(value).trim() === "") return [];
    // A value that is still an LR chain is not a per-lane list, and must not be split
    // into one. styleBySection normally resolves step tags to scalars before classify()
    // sees them, but its whole-feature fallbacks — non-LineString geometry, zero
    // lengthCm, an undecodable chain — pass the RAW tags through. A per-lane step value
    // nests the pipe list inside the step value (`0-1000#yes||yes`), so splitting it
    // yields a slot that is exactly "yes" and the whole way renders as restricted, and a
    // lane count invented from wherever the pipes happened to fall. Exact-match slot
    // comparison does not protect against this; only refusing to split does.
    if ((0, _stepSectionsMjs.isOffsetSectionedValue)(value)) return [];
    return String(value).split("|").map((entry)=>entry.trim());
}

},{"./stepSections.mjs":"bZM8z","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"i6xk4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addFeatureInfoControl", ()=>addFeatureInfoControl);
var _featureInfoControl = require("../controls/FeatureInfoControl");
function addFeatureInfoControl(map) {
    const featureInfoControl = new (0, _featureInfoControl.FeatureInfoControl)();
    map.addControl(featureInfoControl);
    map.on("singleclick", function() {
        const allHoverLayers = featureInfoControl.getAllHoverLayers();
        allHoverLayers.forEach((hoverLayer)=>hoverLayer.getSource().clear());
        featureInfoControl.unset("selectedFeaturesAndLayers");
    });
    map.on("pointermove", function(e) {
        const featuresAtPixel = [];
        if (e.originalEvent.target.tagName !== "CANVAS") return;
        const allHoverLayers = featureInfoControl.getAllHoverLayers();
        map.forEachFeatureAtPixel(e.pixel, (feature, layer)=>{
            if (feature.get("nonInteractive")) return;
            featuresAtPixel.push({
                feature: feature,
                layer: layer
            });
        }, {
            layerFilter: (layer)=>!allHoverLayers.includes(layer)
        });
        featureInfoControl.setProperties({
            selectedFeaturesAndLayers: featuresAtPixel,
            position: e.coordinate
        });
    });
    return featureInfoControl;
}

},{"../controls/FeatureInfoControl":"1o8a6","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1o8a6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FeatureInfoControl", ()=>FeatureInfoControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
var _util = require("../util");
var _curvature = require("../layers/style/curvature");
var _helpers = require("@turf/helpers");
var _turf = require("@turf/turf");
var _nearestPointOnLine = require("@turf/nearest-point-on-line");
var _nearestPointOnLineDefault = parcelHelpers.interopDefault(_nearestPointOnLine);
var _geom = require("ol/geom");
var _orbisLrSdk = require("@orbis-lr-sdk/orbis-lr-sdk");
var _hoverLayer = require("../layers/HoverLayer");
var _laneListsMjs = require("../layers/style/util/laneLists.mjs");
var _conditionalValuesMjs = require("../layers/style/util/conditionalValues.mjs");
class FeatureInfoControl extends (0, _controlDefault.default) {
    constructor(){
        const div = document.createElement("div");
        super({
            element: div
        });
        const this_ = this;
        this.handlersForLayers = [];
        this.hoverLayersForLayers = [];
        div.id = "feature-info";
        div.className = "ol-unselectable";
        this.attributesTable = document.createElement("table");
        this.attributesTable.className = "ol-selectable feature-info-list";
        div.append(this.attributesTable);
        // listen to changes
        this.on("propertychange", ()=>{
            // roles
            const selectedFeaturesAndLayers = this_.get("selectedFeaturesAndLayers");
            if (selectedFeaturesAndLayers === undefined) {
                this.element.style.display = "none";
                return;
            }
            const selectedFeatures = selectedFeaturesAndLayers.map((featureAndLayer)=>featureAndLayer.feature);
            const position = this_.get("position");
            const fcdSpeeds = this_.get("fcdSpeeds");
            this.showValuesAtPosition(position, selectedFeatures, fcdSpeeds);
            selectedFeaturesAndLayers.forEach((featureAndLayer)=>{
                const feature = featureAndLayer.feature;
                const layer = featureAndLayer.layer;
                this_.getHandlersForLayer(layer).forEach((handler)=>handler(feature, layer, position));
                const hoverLayers = this_.getHoverLayersForLayer(layer);
                if (hoverLayers.length === 0) return;
                const built = (0, _hoverLayer.buildTangentFeature)(feature, position);
                if (!built) return;
                const keyValuesAt = this.getKeyValuesAt(feature, (0, _util.distanceAlongCm)(built.latLonGeometry, built.closestPointLatLon));
                keyValuesAt.forEach(([k, v])=>built.tangent.set(k, v));
                hoverLayers.forEach((hoverLayer)=>{
                    hoverLayer.getSource().clear();
                    hoverLayer.getSource().addFeature(built.tangent);
                });
            });
        });
    }
    getHandlersForLayer(layer) {
        return this.handlersForLayers.filter((layerAndHandler)=>layerAndHandler.layer === layer).map((layerAndHandler)=>layerAndHandler.handler);
    }
    getHoverLayersForLayer(layer) {
        return this.hoverLayersForLayers.filter((layerAndHoverLayer)=>layerAndHoverLayer.layer === layer).map((layerAndHoverLayer)=>layerAndHoverLayer.hoverLayer);
    }
    getAllHoverLayers() {
        return this.hoverLayersForLayers.map((layerAndHoverLayer)=>layerAndHoverLayer.hoverLayer);
    }
    addHandlerForLayer(handler, layer) {
        this.handlersForLayers.push({
            layer: layer,
            handler: handler
        });
    }
    addHoverLayerForLayer(hoverLayer, layer) {
        this.hoverLayersForLayers.push({
            layer: layer,
            hoverLayer: hoverLayer
        });
    }
    showValuesAtPosition(position, selectedFeatures, fcdSpeeds) {
        const hasFcd = fcdSpeeds && Object.keys(fcdSpeeds).length > 0;
        const closestFeature = position !== undefined && selectedFeatures !== undefined ? this.findClosestLineFeature(selectedFeatures, position) : null;
        if (!closestFeature) {
            if (!hasFcd) {
                this.element.style.display = "none";
                return;
            }
            this.refreshAttributes(null, null, [], fcdSpeeds);
            return;
        }
        const latLonGeometry = (0, _util.toLatLon)((0, _helpers.lineString)(closestFeature.getGeometry().getCoordinates()).geometry);
        const closestPointLatLon = (0, _nearestPointOnLineDefault.default)(latLonGeometry, (0, _util.toLatLon)((0, _helpers.point)(position).geometry));
        const distanceAtFeatureCm = (0, _util.distanceAlongCm)(latLonGeometry, closestPointLatLon);
        const keyValuesAt = this.getKeyValuesAt(closestFeature, distanceAtFeatureCm);
        const featureLengthCm = closestFeature.get("lengthCm");
        this.refreshAttributes(distanceAtFeatureCm, featureLengthCm, keyValuesAt, fcdSpeeds);
    }
    findClosestLineFeature(selectedFeatures, position) {
        const latLonEventPoint = (0, _util.toLatLon)((0, _helpers.point)(position).geometry);
        return Array.from(selectedFeatures).filter((feature)=>feature.getGeometry() instanceof (0, _geom.LineString)).sort((f1, f2)=>(0, _turf.pointToLineDistance)(latLonEventPoint, (0, _helpers.lineString)(f1.getGeometry().getCoordinates()).geometry) - (0, _turf.pointToLineDistance)(latLonEventPoint, (0, _helpers.lineString)(f2.getGeometry().getCoordinates()).geometry))[0];
    }
    refreshAttributes(distanceAtFeatureCm, featureLengthCm, keyValuesAt, fcdSpeeds) {
        this.attributesTable.innerHTML = "";
        const colGroup = document.createElement("colgroup");
        const colLabel = document.createElement("col");
        colLabel.classList.add("label");
        const colValue = document.createElement("col");
        colValue.classList.add("value");
        colGroup.appendChild(colLabel);
        colGroup.appendChild(colValue);
        this.attributesTable.appendChild(colGroup);
        this.element.style.display = "block";
        this.attributesTable.style = "display: table;";
        if (distanceAtFeatureCm !== null) {
            this.attributesTable.append((0, _util.rowHeader)("position " + distanceAtFeatureCm + " / " + featureLengthCm + " cm"));
            keyValuesAt.forEach((keyValueAt)=>this.attributesTable.append((0, _util.row)(keyValueAt[0], keyValueAt[1])));
            this.attributesTable.append((0, _util.rowHint)("click feature to see all tags"));
        }
        if (fcdSpeeds && Object.keys(fcdSpeeds).length > 0) {
            this.attributesTable.append((0, _util.rowHeader)("FCD speed at cursor"));
            Object.keys(fcdSpeeds).map((id)=>Number(id)).sort((a, b)=>a - b).forEach((id)=>{
                const arrow = document.createElement("span");
                arrow.textContent = "\u2191";
                arrow.style.display = "inline-block";
                arrow.style.transform = `rotate(${id * 30}deg)`;
                this.attributesTable.append((0, _util.row)(arrow, fcdSpeeds[id] + " km/h"));
            });
        }
    }
    getKeyValuesAt(feature, distanceAtFeatureCm) {
        const keyValuesAt = feature.getKeys().filter((key)=>key !== "geometry").filter((key)=>key !== "type").filter((key)=>key !== "lengthCm").filter((key)=>key !== "meta-uuid").filter((key)=>!key.startsWith("revision-")).filter((key)=>{
            const value = feature.get(key);
            return new (0, _orbisLrSdk.LRChainEncoded)(key, value?.toString() ?? "").isLrEncoded();
        }).map((key)=>{
            const value = feature.get(key);
            const valueAt = (0, _orbisLrSdk.ValueAtProducer).getValueAt(key, value?.toString(), distanceAtFeatureCm);
            return [
                key,
                valueAt
            ];
        });
        // Append derived radius and max speed for LR-encoded curvature
        const curvatureEntry = keyValuesAt.find(([key])=>key.endsWith("-curvature:linear") || key.endsWith("-curvature"));
        if (curvatureEntry) {
            const curvature = Number(curvatureEntry[1]);
            if (curvature !== 0 && !isNaN(curvature)) {
                const radius = 10000 / Math.abs(curvature);
                keyValuesAt.push([
                    "NDS curvature",
                    (0, _curvature.orbisCurvatureToNds)(curvature)
                ]);
                keyValuesAt.push([
                    "radius",
                    Math.round(radius) + " m"
                ]);
                keyValuesAt.push([
                    "max speed (based on curvature)",
                    (0, _curvature.maxSpeedDisplayFromCurvature)(curvature)
                ]);
            }
        }
        // Append curvature_at_junction (plain numeric, not LR-encoded) + derived values
        keyValuesAt.push(...(0, _curvature.curvatureAtJunctionKeyValues)(feature.get("curvature_at_junction")));
        // Append readable per-lane rows for #Conditional HOV. Read from the FEATURE, not
        // from keyValuesAt: whether the raw row survived the isLrEncoded filter is the
        // SDK's call, but the derived summary must not depend on it.
        keyValuesAt.push(...hovConditionalKeyValues(feature, distanceAtFeatureCm));
        return keyValuesAt;
    }
}
// The position-resolved value of the first feature key containing `part` (the
// step-sectioned variant carries a `:step` suffix, so a contains-test finds both).
function conditionalValueAt(feature, part, distanceAtFeatureCm) {
    const key = feature.getKeys().filter((key)=>!key.startsWith("revision-")).find((key)=>key.includes(part));
    if (!key) return undefined;
    return (0, _orbisLrSdk.ValueAtProducer).getValueAt(key, feature.get(key)?.toString(), distanceAtFeatureCm);
}
// One row per HOV lane: its time window, the minimum occupancy, and — when the
// window parses — whether it is active at the browser's clock. The window is written
// in the ROAD's local time, so the row names the timezone it was evaluated in
// instead of pretending the two clocks agree.
function hovConditionalKeyValues(feature, distanceAtFeatureCm) {
    const lanesValue = conditionalValueAt(feature, "-hov:lanes:conditional", distanceAtFeatureCm);
    if (lanesValue === undefined) return [];
    const minimumsValue = conditionalValueAt(feature, "-hov:minimum:lanes:conditional", distanceAtFeatureCm);
    const lanes = (0, _laneListsMjs.splitLaneList)(lanesValue);
    const minimums = (0, _laneListsMjs.splitLaneList)(minimumsValue);
    const now = new Date();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const rows = [];
    lanes.forEach((slot, index)=>{
        const parsed = (0, _conditionalValuesMjs.splitConditionalValue)(slot);
        if (!parsed) return;
        const minimum = (0, _conditionalValuesMjs.splitConditionalValue)(minimums[index] ?? "");
        let text = parsed.condition ?? "always";
        if (minimum?.value) text += ` \xb7 min occupancy ${minimum.value}`;
        const active = (0, _conditionalValuesMjs.isActiveAt)((0, _conditionalValuesMjs.parseTimeDomain)(parsed.condition), now);
        if (active !== null) text += ` \xb7 active now (${timeZone}): ${active ? "yes" : "no"}`;
        rows.push([
            `HOV window, lane ${index + 1} of ${lanes.length}`,
            text
        ]);
    });
    return rows;
}

},{"ol/control/Control":"8KSMn","../util":"4IC9E","../layers/style/curvature":"dM5mO","@turf/helpers":"ityOQ","@turf/turf":"jMUNq","@turf/nearest-point-on-line":"bwWlY","ol/geom":[["LineString","223qD","default"]],"@orbis-lr-sdk/orbis-lr-sdk":"04bfk","../layers/HoverLayer":"3Tely","../layers/style/util/laneLists.mjs":"fzyYi","../layers/style/util/conditionalValues.mjs":"adIen","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jMUNq":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>index_default);
parcelHelpers.export(exports, "pointToLineDistance", ()=>pointToLineDistance);
var _helpers = require("@turf/helpers");
var _nearestPointOnLine = require("@turf/nearest-point-on-line");
var _invariant = require("@turf/invariant");
var _meta = require("@turf/meta");
var _rhumbDistance = require("@turf/rhumb-distance");
function pointToLineDistance(pt, line, options = {}) {
    var _a, _b;
    const method = (_a = options.method) != null ? _a : "geodesic";
    const units = (_b = options.units) != null ? _b : "kilometers";
    if (!pt) throw new Error("pt is required");
    if (Array.isArray(pt)) pt = (0, _helpers.point)(pt);
    else if (pt.type === "Point") pt = (0, _helpers.feature)(pt);
    else (0, _invariant.featureOf)(pt, "Point", "point");
    if (!line) throw new Error("line is required");
    if (Array.isArray(line)) line = (0, _helpers.lineString)(line);
    else if (line.type === "LineString") line = (0, _helpers.feature)(line);
    else (0, _invariant.featureOf)(line, "LineString", "line");
    let distance = Infinity;
    const p = pt.geometry.coordinates;
    (0, _meta.segmentEach)(line, (segment)=>{
        if (segment) {
            const a = segment.geometry.coordinates[0];
            const b = segment.geometry.coordinates[1];
            const d = distanceToSegment(p, a, b, {
                method
            });
            if (d < distance) distance = d;
        }
    });
    return (0, _helpers.convertLength)(distance, "degrees", units);
}
function distanceToSegment(p, a, b, options) {
    if (options.method === "geodesic") {
        const nearest = (0, _nearestPointOnLine.nearestPointOnLine)((0, _helpers.lineString)([
            a,
            b
        ]).geometry, p, {
            units: "degrees"
        });
        return nearest.properties.pointDistance;
    }
    const v = [
        b[0] - a[0],
        b[1] - a[1]
    ];
    const w = [
        p[0] - a[0],
        p[1] - a[1]
    ];
    const c1 = dot(w, v);
    if (c1 <= 0) return (0, _rhumbDistance.rhumbDistance)(p, a, {
        units: "degrees"
    });
    const c2 = dot(v, v);
    if (c2 <= c1) return (0, _rhumbDistance.rhumbDistance)(p, b, {
        units: "degrees"
    });
    const b2 = c1 / c2;
    const Pb = [
        a[0] + b2 * v[0],
        a[1] + b2 * v[1]
    ];
    return (0, _rhumbDistance.rhumbDistance)(p, Pb, {
        units: "degrees"
    });
}
function dot(u, v) {
    return u[0] * v[0] + u[1] * v[1];
}
var index_default = pointToLineDistance;

},{"@turf/helpers":"ityOQ","@turf/nearest-point-on-line":"bwWlY","@turf/invariant":"8Sv4q","@turf/meta":"7ABec","@turf/rhumb-distance":"302tZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"302tZ":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>index_default);
parcelHelpers.export(exports, "rhumbDistance", ()=>rhumbDistance);
var _helpers = require("@turf/helpers");
var _invariant = require("@turf/invariant");
function rhumbDistance(from, to, options = {}) {
    const origin = (0, _invariant.getCoord)(from);
    const destination = (0, _invariant.getCoord)(to);
    destination[0] += destination[0] - origin[0] > 180 ? -360 : origin[0] - destination[0] > 180 ? 360 : 0;
    const distanceInMeters = calculateRhumbDistance(origin, destination);
    const distance = (0, _helpers.convertLength)(distanceInMeters, "meters", options.units);
    return distance;
}
function calculateRhumbDistance(origin, destination, radius) {
    radius = radius === void 0 ? (0, _helpers.earthRadius) : Number(radius);
    const R = radius;
    const phi1 = origin[1] * Math.PI / 180;
    const phi2 = destination[1] * Math.PI / 180;
    const DeltaPhi = phi2 - phi1;
    let DeltaLambda = Math.abs(destination[0] - origin[0]) * Math.PI / 180;
    if (DeltaLambda > Math.PI) DeltaLambda -= 2 * Math.PI;
    const DeltaPsi = Math.log(Math.tan(phi2 / 2 + Math.PI / 4) / Math.tan(phi1 / 2 + Math.PI / 4));
    const q = Math.abs(DeltaPsi) > 1e-11 ? DeltaPhi / DeltaPsi : Math.cos(phi1);
    const delta = Math.sqrt(DeltaPhi * DeltaPhi + q * q * DeltaLambda * DeltaLambda);
    const dist = delta * R;
    return dist;
}
var index_default = rhumbDistance;

},{"@turf/helpers":"ityOQ","@turf/invariant":"8Sv4q","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}]},[], null, "parcelRequire05b1", {})

//# sourceMappingURL=open-maps-restriction-wkt-viewer.4950432d.js.map
